(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("ca-ui-carbon-toolkit"), require("underscore"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("react-dom"), require("jquery"), require("polyglot"), require("ca-ui-carbon"), require("doT"), require("hammerjs"), require("jquery.hammer"), require("baglass/core-client/js/core-client/ui/properties/PropertyUIControl"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "ca-ui-carbon-toolkit", "underscore", "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons", "react-dom", "jquery", "polyglot", "ca-ui-carbon", "doT", "hammerjs", "jquery.hammer", "baglass/core-client/js/core-client/ui/properties/PropertyUIControl"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("ca-ui-carbon-toolkit"), require("underscore"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("react-dom"), require("jquery"), require("polyglot"), require("ca-ui-carbon"), require("doT"), require("hammerjs"), require("jquery.hammer"), require("baglass/core-client/js/core-client/ui/properties/PropertyUIControl")) : factory(root["react"], root["ca-ui-carbon-toolkit"], root["underscore"], root["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"], root["react-dom"], root["jquery"], root["polyglot"], root["ca-ui-carbon"], root["doT"], root["hammerjs"], root["jquery.hammer"], root["baglass/core-client/js/core-client/ui/properties/PropertyUIControl"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_50__, __WEBPACK_EXTERNAL_MODULE_55__, __WEBPACK_EXTERNAL_MODULE_56__, __WEBPACK_EXTERNAL_MODULE_57__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/bundles";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(35)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(38)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AuthoringCommonResources = __webpack_require__(16);

var _AuthoringCommonResources2 = _interopRequireDefault(_AuthoringCommonResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Cognos Products: BI
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Polyglot = __webpack_require__(17);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _AuthoringCommonResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	StringResources.prototype.get = function get(key, interpolationOptions) {
		return this.polyglot.t(key, interpolationOptions);
	};

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(42);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(44)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./all.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./all.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (_) {
	'use strict';

	/**
  * The Class implements the root of class hierarchy implementing the mechanism for
  * creating new derived classes and calling inherited methods.
  */

	// @class
	// @abstract

	var Class = function Class() {};

	function createConstructor() {
		return function () {
			if (typeof this.init === 'function') {
				this.init.apply(this, arguments);
			}
		};
	}

	// Create new widget class derived from the Class
	// @static
	// @param mixins	[optional] An array of the mixin classes.
	// @param def		The definition of the derived class, methods, member variables. The
	//					special method 'init' is called at construction of the class instance.
	//
	Class.extend = function (mixins, def) {
		if (arguments.length === 1) {
			def = mixins;
			mixins = null;
		}

		var baseProto = this.prototype,
		    parentProto = baseProto,
		    proto = Object.create(parentProto);

		// create the constructor
		var ctor = createConstructor();

		// add the mixins
		if (mixins) {
			for (var i = 0, len = mixins.length; i < len; ++i) {
				proto = _.extend(proto, mixins[i].prototype);
			}
			parentProto = proto;
			proto = Object.create(proto);

			if (typeof def.init !== 'function') {
				// generate default init method for multi-class inheritance
				def.init = function () {
					ctor.inherited('init', this, arguments);
				};
			}
		}

		_.extend(proto, def);
		ctor.prototype = proto;

		// static method to allow for further extension
		ctor.extend = this.extend;

		// calling the inherited methods
		ctor.inherited = function (name, that, args) {
			if (name === 'init') {
				// the 'init' method has a special case of calling inherited implementation
				// it should call all the 'init' methods from the base class and mixins
				if (typeof baseProto[name] === 'function') {
					baseProto[name].apply(that, args);
				}
				_.each(mixins, function (m) {
					if (typeof m.prototype[name] === 'function') {
						m.prototype[name].apply(that, args);
					}
				});
			} else if (typeof parentProto[name] === 'function') {
				return parentProto[name].apply(that, args);
			}
		};

		return ctor;
	};

	return Class;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=Class.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var ColorConversion = function () {
	function ColorConversion() {
		_classCallCheck(this, ColorConversion);
	}

	ColorConversion.convertRgbHexToRgbVal = function convertRgbHexToRgbVal(rgbHex) {
		var rgbColor = {};
		if (rgbHex) {
			rgbColor.red = parseInt(rgbHex.substr(1, 2), 16) || 0;
			rgbColor.green = parseInt(rgbHex.substr(3, 2), 16) || 0;
			rgbColor.blue = parseInt(rgbHex.substr(5, 2), 16) || 0;
		}
		return rgbColor;
	};

	ColorConversion.convertRgbValToRgbHex = function convertRgbValToRgbHex(rgbVal) {
		var redCode = Math.round(rgbVal.red).toString(16);
		var greenCode = Math.round(rgbVal.green).toString(16);
		var blueCode = Math.round(rgbVal.blue).toString(16);

		while (redCode.length < 2) {
			redCode = '0' + redCode;
		}
		while (greenCode.length < 2) {
			greenCode = '0' + greenCode;
		}
		while (blueCode.length < 2) {
			blueCode = '0' + blueCode;
		}
		return ('#' + redCode + greenCode + blueCode).toUpperCase();
	};

	ColorConversion.convertRgbToHsl = function convertRgbToHsl(color) {
		if (!color) {
			return {};
		}
		var rgbVal = this.convertRgbHexToRgbVal(color);
		var hslVal = {};

		var redVal = rgbVal.red / 255;
		var greenVal = rgbVal.green / 255;
		var blueVal = rgbVal.blue / 255;

		var maxVal = Math.max(redVal, greenVal, blueVal);
		var minVal = Math.min(redVal, greenVal, blueVal);

		var chroma = maxVal - minVal;

		var lightnessVal = (maxVal + minVal) / 2;

		var hueVal = 0;

		if (chroma == 0) {
			hueVal = 0;
		} else {
			if (maxVal == redVal) {
				hueVal = (greenVal - blueVal) / chroma % 6;
			} else if (maxVal == greenVal) {
				hueVal = (blueVal - redVal) / chroma + 2;
			} else if (maxVal == blueVal) {
				hueVal = (redVal - greenVal) / chroma + 4;
			}
		}

		var satVal = chroma / (1 - Math.abs(2 * lightnessVal - 1));
		if (!satVal) {
			satVal = 0;
		}
		hslVal.hue = hueVal * 60;

		if (hslVal.hue < 0) {
			hslVal.hue += 360;
		} else if (hslVal.hue > 360) {
			hslVal.hue -= 360;
		}

		hslVal.sat = satVal;
		hslVal.light = lightnessVal;

		return hslVal;
	};

	ColorConversion.convertHslToRgb = function convertHslToRgb(hslColor) {
		var chroma = (1 - Math.abs(2 * hslColor.light - 1)) * hslColor.sat;
		var huePrime = hslColor.hue / 60;
		var rgbColor = {};
		var variance = 1 * (hslColor.light - chroma / 2);

		var colorShift = chroma * (1 - Math.abs(huePrime % 2 - 1));

		if (huePrime >= 0 && huePrime <= 1) {
			rgbColor.red = chroma;
			rgbColor.green = colorShift;
			rgbColor.blue = 0;
		} else if (huePrime >= 1 && huePrime <= 2) {
			rgbColor.red = colorShift;
			rgbColor.green = chroma;
			rgbColor.blue = 0;
		} else if (huePrime >= 2 && huePrime <= 3) {
			rgbColor.red = 0;
			rgbColor.green = chroma;
			rgbColor.blue = colorShift;
		} else if (huePrime >= 3 && huePrime <= 4) {
			rgbColor.red = 0;
			rgbColor.green = colorShift;
			rgbColor.blue = chroma;
		} else if (huePrime >= 4 && huePrime <= 5) {
			rgbColor.red = colorShift;
			rgbColor.green = 0;
			rgbColor.blue = chroma;
		} else if (huePrime >= 5 && huePrime <= 6) {
			rgbColor.red = chroma;
			rgbColor.green = 0;
			rgbColor.blue = colorShift;
		} else {
			rgbColor.red = 0;
			rgbColor.green = 0;
			rgbColor.blue = 0;
		}

		rgbColor.red = (rgbColor.red + variance) * 255;
		rgbColor.green = (rgbColor.green + variance) * 255;
		rgbColor.blue = (rgbColor.blue + variance) * 255;

		return rgbColor;
	};

	return ColorConversion;
}();

exports.default = ColorConversion;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"errorCreatingPalette":"An error occurred while saving the palette.","paletteErrorTitle":"Palette Error","changePaletteLabel":"Change color palette","myPaletteLabel":"Custom","legacyPaletteLabel":"Legacy","systemPaletteLabel":"System","publicPaletteLabel":"Global","localPaletteLabel":"Local","mruPaletteLabel":"Recently used","okDialog":"OK","deleteDialogTitle":"Delete","applyDialog":"Apply","cancelDialog":"Cancel","saveDialog":"Save","createDialog":"Create","deleteMessage":"Are you sure you want to delete the palette \"%{name}\"?","deleteToast":"\"%{name}\" was deleted","favoritesLabel":"Favorites","setAsFavorite":"Set as favorite","createdToastMessage":"\"%{name}\" was successfully created.","createPalette":"Create a custom palette","colorPicker":"Color picker","errorNoName":"Enter a name for your palette","errorInsufficientColors":"Choose at least two colors","paletteAppliedToastMessage":"Palette \"%{name}\", was applied to the report.","createPaletteHeader":"Create color palette","modifyPaletteHeader":"Edit color palette","paletteNamePlaceholder":"Type palette name here","paletteName":"Palette name","standardPalette":"Categorical palette","continuousPalette":"Continuous palette","removeSwatch":"Remove swatch","addSwatch":"Add swatch","reversePalette":"Reverse palette","colorGuide":"Color guide","modeAutomatic":"Automatic","modeCustom":"Custom","colorModel":"Color model","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grid","wheel":"Wheel","hexCode":"Hex code","colorRed":"Red","colorGreen":"Green","colorBlue":"Blue","colorHue":"Hue","colorSaturation":"Saturation","colorBrightness":"Brightness","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Yellow","colorBlack":"Black","codeRed":"Red","codeGreen":"Green","codeBlue":"Blue","codeHue":"Hue","codeSaturation":"Saturation","codeBrightness":"Brightness","close":"Close","duplicate":"Duplicate","edit":"Edit","delete":"Delete","editSchematic":"Edit package","searchSchematic":"Search","nameLabelSchematic":"Name","captionLabelSchematic":"Caption","keyLabelSchematic":"Key","addSchematic":"Upload file","schematicsInvalidSvg":"Invalid or unsupported SVG","schematicsInvalidSvgData":"Could not obtain file data","schematicsInvalidType":"Unsupported file type: %{type}","schematicsInvalidSize":"File %{file}, size %{size} exceeds limit.","schematicsContextMenuReplace":"Replace","schematicsContextMenuDelete":"Delete","schematicsEmptySearchResults":"Search results are empty","schematicsNoSelection":"No items selected","schematicsMultipleSelection":"%{count} items selected","schematicsSingleDeletionSuccessed":"Your schematic was successfully deleted.","schematicsMultipleDeletionSuccessed":"%{count} schematics were successfully deleted.","schematicsSingleAddSuccessed":"Your schematic was successfully added.","schematicsMultipleAddSuccessed":"%{count} schematics were successfully added.","schematicsAddFailed":"Failed adding your schematic.","schematicsReplaceDlgTitle":"Confirm replacement of existing file","schematicsReplaceDlgContent":"The file '%{sourceName}' already exists. Do you want to replace it with the new file?","schematicsReplaceDlgApplyToAllFiles":"Apply to all files","schematicsPackageTab":"Package","schematicsContentTab":"Content","schematicsDescriptionLabel":"Description","schematicsIconLabel":"Icon","schematicsChooseFile":"Add file","schematicsDeleteIcon":"Remove the icon","schematicsIconAdded":"The icon \"%{file}\" has been successfully added.","schematicsIconRemove":"The icon has been successully removed.","schematicsIconDropFiles":"Drag and drop file here or upload","schematicsIconOr":"or","schematicsIconFileTypes":"Only .jpg, .png, and .svg files.","schematicsIconFileSize":"%{size}MB max file size.","legacySectionExtraMessage":"Warning: Legacy palettes are from an earlier version before you upgraded. Changes to these palettes will cause them to no longer appear for this visualization.","favorite":"Favorites"},"__cy":{"errorCreatingPalette":"An error occurred while saving the palette.~DB1","paletteErrorTitle":"Palette Error~DB2","changePaletteLabel":"Change color palette~DB3","myPaletteLabel":"Custom~DB4","systemPaletteLabel":"System~DB5","publicPaletteLabel":"Global~DB6","localPaletteLabel":"Local~DB7","mruPaletteLabel":"Recently used~DB8","okDialog":"OK~DB9","deleteDialogTitle":"Delete~DB10","applyDialog":"Apply~DB11","cancelDialog":"Cancel~DB12","saveDialog":"Save~DB13","deleteMessage":"Are you sure you want to delete the palette \"[%{name}]\"?~DB14","deleteToast":"\"[%{name}]\" was deleted~DB15","favoritesLabel":"Favorites~DB16","setAsFavorite":"Set as favorite~DB17","createdToastMessage":"\"[%{name}]\" was successfully created.~DB18","createPalette":"Create a custom palette~DB19","colorPicker":"Color picker~DB20","errorNoName":"Enter a name for your palette~DB21","errorInsufficientColors":"Choose at least two colors~DB22","paletteAppliedToastMessage":"Palette \"[%{name}]\", was applied to the report.~DB23","createContinuousPalette":"Create continuous color palette~DB24","createStandardPalette":"Create categorical color palette~DB25","paletteNamePlaceholder":"Type palette name here~DB26","paletteName":"Palette name~DB27","standardPalette":"Categorical palette~DB28","continuousPalette":"Continuous palette~DB29","removeSwatch":"Remove swatch~DB30","addSwatch":"Add swatch~DB31","reversePalette":"Reverse palette~DB32","colorGuide":"Color guide~DB33","modeAutomatic":"Automatic~DB34","modeCustom":"Custom~DB35","colorModel":"Color model~DB36","modelRGB":"RGB~DB37","modelHSB":"HSB~DB38","modelCMYK":"CMYK~DB39","grid":"Grid~DB40","wheel":"Wheel~DB41","hexCode":"Hex code~DB42","colorRed":"Red~DB43","colorGreen":"Green~DB44","colorBlue":"Blue~DB45","colorHue":"Hue~DB46","colorSaturation":"Saturation~DB47","colorBrightness":"Brightness~DB48","colorCyan":"Cyan~DB49","colorMagenta":"Magenta~DB50","colorYellow":"Yellow~DB51","colorBlack":"Black~DB52","codeRed":"R~DB53","codeGreen":"G~DB54","codeBlue":"B~DB55","codeHue":"H~DB56","codeSaturation":"S~DB57","codeBrightness":"B~DB58","codeCyan":"C~DB59","codeMagenta":"M~DB60","codeYellow":"Y~DB61","codeBlack":"K~DB62","close":"Close~DB63","editSchematic":"Edit package~DB64","searchSchematic":"Search~DB65","nameLabelSchematic":"Name~DB66","captionLabelSchematic":"Caption~DB67","keyLabelSchematic":"Key~DB68","addSchematic":"Upload File~DB69","schematicsInvalidSvg":"Invalid or unsupported SVG~DB70","schematicsInvalidSvgData":"Could not obtain file data~DB71","schematicsInvalidType":"Unsupported file type: [%{type}]~DB72","schematicsInvalidSize":"File [%{file}], size [%{size}] exceeds limit.~DB73","schematicsContextMenuReplace":"Replace~DB74","schematicsContextMenuDelete":"Delete~DB75","schematicsEmptySearchResults":"Search results are empty~DB76","schematicsNoSelection":"No items selected~DB77","schematicsMultipleSelection":"[%{count}] items selected~DB78","schematicsSingleDeletionSuccessed":"Your schematic was successfully deleted.~DB79","schematicsMultipleDeletionSuccessed":"[%{count}] schematics were successfully deleted.~DB80","schematicsSingleAddSuccessed":"Your schematic was successfully added.~DB81","schematicsMultipleAddSuccessed":"[%{count}] schematics were successfully added.~DB82","schematicsAddFailed":"Failed adding your schematic.~DB83","schematicsReplaceDlgTitle":"Confirm replacement of existing file~DB84","schematicsReplaceDlgContent":"The file '[%{sourceName}]' already exists. Do you want to replace it with the new file?~DB85","schematicsReplaceDlgApplyToAllFiles":"Apply to all files~DB86","schematicsPackageTab":"Package~DB87","schematicsContentTab":"Content~DB88","schematicsDescriptionLabel":"Description~DB89","schematicsIconLabel":"Icon~DB90","schematicsChooseFile":"Choose a file~DB91","schematicsDeleteIcon":"Remove the icon~DB92","schematicsIconAdded":"The icon \"[%{file}]\" has been successfully added.~DB93","schematicsIconRemove":"The icon has been successully removed.~DB94","schematicsIconDropFiles":"Drop files here~DB95","schematicsIconOr":"or~DB96","schematicsIconFileTypes":"Only .jpg, .png, and .svg files.~DB97","schematicsIconFileSize":"[%{size}]MB max file size.~DB98"},"__gl":{"errorCreatingPalette":"«头'ทั้ดูΣ＿Ａｎ error occurred while saving the palette.＿Э İı｜尾»","paletteErrorTitle":"«头'ทั้ดูΣ＿Palette Error＿Э İı｜尾»","changePaletteLabel":"«头'ทั้ดูΣ＿Change color palette＿Э İı｜尾»","myPaletteLabel":"«头'ทั้ดูΣ＿Custom＿Э İı｜尾»","systemPaletteLabel":"«头'ทั้ดูΣ＿System＿Э İı｜尾»","publicPaletteLabel":"«头'ทั้ดูΣ＿Global＿Э İı｜尾»","localPaletteLabel":"«头'ทั้ดูΣ＿Local＿Э İı｜尾»","mruPaletteLabel":"«头'ทั้ดูΣ＿Recently used＿Э İı｜尾»","okDialog":"«头'ทั้ดูΣ＿OK＿Э İı｜尾»","deleteDialogTitle":"«头'ทั้ดูΣ＿Delete＿Э İı｜尾»","applyDialog":"«头'ทั้ดูΣ＿Apply＿Э İı｜尾»","cancelDialog":"«头'ทั้ดูΣ＿Cancel＿Э İı｜尾»","saveDialog":"«头'ทั้ดูΣ＿Save＿Э İı｜尾»","deleteMessage":"«头'ทั้ดูΣ＿Ａｒe you sure you want to delete the palette \"[%{name}]\"?＿Э İı｜尾»","deleteToast":"«头'ทั้ดูΣ＿\"[%{name}]\" was deleted＿Э İı｜尾»","favoritesLabel":"«头'ทั้ดูΣ＿Favorites＿Э İı｜尾»","setAsFavorite":"«头'ทั้ดูΣ＿Set as favorite＿Э İı｜尾»","createdToastMessage":"«头'ทั้ดูΣ＿\"[%{name}]\" was successfully created.＿Э İı｜尾»","createPalette":"«头'ทั้ดูΣ＿Create a custom palette＿Э İı｜尾»","colorPicker":"«头'ทั้ดูΣ＿Color picker＿Э İı｜尾»","errorNoName":"«头'ทั้ดูΣ＿Enter a name for your palette＿Э İı｜尾»","errorInsufficientColors":"«头'ทั้ดูΣ＿Choose at least two colors＿Э İı｜尾»","paletteAppliedToastMessage":"«头'ทั้ดูΣ＿Ｐａlette \"[%{name}]\", was applied to the report.＿Э İı｜尾»","createContinuousPalette":"«头'ทั้ดูΣ＿Create continuous color palette＿Э İı｜尾»","createStandardPalette":"«头'ทั้ดูΣ＿Create categorical color palette＿Э İı｜尾»","paletteNamePlaceholder":"«头'ทั้ดูΣ＿Type palette name here＿Э İı｜尾»","paletteName":"«头'ทั้ดูΣ＿Palette name＿Э İı｜尾»","standardPalette":"«头'ทั้ดูΣ＿Categorical palette＿Э İı｜尾»","continuousPalette":"«头'ทั้ดูΣ＿Continuous palette＿Э İı｜尾»","removeSwatch":"«头'ทั้ดูΣ＿Remove swatch＿Э İı｜尾»","addSwatch":"«头'ทั้ดูΣ＿Add swatch＿Э İı｜尾»","reversePalette":"«头'ทั้ดูΣ＿Reverse palette＿Э İı｜尾»","colorGuide":"«头'ทั้ดูΣ＿Color guide＿Э İı｜尾»","modeAutomatic":"«头'ทั้ดูΣ＿Automatic＿Э İı｜尾»","modeCustom":"«头'ทั้ดูΣ＿Custom＿Э İı｜尾»","colorModel":"«头'ทั้ดูΣ＿Color model＿Э İı｜尾»","modelRGB":"«头'ทั้ดูΣ＿RGB＿Э İı｜尾»","modelHSB":"«头'ทั้ดูΣ＿HSB＿Э İı｜尾»","modelCMYK":"«头'ทั้ดูΣ＿CMYK＿Э İı｜尾»","grid":"«头'ทั้ดูΣ＿Grid＿Э İı｜尾»","wheel":"«头'ทั้ดูΣ＿Wheel＿Э İı｜尾»","hexCode":"«头'ทั้ดูΣ＿Hex code＿Э İı｜尾»","colorRed":"«头'ทั้ดูΣ＿Red＿Э İı｜尾»","colorGreen":"«头'ทั้ดูΣ＿Green＿Э İı｜尾»","colorBlue":"«头'ทั้ดูΣ＿Blue＿Э İı｜尾»","colorHue":"«头'ทั้ดูΣ＿Hue＿Э İı｜尾»","colorSaturation":"«头'ทั้ดูΣ＿Saturation＿Э İı｜尾»","colorBrightness":"«头'ทั้ดูΣ＿Brightness＿Э İı｜尾»","colorCyan":"«头'ทั้ดูΣ＿Cyan＿Э İı｜尾»","colorMagenta":"«头'ทั้ดูΣ＿Magenta＿Э İı｜尾»","colorYellow":"«头'ทั้ดูΣ＿Yellow＿Э İı｜尾»","colorBlack":"«头'ทั้ดูΣ＿Black＿Э İı｜尾»","codeRed":"«头'ทั้ดูΣ＿R＿Э İı｜尾»","codeGreen":"«头'ทั้ดูΣ＿G＿Э İı｜尾»","codeBlue":"«头'ทั้ดูΣ＿B＿Э İı｜尾»","codeHue":"«头'ทั้ดูΣ＿H＿Э İı｜尾»","codeSaturation":"«头'ทั้ดูΣ＿S＿Э İı｜尾»","codeBrightness":"«头'ทั้ดูΣ＿B＿Э İı｜尾»","codeCyan":"«头'ทั้ดูΣ＿C＿Э İı｜尾»","codeMagenta":"«头'ทั้ดูΣ＿M＿Э İı｜尾»","codeYellow":"«头'ทั้ดูΣ＿Y＿Э İı｜尾»","codeBlack":"«头'ทั้ดูΣ＿K＿Э İı｜尾»","close":"«头'ทั้ดูΣ＿Close＿Э İı｜尾»","editSchematic":"«头'ทั้ดูΣ＿Edit package＿Э İı｜尾»","searchSchematic":"«头'ทั้ดูΣ＿Search＿Э İı｜尾»","nameLabelSchematic":"«头'ทั้ดูΣ＿Name＿Э İı｜尾»","captionLabelSchematic":"«头'ทั้ดูΣ＿Caption＿Э İı｜尾»","keyLabelSchematic":"«头'ทั้ดูΣ＿Key＿Э İı｜尾»","addSchematic":"«头'ทั้ดูΣ＿Upload File＿Э İı｜尾»","schematicsInvalidSvg":"«头'ทั้ดูΣ＿Invalid or unsupported SVG＿Э İı｜尾»","schematicsInvalidSvgData":"«头'ทั้ดูΣ＿Could not obtain file data＿Э İı｜尾»","schematicsInvalidType":"«头'ทั้ดูΣ＿Unsupported file type: [%{type}]＿Э İı｜尾»","schematicsInvalidSize":"«头'ทั้ดูΣ＿File [%{file}], size [%{size}] exceeds limit.＿Э İı｜尾»","schematicsContextMenuReplace":"«头'ทั้ดูΣ＿Replace＿Э İı｜尾»","schematicsContextMenuDelete":"«头'ทั้ดูΣ＿Delete＿Э İı｜尾»","schematicsEmptySearchResults":"«头'ทั้ดูΣ＿Search results are empty＿Э İı｜尾»","schematicsNoSelection":"«头'ทั้ดูΣ＿No items selected＿Э İı｜尾»","schematicsMultipleSelection":"«头'ทั้ดูΣ＿[%{count}] items selected＿Э İı｜尾»","schematicsSingleDeletionSuccessed":"«头'ทั้ดูΣ＿Ｙｏur schematic was successfully deleted.＿Э İı｜尾»","schematicsMultipleDeletionSuccessed":"«头'ทั้ดูΣ＿[%{count}] ｓｃhematics were successfully deleted.＿Э İı｜尾»","schematicsSingleAddSuccessed":"«头'ทั้ดูΣ＿Ｙｏur schematic was successfully added.＿Э İı｜尾»","schematicsMultipleAddSuccessed":"«头'ทั้ดูΣ＿[%{count}] ｓchematics were successfully added.＿Э İı｜尾»","schematicsAddFailed":"«头'ทั้ดูΣ＿Failed adding your schematic.＿Э İı｜尾»","schematicsReplaceDlgTitle":"«头'ทั้ดูΣ＿Ｃonfirm replacement of existing file＿Э İı｜尾»","schematicsReplaceDlgContent":"«头'ทั้ดูΣ＿Ｔｈｅ ｆile '[%{sourceName}]' already exists. Do you want to replace it with the new file?＿Э İı｜尾»","schematicsReplaceDlgApplyToAllFiles":"«头'ทั้ดูΣ＿Apply to all files＿Э İı｜尾»","schematicsPackageTab":"«头'ทั้ดูΣ＿Package＿Э İı｜尾»","schematicsContentTab":"«头'ทั้ดูΣ＿Content＿Э İı｜尾»","schematicsDescriptionLabel":"«头'ทั้ดูΣ＿Description＿Э İı｜尾»","schematicsIconLabel":"«头'ทั้ดูΣ＿Icon＿Э İı｜尾»","schematicsChooseFile":"«头'ทั้ดูΣ＿Choose a file＿Э İı｜尾»","schematicsDeleteIcon":"«头'ทั้ดูΣ＿Remove the icon＿Э İı｜尾»","schematicsIconAdded":"«头'ทั้ดูΣ＿Ｔｈe icon \"[%{file}]\" has been successfully added.＿Э İı｜尾»","schematicsIconRemove":"«头'ทั้ดูΣ＿Ｔｈe icon has been successully removed.＿Э İı｜尾»","schematicsIconDropFiles":"«头'ทั้ดูΣ＿Drop files here＿Э İı｜尾»","schematicsIconOr":"«头'ทั้ดูΣ＿or＿Э İı｜尾»","schematicsIconFileTypes":"«头'ทั้ดูΣ＿Only .jpg, .png, and .svg files.＿Э İı｜尾»","schematicsIconFileSize":"«头'ทั้ดูΣ＿[%{size}]MB max file size.＿Э İı｜尾»"},"__cs":{"errorCreatingPalette":"Došlo k chybě při ukládání palety.","paletteErrorTitle":"Chyba palety","changePaletteLabel":"Změnit paletu barev","myPaletteLabel":"Vlastní","legacyPaletteLabel":"Starší","systemPaletteLabel":"Systém","publicPaletteLabel":"Globální","localPaletteLabel":"Lokální","mruPaletteLabel":"Nedávno použité","okDialog":"OK","deleteDialogTitle":"Odstranit","applyDialog":"Použít","cancelDialog":"Storno","saveDialog":"Uložit","createDialog":"Vytvořit","deleteMessage":"Opravdu chcete odstranit paletu \"%{name}\"?","deleteToast":"Odstraněno: \"%{name}\"","favoritesLabel":"Oblíbené položky","setAsFavorite":"Nastavit jako oblíbené","createdToastMessage":"Úspěšně vytvořeno: \"%{name}\"","createPalette":"Vytvořit vlastní paletu","colorPicker":"Výběr barvy","errorNoName":"Zadejte název palety.","errorInsufficientColors":"Vyberte alespoň dvě barvy.","paletteAppliedToastMessage":"Na sestavu byla použit a paleta \"%{name}\".","createPaletteHeader":"Vytvořit paletu barev","modifyPaletteHeader":"Upravit paletu barev","paletteNamePlaceholder":"Zde zadejte název palety.","paletteName":"Název palety","standardPalette":"Kategorická paleta","continuousPalette":"Spojitá paleta","removeSwatch":"Odebrat paletu","addSwatch":"Přidat paletu","reversePalette":"Obrátit paletu","colorGuide":"Průvodce barvami","modeAutomatic":"Automaticky","modeCustom":"Vlastní","colorModel":"Barevný model","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Mřížka","wheel":"Kolo","hexCode":"Hexadecimální kód","colorRed":"Červená","colorGreen":"Zelená","colorBlue":"Modrá","colorHue":"Odstín","colorSaturation":"Sytost","colorBrightness":"Jas","colorCyan":"Azurová","colorMagenta":"Purpurová","colorYellow":"Žlutá","colorBlack":"Černá","codeRed":"Červená","codeGreen":"Zelená","codeBlue":"Modrá","codeHue":"Odstín","codeSaturation":"Sytost","codeBrightness":"Jas","close":"Zavřít","duplicate":"Duplikovat","edit":"Upravit","delete":"Odstranit","editSchematic":"Upravit balík","searchSchematic":"Hledat","nameLabelSchematic":"Název","captionLabelSchematic":"Titulek","keyLabelSchematic":"Klíč","addSchematic":"Odeslat soubor","schematicsInvalidSvg":"Neplatný nebo nepodporovaný formát SVG","schematicsInvalidSvgData":"Nelze získat data souboru","schematicsInvalidType":"Nepodporovaný typ souboru: %{type}","schematicsInvalidSize":"Soubor %{file} s velikostí %{size} překračuje limit.","schematicsContextMenuReplace":"Nahradit","schematicsContextMenuDelete":"Odstranit","schematicsEmptySearchResults":"Výsledky hledání jsou prázdné.","schematicsNoSelection":"Nejsou vybrány žádné prvky.","schematicsMultipleSelection":"Počet vybraných položek: %{count}","schematicsSingleDeletionSuccessed":"Vaše schéma bylo úspěšně odstraněno.","schematicsMultipleDeletionSuccessed":"Počet úspěšně odstraněných schémat: %{count}.","schematicsSingleAddSuccessed":"Vaše schéma bylo úspěšně přidáno.","schematicsMultipleAddSuccessed":"Počet úspěšně přidaných schémat: %{count}.","schematicsAddFailed":"Neúspěšné přidání nového schématu","schematicsReplaceDlgTitle":"Potvrdit nahrazení existujícího souboru","schematicsReplaceDlgContent":"Soubor '%{sourceName}' již existuje. Chcete ho nahradit tímto novým souborem?","schematicsReplaceDlgApplyToAllFiles":"Použít na všechny soubory","schematicsPackageTab":"Balík","schematicsContentTab":"Obsah","schematicsDescriptionLabel":"Popis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Přidat soubor","schematicsDeleteIcon":"Odebrat ikonu","schematicsIconAdded":"Ikona \"%{file}\" byla úspěšně přidána.","schematicsIconRemove":"Ikona byla úspěšně odebrána.","schematicsIconDropFiles":"Přetáhněte soubor sem nebo jej odešlete","schematicsIconOr":"nebo","schematicsIconFileTypes":"Pouze soubory .jpg, .png a .svg.","schematicsIconFileSize":"Maximální velikost souboru %{size} MB.","legacySectionExtraMessage":"Varování: Starší palety pocházejí z dřívější verze před upgradem. Změny těchto palet způsobí, že se již nezobrazí v této vizualizaci.","favorite":"Oblíbené položky"},"__da":{"errorCreatingPalette":"Der er opstået en fejl i forbindelse med at gemme paletten.","paletteErrorTitle":"Paletfejl","changePaletteLabel":"Skift farvepalet","myPaletteLabel":"Tilpasset","legacyPaletteLabel":"Ældre","systemPaletteLabel":"System","publicPaletteLabel":"Global","localPaletteLabel":"Lokal","mruPaletteLabel":"Anvendt for nylig","okDialog":"OK","deleteDialogTitle":"Slet","applyDialog":"Anvend","cancelDialog":"Annullér","saveDialog":"Gem","createDialog":"Opret","deleteMessage":"Er du sikker på, at du vil slette paletten \"%{name}\"?","deleteToast":"\"%{name}\" blev slettet","favoritesLabel":"Favoritter","setAsFavorite":"Angiv som favorit","createdToastMessage":"\"%{name}\" blev oprettet.","createPalette":"Opret en tilpasset palet","colorPicker":"Farvevælger","errorNoName":"Angiv et navn på din palet","errorInsufficientColors":"Vælg mindst to farver","paletteAppliedToastMessage":"Palet \"%{name}\" er anvendt til rapporten.","createPaletteHeader":"Opret farvepalet","modifyPaletteHeader":"Redigér farvepalet","paletteNamePlaceholder":"Angiv paletnavn her","paletteName":"Paletnavn","standardPalette":"Kategorisk palet","continuousPalette":"Fortløbende palet","removeSwatch":"Fjern prøve","addSwatch":"Tilføj prøve","reversePalette":"Omvendt palet","colorGuide":"Farvevejledning","modeAutomatic":"Automatisk","modeCustom":"Tilpasset","colorModel":"Farvemodel","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Gitter","wheel":"Hjul","hexCode":"Hex-kode","colorRed":"Rød","colorGreen":"Grøn","colorBlue":"Blå","colorHue":"Hue","colorSaturation":"Mætning","colorBrightness":"Lysstyrke","colorCyan":"Turkis","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Sort","codeRed":"Rød","codeGreen":"Grøn","codeBlue":"Blå","codeHue":"Hue","codeSaturation":"Mætning","codeBrightness":"Lysstyrke","close":"Luk","duplicate":"Duplikér","edit":"Redigér","delete":"Slet","editSchematic":"Redigér pakke","searchSchematic":"Søg","nameLabelSchematic":"Navn","captionLabelSchematic":"Overskrift","keyLabelSchematic":"Nøgle","addSchematic":"Upload fil","schematicsInvalidSvg":"Ugyldig eller ikke-understøttet SVG","schematicsInvalidSvgData":"Kan ikke hente fildata","schematicsInvalidType":"Ikke-understøttet filtype: %{type}","schematicsInvalidSize":"Filen %{file}, størrelse %{size} overskrider grænsen.","schematicsContextMenuReplace":"Erstat","schematicsContextMenuDelete":"Slet","schematicsEmptySearchResults":"Søgeresultater er tom","schematicsNoSelection":"Ingen elementer valgt","schematicsMultipleSelection":"%{count} elementer valgt","schematicsSingleDeletionSuccessed":"Skemaet er slettet.","schematicsMultipleDeletionSuccessed":"%{count} skemaer blev slettet.","schematicsSingleAddSuccessed":"dit skema er tilføjet.","schematicsMultipleAddSuccessed":"%{count} skemaer blev tilføjet.","schematicsAddFailed":"Fejl under tilføjelse af dit skema","schematicsReplaceDlgTitle":"Bekræft erstatning af eksisterende file","schematicsReplaceDlgContent":"Filen '%{sourceName}' findes allerede. Vil du overskrive den med den nye fil?","schematicsReplaceDlgApplyToAllFiles":"Anvend på alle filer","schematicsPackageTab":"Pakke","schematicsContentTab":"Indhold","schematicsDescriptionLabel":"Beskrivelse","schematicsIconLabel":"Ikon","schematicsChooseFile":"Tilføj fil","schematicsDeleteIcon":"Fjern ikonen","schematicsIconAdded":"Ikonen \"%{file}\" er tilføjet.","schematicsIconRemove":"Ikonen er fjernet.","schematicsIconDropFiles":"Træk og placér fil her, eller upload","schematicsIconOr":"eller","schematicsIconFileTypes":"Kun filer af typen .jpg, .png og .svg.","schematicsIconFileSize":"%{size}MB maks. filstørrelse.","legacySectionExtraMessage":"Advarsel: Paletterne er fra en tidligere version, før du opgraderede. Ændringer af disse paletter medfører, at de ikke længere vil blive vist for denne visualisering.","favorite":"Favoritter"},"__de":{"errorCreatingPalette":"Beim Speichern der Palette ist ein Fehler aufgetreten.","paletteErrorTitle":"Palette - Fehler","changePaletteLabel":"Farbpalette ändern","myPaletteLabel":"Benutzerdefiniert","legacyPaletteLabel":"Vorgängerdiagramm","systemPaletteLabel":"System","publicPaletteLabel":"Global","localPaletteLabel":"Lokal","mruPaletteLabel":"Zuletzt verwendet","okDialog":"OK","deleteDialogTitle":"Löschen","applyDialog":"Anwenden","cancelDialog":"Abbrechen","saveDialog":"Speichern","createDialog":"Erstellen","deleteMessage":"Soll die Palette \"%{name}\" tatsächlich gelöscht werden?","deleteToast":"\"%{name}\" wurde gelöscht","favoritesLabel":"Favoriten","setAsFavorite":"Als Favorit festlegen","createdToastMessage":"\"%{name}\" wurde erfolgreich erstellt.","createPalette":"Benutzerdefinierte Palette erstellen","colorPicker":"Farbauswahl","errorNoName":"Namen für die Palette eingeben","errorInsufficientColors":"Mindestens zwei Farben auswählen","paletteAppliedToastMessage":"Die Palette \"%{name}\" wurde auf den Bericht angewendet.","createPaletteHeader":"Farbpalette erstellen","modifyPaletteHeader":"Farbpalette bearbeiten","paletteNamePlaceholder":"Palettennamen hier eingeben","paletteName":"Palettenname","standardPalette":"Kategoriale Palette","continuousPalette":"Fortlaufende Palette","removeSwatch":"Muster entfernen","addSwatch":"Muster hinzufügen","reversePalette":"Umgekehrte Palette","colorGuide":"Richtlinien für Farben","modeAutomatic":"Automatisch","modeCustom":"Benutzerdefiniert","colorModel":"Farbmodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Raster","wheel":"Rad","hexCode":"Hexadezimalcode","colorRed":"Rot","colorGreen":"Grün","colorBlue":"Blau","colorHue":"Farbton","colorSaturation":"Sättigung","colorBrightness":"Helligkeit","colorCyan":"Zyan","colorMagenta":"Magenta","colorYellow":"Gelb","colorBlack":"Schwarz","codeRed":"Rot","codeGreen":"Grün","codeBlue":"Blau","codeHue":"Farbton","codeSaturation":"Sättigung","codeBrightness":"Helligkeit","close":"Schließen","duplicate":"Duplizieren","edit":"Bearbeiten","delete":"Löschen","editSchematic":"Package bearbeiten","searchSchematic":"Suchen","nameLabelSchematic":"Name","captionLabelSchematic":"Titelzeile","keyLabelSchematic":"Schlüssel","addSchematic":"Datei hochladen","schematicsInvalidSvg":"Ungültige oder nicht unterstützte SVG","schematicsInvalidSvgData":"Abrufen der Dateidaten nicht möglich","schematicsInvalidType":"Nicht unterstützter Dateityp: %{type}","schematicsInvalidSize":"Die Größe %{size} der Datei %{file} überschreitet den Grenzwert.","schematicsContextMenuReplace":"Ersetzen","schematicsContextMenuDelete":"Löschen","schematicsEmptySearchResults":"Suchergebnisse sind leer","schematicsNoSelection":"Keine Elemente ausgewählt","schematicsMultipleSelection":"%{count} Elemente ausgewählt","schematicsSingleDeletionSuccessed":"Das Schema wurde erfolgreich gelöscht.","schematicsMultipleDeletionSuccessed":"%{count} Schemas wurden erfolgreich gelöscht.","schematicsSingleAddSuccessed":"Das Schema wurde erfolgreich hinzugefügt.","schematicsMultipleAddSuccessed":"%{count} Schemas wurden erfolgreich hinzugefügt.","schematicsAddFailed":"Hinzufügen des Schemas fehlgeschlagen.","schematicsReplaceDlgTitle":"Ersetzen vorhandener Datei bestätigen","schematicsReplaceDlgContent":"Die Datei '%{sourceName}' ist bereits vorhanden. Soll sie durch die neue Datei ersetzt werden?","schematicsReplaceDlgApplyToAllFiles":"Für alle Dateien anwenden","schematicsPackageTab":"Package","schematicsContentTab":"Inhalt","schematicsDescriptionLabel":"Beschreibung","schematicsIconLabel":"Symbol","schematicsChooseFile":"Datei hinzufügen","schematicsDeleteIcon":"Symbol entfernen","schematicsIconAdded":"Das Symbol \"%{file}\" wurde erfolgreich hinzugefügt.","schematicsIconRemove":"Das Symbol wurde erfolgreich entfernt.","schematicsIconDropFiles":"Datei hierher ziehen und ablegen oder hochladen","schematicsIconOr":"oder","schematicsIconFileTypes":"Nur .jpg-, .png- und .svg-Dateien. ","schematicsIconFileSize":"Maximale Dateigröße %{size} MB. ","legacySectionExtraMessage":"Warnung: Vorgängerpaletten stammen aus einer früheren Version vor dem Upgrade. Wenn an diesen Paletten Änderungen vorgenommen werden, werden sie für diese Visualisierung nicht mehr angezeigt. ","favorite":"Favoriten"},"__es":{"errorCreatingPalette":"Se ha producido un error al guardar la paleta.","paletteErrorTitle":"Error de paleta","changePaletteLabel":"Cambiar paleta de colores","myPaletteLabel":"Personalizado","legacyPaletteLabel":"Heredada","systemPaletteLabel":"Sistema","publicPaletteLabel":"Global","localPaletteLabel":"Local","mruPaletteLabel":"Utilizados recientemente","okDialog":"Aceptar","deleteDialogTitle":"Suprimir","applyDialog":"Aplicar","cancelDialog":"Cancelar","saveDialog":"Guardar","createDialog":"Crear","deleteMessage":"¿Está seguro de que desea suprimir la paleta \"%{name}\"?","deleteToast":"Se ha suprimido \"%{name}\"","favoritesLabel":"Favoritos","setAsFavorite":"Establecer como favorito","createdToastMessage":"Se ha creado correctamente \"%{name}\".","createPalette":"Crear una paleta personalizada","colorPicker":"Selector de color","errorNoName":"Escriba un nombre para la paleta.","errorInsufficientColors":"Seleccione al menos dos colores","paletteAppliedToastMessage":"Se ha aplicado la paleta \"%{name}\" al informe.","createPaletteHeader":"Crear paleta de colores","modifyPaletteHeader":"Editar paleta de colores","paletteNamePlaceholder":"Escriba aquí un nombre de paleta","paletteName":"Nombre de paleta","standardPalette":"Paleta de categorías","continuousPalette":"Paleta continua","removeSwatch":"Eliminar reloj","addSwatch":"Añadir reloj","reversePalette":"Invertir paleta","colorGuide":"Guía de colores","modeAutomatic":"Automático","modeCustom":"Personalizado","colorModel":"Modelo de color","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Cuadrícula","wheel":"Rueda","hexCode":"Código hexadecimal","colorRed":"Rojo","colorGreen":"Verde","colorBlue":"Azul","colorHue":"Tono","colorSaturation":"Saturación","colorBrightness":"Luminosidad","colorCyan":"Cian","colorMagenta":"Magenta","colorYellow":"Amarillo","colorBlack":"Negro","codeRed":"Rojo","codeGreen":"Verde","codeBlue":"Azul","codeHue":"Tono","codeSaturation":"Saturación","codeBrightness":"Luminosidad","close":"Cerrar","duplicate":"Duplicar","edit":"Editar","delete":"Suprimir","editSchematic":"Editar paquete","searchSchematic":"Buscar","nameLabelSchematic":"Nombre","captionLabelSchematic":"Título","keyLabelSchematic":"Clave","addSchematic":"Cargar archivo","schematicsInvalidSvg":"SVG no válido o no soportado","schematicsInvalidSvgData":"No se han podido obtener los datos del archivo:","schematicsInvalidType":"Tipo de archivo no soportado: %{type}","schematicsInvalidSize":"El archivo %{file}, tamaño %{size} supera el límite.","schematicsContextMenuReplace":"Sustituir","schematicsContextMenuDelete":"Suprimir","schematicsEmptySearchResults":"El resultado de la búsqueda está vacío","schematicsNoSelection":"No se ha seleccionado ningún elemento","schematicsMultipleSelection":"%{count} elementos seleccionados","schematicsSingleDeletionSuccessed":"Su esquemático se ha suprimido correctamente.","schematicsMultipleDeletionSuccessed":"Se han suprimido %{count} esquemáticos correctamente.","schematicsSingleAddSuccessed":"Su esquemático se ha añadido correctamente.","schematicsMultipleAddSuccessed":"Se han añadido %{count} esquemáticos correctamente.","schematicsAddFailed":"Error al añadir su esquemático.","schematicsReplaceDlgTitle":"Confirmar sustitución del archivo existente","schematicsReplaceDlgContent":"El archivo '%{sourceName}' ya existe. ¿Desea reemplazarlo por este nuevo archivo?","schematicsReplaceDlgApplyToAllFiles":"Aplicar a todos los filtros","schematicsPackageTab":"Paquete","schematicsContentTab":"Contenido","schematicsDescriptionLabel":"Descripción","schematicsIconLabel":"Icono","schematicsChooseFile":"Añadir archivo","schematicsDeleteIcon":"Suprimir el icono","schematicsIconAdded":"El icono \"%{file}\" se ha añadido correctamente.","schematicsIconRemove":"El icono se ha eliminado correctamente.","schematicsIconDropFiles":"Arrastre y suelte o cargue el archivo aquí","schematicsIconOr":"o bien","schematicsIconFileTypes":"Solo archivos .jpg, .png y .svg.","schematicsIconFileSize":"%{size}MB de tamaño máximo de archivo. ","legacySectionExtraMessage":"Aviso: Las paletas de herencia pertenecen a una versión anterior a la actualización. Los cambios realizados en estas paletas harán que ya no se muestren en esta visualización. ","favorite":"Favoritos"},"__fi":{"errorCreatingPalette":"Virhe tallennettaessa palettia.","paletteErrorTitle":"Palettivirhe","changePaletteLabel":"Vaihda väripaletti","myPaletteLabel":"Mukautettu","legacyPaletteLabel":"Vanha","systemPaletteLabel":"Järjestelmä","publicPaletteLabel":"Yleiset","localPaletteLabel":"Paikallinen","mruPaletteLabel":"Viimeksi käytetyt","okDialog":"OK","deleteDialogTitle":"Poista","applyDialog":"Käytä","cancelDialog":"Peruuta","saveDialog":"Tallenna","createDialog":"Luo","deleteMessage":"Haluatko varmasti poistaa paletin %{name}?","deleteToast":"%{name} on poistettu","favoritesLabel":"Suosikit","setAsFavorite":"Aseta suosikiksi","createdToastMessage":"%{name} on luotu.","createPalette":"Luo mukautettu paletti","colorPicker":"Värinvalitsin","errorNoName":"Anna paletille nimi:","errorInsufficientColors":"Valitse vähintään kaksi väriä","paletteAppliedToastMessage":"Raporttiin on käytetty palettia %{name}.","createPaletteHeader":"Luo väripaletti","modifyPaletteHeader":"Muokkaa väripalettia","paletteNamePlaceholder":"Kirjoita paletin nimi tähän","paletteName":"Paletin nimi","standardPalette":"Kategorinen paletti","continuousPalette":"Yhtenäinen paletti","removeSwatch":"Poista värivalikoima","addSwatch":"Lisää värivalikoima","reversePalette":"Käänteinen paletti","colorGuide":"Väriopas","modeAutomatic":"Automaattinen","modeCustom":"Mukautettu","colorModel":"Värimalli","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Ruudukko","wheel":"Pyörä","hexCode":"Heksadesimaalikoodi","colorRed":"Punainen","colorGreen":"Vihreä","colorBlue":"Sininen","colorHue":"Sävy","colorSaturation":"Kylläisyys","colorBrightness":"Kirkkaus","colorCyan":"Syaani","colorMagenta":"Magenta","colorYellow":"Keltainen","colorBlack":"Musta","codeRed":"Punainen","codeGreen":"Vihreä","codeBlue":"Sininen","codeHue":"Sävy","codeSaturation":"Kylläisyys","codeBrightness":"Kirkkaus","close":"Sulje","duplicate":"Kaksoiskappale","edit":"Muokkaa","delete":"Poista","editSchematic":"Muokkaa pakettia","searchSchematic":"Hae","nameLabelSchematic":"Nimi","captionLabelSchematic":"Kuvateksti","keyLabelSchematic":"Avain","addSchematic":"Siirrä tiedosto palvelimeen","schematicsInvalidSvg":"SVG on virheellinen tai sitä ei tueta","schematicsInvalidSvgData":"Tiedostotietojen nouto ei onnistunut","schematicsInvalidType":"Tiedoston laji ei ole tuettu: %{type}","schematicsInvalidSize":"Tiedoston %{file} koko %{size} ylittää enimmäiskoon.","schematicsContextMenuReplace":"Korvaa","schematicsContextMenuDelete":"Poista","schematicsEmptySearchResults":"Hakutulos on tyhjä","schematicsNoSelection":"Kohteita ei ole valittu","schematicsMultipleSelection":"%{count} kohdetta on valittu","schematicsSingleDeletionSuccessed":"Skematiikka on poistettu.","schematicsMultipleDeletionSuccessed":"%{count} skematiikkaa on poistettu.","schematicsSingleAddSuccessed":"Skematiikka on lisätty.","schematicsMultipleAddSuccessed":"%{count} skematiikkaa on lisätty.","schematicsAddFailed":"Skematiikan lisäys epäonnistui.","schematicsReplaceDlgTitle":"Vahvista aiemmin luodun tiedoston korvaus","schematicsReplaceDlgContent":"Järjestelmässä on jo tiedosto %{sourceName}. Haluatko korvata sen uudella tiedostolla?","schematicsReplaceDlgApplyToAllFiles":"Käytä kaikissa tiedostoissa","schematicsPackageTab":"Paketti","schematicsContentTab":"Sisältö","schematicsDescriptionLabel":"Kuvaus","schematicsIconLabel":"Kuvake","schematicsChooseFile":"Lisää tiedosto","schematicsDeleteIcon":"Poista kuvake","schematicsIconAdded":"Kuvake %{file} on lisätty.","schematicsIconRemove":"Kuvake on poistettu.","schematicsIconDropFiles":"Vedä ja pudota tiedosto tähän tai siirrä se","schematicsIconOr":"tai","schematicsIconFileTypes":"Vain .jpg-, .png- ja .svg-tiedostoja.","schematicsIconFileSize":"Tiedoston enimmäiskoko %{size} Mt.","legacySectionExtraMessage":"Varoitus: Vanhat paletit ovat peräisin päivitystä edeltävästä aiemmasta versiosta. Jos näihin paletteihin tehdään muutoksia, ne eivät enää tule näkyviin tätä visualisointia varten.","favorite":"Suosikit"},"__fr":{"errorCreatingPalette":"Une erreur est survenue lors de la sauvegarde de la palette.","paletteErrorTitle":"Erreur liée à la palette","changePaletteLabel":"Modifier la palette de couleurs","myPaletteLabel":"Personnalisé","legacyPaletteLabel":"Existant","systemPaletteLabel":"Système","publicPaletteLabel":"Global","localPaletteLabel":"Local","mruPaletteLabel":"Utilisée récemment","okDialog":"OK","deleteDialogTitle":"Supprimer","applyDialog":"Appliquer","cancelDialog":"Annuler","saveDialog":"Enregistrer","createDialog":"Créer","deleteMessage":"Voulez-vous vraiment supprimer la palette \"%{name}\" ?","deleteToast":"\"%{name}\" a été supprimée","favoritesLabel":"Favoris","setAsFavorite":"Définir en tant que favori","createdToastMessage":"\"%{name}\" a été créé(e) avec succès.","createPalette":"Créer une palette personnalisée","colorPicker":"Sélecteur de couleur","errorNoName":"Entrez un nom pour votre palette","errorInsufficientColors":"Choisissez au moins deux couleurs","paletteAppliedToastMessage":"La palette \"%{name}\" a été appliquée au rapport.","createPaletteHeader":"Créer une palette de couleurs","modifyPaletteHeader":"Editer la palette de couleurs","paletteNamePlaceholder":"Entrez le nom de la palette ici","paletteName":"Nom de la palette","standardPalette":"Palette catégorielle","continuousPalette":"Palette continue","removeSwatch":"Supprimer l'échantillon témoin","addSwatch":"Ajouter un échantillon témoin","reversePalette":"Annuler la palette","colorGuide":"Guide de couleur","modeAutomatic":"Automatique","modeCustom":"Personnalisé","colorModel":"Modèle de couleur","modelRGB":"RVB","modelHSB":"TSI","modelCMYK":"CMJK","grid":"Grille","wheel":"Roue","hexCode":"Code hexadécimal","colorRed":"Rouge","colorGreen":"Vert","colorBlue":"Bleu","colorHue":"Teinte","colorSaturation":"Saturation","colorBrightness":"Intensité","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Jaune","colorBlack":"Noir","codeRed":"Rouge","codeGreen":"Vert","codeBlue":"Bleu","codeHue":"Teinte","codeSaturation":"Saturation","codeBrightness":"Intensité","close":"Fermer","duplicate":"Dupliquer","edit":"Editer","delete":"Supprimer","editSchematic":"Editer le pack","searchSchematic":"Rechercher","nameLabelSchematic":"Nom","captionLabelSchematic":"Légende","keyLabelSchematic":"Clé","addSchematic":"Transférer le fichier","schematicsInvalidSvg":"Fichier SVG non valide ou non pris en charge","schematicsInvalidSvgData":"Impossible d'obtenir les données du fichier","schematicsInvalidType":"Type de fichier non pris en charge : %{type}","schematicsInvalidSize":"La taille %{size} du fichier %{file} dépasse la limite admise.","schematicsContextMenuReplace":"Remplacer","schematicsContextMenuDelete":"Supprimer","schematicsEmptySearchResults":"Les résultats de la recherche sont vides","schematicsNoSelection":"Aucun élément sélectionné","schematicsMultipleSelection":"%{count} éléments sélectionnés","schematicsSingleDeletionSuccessed":"Votre schéma a été supprimé.","schematicsMultipleDeletionSuccessed":"%{count} schémas ont été supprimés.","schematicsSingleAddSuccessed":"Votre schéma a été ajouté.","schematicsMultipleAddSuccessed":"%{count} schémas ont été ajoutés.","schematicsAddFailed":"Echec de l'ajout de votre schéma.","schematicsReplaceDlgTitle":"Confirmer le remplacement du fichier existant","schematicsReplaceDlgContent":"Le fichier '%{sourceName}' existe déjà. Voulez-vous le remplacer par le nouveau fichier ?","schematicsReplaceDlgApplyToAllFiles":"Appliquer à tous les fichiers","schematicsPackageTab":"Pack","schematicsContentTab":"Contenu","schematicsDescriptionLabel":"Description","schematicsIconLabel":"Icône","schematicsChooseFile":"Ajouter un fichier","schematicsDeleteIcon":"Retirer l'icône","schematicsIconAdded":"L'icône \"%{file}\" a été ajoutée.","schematicsIconRemove":"L'icône a été retirée.","schematicsIconDropFiles":"Transférez ou glissez-déposez le fichier ici","schematicsIconOr":"ou","schematicsIconFileTypes":"Uniquement les fichiers .jpg, .png et .svg.","schematicsIconFileSize":"Taille maximale du fichier : %{size} Mo.","legacySectionExtraMessage":"Avertissement : les palettes existantes proviennent d'une version antérieure à la mise à niveau. Si vous modifiez ces palettes, elles n'apparaîtront plus pour cette visualisation.","favorite":"Favoris"},"__hr":{"errorCreatingPalette":"Pojavila se greška tijekom spremanja ove palete.","paletteErrorTitle":"Greška palete","changePaletteLabel":"Promijeni paletu boja","myPaletteLabel":"Prilagođeno","legacyPaletteLabel":"Naslijeđeno","systemPaletteLabel":"Sistem","publicPaletteLabel":"Globalno","localPaletteLabel":"Lokalno","mruPaletteLabel":"Nedavno korišteno","okDialog":"OK","deleteDialogTitle":"Izbriši","applyDialog":"Primijeni","cancelDialog":"Opoziv","saveDialog":"Spremi","createDialog":"Kreiraj","deleteMessage":"Jeste li sigurni da želite izbrisati paletu \"%{name}\"?","deleteToast":"\"%{name}\" je izbrisana","favoritesLabel":"Favoriti","setAsFavorite":"Postavi za favorit","createdToastMessage":"\"%{name}\" je uspješno kreirana.","createPalette":"Kreiraj prilagođenu paletu","colorPicker":"Izbornik boja","errorNoName":"Unesite naziv vaše palete","errorInsufficientColors":"Izaberi barem dvije boje","paletteAppliedToastMessage":"Paleta \"%{name}\" je primijenjena na izvještaj.","createPaletteHeader":"Kreiraj paletu boja","modifyPaletteHeader":"Uredi paletu boja","paletteNamePlaceholder":"Ovdje upišite naziv palete","paletteName":"Naziv palete","standardPalette":"Kategorijska paleta","continuousPalette":"Kontinuirana paleta","removeSwatch":"Ukloni uzorak","addSwatch":"Dodaj uzorak","reversePalette":"Obrni paletu","colorGuide":"Vodič za boje","modeAutomatic":"Automatski","modeCustom":"Prilagođeno","colorModel":"Model boje","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Mreža","wheel":"Kotač","hexCode":"Heksadecimalan kod","colorRed":"Crvena","colorGreen":"Zelena","colorBlue":"Plava","colorHue":"Nijansa","colorSaturation":"Zasićenost","colorBrightness":"Svjetlost","colorCyan":"Cijan","colorMagenta":"Grimizna","colorYellow":"Žuta","colorBlack":"Crna","codeRed":"Crvena","codeGreen":"Zelena","codeBlue":"Plava","codeHue":"Nijansa","codeSaturation":"Zasićenost","codeBrightness":"Svjetlost","close":"Zatvori","duplicate":"Dupliciraj","edit":"Uredi","delete":"Izbriši","editSchematic":"Uredi paket","searchSchematic":"Traži","nameLabelSchematic":"Naziv","captionLabelSchematic":"Zaglavlje","keyLabelSchematic":"Ključ","addSchematic":"Upload datoteke","schematicsInvalidSvg":"Pogrešan ili nepodržani SVG","schematicsInvalidSvgData":"Nisu se mogli dobiti podaci datoteke","schematicsInvalidType":"Nepodržani tip datoteke: %{type}","schematicsInvalidSize":"Datoteka %{file}, veličina %{size} premašuje ograničenje.","schematicsContextMenuReplace":"Zamijeni","schematicsContextMenuDelete":"Izbriši","schematicsEmptySearchResults":"Rezultati pretraživanja su prazni","schematicsNoSelection":"Nema izabranih stavki","schematicsMultipleSelection":"%{count} stavki je izabrano","schematicsSingleDeletionSuccessed":"Vaša shema je uspješno izbrisana.","schematicsMultipleDeletionSuccessed":"%{count} shema je uspješno izbrisano.","schematicsSingleAddSuccessed":"Vaša shema je uspješno dodana.","schematicsMultipleAddSuccessed":"%{count} shema je uspješno dodano.","schematicsAddFailed":"Neuspješno dodavanje sheme.","schematicsReplaceDlgTitle":"Potvrdite zamjenu postojeće datoteke","schematicsReplaceDlgContent":"Datoteka '%{sourceName}' već postoji. Želite li ju zamijeniti s novom datotekom?","schematicsReplaceDlgApplyToAllFiles":"Primijeni na sve datoteke","schematicsPackageTab":"Paket","schematicsContentTab":"Sadržaj","schematicsDescriptionLabel":"Opis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Dodaj datoteku","schematicsDeleteIcon":"Ukloni ikonu","schematicsIconAdded":"Ikona \"%{file}\" je uspješno dodana.","schematicsIconRemove":"Ikona je uspješno uklonjena.","schematicsIconDropFiles":"povucite i ispustite datoteke ovdje ili ih uploadajte","schematicsIconOr":"ili","schematicsIconFileTypes":"Samo .jpg, .png i .svg datoteke","schematicsIconFileSize":"%{size}MB je maksimalna veličina datoteke.","legacySectionExtraMessage":"Upozorenje: Naslijeđene palete su iz ranije verzije prije nadogradnje. Promjene na ovim paletama uzrokovat će da se više ne pojavljuju kod ove vizualizacije.","favorite":"Favoriti"},"__hu":{"errorCreatingPalette":"Hiba történt a paletta mentése közben.","paletteErrorTitle":"Paletta hiba","changePaletteLabel":"Színpaletta módosítása","myPaletteLabel":"Egyéni","legacyPaletteLabel":"Örökölt","systemPaletteLabel":"Rendszer","publicPaletteLabel":"Globális","localPaletteLabel":"Helyi","mruPaletteLabel":"Nemrégiben használt","okDialog":"OK","deleteDialogTitle":"Törlés","applyDialog":"Alkalmaz","cancelDialog":"Mégse","saveDialog":"Mentés","createDialog":"Létrehozás","deleteMessage":"Valóban törölni kívánja a(z) \"%{name}\" palettát?","deleteToast":"A(z) \"%{name}\" törlésre került","favoritesLabel":"Kedvencek","setAsFavorite":"Beállítás kedvencként","createdToastMessage":"A(z) \"%{name}\" sikeresen létrehozásra került","createPalette":"Egyéni paletta létrehozása","colorPicker":"Színválasztó","errorNoName":"Adja meg a paletta nevét","errorInsufficientColors":"Válasszon legalább két színt","paletteAppliedToastMessage":"A(z) \"%{name}\" paletta került alkalmazásra a jelentéshez.","createPaletteHeader":"Színpaletta létrehozása","modifyPaletteHeader":"Színpaletta szerkesztése","paletteNamePlaceholder":"Itt adja meg a paletta nevét","paletteName":"Paletta neve","standardPalette":"Kategorikus paletta","continuousPalette":"Folytonos paletta","removeSwatch":"Minta eltávolítása","addSwatch":"Minta hozzáadása","reversePalette":"Fordított paletta","colorGuide":"Szín útmutató","modeAutomatic":"Automatikus","modeCustom":"Egyéni","colorModel":"Színmodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rács","wheel":"Kerék","hexCode":"Hexa kód","colorRed":"Piros","colorGreen":"Zöld","colorBlue":"Kék","colorHue":"Árnyalat","colorSaturation":"Telítettség","colorBrightness":"Fényerő","colorCyan":"Cián","colorMagenta":"Bíbor","colorYellow":"Sárga","colorBlack":"Fekete","codeRed":"Piros","codeGreen":"Zöld","codeBlue":"Kék","codeHue":"Árnyalat","codeSaturation":"Telítettség","codeBrightness":"Fényerő","close":"Bezárás","duplicate":"Többszörözés","edit":"Szerkesztés","delete":"Törlés","editSchematic":"Csomagok szerkesztése","searchSchematic":"Keresés","nameLabelSchematic":"Név","captionLabelSchematic":"Felirat","keyLabelSchematic":"Kulcs","addSchematic":"Fájl feltöltése","schematicsInvalidSvg":"Érvénytelen vagy nem támogatott SVG","schematicsInvalidSvgData":"A fájl adatait nem lehet lekérdezni","schematicsInvalidType":"Nem támogatott fájltípus: %{type}","schematicsInvalidSize":"A(z) %{file} fájl %{size} mérete meghaladja a korlátot.","schematicsContextMenuReplace":"Csere","schematicsContextMenuDelete":"Törlés","schematicsEmptySearchResults":"A keresési eredmény üres","schematicsNoSelection":"Nincs kijelölt elem","schematicsMultipleSelection":"%{count} elem kijelölve","schematicsSingleDeletionSuccessed":"Tervrajza sikeresen törlésre került.","schematicsMultipleDeletionSuccessed":"%{count} tervrajz sikeresen törlésre került.","schematicsSingleAddSuccessed":"Tervrajza sikeresen hozzáadásra került.","schematicsMultipleAddSuccessed":"%{count} tervrajz sikeresen hozzáadásra került.","schematicsAddFailed":"A tervrajz hozzáadása nem sikerült.","schematicsReplaceDlgTitle":"A meglévő fájl cseréjének jóváhagyása","schematicsReplaceDlgContent":"A(z) '%{sourceName}' fájl már létezik. Kívánja felülírni az új fájllal?","schematicsReplaceDlgApplyToAllFiles":"Minden fájlra vonatkozik","schematicsPackageTab":"Csomag","schematicsContentTab":"Tartalom","schematicsDescriptionLabel":"Leírás","schematicsIconLabel":"Ikon","schematicsChooseFile":"Fájl hozzáadása","schematicsDeleteIcon":"Az ikon eltávolítása","schematicsIconAdded":"A(z) \"%{file}\" ikon sikeresen hozzáadásra került.","schematicsIconRemove":"Az ikon sikeresen eltávolításra került.","schematicsIconDropFiles":"Húzza ide a fájlt vagy töltse fel","schematicsIconOr":"vagy","schematicsIconFileTypes":"Csak .jpg, .png és .svg fájlok.","schematicsIconFileSize":"%{size}MB maximális fájlméret.","legacySectionExtraMessage":"Figyelem: Az örökölt paletták egy frissítés előtti korábbi változatból származnak. Ha a palettákat módosítja, akkor azok többé nem jelennek meg az adott megjelenítésben. ","favorite":"Kedvencek"},"__it":{"errorCreatingPalette":"Si è verificato un errore durante il salvataggio della tavolozza.","paletteErrorTitle":"Errore della tavolozza","changePaletteLabel":"Modifica tavolozza colori","myPaletteLabel":"Personalizzato","legacyPaletteLabel":"Legacy","systemPaletteLabel":"Sistema","publicPaletteLabel":"Globale","localPaletteLabel":"Locale","mruPaletteLabel":"Utilizzato di recente","okDialog":"OK","deleteDialogTitle":"Elimina","applyDialog":"Applica","cancelDialog":"Annulla","saveDialog":"Salva","createDialog":"Crea","deleteMessage":"Si è sicuri di voler eliminare la tavolozza \"%{name}\"?","deleteToast":"\"%{name}\" è stato eliminato","favoritesLabel":"Preferiti","setAsFavorite":"Imposta come Preferiti","createdToastMessage":"\"%{name}\" creato correttamente.","createPalette":"Creazione di una tavolozza personalizzata","colorPicker":"Selettore colori","errorNoName":"Immettere un nome per la tavolozza","errorInsufficientColors":"Scegli almeno due colori","paletteAppliedToastMessage":"La tavolozza  \"%{name}\", è stata applicata al report.","createPaletteHeader":"Crea tavolozza colori","modifyPaletteHeader":"Modifica tavolozza colori","paletteNamePlaceholder":"Immetti qui il nome tavolozza","paletteName":"Nome tavolozza","standardPalette":"Tavolozza categoriale","continuousPalette":"Tavolozza continua","removeSwatch":"Rimuovi campionario","addSwatch":"Aggiungi campionario","reversePalette":"Inverti tavolozza","colorGuide":"Guida a colori","modeAutomatic":"Automatico","modeCustom":"Personalizzato","colorModel":"Modello di colore","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Griglia","wheel":"Cerchio","hexCode":"Codice esadecimale","colorRed":"Rosso","colorGreen":"Verde","colorBlue":"Blu","colorHue":"Tonalità","colorSaturation":"Saturazione","colorBrightness":"Brillantezza","colorCyan":"Ciano","colorMagenta":"Magenta","colorYellow":"Giallo","colorBlack":"Nero","codeRed":"Rosso","codeGreen":"Verde","codeBlue":"Blu","codeHue":"Tonalità","codeSaturation":"Saturazione","codeBrightness":"Brillantezza","close":"Chiudi","duplicate":"Duplica","edit":"Modifica","delete":"Elimina","editSchematic":"Modifica package","searchSchematic":"Ricerca","nameLabelSchematic":"Nome","captionLabelSchematic":"Didascalia","keyLabelSchematic":"Chiave","addSchematic":"Carica file","schematicsInvalidSvg":"SVG non valido o non supportato","schematicsInvalidSvgData":"Impossibile ottenere i dati del file","schematicsInvalidType":"Tipo file non supportato: %{type}","schematicsInvalidSize":"File %{file}, dimensione %{size} supera il limite.","schematicsContextMenuReplace":"Sostituisci","schematicsContextMenuDelete":"Elimina","schematicsEmptySearchResults":"I risultati della ricerca sono vuoti.","schematicsNoSelection":"Nessun elemento selezionato","schematicsMultipleSelection":"%{count} elementi selezionato","schematicsSingleDeletionSuccessed":"La schematica è stata correttamente eliminata.","schematicsMultipleDeletionSuccessed":"%{count} schematiche sono state correttamente eliminate.","schematicsSingleAddSuccessed":"Le schematiche sono state correttamente aggiunte.","schematicsMultipleAddSuccessed":"%{count} schematiche sono state correttamente aggiunte.","schematicsAddFailed":"Aggiunta schematica non riuscita.","schematicsReplaceDlgTitle":"Conferma sostituzione del file esistente","schematicsReplaceDlgContent":"Il file '%{sourceName}' esiste già. Si desidera sostituirlo con il nuovo file?","schematicsReplaceDlgApplyToAllFiles":"Applica a tutti i file","schematicsPackageTab":"Package","schematicsContentTab":"Contenuto","schematicsDescriptionLabel":"Descrizione","schematicsIconLabel":"Icona","schematicsChooseFile":"Aggiungi file","schematicsDeleteIcon":"Rimuovi l'icona","schematicsIconAdded":"L'icona \"%{file}\" è stata correttamente aggiunta.","schematicsIconRemove":"L'icona è stata correttamente rimossa.","schematicsIconDropFiles":"Trascinare e rilasciare il file qui o caricare","schematicsIconOr":"o ","schematicsIconFileTypes":"Solo file .jpg, .png e .svg ","schematicsIconFileSize":"Dimensione file massima %{size} MB ","legacySectionExtraMessage":"Avvertenza: le tavolozze legacy provengono da una versione precedente prima dell'aggiornamento. Modificando queste tavolozze, non saranno più visualizzate per questa visualizzazione. ","favorite":"Preferiti"},"__ja":{"errorCreatingPalette":"パレットの保存中にエラーが発生しました。","paletteErrorTitle":"パレット・エラー","changePaletteLabel":"カラー・パレットの変更","myPaletteLabel":"カスタム","legacyPaletteLabel":"レガシー","systemPaletteLabel":"システム","publicPaletteLabel":"グローバル","localPaletteLabel":"ローカル","mruPaletteLabel":"最近使用された","okDialog":"OK","deleteDialogTitle":"削除","applyDialog":"適用","cancelDialog":"キャンセル","saveDialog":"保存","createDialog":"作成","deleteMessage":"パレット \"%{name}\" を削除しますか?","deleteToast":"\"%{name}\" が削除されました","favoritesLabel":"お気に入り","setAsFavorite":"お気に入りとして設定","createdToastMessage":"\"%{name}\" が正常に作成されました。","createPalette":"カスタム・パレットの作成","colorPicker":"カラー・ピッカー","errorNoName":"パレットの名前を入力してください","errorInsufficientColors":"少なくとも 2 つの色を選択してください","paletteAppliedToastMessage":"パレット \"%{name}\" がレポートに適用されました。","createPaletteHeader":"カラー・パレットの作成","modifyPaletteHeader":"カラー・パレットの編集","paletteNamePlaceholder":"ここにパレット名を入力","paletteName":"パレット名","standardPalette":"カテゴリー型パレット","continuousPalette":"連続型パレット","removeSwatch":"スウォッチを削除","addSwatch":"スウォッチを追加","reversePalette":"パレットを反転","colorGuide":"カラー・ガイド","modeAutomatic":"自動","modeCustom":"カスタム","colorModel":"カラー型","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"グリッド","wheel":"ホイール","hexCode":"16 進コード","colorRed":"赤","colorGreen":"緑","colorBlue":"青","colorHue":"色調","colorSaturation":"彩度","colorBrightness":"輝度","colorCyan":"シアン","colorMagenta":"マゼンタ","colorYellow":"黄","colorBlack":"黒","codeRed":"赤","codeGreen":"緑","codeBlue":"青","codeHue":"色調","codeSaturation":"彩度","codeBrightness":"輝度","close":"閉じる","duplicate":"複製","edit":"編集","delete":"削除","editSchematic":"パッケージの編集","searchSchematic":"検索","nameLabelSchematic":"名前","captionLabelSchematic":"キャプション","keyLabelSchematic":"キー","addSchematic":"ファイルのアップロード","schematicsInvalidSvg":"正しくない、またはサポートされていない SVG です","schematicsInvalidSvgData":"ファイル・データを取得できませんでした","schematicsInvalidType":"サポートされないファイル・タイプ: %{type}","schematicsInvalidSize":"ファイル %{file}、サイズ %{size} が制限を超えています。","schematicsContextMenuReplace":"置換","schematicsContextMenuDelete":"削除","schematicsEmptySearchResults":"検索結果が空です","schematicsNoSelection":"アイテムが選択されていません","schematicsMultipleSelection":"%{count} 個のアイテムを選択","schematicsSingleDeletionSuccessed":"図式が正常に削除されました。","schematicsMultipleDeletionSuccessed":"%{count} 個の図式が正常に削除されました。","schematicsSingleAddSuccessed":"図式が正常に追加されました。","schematicsMultipleAddSuccessed":"%{count} 個の図式が正常に追加されました。","schematicsAddFailed":"図式を追加できませんでした。","schematicsReplaceDlgTitle":"既存ファイルの置換の確認","schematicsReplaceDlgContent":"ファイル '%{sourceName}' は既に存在しています。 新しいファイルに置き換えますか?","schematicsReplaceDlgApplyToAllFiles":"すべてのファイルに適用","schematicsPackageTab":"パッケージ","schematicsContentTab":"コンテンツ","schematicsDescriptionLabel":"説明","schematicsIconLabel":"アイコン","schematicsChooseFile":"ファイルの追加","schematicsDeleteIcon":"アイコンの削除","schematicsIconAdded":"アイコン \"%{file}\" が正常に追加されました。","schematicsIconRemove":"アイコンが正常に削除されました。","schematicsIconDropFiles":"ファイルをここにドラッグ・アンド・ドロップするかアップロードしてください","schematicsIconOr":"または","schematicsIconFileTypes":".jpg、.png、および .svg ファイルのみ。","schematicsIconFileSize":"ファイル・サイズは最大 %{size}MB。","legacySectionExtraMessage":"警告: レガシー・パレットは、アップグレードする前のバージョンのものです。これらのパレットに変更を加えると、この視覚化には表示されなくなります。","favorite":"お気に入り"},"__kk":{"errorCreatingPalette":"Бояғышты сақтау кезінде қате пайда болды.","paletteErrorTitle":"Бояғыш қатесі","changePaletteLabel":"Түсті бояғыштарды өзгерту","myPaletteLabel":"Теңшелім","legacyPaletteLabel":"Бұрынғы","systemPaletteLabel":"Жүйе","publicPaletteLabel":"Глобалдық","localPaletteLabel":"Жергілікті","mruPaletteLabel":"Жақында қолданылған","okDialog":"OK","deleteDialogTitle":"Жою","applyDialog":"Қолдану","cancelDialog":"Болдырмау","saveDialog":"Сақтау","createDialog":"Жасау","deleteMessage":"\"%{name}\" бояғышын жойғыңыз келетініне сенімдісіз бе?","deleteToast":"\"%{name}\" жойылған","favoritesLabel":"Таңдаулылар","setAsFavorite":"Таңдаулы ретінде орнату","createdToastMessage":"\"%{name}\"  сәтті жасалды.","createPalette":"Пайдаланушы бояғышты жасау","colorPicker":"Түс таңдағыш","errorNoName":"Бояғыштың атын енгізіңіз","errorInsufficientColors":"Кемінде екі түсті таңдаңыз","paletteAppliedToastMessage":"Есепке \"%{name}\" бояғышы қолданылды.","createPaletteHeader":"Түстер бояғышын жасаңыз","modifyPaletteHeader":"Түстер бояғышын өңдеу","paletteNamePlaceholder":"Бояғыштың атауын мына жерде теріңіз","paletteName":"Бояғыш атауы","standardPalette":"Категориялы бояғыш","continuousPalette":"Үздіксіз бояғыш","removeSwatch":"Таңбаны алып тастау","addSwatch":"Таңба қосу","reversePalette":"Кері бояғышы","colorGuide":"Түс бағыттаушы","modeAutomatic":"Автоматты","modeCustom":"Теңшелім","colorModel":"Түс үлгісі","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Жоғарғы","wheel":"Шеңбері","hexCode":"Hex код","colorRed":"Қызыл","colorGreen":"Жасыл","colorBlue":"Көк","colorHue":"Реңк","colorSaturation":"Қанықтық","colorBrightness":"Жарықтық","colorCyan":"Көкшіл","colorMagenta":"Күлгін","colorYellow":"Сары","colorBlack":"Қара","codeRed":"Қызыл","codeGreen":"Жасыл","codeBlue":"Көк","codeHue":"Реңк","codeSaturation":"Қанықтық","codeBrightness":"Жарықтық","close":"Жабу","duplicate":"Көшірмелеу","edit":"Өңдеу","delete":"Жою","editSchematic":"Буманы өңдеу","searchSchematic":"Іздеу","nameLabelSchematic":"Аты","captionLabelSchematic":"Тақырып","keyLabelSchematic":"Кілт","addSchematic":"Файлды жүктеп алу","schematicsInvalidSvg":"Жарамсыз немесе қолдау көрсетілмейтін SVG","schematicsInvalidSvgData":"Файл деректерін алу мүмкін болмады","schematicsInvalidType":"Қолдау көрсетілмейтін файл түрі: %{type}","schematicsInvalidSize":"%{file} файлы, %{size} мөлшері шектен асады.","schematicsContextMenuReplace":"Ауыстыру","schematicsContextMenuDelete":"Жою","schematicsEmptySearchResults":"Іздеу нәтижелері бос","schematicsNoSelection":"Ешбір элемент таңдалмады","schematicsMultipleSelection":"%{count} элемент таңдалды","schematicsSingleDeletionSuccessed":"Сіздің схемаңыз сәтті жойылды.","schematicsMultipleDeletionSuccessed":"%{count} схемасы сәтті жойылды.","schematicsSingleAddSuccessed":"Сіздің схемаңыз сәтті қосылды.","schematicsMultipleAddSuccessed":"%{count} схемасы сәтті қосылды.","schematicsAddFailed":"Схемаңызды қосу сәтсіз аяқталды.","schematicsReplaceDlgTitle":"Бар файлды ауыстыруды растаңыз","schematicsReplaceDlgContent":"'%{sourceName}' файлы бұрыннан бар. Оны жаңа файлмен алмастырғыңыз келе ме?","schematicsReplaceDlgApplyToAllFiles":"Барлық файлдарға қолданыңыз","schematicsPackageTab":"Бума","schematicsContentTab":"Мазмұн","schematicsDescriptionLabel":"Сипаттама","schematicsIconLabel":"Белгіше","schematicsChooseFile":"Файлды қосу","schematicsDeleteIcon":"Белгішені жоюңыз","schematicsIconAdded":"\"%{file}\" белгішесі сәтті қосылды.","schematicsIconRemove":"Белгіше сәтті алынып тасталды.","schematicsIconDropFiles":"Файлды сүйреп апарыңыз немесе жүктеңіз","schematicsIconOr":"or","schematicsIconFileTypes":"Тек .jpg, .png және .svg файлдары.","schematicsIconFileSize":"%{size} МБ максималды файл өлшемі.","legacySectionExtraMessage":"Ескерту: бұрынғы палитралар сіз жаңартқанға дейінгі алдыңғы нұсқадан алынған. Бұл палитраларға енгізілген өзгертулер олардың көрнекілендіру үшін пайда болмауына әкеледі.","favorite":"Таңдаулылар"},"__ko":{"errorCreatingPalette":"색상표를 저장하는 중에 오류가 발생했습니다.","paletteErrorTitle":"색상표 오류","changePaletteLabel":"색상표 변경","myPaletteLabel":"사용자 정의","legacyPaletteLabel":"레거시","systemPaletteLabel":"시스템","publicPaletteLabel":"글로벌","localPaletteLabel":"로컬","mruPaletteLabel":"최근 사용됨","okDialog":"확인","deleteDialogTitle":"삭제","applyDialog":"적용","cancelDialog":"취소","saveDialog":"저장","createDialog":"작성","deleteMessage":"\"%{name}\" 색상표를 삭제하시겠습니까?","deleteToast":"\"%{name}\"이(가) 삭제됨","favoritesLabel":"즐겨찾기","setAsFavorite":"즐겨찾기로 설정","createdToastMessage":"\"%{name}\"이(가) 작성되었습니다.","createPalette":"사용자 정의 색상표 작성","colorPicker":"색상 선택도구","errorNoName":"색상표 이름 입력","errorInsufficientColors":"둘 이상의 색상 선택","paletteAppliedToastMessage":"\"%{name}\" 색상표가 보고서에 적용되었습니다.","createPaletteHeader":"색상표 작성","modifyPaletteHeader":"색상표 편집","paletteNamePlaceholder":"여기에 색상표 이름 입력","paletteName":"색상표 이름","standardPalette":"카테고리형 색상표","continuousPalette":"연속 색상표","removeSwatch":"견본 제거","addSwatch":"견본 추가","reversePalette":"색상표 반전","colorGuide":"색상 안내서","modeAutomatic":"자동","modeCustom":"사용자 정의","colorModel":"색상 모델","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"눈금","wheel":"휠","hexCode":"16진 코드","colorRed":"빨간색","colorGreen":"녹색","colorBlue":"파란색","colorHue":"색상","colorSaturation":"채도","colorBrightness":"밝기","colorCyan":"청록색","colorMagenta":"진홍색","colorYellow":"노란색","colorBlack":"검은색","codeRed":"빨간색","codeGreen":"녹색","codeBlue":"파란색","codeHue":"색상","codeSaturation":"채도","codeBrightness":"밝기","close":"닫기","duplicate":"복제","edit":"편집","delete":"삭제","editSchematic":"패키지 편집","searchSchematic":"검색","nameLabelSchematic":"이름","captionLabelSchematic":"캡션","keyLabelSchematic":"키","addSchematic":"파일 업로드","schematicsInvalidSvg":"올바르지 않거나 지원되지 않는 SVG","schematicsInvalidSvgData":"파일 데이터를 확보할 수 없음","schematicsInvalidType":"지원되지 않는 파일 유형: %{type}","schematicsInvalidSize":"%{file} 파일, %{size} 크기가 한계를 초과했습니다.","schematicsContextMenuReplace":"대체","schematicsContextMenuDelete":"삭제","schematicsEmptySearchResults":"검색 결과가 비어 있음","schematicsNoSelection":"항목을 선택하지 않음","schematicsMultipleSelection":"%{count}개의 항목이 선택됨","schematicsSingleDeletionSuccessed":"도식이 삭제되었습니다.","schematicsMultipleDeletionSuccessed":"%{count} 도식이 삭제되었습니다.","schematicsSingleAddSuccessed":"도식이 추가되었습니다.","schematicsMultipleAddSuccessed":"%{count} 도식이 추가되었습니다.","schematicsAddFailed":"도식 추가에 실패했습니다.","schematicsReplaceDlgTitle":"기존 파일의 대체 확인","schematicsReplaceDlgContent":"'%{sourceName}' 파일이 이미 있습니다. 새 파일로 이를 대체하시겠습니까?","schematicsReplaceDlgApplyToAllFiles":"모든 파일에 적용","schematicsPackageTab":"패키지","schematicsContentTab":"컨텐츠","schematicsDescriptionLabel":"설명","schematicsIconLabel":"아이콘","schematicsChooseFile":"파일 추가","schematicsDeleteIcon":"아이콘 제거","schematicsIconAdded":"\"%{file}\" 아이콘이 추가되었습니다.","schematicsIconRemove":"아이콘이 제거되었습니다.","schematicsIconDropFiles":"여기에 파일을 끌어서 놓거나 업로드","schematicsIconOr":"또는","schematicsIconFileTypes":".jpg, .png 및 .svg 파일만.","schematicsIconFileSize":"%{size}MB의 최대 파일 크기.","legacySectionExtraMessage":"경고: 레거시 팔레트는 업그레이드하기 전에 이전 버전에서 가져온 것입니다. 이러한 팔레트를 변경하면 이 시각화에 더 이상 표시되지 않습니다. ","favorite":"즐겨찾기"},"__no":{"errorCreatingPalette":"Det oppstod en feil under lagring av paletten.","paletteErrorTitle":"Palettfeil","changePaletteLabel":"Endre fargepalett","myPaletteLabel":"Tilpasset","legacyPaletteLabel":"Gammel (legacy)","systemPaletteLabel":"System","publicPaletteLabel":"Globale","localPaletteLabel":"Lokal","mruPaletteLabel":"Nylig brukt","okDialog":"OK","deleteDialogTitle":"Slett","applyDialog":"Bruk","cancelDialog":"Avbryt","saveDialog":"Lagre","createDialog":"Opprett","deleteMessage":"Er du sikker på at du vil slette paletten \"%{name}\"?","deleteToast":"\"%{name}\" ble slettet","favoritesLabel":"Favoritter","setAsFavorite":"Definer som favoritt","createdToastMessage":"\"%{name}\" ble opprettet.","createPalette":"Opprett en tilpasset palett","colorPicker":"Fargevelger","errorNoName":"Oppgi et navn på paletten.","errorInsufficientColors":"Velg minst to farger","paletteAppliedToastMessage":"Palett \"%{name}\" ble brukt på rapporten.","createPaletteHeader":"Opprett fargepalett","modifyPaletteHeader":"Rediger fargepalett","paletteNamePlaceholder":"Skriv palettnavn her","paletteName":"Palettnavn","standardPalette":"Kategorisk palett","continuousPalette":"Kontinuerlig palett","removeSwatch":"Fjern prøve","addSwatch":"Legg til prøve","reversePalette":"Omvendt palett","colorGuide":"Fargeveiledning","modeAutomatic":"Automatisk","modeCustom":"Tilpasset","colorModel":"Fargemodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rutenett","wheel":"Hjul","hexCode":"Heksadesimal kode","colorRed":"Rød","colorGreen":"Grønn","colorBlue":"Blå","colorHue":"Nyanse","colorSaturation":"Metning","colorBrightness":"Lysstyrke","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Svart","codeRed":"Rød","codeGreen":"Grønn","codeBlue":"Blå","codeHue":"Nyanse","codeSaturation":"Metning","codeBrightness":"Lysstyrke","close":"Lukk","duplicate":"Dupliser","edit":"Rediger","delete":"Slett","editSchematic":"Rediger pakke","searchSchematic":"Søk","nameLabelSchematic":"Navn","captionLabelSchematic":"Tittel","keyLabelSchematic":"Nøkkel","addSchematic":"Last opp fil","schematicsInvalidSvg":"Ugyldig eller ikke støttet SVG","schematicsInvalidSvgData":"Kunne ikke hente fildata","schematicsInvalidType":"Ikke-støttet filtype: %{type}","schematicsInvalidSize":"Fil %{file}, størrelse %{size} overskrider grense.","schematicsContextMenuReplace":"Erstatt","schematicsContextMenuDelete":"Slett","schematicsEmptySearchResults":"Søkeresultatet er tomt","schematicsNoSelection":"Ingen elementer valgt","schematicsMultipleSelection":"%{count} elementer valgt","schematicsSingleDeletionSuccessed":"Skjemaet ble slettet.","schematicsMultipleDeletionSuccessed":"%{count} skjemaer ble slettet.","schematicsSingleAddSuccessed":"Skjemaet ble lagt til.","schematicsMultipleAddSuccessed":"%{count} skjemaer ble lagt til.","schematicsAddFailed":"Kunne ikke legge til skjema.","schematicsReplaceDlgTitle":"Bekreft erstatning av eksisterende fil","schematicsReplaceDlgContent":"Filen '%{sourceName}' finnes allerede. Vil du erstatte den med den nye filen?","schematicsReplaceDlgApplyToAllFiles":"Bruk på alle filer","schematicsPackageTab":"Pakke","schematicsContentTab":"Innhold","schematicsDescriptionLabel":"Beskrivelse","schematicsIconLabel":"Ikon","schematicsChooseFile":"Legg til fil","schematicsDeleteIcon":"Fjern ikonet","schematicsIconAdded":"Ikonet \"%{file}\" ble lagt til.","schematicsIconRemove":"Ikonet ble fjernet.","schematicsIconDropFiles":"Dra og slipp fil her eller last opp","schematicsIconOr":"eller","schematicsIconFileTypes":"Bare filer av typen .jpg, .png og .svg.","schematicsIconFileSize":"%{size} MB maks filstørrelse.","legacySectionExtraMessage":"Advarsel: Eldre paletter er fra en tidligere versjon før du oppgraderte. Endringer i disse palettene vil gjøre at de ikke lenger blir vist for denne visualiseringen.","favorite":"Favoritter"},"__nb":{"errorCreatingPalette":"Det oppstod en feil under lagring av paletten.","paletteErrorTitle":"Palettfeil","changePaletteLabel":"Endre fargepalett","myPaletteLabel":"Tilpasset","legacyPaletteLabel":"Gammel (legacy)","systemPaletteLabel":"System","publicPaletteLabel":"Globale","localPaletteLabel":"Lokal","mruPaletteLabel":"Nylig brukt","okDialog":"OK","deleteDialogTitle":"Slett","applyDialog":"Bruk","cancelDialog":"Avbryt","saveDialog":"Lagre","createDialog":"Opprett","deleteMessage":"Er du sikker på at du vil slette paletten \"%{name}\"?","deleteToast":"\"%{name}\" ble slettet","favoritesLabel":"Favoritter","setAsFavorite":"Definer som favoritt","createdToastMessage":"\"%{name}\" ble opprettet.","createPalette":"Opprett en tilpasset palett","colorPicker":"Fargevelger","errorNoName":"Oppgi et navn på paletten.","errorInsufficientColors":"Velg minst to farger","paletteAppliedToastMessage":"Palett \"%{name}\" ble brukt på rapporten.","createPaletteHeader":"Opprett fargepalett","modifyPaletteHeader":"Rediger fargepalett","paletteNamePlaceholder":"Skriv palettnavn her","paletteName":"Palettnavn","standardPalette":"Kategorisk palett","continuousPalette":"Kontinuerlig palett","removeSwatch":"Fjern prøve","addSwatch":"Legg til prøve","reversePalette":"Omvendt palett","colorGuide":"Fargeveiledning","modeAutomatic":"Automatisk","modeCustom":"Tilpasset","colorModel":"Fargemodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rutenett","wheel":"Hjul","hexCode":"Heksadesimal kode","colorRed":"Rød","colorGreen":"Grønn","colorBlue":"Blå","colorHue":"Nyanse","colorSaturation":"Metning","colorBrightness":"Lysstyrke","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Svart","codeRed":"Rød","codeGreen":"Grønn","codeBlue":"Blå","codeHue":"Nyanse","codeSaturation":"Metning","codeBrightness":"Lysstyrke","close":"Lukk","duplicate":"Dupliser","edit":"Rediger","delete":"Slett","editSchematic":"Rediger pakke","searchSchematic":"Søk","nameLabelSchematic":"Navn","captionLabelSchematic":"Tittel","keyLabelSchematic":"Nøkkel","addSchematic":"Last opp fil","schematicsInvalidSvg":"Ugyldig eller ikke støttet SVG","schematicsInvalidSvgData":"Kunne ikke hente fildata","schematicsInvalidType":"Ikke-støttet filtype: %{type}","schematicsInvalidSize":"Fil %{file}, størrelse %{size} overskrider grense.","schematicsContextMenuReplace":"Erstatt","schematicsContextMenuDelete":"Slett","schematicsEmptySearchResults":"Søkeresultatet er tomt","schematicsNoSelection":"Ingen elementer valgt","schematicsMultipleSelection":"%{count} elementer valgt","schematicsSingleDeletionSuccessed":"Skjemaet ble slettet.","schematicsMultipleDeletionSuccessed":"%{count} skjemaer ble slettet.","schematicsSingleAddSuccessed":"Skjemaet ble lagt til.","schematicsMultipleAddSuccessed":"%{count} skjemaer ble lagt til.","schematicsAddFailed":"Kunne ikke legge til skjema.","schematicsReplaceDlgTitle":"Bekreft erstatning av eksisterende fil","schematicsReplaceDlgContent":"Filen '%{sourceName}' finnes allerede. Vil du erstatte den med den nye filen?","schematicsReplaceDlgApplyToAllFiles":"Bruk på alle filer","schematicsPackageTab":"Pakke","schematicsContentTab":"Innhold","schematicsDescriptionLabel":"Beskrivelse","schematicsIconLabel":"Ikon","schematicsChooseFile":"Legg til fil","schematicsDeleteIcon":"Fjern ikonet","schematicsIconAdded":"Ikonet \"%{file}\" ble lagt til.","schematicsIconRemove":"Ikonet ble fjernet.","schematicsIconDropFiles":"Dra og slipp fil her eller last opp","schematicsIconOr":"eller","schematicsIconFileTypes":"Bare filer av typen .jpg, .png og .svg.","schematicsIconFileSize":"%{size} MB maks filstørrelse.","legacySectionExtraMessage":"Advarsel: Eldre paletter er fra en tidligere versjon før du oppgraderte. Endringer i disse palettene vil gjøre at de ikke lenger blir vist for denne visualiseringen.","favorite":"Favoritter"},"__nl":{"errorCreatingPalette":"Fout opgetreden bij het opslaan van het palet.","paletteErrorTitle":"Paletfout","changePaletteLabel":"Kleurenpalet wijzigen","myPaletteLabel":"Aangepast","legacyPaletteLabel":"Legacy","systemPaletteLabel":"Systeem","publicPaletteLabel":"Algemeen","localPaletteLabel":"Lokaal","mruPaletteLabel":"Kortgeleden gebruikt","okDialog":"OK","deleteDialogTitle":"Verwijderen","applyDialog":"Toepassen","cancelDialog":"Annuleren","saveDialog":"Opslaan","createDialog":"Maken","deleteMessage":"Weet u zeker dat u het palet \"%{name}\" wilt wissen?","deleteToast":"\"%{name}\" is gewist","favoritesLabel":"Favorieten","setAsFavorite":"Instellen als favoriet","createdToastMessage":"\"%{name}\" is gemaakt.","createPalette":"Aangepast palet maken","colorPicker":"Kleurenselector","errorNoName":"Geef een naam voor uw palet op","errorInsufficientColors":"Kies minimaal twee kleuren","paletteAppliedToastMessage":"Palet \"%{name}\" is toegepast op het rapport.","createPaletteHeader":"Kleurenpalet maken","modifyPaletteHeader":"Kleurenpalet bewerken","paletteNamePlaceholder":"Typ hier de naam van het palet","paletteName":"Naam van palet","standardPalette":"Categorisch palet","continuousPalette":"Doorlopend palet","removeSwatch":"Staal verwijderen","addSwatch":"Staal toevoegen","reversePalette":"Palet negatief maken","colorGuide":"Kleurengids","modeAutomatic":"Automatisch","modeCustom":"Aangepast","colorModel":"Kleurmodel","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Raster","wheel":"Cirkel","hexCode":"Hexcode","colorRed":"Rood","colorGreen":"Groen","colorBlue":"Blauw","colorHue":"Tint","colorSaturation":"Verzadiging","colorBrightness":"Helderheid","colorCyan":"Cyaan","colorMagenta":"Magenta","colorYellow":"Geel","colorBlack":"Zwart","codeRed":"Rood","codeGreen":"Groen","codeBlue":"Blauw","codeHue":"Tint","codeSaturation":"Verzadiging","codeBrightness":"Helderheid","close":"Sluiten","duplicate":"Dupliceren","edit":"Bewerken","delete":"Verwijderen","editSchematic":"Pakket bewerken","searchSchematic":"Zoeken","nameLabelSchematic":"Name","captionLabelSchematic":"Bijschrift","keyLabelSchematic":"Sleutel","addSchematic":"Bestand uploaden","schematicsInvalidSvg":"Ongeldige of niet-ondersteunde SVG","schematicsInvalidSvgData":"Bestandsgegevens kunnen niet worden opgehaald","schematicsInvalidType":"Niet-ondersteund bestandstype: %{type}","schematicsInvalidSize":"Bestand %{file}, grootte %{size} overschrijdt de limiet.","schematicsContextMenuReplace":"Vervangen","schematicsContextMenuDelete":"Verwijderen","schematicsEmptySearchResults":"Het zoekresultaat is leeg","schematicsNoSelection":"Geen items geselecteerd","schematicsMultipleSelection":"%{count} items geselecteerd","schematicsSingleDeletionSuccessed":"Uw schema is gewist.","schematicsMultipleDeletionSuccessed":"%{count} schema's gewist.","schematicsSingleAddSuccessed":"Uw schema is toegevoegd.","schematicsMultipleAddSuccessed":"%{count} schema's zijn toegevoegd.","schematicsAddFailed":"Toevoegen van uw schema is mislukt.","schematicsReplaceDlgTitle":"Vervanging van bestaand bestand bevestigen","schematicsReplaceDlgContent":"Het bestand '%{sourceName}' bestaat al. Wilt u het vervangen door het nieuwe bestand?","schematicsReplaceDlgApplyToAllFiles":"Toepassen op alle bestanden","schematicsPackageTab":"Pakket","schematicsContentTab":"Inhoud","schematicsDescriptionLabel":"Naam","schematicsIconLabel":"Pictogram","schematicsChooseFile":"Bestand toevoegen","schematicsDeleteIcon":"Het pictogram verwijderen","schematicsIconAdded":"Het pictogram \"%{file}\" is toegevoegd.","schematicsIconRemove":"Het pictogram is verwijderd.","schematicsIconDropFiles":"Versleep een bestand hiernaartoe of upload het","schematicsIconOr":"of","schematicsIconFileTypes":"Alleen .jpg, .png en .svg-bestanden.","schematicsIconFileSize":"%{size} MB max bestandsgrootte.","legacySectionExtraMessage":"Waarschuwing: Legacypaletten zijn van een eerdere versie voordat een upgrade uitvoerde. Wijzigingen in deze paletten leiden ertoe dat ze niet meer in deze visualisatie zichtbaar zijn. ","favorite":"Favorieten"},"__pl":{"errorCreatingPalette":"Wystąpił błąd podczas zapisywania palety.","paletteErrorTitle":"Błąd palety","changePaletteLabel":"Zmień paletę kolorów","myPaletteLabel":"Niestandardowa","legacyPaletteLabel":"Poprzednia wersja","systemPaletteLabel":"System","publicPaletteLabel":"Globalne","localPaletteLabel":"Lokalne","mruPaletteLabel":"Ostatnio używane","okDialog":"OK","deleteDialogTitle":"Usuń","applyDialog":"Zastosuj","cancelDialog":"Anuluj","saveDialog":"Zapisz","createDialog":"Utwórz","deleteMessage":"Czy na pewno chcesz usunąć paletę \"%{name}\"?","deleteToast":"Usunięto \"%{name}\"","favoritesLabel":"Ulubione","setAsFavorite":"Ustaw jako ulubione","createdToastMessage":"Pomyślnie utworzono \"%{name}\".","createPalette":"Utwórz paletę niestandardową","colorPicker":"Selektor kolorów","errorNoName":"Wprowadź nazwę palety","errorInsufficientColors":"Wybierz co najmniej dwa kolory","paletteAppliedToastMessage":"Paleta o nazwie \"%{name}\" została zastosowana w raporcie.","createPaletteHeader":"Utwórz paletę kolorów","modifyPaletteHeader":"Edytuj paletę kolorów","paletteNamePlaceholder":"Tutaj wpisz nazwę palety","paletteName":"Nazwa palety","standardPalette":"Paleta kategorialna","continuousPalette":"Paleta ciągła","removeSwatch":"Usuń próbkę","addSwatch":"Dodaj próbkę","reversePalette":"Odwróć paletę","colorGuide":"Przewodnik po kolorach","modeAutomatic":"Automatycznie","modeCustom":"Niestandardowa","colorModel":"Model kolorów","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Siatka","wheel":"Koło","hexCode":"Kod szesnastkowy","colorRed":"Czerwony","colorGreen":"Zielony","colorBlue":"Niebieski","colorHue":"Barwa","colorSaturation":"Nasycenie","colorBrightness":"Jasność","colorCyan":"Niebieskozielony","colorMagenta":"Amarantowy","colorYellow":"Żółty","colorBlack":"Czarny","codeRed":"Czerwony","codeGreen":"Zielony","codeBlue":"Niebieski","codeHue":"Barwa","codeSaturation":"Nasycenie","codeBrightness":"Jasność","close":"Zamknij","duplicate":"Duplikuj","edit":"Edytuj","delete":"Usuń","editSchematic":"Edytuj pakiet","searchSchematic":"Szukaj","nameLabelSchematic":"Nazwa","captionLabelSchematic":"Podpis","keyLabelSchematic":"Klucz","addSchematic":"Prześlij plik","schematicsInvalidSvg":"Niepoprawny lub nieobsługiwany plik SVG","schematicsInvalidSvgData":"Nie można uzyskać danych pliku","schematicsInvalidType":"Nieobsługiwany typ pliku: %{type}","schematicsInvalidSize":"Rozmiar %{size} pliku %{file} przekracza limit.","schematicsContextMenuReplace":"Zastąp","schematicsContextMenuDelete":"Usuń","schematicsEmptySearchResults":"Wyniki wyszukiwania są puste","schematicsNoSelection":"Nie wybrano żadnego elementu","schematicsMultipleSelection":"Wybrano elementów: %{count}","schematicsSingleDeletionSuccessed":"Schemat został pomyślnie usunięty.","schematicsMultipleDeletionSuccessed":"Pomyślnie usunięto następującą liczbę schematów: %{count}","schematicsSingleAddSuccessed":"Schemat został pomyślnie dodany.","schematicsMultipleAddSuccessed":"Pomyślnie dodano następującą liczbę schematów: %{count}","schematicsAddFailed":"Nie powiodło się dodanie schematu.","schematicsReplaceDlgTitle":"Potwierdź zastąpienie istniejącego pliku","schematicsReplaceDlgContent":"Plik '%{sourceName}' już istnieje. Czy zastąpić go nowym plikiem?","schematicsReplaceDlgApplyToAllFiles":"Zastosuj do wszystkich plików","schematicsPackageTab":"Pakiet","schematicsContentTab":"Treść","schematicsDescriptionLabel":"Opis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Dodaj plik","schematicsDeleteIcon":"Usuń ikonę","schematicsIconAdded":"Ikona \"%{file}\" została pomyślnie dodana.","schematicsIconRemove":"Ikona została pomyślnie usunięta.","schematicsIconDropFiles":"Przeciągnij i upuść plik w tym miejscu lub go prześlij","schematicsIconOr":"lub","schematicsIconFileTypes":"Tylko pliki .jpg, .png i .svg.","schematicsIconFileSize":"Maks. wielkość pliku: %{size}MB.","legacySectionExtraMessage":"Ostrzeżenie: Starsze palety pochodzą z wersji wcześniejszej, sprzed aktualizacji. Wprowadzenie zmian w tych paletach spowoduje, że nie będą już widoczne w tej wizualizacji.","favorite":"Ulubione"},"__pt":{"errorCreatingPalette":"Ocorreu um erro ao salvar a paleta.","paletteErrorTitle":"Erro da Paleta","changePaletteLabel":"Alterar paleta de cores","myPaletteLabel":"Personalização","legacyPaletteLabel":"Preexistente","systemPaletteLabel":"Sistema","publicPaletteLabel":"Global","localPaletteLabel":"Local","mruPaletteLabel":"Recentemente usado","okDialog":"OK","deleteDialogTitle":"Excluir","applyDialog":"Aplicar","cancelDialog":"Cancelar","saveDialog":"Salvar","createDialog":"Criar","deleteMessage":"Tem certeza de que deseja excluir a paleta \"%{name}\"?","deleteToast":"\"%{name}\" foi excluído","favoritesLabel":"Destaques","setAsFavorite":"Configurar como favorito","createdToastMessage":"\"%{name}\" foi criado com êxito.","createPalette":"Criar uma Paleta Customizada","colorPicker":"Selecionador de Cores","errorNoName":"Digite um nome para a paleta","errorInsufficientColors":"Escolha pelo menos duas cores","paletteAppliedToastMessage":"A paleta \"%{name}\" foi aplicada no relatório.","createPaletteHeader":"Criar paleta de cores","modifyPaletteHeader":"Editar paleta de cores","paletteNamePlaceholder":"Digite o nome da paleta aqui","paletteName":"Nome da paleta","standardPalette":"Paleta categórica","continuousPalette":"Paleta Contínua","removeSwatch":"Remover swatch","addSwatch":"Incluir swatch","reversePalette":"Reverter Paleta","colorGuide":"Guia de Cores","modeAutomatic":"Automática","modeCustom":"Personalização","colorModel":"Modelo de Cor","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grade","wheel":"Roda","hexCode":"Código Hex","colorRed":"Vermelho","colorGreen":"Verde","colorBlue":"Azul","colorHue":"Hue","colorSaturation":"Saturação","colorBrightness":"Brilho","colorCyan":"Ciano","colorMagenta":"Magenta","colorYellow":"Amarelo","colorBlack":"Preto","codeRed":"Vermelho","codeGreen":"Verde","codeBlue":"Azul","codeHue":"Hue","codeSaturation":"Saturação","codeBrightness":"Brilho","close":"Fechar","duplicate":"Duplicado","edit":"Editar","delete":"Excluir","editSchematic":"Editar pacote","searchSchematic":"Procurar","nameLabelSchematic":"Nome","captionLabelSchematic":"Texto Explicativo","keyLabelSchematic":"Chave","addSchematic":"Fazer upload do arquivo","schematicsInvalidSvg":"SVG inválido ou não suportado","schematicsInvalidSvgData":"Não foi possível obter os dados do arquivo","schematicsInvalidType":"Tipo de arquivo não suportado: %{type}","schematicsInvalidSize":"O arquivo %{file}, tamanho %{size}, excede o limite.","schematicsContextMenuReplace":"Substituir","schematicsContextMenuDelete":"Excluir","schematicsEmptySearchResults":"Os resultados da procura estão vazios","schematicsNoSelection":"Nenhum Item Selecionado","schematicsMultipleSelection":"%{count} itens selecionados","schematicsSingleDeletionSuccessed":"Seu esquema foi excluído com sucesso.","schematicsMultipleDeletionSuccessed":"%{count} esquemas foram excluídos com sucesso.","schematicsSingleAddSuccessed":"Seu esquema foi incluído com sucesso.","schematicsMultipleAddSuccessed":"%{count} esquemas foram incluídos com sucesso.","schematicsAddFailed":"Falha ao incluir seu esquema.","schematicsReplaceDlgTitle":"Confirmar substituição do arquivo existente","schematicsReplaceDlgContent":"O arquivo '%{sourceName}' já existe. Deseja substituí-lo pelo novo arquivo?","schematicsReplaceDlgApplyToAllFiles":"Aplicar a todos os arquivos","schematicsPackageTab":"Pacote","schematicsContentTab":"Conteúdo","schematicsDescriptionLabel":"Descrição","schematicsIconLabel":"Ícone","schematicsChooseFile":"Incluir arquivo","schematicsDeleteIcon":"Remover o ícone","schematicsIconAdded":"O ícone \"%{file}\" foi incluído com sucesso.","schematicsIconRemove":"O ícone foi removido com sucesso.","schematicsIconDropFiles":"Arraste e solte o arquivo aqui ou faça upload dele","schematicsIconOr":"ou","schematicsIconFileTypes":"Somente arquivos .jpg, .png, and .svg.","schematicsIconFileSize":"Tamanho máximo do arquivo: %{size}MB.","legacySectionExtraMessage":"Aviso: as paletas anteriores são de uma versão anterior ao upgrade. As mudanças nessas paletas farão com que elas não apareçam mais nesta visualização. ","favorite":"Destaques"},"__pt-br":{"errorCreatingPalette":"Ocorreu um erro ao salvar a paleta.","paletteErrorTitle":"Erro da Paleta","changePaletteLabel":"Alterar paleta de cores","myPaletteLabel":"Personalização","legacyPaletteLabel":"Preexistente","systemPaletteLabel":"Sistema","publicPaletteLabel":"Global","localPaletteLabel":"Local","mruPaletteLabel":"Recentemente usado","okDialog":"OK","deleteDialogTitle":"Excluir","applyDialog":"Aplicar","cancelDialog":"Cancelar","saveDialog":"Salvar","createDialog":"Criar","deleteMessage":"Tem certeza de que deseja excluir a paleta \"%{name}\"?","deleteToast":"\"%{name}\" foi excluído","favoritesLabel":"Destaques","setAsFavorite":"Configurar como favorito","createdToastMessage":"\"%{name}\" foi criado com êxito.","createPalette":"Criar uma Paleta Customizada","colorPicker":"Selecionador de Cores","errorNoName":"Digite um nome para a paleta","errorInsufficientColors":"Escolha pelo menos duas cores","paletteAppliedToastMessage":"A paleta \"%{name}\" foi aplicada no relatório.","createPaletteHeader":"Criar paleta de cores","modifyPaletteHeader":"Editar paleta de cores","paletteNamePlaceholder":"Digite o nome da paleta aqui","paletteName":"Nome da paleta","standardPalette":"Paleta categórica","continuousPalette":"Paleta Contínua","removeSwatch":"Remover swatch","addSwatch":"Incluir swatch","reversePalette":"Reverter Paleta","colorGuide":"Guia de Cores","modeAutomatic":"Automática","modeCustom":"Personalização","colorModel":"Modelo de Cor","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grade","wheel":"Roda","hexCode":"Código Hex","colorRed":"Vermelho","colorGreen":"Verde","colorBlue":"Azul","colorHue":"Hue","colorSaturation":"Saturação","colorBrightness":"Brilho","colorCyan":"Ciano","colorMagenta":"Magenta","colorYellow":"Amarelo","colorBlack":"Preto","codeRed":"Vermelho","codeGreen":"Verde","codeBlue":"Azul","codeHue":"Hue","codeSaturation":"Saturação","codeBrightness":"Brilho","close":"Fechar","duplicate":"Duplicado","edit":"Editar","delete":"Excluir","editSchematic":"Editar pacote","searchSchematic":"Procurar","nameLabelSchematic":"Nome","captionLabelSchematic":"Texto Explicativo","keyLabelSchematic":"Chave","addSchematic":"Fazer upload do arquivo","schematicsInvalidSvg":"SVG inválido ou não suportado","schematicsInvalidSvgData":"Não foi possível obter os dados do arquivo","schematicsInvalidType":"Tipo de arquivo não suportado: %{type}","schematicsInvalidSize":"O arquivo %{file}, tamanho %{size}, excede o limite.","schematicsContextMenuReplace":"Substituir","schematicsContextMenuDelete":"Excluir","schematicsEmptySearchResults":"Os resultados da procura estão vazios","schematicsNoSelection":"Nenhum Item Selecionado","schematicsMultipleSelection":"%{count} itens selecionados","schematicsSingleDeletionSuccessed":"Seu esquema foi excluído com sucesso.","schematicsMultipleDeletionSuccessed":"%{count} esquemas foram excluídos com sucesso.","schematicsSingleAddSuccessed":"Seu esquema foi incluído com sucesso.","schematicsMultipleAddSuccessed":"%{count} esquemas foram incluídos com sucesso.","schematicsAddFailed":"Falha ao incluir seu esquema.","schematicsReplaceDlgTitle":"Confirmar substituição do arquivo existente","schematicsReplaceDlgContent":"O arquivo '%{sourceName}' já existe. Deseja substituí-lo pelo novo arquivo?","schematicsReplaceDlgApplyToAllFiles":"Aplicar a todos os arquivos","schematicsPackageTab":"Pacote","schematicsContentTab":"Conteúdo","schematicsDescriptionLabel":"Descrição","schematicsIconLabel":"Ícone","schematicsChooseFile":"Incluir arquivo","schematicsDeleteIcon":"Remover o ícone","schematicsIconAdded":"O ícone \"%{file}\" foi incluído com sucesso.","schematicsIconRemove":"O ícone foi removido com sucesso.","schematicsIconDropFiles":"Arraste e solte o arquivo aqui ou faça upload dele","schematicsIconOr":"ou","schematicsIconFileTypes":"Somente arquivos .jpg, .png, and .svg.","schematicsIconFileSize":"Tamanho máximo do arquivo: %{size}MB.","legacySectionExtraMessage":"Aviso: as paletas anteriores são de uma versão anterior ao upgrade. As mudanças nessas paletas farão com que elas não apareçam mais nesta visualização. ","favorite":"Destaques"},"__ro":{"errorCreatingPalette":"A apărut o eroare la salvarea paletei.","paletteErrorTitle":"Eroare paletă","changePaletteLabel":"Modificare paletă de culori","myPaletteLabel":"Personalizat","legacyPaletteLabel":"Moştenită","systemPaletteLabel":"Sistem","publicPaletteLabel":"Globală","localPaletteLabel":"Locală","mruPaletteLabel":"Utilizată recent","okDialog":"OK","deleteDialogTitle":"Ştergere","applyDialog":"Aplicare","cancelDialog":"Renunţare","saveDialog":"Salvare","createDialog":"Creare","deleteMessage":"Sunteţi sigur că vreţi să ştergeţi paleta \"%{name}\"?","deleteToast":"\"%{name}\" a fost ştearsă","favoritesLabel":"Favorite","setAsFavorite":"Setare ca favorit","createdToastMessage":"\"%{name}\" a fost creat cu succes.","createPalette":"Creare paletă personalizată","colorPicker":"Selector de culoare","errorNoName":"Introduceţi un nume paleta dumneavoastră","errorInsufficientColors":"Alegeţi cel puţin două culori","paletteAppliedToastMessage":"Paleta \"%{name}\", a fost aplicată la raport.","createPaletteHeader":"Creare paletă de culori","modifyPaletteHeader":"Editare paletă de culori","paletteNamePlaceholder":"Tastaţi numele de paletă aici","paletteName":"Nume paletă","standardPalette":"Paletă categorială","continuousPalette":"Paletă continuă","removeSwatch":"Înlăturare mostră","addSwatch":"Adăugare mostră","reversePalette":"Paletă inversă","colorGuide":"Ghid de culoare","modeAutomatic":"Automat","modeCustom":"Personalizată","colorModel":"Model de culoare","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Grilă","wheel":"Roată","hexCode":"Cod hex","colorRed":"Roşu","colorGreen":"Verde","colorBlue":"Albastru","colorHue":"Nuanţă","colorSaturation":"Saturaţie","colorBrightness":"Luminozitate","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Galben","colorBlack":"Negru","codeRed":"Roşu","codeGreen":"Verde","codeBlue":"Albastru","codeHue":"Nuanţă","codeSaturation":"Saturaţie","codeBrightness":"Luminozitate","close":"Închidere","duplicate":"Duplicare","edit":"Editare","delete":"Ştergere","editSchematic":"Editare pachet","searchSchematic":"Căutare","nameLabelSchematic":"Nume","captionLabelSchematic":"Subtitlu","keyLabelSchematic":"Cheie","addSchematic":"Încărcare fişier","schematicsInvalidSvg":"SVG invalid sau nesuportat","schematicsInvalidSvgData":"Nu s-au putut obţine datele fişierului","schematicsInvalidType":"Tip de fişier nesuportat: %{type}","schematicsInvalidSize":"Fişierul %{file}, dimensiunea %{size} depăşeşte limita.","schematicsContextMenuReplace":"Înlocuire","schematicsContextMenuDelete":"Ştergere","schematicsEmptySearchResults":"Rezultatele căutării sunt goale","schematicsNoSelection":"Niciun articol selectat","schematicsMultipleSelection":"%{count} articole selectate","schematicsSingleDeletionSuccessed":"Schematicul a fost şters cu succes.","schematicsMultipleDeletionSuccessed":"%{count} schematice au fost şterse cu succes.","schematicsSingleAddSuccessed":"Schematicul a fost adăugat cu succes.","schematicsMultipleAddSuccessed":"%{count} schematice au fost adăugate cu succes.","schematicsAddFailed":"A eşuat adăugarea schematicului.","schematicsReplaceDlgTitle":"Confirmare înlocuire fişier existent","schematicsReplaceDlgContent":"Fişierul '%{sourceName}' există deja. Doriţi să-l înlocuiţi cu noul fişier?","schematicsReplaceDlgApplyToAllFiles":"Aplicare pentru toate fişierele","schematicsPackageTab":"Pachet","schematicsContentTab":"Conţinut","schematicsDescriptionLabel":"Descriere","schematicsIconLabel":"Pictogramă","schematicsChooseFile":"Adăugare fişier","schematicsDeleteIcon":"Înlăturaţi pictograma","schematicsIconAdded":"Pictograma \"%{file}\" a fost adăugată cu succes.","schematicsIconRemove":"Pictograma a fost înlăturată cu succes.","schematicsIconDropFiles":"Trageţi şi plasaţi fişierul aici sau încărcaţi","schematicsIconOr":"sau","schematicsIconFileTypes":"Doar fişiere .jpg, .png, and .svg.","schematicsIconFileSize":"Dim. max. fişier %{size} MB.","legacySectionExtraMessage":"Avertisment: Paletele moştenite sunt de la o versiune anterioară înainte de a fi făcut modernizarea. Modificările la aceste palete vor face să nu mai apară pentru această vizualizare. ","favorite":"Favorite"},"__ru":{"errorCreatingPalette":"При сохранении палитры произошла ошибка.","paletteErrorTitle":"Ошибка палитры","changePaletteLabel":"Изменить цветовую палитру","myPaletteLabel":"Настроить","legacyPaletteLabel":"Прежняя версия","systemPaletteLabel":"Система","publicPaletteLabel":"Глобальные","localPaletteLabel":"Локальный","mruPaletteLabel":"Недавно использованные","okDialog":"ОК","deleteDialogTitle":"Удалить","applyDialog":"Применить","cancelDialog":"Отмена","saveDialog":"Сохранить","createDialog":"Создать","deleteMessage":"Вы уверены, что хотите удалить палитру \"%{name}\"?","deleteToast":"\"%{name}\" удалено","favoritesLabel":"Избранное","setAsFavorite":"Задать как избранное","createdToastMessage":"\"%{name}\" успешно создано.","createPalette":"Создать пользовательскую палитру","colorPicker":"Выбор цвета","errorNoName":"Введите имя для своей палитры","errorInsufficientColors":"Выберите хотя бы два цвета","paletteAppliedToastMessage":"Палитра \"%{name}\" применена к отчету.","createPaletteHeader":"Создать цветовую палитру","modifyPaletteHeader":"Изменить цветовую палитру","paletteNamePlaceholder":"Введите здесь имя палитры","paletteName":"Имя палитры","standardPalette":"Категориальная палитра","continuousPalette":"Непрерывная палитра","removeSwatch":"Удалить палитру","addSwatch":"Добавить палитру","reversePalette":"Обратить палитру","colorGuide":"Руководство по цветам","modeAutomatic":"Автоматически","modeCustom":"Настроить","colorModel":"Цветовая модель","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Таблица","wheel":"Часовая стрелка","hexCode":"Шестнадцатеричный код","colorRed":"Красный","colorGreen":"Зеленый","colorBlue":"Синий","colorHue":"Оттенок","colorSaturation":"Насыщенность","colorBrightness":"Яркость","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Желтый","colorBlack":"Черный","codeRed":"Красный","codeGreen":"Зеленый","codeBlue":"Синий","codeHue":"Оттенок","codeSaturation":"Насыщенность","codeBrightness":"Яркость","close":"Закрыть","duplicate":"Дублировать","edit":"Изменить","delete":"Удалить","editSchematic":"Изменить пакет","searchSchematic":"Поиск","nameLabelSchematic":"Имя","captionLabelSchematic":"Заголовок","keyLabelSchematic":"Ключ","addSchematic":"Закачать файл","schematicsInvalidSvg":"Недопустимый или неподдерживаемый SVG","schematicsInvalidSvgData":"Не удалось получить данные файла","schematicsInvalidType":"Неподдерживаемый тип файла: %{type}","schematicsInvalidSize":"Файл %{file}, размер %{size} превышает предел.","schematicsContextMenuReplace":"Заменить","schematicsContextMenuDelete":"Удалить","schematicsEmptySearchResults":"Результаты поиска - пустые","schematicsNoSelection":"Элементы не выбраны","schematicsMultipleSelection":"%{count} элементов выбрано","schematicsSingleDeletionSuccessed":"Ваше схематическое представление успешно удалено.","schematicsMultipleDeletionSuccessed":"%{count} схематических представлений успешно удалены.","schematicsSingleAddSuccessed":"Ваше схематическое представление успешно добавлено.","schematicsMultipleAddSuccessed":"%{count} схематических представлений успешно добавлены.","schematicsAddFailed":"Не удалось добавить ваше схематическое представление.","schematicsReplaceDlgTitle":"Подтвердить замену существующего файла","schematicsReplaceDlgContent":"Файл '%{sourceName}' уже существует. Хотите заменить его новым файлом?","schematicsReplaceDlgApplyToAllFiles":"Применить ко всем файлам","schematicsPackageTab":"Пакет","schematicsContentTab":"Содержимое","schematicsDescriptionLabel":"Описание","schematicsIconLabel":"Значок","schematicsChooseFile":"Добавить файл","schematicsDeleteIcon":"Удалить значок","schematicsIconAdded":"Значок \"%{file}\" успешно добавлен.","schematicsIconRemove":"Значок успешно удален.","schematicsIconDropFiles":"Перетащите файл сюда или закачайте его","schematicsIconOr":"или","schematicsIconFileTypes":"Только файлы .jpg, .png и .svg.","schematicsIconFileSize":"Максимальный размер файла %{size} МБ.","legacySectionExtraMessage":"Предупреждение: Палитры до обновления происходят из предыдущей версии. Изменения в этих палитрах приведут к их исчезновению из этой визуализации.","favorite":"Избранное"},"__sl":{"errorCreatingPalette":"Med shranjevanjem palete je prišlo do napake.","paletteErrorTitle":"Napaka palete","changePaletteLabel":"Spremeni barvno paleto","myPaletteLabel":"Po meri","legacyPaletteLabel":"Starejša različica","systemPaletteLabel":"Sistem","publicPaletteLabel":"Globalno","localPaletteLabel":"Lokalno","mruPaletteLabel":"Nedavno uporabljeno","okDialog":"V redu","deleteDialogTitle":"Izbriši","applyDialog":"Uveljavi","cancelDialog":"Prekliči","saveDialog":"Shrani","createDialog":"Ustvari","deleteMessage":"Ali ste prepričani, da želite izbrisati paleto \"%{name}\"?","deleteToast":"\"%{name}\" je bil izbrisan","favoritesLabel":"Priljubljene","setAsFavorite":"Nastavi kot priljubljeno","createdToastMessage":"\"%{name}\" je bil uspešno ustvarjen.","createPalette":"Ustvari paleto po meri","colorPicker":"Izbirnik barv","errorNoName":"Vnesite ime svoje palete","errorInsufficientColors":"Izberite vsaj dve barvi","paletteAppliedToastMessage":"Paleta \"%{name}\" je bila uveljavljena za poročilo.","createPaletteHeader":"Ustvari barvno paleto","modifyPaletteHeader":"Urejanje barvne palete","paletteNamePlaceholder":"Na to mesto vpišite ime palete","paletteName":"Ime palete","standardPalette":"Kategorična paleta","continuousPalette":"Neprekinjena paleta","removeSwatch":"Odstrani paleto","addSwatch":"Dodaj paleto","reversePalette":"Obrni paleto","colorGuide":"Vodič za barve","modeAutomatic":"Samodejno","modeCustom":"Po meri","colorModel":"Barvni model","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Mreža","wheel":"Kolo","hexCode":"Šestnajstiška koda","colorRed":"Rdeča","colorGreen":"Zelena","colorBlue":"Modra","colorHue":"Odtenek","colorSaturation":"Nasičenost","colorBrightness":"Svetlost","colorCyan":"Cian","colorMagenta":"Magenta","colorYellow":"Rumena","colorBlack":"Črna","codeRed":"Rdeča","codeGreen":"Zelena","codeBlue":"Modra","codeHue":"Odtenek","codeSaturation":"Nasičenost","codeBrightness":"Svetlost","close":"Zapri","duplicate":"Podvoji","edit":"Urejanje","delete":"Izbriši","editSchematic":"Urejanje paketa","searchSchematic":"Iskanje","nameLabelSchematic":"Ime","captionLabelSchematic":"Napis","keyLabelSchematic":"Ključ","addSchematic":"Naloži datoteko","schematicsInvalidSvg":"Neveljavna ali nepodprta datoteka SVG","schematicsInvalidSvgData":"Podatkov datoteke ni bilo mogoče pridobiti","schematicsInvalidType":"Nepodprta vrsta datoteke: %{type}","schematicsInvalidSize":"Datoteka %{file}, velikost %{size} presega omejitev.","schematicsContextMenuReplace":"Zamenjaj","schematicsContextMenuDelete":"Izbriši","schematicsEmptySearchResults":"Rezultati iskanja so prazni","schematicsNoSelection":"Noben element ni izbran","schematicsMultipleSelection":"%{count} elementov je izbranih","schematicsSingleDeletionSuccessed":"Vaša shema je bila uspešno izbrisana.","schematicsMultipleDeletionSuccessed":"%{count} shem je bilo uspešno izbrisanih.","schematicsSingleAddSuccessed":"Vaša shema je bila uspešno dodana.","schematicsMultipleAddSuccessed":"%{count} shem je bilo uspešno dodanih.","schematicsAddFailed":"Dodajanje sheme ni bilo uspešno.","schematicsReplaceDlgTitle":"Potrdi zamenjavo obstoječe datoteke","schematicsReplaceDlgContent":"Datoteka '%{sourceName}' že obstaja. Ali jo želite zamenjati z novo datoteko?","schematicsReplaceDlgApplyToAllFiles":"Uveljavi za vse datoteke","schematicsPackageTab":"Paket","schematicsContentTab":"Vsebina","schematicsDescriptionLabel":"Opis","schematicsIconLabel":"Ikona","schematicsChooseFile":"Dodaj datoteko","schematicsDeleteIcon":"Odstrani ikono","schematicsIconAdded":"Ikona \"%{file}\" je bila uspešno dodana.","schematicsIconRemove":"Ikona je bila uspešno odstranjena.","schematicsIconDropFiles":"Datoteko povlecite in spustite na to mesto ali naložite","schematicsIconOr":"ali","schematicsIconFileTypes":"Samo datoteke .jpg, .png in .svg.","schematicsIconFileSize":"Največja velikost datoteke je %{size} MB.","legacySectionExtraMessage":"Opozorilo: palete starejših različic so iz starejše različice pred nadgradnjo. Spremembe palet bodo povzročite, da palete ne bodo več prikazane za to vizualizacijo. ","favorite":"Priljubljene"},"__sv":{"errorCreatingPalette":"Ett fel uppstod när paletten skulle sparas.","paletteErrorTitle":"Palettfel","changePaletteLabel":"Ändra färgpalett","myPaletteLabel":"Anpassad","legacyPaletteLabel":"Äldre","systemPaletteLabel":"System","publicPaletteLabel":"Global","localPaletteLabel":"Lokal","mruPaletteLabel":"Senast använda","okDialog":"OK","deleteDialogTitle":"Ta bort","applyDialog":"Tillämpa","cancelDialog":"Avbryt","saveDialog":"Spara","createDialog":"Skapa","deleteMessage":"Vill du ta bort paletten %{name}?","deleteToast":"%{name} togs bort","favoritesLabel":"Favoriter","setAsFavorite":"Ange som favorit","createdToastMessage":"%{name} har skapats.","createPalette":"Skapa en anpassad palett","colorPicker":"Färgväljare","errorNoName":"Ange ett namn för paletten","errorInsufficientColors":"Välj minst två färger","paletteAppliedToastMessage":"Paletten %{name} tillämpades på rapporten.","createPaletteHeader":"Skapa färgpalett","modifyPaletteHeader":"Redigera färgpalett","paletteNamePlaceholder":"Skriv palettnamn här","paletteName":"Palettnamn","standardPalette":"Kategorisk palett","continuousPalette":"Kontinuerlig palett","removeSwatch":"Ta bort färgrutor","addSwatch":"Lägg till färgrutor","reversePalette":"Omvänd palett","colorGuide":"Färgguide","modeAutomatic":"Automatisk","modeCustom":"Anpassad","colorModel":"Färgmodell","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Rutnät","wheel":"Hjul","hexCode":"Hexkod","colorRed":"Röd","colorGreen":"Grön","colorBlue":"Blå","colorHue":"Nyans","colorSaturation":"Mättnad","colorBrightness":"Ljusstyrka","colorCyan":"Cyan","colorMagenta":"Magenta","colorYellow":"Gul","colorBlack":"Svart","codeRed":"Röd","codeGreen":"Grön","codeBlue":"Blå","codeHue":"Nyans","codeSaturation":"Mättnad","codeBrightness":"Ljusstyrka","close":"Stäng","duplicate":"Kopiera","edit":"Redigera","delete":"Ta bort","editSchematic":"Redigera paket","searchSchematic":"Sök","nameLabelSchematic":"Namn","captionLabelSchematic":"Objekttext","keyLabelSchematic":"Nyckel","addSchematic":"Överför fil","schematicsInvalidSvg":"Ogiltig eller ohanterad SVG","schematicsInvalidSvgData":"Det gick inte att hämta fildata","schematicsInvalidType":"Otillåten filtyp: %{type}","schematicsInvalidSize":"Filen %{file}, storlek %{size} överskrider gränsen.","schematicsContextMenuReplace":"Ersätt","schematicsContextMenuDelete":"Ta bort","schematicsEmptySearchResults":"Sökresultatet är tomt","schematicsNoSelection":"Inga objekt har valts","schematicsMultipleSelection":"%{count} objekt har valts","schematicsSingleDeletionSuccessed":"Din schematik togs bort.","schematicsMultipleDeletionSuccessed":"%{count} schematiker togs bort.","schematicsSingleAddSuccessed":"Din schematik lades till.","schematicsMultipleAddSuccessed":"%{count} schematiker lades till.","schematicsAddFailed":"Det gick inte att lägga till din schematik","schematicsReplaceDlgTitle":"Bekräfta ersättning av befintlig fil","schematicsReplaceDlgContent":"Filen '%{sourceName}' finns redan. Vill du ersätta den med den nya filen?","schematicsReplaceDlgApplyToAllFiles":"Tillämpa på alla filer","schematicsPackageTab":"Paket","schematicsContentTab":"Innehåll","schematicsDescriptionLabel":"Beskrivning","schematicsIconLabel":"Ikon","schematicsChooseFile":"Lägg till fil","schematicsDeleteIcon":"Ta bort ikonen","schematicsIconAdded":"Ikonen \"%{file}\" lades till.","schematicsIconRemove":"Ikonen togs bort.","schematicsIconDropFiles":"Dra och släpp fil här eller överför","schematicsIconOr":"eller","schematicsIconFileTypes":"Endast .jpg-, .png- och .svg-filer.","schematicsIconFileSize":"%{size} MB max filstorlek.","legacySectionExtraMessage":"Varning: Paletter är från en tidigare version innan du uppgraderade. Ändringar av dessa paletter kommer att orsaka att de inte längre visas för den här visualiseringen.","favorite":"Favoriter"},"__th":{"errorCreatingPalette":"เกิดข้อผิดพลาดขณะบันทึกพาเล็ต","paletteErrorTitle":"ข้อผิดพลาดพาเล็ต","changePaletteLabel":"เปลี่ยนพาเล็ตสี","myPaletteLabel":"กำหนดเอง","legacyPaletteLabel":"ดั้งเดิม","systemPaletteLabel":"ระบบ","publicPaletteLabel":"โกลบอล","localPaletteLabel":"โลคัล","mruPaletteLabel":"ใช้ล่าสุด","okDialog":"ตกลง","deleteDialogTitle":"ลบ","applyDialog":"ใช้","cancelDialog":"ยกเลิก","saveDialog":"บันทึก","createDialog":"สร้าง","deleteMessage":"คุณแน่ใจหรือว่าต้องการลบพาเล็ต \"%{name}\"?","deleteToast":"ลบ \"%{name}\" ออกแล้ว","favoritesLabel":"รายการโปรด","setAsFavorite":"ตั้งค่าเป็นรายการโปรด","createdToastMessage":"สร้าง \"%{name}\" เรียบร้อยแล้ว","createPalette":"สร้างพาเล็ตแบบกำหนดเอง","colorPicker":"ตัวเลือกสี","errorNoName":"ป้อนชื่อสำหรับพาเล็ตของคุณ","errorInsufficientColors":"เลือกสีสองสีขึ้นไป","paletteAppliedToastMessage":"พาเล็ต \"%{name}\" ถูกนำไปใช้กับรายงาน","createPaletteHeader":"สร้างพาเล็ตสี","modifyPaletteHeader":"แก้ไขพาเล็ตสี","paletteNamePlaceholder":"พิมพ์ชื่อพาเล็ตที่นี่","paletteName":"ชื่อพาเล็ต","standardPalette":"พาเล็ตแบบเป็นหมวดหมู่","continuousPalette":"พาเล็ตแบบต่อเนื่องกัน","removeSwatch":"ลบ swatch","addSwatch":"เพิ่ม swatch","reversePalette":"กลับพาเล็ต","colorGuide":"ตารางสี","modeAutomatic":"อัตโนมัติ","modeCustom":"กำหนดเอง","colorModel":"โมเดลสี","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"กริด","wheel":"วงล้อ","hexCode":"รหัสเลขฐานสิบหก","colorRed":"สีแดง","colorGreen":"สีเขียว","colorBlue":"สีน้ำเงิน","colorHue":"สี","colorSaturation":"ความสดของสี","colorBrightness":"ความสว่าง","colorCyan":"สีฟ้า","colorMagenta":"สีม่วงแดง","colorYellow":"สีเหลือง","colorBlack":"สีดำ","codeRed":"สีแดง","codeGreen":"สีเขียว","codeBlue":"สีน้ำเงิน","codeHue":"สี","codeSaturation":"ความสดของสี","codeBrightness":"ความสว่าง","close":"ปิด","duplicate":"ทำซ้ำ","edit":"แก้ไข","delete":"ลบ","editSchematic":"แก้ไขแพ็กเกจ","searchSchematic":"ค้นหา","nameLabelSchematic":"ชื่อ","captionLabelSchematic":"คำบรรยาย","keyLabelSchematic":"คีย์","addSchematic":"อัพโหลดไฟล์","schematicsInvalidSvg":"SVG ไม่ถูกต้องหรือไม่สนับสนุน","schematicsInvalidSvgData":"ไม่สามารถขอรับข้อมูลไฟล์","schematicsInvalidType":"ชนิดไฟล์ที่ไม่สนับสนุน: %{type}","schematicsInvalidSize":"ไฟล์ %{file} ขนาด %{size} เกินขนาดที่จำกัดไว้","schematicsContextMenuReplace":"แทนที่","schematicsContextMenuDelete":"ลบ","schematicsEmptySearchResults":"ผลลัพธ์การค้นหาว่างเปล่า","schematicsNoSelection":"ไม่มีไอเท็มที่เลือกไว้","schematicsMultipleSelection":"%{count} ไอเท็มที่เลือกไว้","schematicsSingleDeletionSuccessed":"แบบแผนของคุณถูกลบทิ้งเป็นผลสำเร็จแล้ว","schematicsMultipleDeletionSuccessed":"%{count} แบบแผนถูกลบทิ้งเป็นผลสำเร็จแล้ว","schematicsSingleAddSuccessed":"แบบแผนของคุณถูกเพิ่มเป็นผลสำเร็จแล้ว","schematicsMultipleAddSuccessed":"%{count} แบบแผนถูกเพิ่มเป็นผลสำเร็จแล้ว","schematicsAddFailed":"ล้มเหลวในการเพิ่มแบบแผนของคุณ","schematicsReplaceDlgTitle":"ยืนยันการแทนที่ไฟล์ที่มีอยู่","schematicsReplaceDlgContent":"ไฟล์ '%{sourceName}' มีอยู่ก่อนแล้ว คุณต้องการแทนที่ด้วยไฟล์ใหม่หรือไม่?","schematicsReplaceDlgApplyToAllFiles":"ใช้กับไฟล์ทั้งหมด","schematicsPackageTab":"แพ็กเกจ","schematicsContentTab":"เนื้อหา","schematicsDescriptionLabel":"คำอธิบาย","schematicsIconLabel":"ไอคอน","schematicsChooseFile":"เพิ่มไฟล์","schematicsDeleteIcon":"ลบไอคอนออก","schematicsIconAdded":"ไอคอน \"%{file}\" ถูกเพิ่มเป็นผลสำเร็จแล้ว","schematicsIconRemove":"ไอคอนถูกลบออกเป็นผลสำเร็จแล้ว","schematicsIconDropFiles":"ลากและปล่อยไฟล์ที่นี่หรืออัพโหลด","schematicsIconOr":"หรือ","schematicsIconFileTypes":"เฉพาะไฟล์ .jpg, .png, และ .svg","schematicsIconFileSize":"ขนาดไฟล์สูงสุด %{size}MB","legacySectionExtraMessage":"คำเตือน: พาเล็ตเดิมมาจากเวอร์ชันก่อนหน้าก่อนที่คุณจะอัพเกรด การเปลี่ยนแปลงพาเล็ตเหล่านี้จะทำให้ไม่ปรากฏวิชวลไลเซชันนี้อีกต่อไป","favorite":"รายการโปรด"},"__tr":{"errorCreatingPalette":"Palet kaydedilirken bir hata oluştu.","paletteErrorTitle":"Palet Hatası","changePaletteLabel":"Renk paletini değiştir","myPaletteLabel":"Özel","legacyPaletteLabel":"Eski","systemPaletteLabel":"Sistem","publicPaletteLabel":"Genel","localPaletteLabel":"Yerel","mruPaletteLabel":"Son kullanılan","okDialog":"Tamam","deleteDialogTitle":"Sil","applyDialog":"Uygula","cancelDialog":"İptal","saveDialog":"Kaydet","createDialog":"Oluştur","deleteMessage":"\"%{name}\" paletini silmek istediğinizden emin misiniz?","deleteToast":"\"%{name}\" silindi","favoritesLabel":"Sık Kullanılanlar","setAsFavorite":"Sık kullanılan olarak ayarla","createdToastMessage":"\"%{name}\" başarıyla oluşturuldu.","createPalette":"Özel palet oluştur","colorPicker":"Renk seçici","errorNoName":"Paletiniz için bir ad girin","errorInsufficientColors":"En az iki renk seçin","paletteAppliedToastMessage":"\"%{name}\" paleti, rapora uygulandı.","createPaletteHeader":"Renk paleti yarat","modifyPaletteHeader":"Renk paletini düzenle","paletteNamePlaceholder":"Buraya palet adını yazın","paletteName":"Palet adı","standardPalette":"Kategorik palet","continuousPalette":"Sürekli palet","removeSwatch":"Renk örneğini kaldır","addSwatch":"Renk örneği ekle","reversePalette":"Renk örneğini ters çevir","colorGuide":"Renk kılavuzu","modeAutomatic":"Otomatik","modeCustom":"Özel","colorModel":"Renk modeli","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"Kılavuz","wheel":"Tekerlek","hexCode":"Onaltılı kod","colorRed":"Kırmızı","colorGreen":"Yeşil","colorBlue":"Mavi","colorHue":"Renk Tonu","colorSaturation":"Doygunluk","colorBrightness":"Parlaklık","colorCyan":"Cam Göbeği","colorMagenta":"Macenta","colorYellow":"Sarı","colorBlack":"Siyah","codeRed":"Kırmızı","codeGreen":"Yeşil","codeBlue":"Mavi","codeHue":"Renk Tonu","codeSaturation":"Doygunluk","codeBrightness":"Parlaklık","close":"Kapat","duplicate":"Yinele","edit":"Düzenle","delete":"Sil","editSchematic":"Paketi düzenle","searchSchematic":"Ara","nameLabelSchematic":"Ad","captionLabelSchematic":"Başlık","keyLabelSchematic":"Tuş","addSchematic":"Dosyayı karşıya yükle","schematicsInvalidSvg":"SVG geçersiz veya desteklenmiyor","schematicsInvalidSvgData":"Dosya verileri alınamadı","schematicsInvalidType":"Desteklenmeyen dosya tipi: %{type}","schematicsInvalidSize":"%{file} dosyası, %{size} boyutu sınırı aşıyor.","schematicsContextMenuReplace":"Değiştir","schematicsContextMenuDelete":"Sil","schematicsEmptySearchResults":"Arama sonuçları boş","schematicsNoSelection":"Bir öğe seçilmedi","schematicsMultipleSelection":"%{count} öğe seçildi","schematicsSingleDeletionSuccessed":"Şemanız başarıyla silindi.","schematicsMultipleDeletionSuccessed":"%{count} şema başarıyla silindi.","schematicsSingleAddSuccessed":"Şemanız başarıyla eklendi.","schematicsMultipleAddSuccessed":"%{count} şema başarıyla eklendi.","schematicsAddFailed":"Şemanız eklenemedi.","schematicsReplaceDlgTitle":"Var olan dosyanın değiştirilmesini onayla","schematicsReplaceDlgContent":"'%{sourceName}' dosyası zaten var. Bu dosyayı yeni dosyayla değiştirmek istiyor musunuz?","schematicsReplaceDlgApplyToAllFiles":"Tüm dosyalara uygula","schematicsPackageTab":"Paket","schematicsContentTab":"İçerik","schematicsDescriptionLabel":"Tanım","schematicsIconLabel":"Simge","schematicsChooseFile":"Dosya ekle","schematicsDeleteIcon":"Simgeyi kaldır","schematicsIconAdded":"\"%{file}\" simgesi başarıyla eklendi.","schematicsIconRemove":"Simge başarıyla kaldırıldı.","schematicsIconDropFiles":"Dosyayı sürükleyip buraya bırakın ya da karşıya yükleyin","schematicsIconOr":"ya da","schematicsIconFileTypes":"Yalnızca .jpg, .png ve .svg dosyaları.","schematicsIconFileSize":"Maksimum dosya boyutu: %{size}.","legacySectionExtraMessage":"Uyarı: Eski paletler siz büyütme yapmadan önceki bir sürümden geliyor. Bu paletlerdeki değişiklikler, paletlerin bu görselleştirmede artık görünmemesine neden olacak. ","favorite":"Sık kullanılanlar"},"__zh":{"errorCreatingPalette":"保存调色板时发生错误。","paletteErrorTitle":"调色板错误","changePaletteLabel":"更改调色板","myPaletteLabel":"自定义","legacyPaletteLabel":"原始","systemPaletteLabel":"系统","publicPaletteLabel":"全局","localPaletteLabel":"本地","mruPaletteLabel":"最近使用的","okDialog":"确定","deleteDialogTitle":"删除","applyDialog":"应用","cancelDialog":"取消","saveDialog":"保存","createDialog":"创建","deleteMessage":"确定要删除调色板“%{name}”吗？","deleteToast":"“%{name}”已删除","favoritesLabel":"收藏夹","setAsFavorite":"设置为收藏项","createdToastMessage":"“%{name}”已成功创建。","createPalette":"创建自定义调色板","colorPicker":"颜色选取器","errorNoName":"请为调色板输入名称","errorInsufficientColors":"至少选择两种颜色","paletteAppliedToastMessage":"调色板“%{name}”已应用于报表。","createPaletteHeader":"创建调色板","modifyPaletteHeader":"编辑调色板","paletteNamePlaceholder":"在此输入调色板名称","paletteName":"调色板名称","standardPalette":"分类调色板","continuousPalette":"连续调色板","removeSwatch":"移除图样","addSwatch":"添加图样","reversePalette":"反转调色板","colorGuide":"颜色指南","modeAutomatic":"自动","modeCustom":"自定义","colorModel":"颜色模型","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"网格","wheel":"色轮","hexCode":"十六进制代码","colorRed":"红色","colorGreen":"绿色","colorBlue":"蓝色","colorHue":"色调","colorSaturation":"饱和度","colorBrightness":"亮度","colorCyan":"蓝绿色","colorMagenta":"品红色","colorYellow":"黄色","colorBlack":"黑色","codeRed":"红色","codeGreen":"绿色","codeBlue":"蓝色","codeHue":"色调","codeSaturation":"饱和度","codeBrightness":"亮度","close":"关闭","duplicate":"重复","edit":"编辑","delete":"删除","editSchematic":"编辑数据包","searchSchematic":"搜索","nameLabelSchematic":"名称","captionLabelSchematic":"标题","keyLabelSchematic":"密钥","addSchematic":"上载文件","schematicsInvalidSvg":"SVG 无效或不受支持","schematicsInvalidSvgData":"无法获取文件数据","schematicsInvalidType":"不支持的文件类型：%{type}","schematicsInvalidSize":"文件 %{file} 的大小 %{size} 超过限制。","schematicsContextMenuReplace":"替换","schematicsContextMenuDelete":"删除","schematicsEmptySearchResults":"搜索结果为空","schematicsNoSelection":"未选择任何项","schematicsMultipleSelection":"已选择 %{count} 项","schematicsSingleDeletionSuccessed":"示意图已成功删除。","schematicsMultipleDeletionSuccessed":"%{count} 个示意图已成功删除。","schematicsSingleAddSuccessed":"示意图已成功添加。","schematicsMultipleAddSuccessed":"%{count} 个示意图已成功添加。","schematicsAddFailed":"未能添加示意图。","schematicsReplaceDlgTitle":"确认替换现有文件","schematicsReplaceDlgContent":"文件“%{sourceName}”已存在。是否要将其替换为新文件？","schematicsReplaceDlgApplyToAllFiles":"应用于所有文件","schematicsPackageTab":"数据包","schematicsContentTab":"内容","schematicsDescriptionLabel":"说明","schematicsIconLabel":"图标","schematicsChooseFile":"添加文件","schematicsDeleteIcon":"移除图标","schematicsIconAdded":"图标“%{file}”已成功添加。","schematicsIconRemove":"图标已成功移除。","schematicsIconDropFiles":"将文件拖放到此处或上载文件","schematicsIconOr":"或","schematicsIconFileTypes":"仅限 .jpg、.png 和 .svg 文件。","schematicsIconFileSize":"%{size}MB 最大文件大小。","legacySectionExtraMessage":"警告：原始调色板来自升级前的较低版本。对这些调色板进行更改将导致其不再对此可视化显示。","favorite":"收藏夹"},"__zh-cn":{"errorCreatingPalette":"保存调色板时发生错误。","paletteErrorTitle":"调色板错误","changePaletteLabel":"更改调色板","myPaletteLabel":"自定义","legacyPaletteLabel":"原始","systemPaletteLabel":"系统","publicPaletteLabel":"全局","localPaletteLabel":"本地","mruPaletteLabel":"最近使用的","okDialog":"确定","deleteDialogTitle":"删除","applyDialog":"应用","cancelDialog":"取消","saveDialog":"保存","createDialog":"创建","deleteMessage":"确定要删除调色板“%{name}”吗？","deleteToast":"“%{name}”已删除","favoritesLabel":"收藏夹","setAsFavorite":"设置为收藏项","createdToastMessage":"“%{name}”已成功创建。","createPalette":"创建自定义调色板","colorPicker":"颜色选取器","errorNoName":"请为调色板输入名称","errorInsufficientColors":"至少选择两种颜色","paletteAppliedToastMessage":"调色板“%{name}”已应用于报表。","createPaletteHeader":"创建调色板","modifyPaletteHeader":"编辑调色板","paletteNamePlaceholder":"在此输入调色板名称","paletteName":"调色板名称","standardPalette":"分类调色板","continuousPalette":"连续调色板","removeSwatch":"移除图样","addSwatch":"添加图样","reversePalette":"反转调色板","colorGuide":"颜色指南","modeAutomatic":"自动","modeCustom":"自定义","colorModel":"颜色模型","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"网格","wheel":"色轮","hexCode":"十六进制代码","colorRed":"红色","colorGreen":"绿色","colorBlue":"蓝色","colorHue":"色调","colorSaturation":"饱和度","colorBrightness":"亮度","colorCyan":"蓝绿色","colorMagenta":"品红色","colorYellow":"黄色","colorBlack":"黑色","codeRed":"红色","codeGreen":"绿色","codeBlue":"蓝色","codeHue":"色调","codeSaturation":"饱和度","codeBrightness":"亮度","close":"关闭","duplicate":"重复","edit":"编辑","delete":"删除","editSchematic":"编辑数据包","searchSchematic":"搜索","nameLabelSchematic":"名称","captionLabelSchematic":"标题","keyLabelSchematic":"密钥","addSchematic":"上载文件","schematicsInvalidSvg":"SVG 无效或不受支持","schematicsInvalidSvgData":"无法获取文件数据","schematicsInvalidType":"不支持的文件类型：%{type}","schematicsInvalidSize":"文件 %{file} 的大小 %{size} 超过限制。","schematicsContextMenuReplace":"替换","schematicsContextMenuDelete":"删除","schematicsEmptySearchResults":"搜索结果为空","schematicsNoSelection":"未选择任何项","schematicsMultipleSelection":"已选择 %{count} 项","schematicsSingleDeletionSuccessed":"示意图已成功删除。","schematicsMultipleDeletionSuccessed":"%{count} 个示意图已成功删除。","schematicsSingleAddSuccessed":"示意图已成功添加。","schematicsMultipleAddSuccessed":"%{count} 个示意图已成功添加。","schematicsAddFailed":"未能添加示意图。","schematicsReplaceDlgTitle":"确认替换现有文件","schematicsReplaceDlgContent":"文件“%{sourceName}”已存在。是否要将其替换为新文件？","schematicsReplaceDlgApplyToAllFiles":"应用于所有文件","schematicsPackageTab":"数据包","schematicsContentTab":"内容","schematicsDescriptionLabel":"说明","schematicsIconLabel":"图标","schematicsChooseFile":"添加文件","schematicsDeleteIcon":"移除图标","schematicsIconAdded":"图标“%{file}”已成功添加。","schematicsIconRemove":"图标已成功移除。","schematicsIconDropFiles":"将文件拖放到此处或上载文件","schematicsIconOr":"或","schematicsIconFileTypes":"仅限 .jpg、.png 和 .svg 文件。","schematicsIconFileSize":"%{size}MB 最大文件大小。","legacySectionExtraMessage":"警告：原始调色板来自升级前的较低版本。对这些调色板进行更改将导致其不再对此可视化显示。","favorite":"收藏夹"},"__zh-tw":{"errorCreatingPalette":"儲存選用區時發生錯誤。","paletteErrorTitle":"選用區錯誤","changePaletteLabel":"變更調色盤","myPaletteLabel":"自訂","legacyPaletteLabel":"舊式","systemPaletteLabel":"系統","publicPaletteLabel":"廣域","localPaletteLabel":"本端","mruPaletteLabel":"最近已使用","okDialog":"確定","deleteDialogTitle":"刪除","applyDialog":"套用","cancelDialog":"取消","saveDialog":"儲存","createDialog":"建立","deleteMessage":"您確定要刪除選用區 \"%{name}\" 嗎？","deleteToast":"\"%{name}\" 已刪除","favoritesLabel":"我的最愛","setAsFavorite":"設為我的最愛","createdToastMessage":"\"%{name}\" 已順利建立。","createPalette":"建立自訂選用區","colorPicker":"顏色選取器","errorNoName":"輸入選用區的名稱","errorInsufficientColors":"至少選擇兩種顏色","paletteAppliedToastMessage":"選用區 \"%{name}\" 已套用至報告。","createPaletteHeader":"建立 color 選用區","modifyPaletteHeader":"編輯 color 選用區","paletteNamePlaceholder":"在這裡鍵入選用區名稱","paletteName":"選用區名稱","standardPalette":"種類選用區","continuousPalette":"連續選用區","removeSwatch":"移除色樣","addSwatch":"新增色樣","reversePalette":"反轉選用區","colorGuide":"顏色指南","modeAutomatic":"自動","modeCustom":"自訂","colorModel":"色彩模式","modelRGB":"RGB","modelHSB":"HSB","modelCMYK":"CMYK","grid":"網格","wheel":"輪子","hexCode":"十六進位碼","colorRed":"紅色","colorGreen":"綠色","colorBlue":"藍色","colorHue":"色調","colorSaturation":"飽和度","colorBrightness":"亮度","colorCyan":"青藍色","colorMagenta":"紫紅色","colorYellow":"黃色","colorBlack":"黑色","codeRed":"紅色","codeGreen":"綠色","codeBlue":"藍色","codeHue":"色調","codeSaturation":"飽和度","codeBrightness":"亮度","close":"關閉","duplicate":"複製","edit":"編輯","delete":"刪除","editSchematic":"編輯套件","searchSchematic":"搜尋","nameLabelSchematic":"名稱","captionLabelSchematic":"標題","keyLabelSchematic":"索引鍵","addSchematic":"上傳檔案","schematicsInvalidSvg":"無效或不受支援的 SVG","schematicsInvalidSvgData":"無法取得檔案資料","schematicsInvalidType":"不受支援的檔案類型：%{type}","schematicsInvalidSize":"檔案 %{file}（大小 %{size}）超出限制。","schematicsContextMenuReplace":"取代","schematicsContextMenuDelete":"刪除","schematicsEmptySearchResults":"搜尋結果是空的","schematicsNoSelection":"未選取項目","schematicsMultipleSelection":"%{count} 個項目已選取","schematicsSingleDeletionSuccessed":"您的示意圖已順利刪除。","schematicsMultipleDeletionSuccessed":"%{count} 個示意圖已順利刪除。","schematicsSingleAddSuccessed":"您的示意圖已順利新增。","schematicsMultipleAddSuccessed":"%{count} 個示意圖已順利新增。","schematicsAddFailed":"無法新增您的示意圖。","schematicsReplaceDlgTitle":"確認取代現有檔案","schematicsReplaceDlgContent":"檔案 '%{sourceName}' 已存在。您要使用這個新檔案來進行取代嗎？","schematicsReplaceDlgApplyToAllFiles":"套用至所有檔案","schematicsPackageTab":"套件","schematicsContentTab":"內容","schematicsDescriptionLabel":"說明","schematicsIconLabel":"圖示","schematicsChooseFile":"新增檔案","schematicsDeleteIcon":"請移除圖示","schematicsIconAdded":"圖示 \"%{file}\" 已順利新增。","schematicsIconRemove":"圖示已順利移除。","schematicsIconDropFiles":"在這裡拖放檔案或上傳","schematicsIconOr":"或","schematicsIconFileTypes":"僅限 .jpg、.png 和 .svg 檔案","schematicsIconFileSize":"%{size}MB 檔案大小上限。","legacySectionExtraMessage":"警告：舊式選用區是來自您升級之前的較舊版本。這些選用區的變更將會造成它們不再會為此視覺化而出現。","favorite":"我的最愛"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorWheel = __webpack_require__(23);

var _ColorWheel2 = _interopRequireDefault(_ColorWheel);

var _ColorRgb = __webpack_require__(26);

var _ColorRgb2 = _interopRequireDefault(_ColorRgb);

var _ColorSliders = __webpack_require__(25);

var _ColorSliders2 = _interopRequireDefault(_ColorSliders);

var _ColorMode = __webpack_require__(24);

var _ColorMode2 = _interopRequireDefault(_ColorMode);

var _ColorGrid = __webpack_require__(27);

var _ColorGrid2 = _interopRequireDefault(_ColorGrid);

var _ColorConversion = __webpack_require__(15);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

var _PaletteAlgorithms = __webpack_require__(46);

var _PaletteAlgorithms2 = _interopRequireDefault(_PaletteAlgorithms);

var _underscore = __webpack_require__(5);

var _underscore2 = _interopRequireDefault(_underscore);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

var _delete_ = __webpack_require__(28);

var _delete_2 = _interopRequireDefault(_delete_);

var _addNew_ = __webpack_require__(47);

var _addNew_2 = _interopRequireDefault(_addNew_);

var _repeat_ = __webpack_require__(48);

var _repeat_2 = _interopRequireDefault(_repeat_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var MIN_SWATCH_COUNT = 2;
var MAX_SWATCH_COUNT_CONTINUOUS = 9;
var MAX_SWATCH_COUNT_CATEGORICAL = 36;
// CustomPalette class

var CustomPalette = function (_Component) {
	_inherits(CustomPalette, _Component);

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed, the selectedTab for the tab panel and the selected item in the select drop down list
	function CustomPalette(props) {
		_classCallCheck(this, CustomPalette);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {

			//Check to see if a palette definition exists (opening a palette for edit or duplicating)
			//If one exists set state and properties accordingly from the palette definition
			if (_this.props.paletteDef) {
				var paletteColors = void 0,
				    paletteType = void 0;
				if (_this.props.paletteDef.fillType === 'continuous') {
					paletteType = 'continuous';
					paletteColors = _underscore2.default.map(_this.props.paletteDef.fills, function (aFill) {
						return aFill.fill;
					});
				} else {
					paletteType = 'standard';
					paletteColors = _underscore2.default.map(_this.props.paletteDef.fills, function (aFill) {
						return aFill.toUpperCase();
					});
				}

				_this.setState({
					paletteColors: paletteColors,
					paletteType: paletteType,
					currentSelectIndex: 0,
					paletteNameValue: _this.props.paletteDef.label,
					swatchCount: paletteColors.length
				});
			}
		};

		_this.addSwatchEntry = function () {
			if (_this.state.swatchCount >= _this._getMaxSwatchCount()) {
				return;
			}
			if (_this.state.paletteType == 'continuous') {
				var newPaletteColors = [];
				for (var i = 0; i < _this.state.paletteColors.length; i++) {
					newPaletteColors.push(_this.state.paletteColors[i]);
				}
				newPaletteColors.push('#FFFFFF');
				_this.setState({
					swatchCount: newPaletteColors.length,
					currentSelectIndex: newPaletteColors.length - 1,
					paletteColors: newPaletteColors
				});
			} else {
				var count = _this.state.swatchCount + 1;
				_this.setState({
					swatchCount: count,
					currentSelectIndex: count - 1
				});
			}
		};

		_this.removeSwatchEntry = function () {
			if (_this.state.swatchCount <= MIN_SWATCH_COUNT) {
				return;
			}
			var newPaletteColors = [];
			for (var i = 0; i < _this.state.paletteColors.length; i++) {
				if (i != _this.state.currentSelectIndex) {
					newPaletteColors.push(_this.state.paletteColors[i]);
				}
			}

			var newCount = _this.state.swatchCount - 1;
			// if it was the last one, move the index, otherwise leave it alone
			var selectedIndex = _this.state.currentSelectIndex >= newCount ? newCount - 1 : _this.state.currentSelectIndex;

			_this.setState({
				paletteColors: newPaletteColors,
				currentSelectIndex: selectedIndex,
				swatchCount: newCount
			});
		};

		_this.reversePalette = function () {
			var newPaletteColors = [];
			if (_this.state.paletteType == 'standard') {
				// add any padded empty cells to the front
				for (var i = 0; i < _this.state.swatchCount - _this.state.paletteColors.length; i++) {
					newPaletteColors.push(null);
				}
			}

			for (var _i = _this.state.paletteColors.length - 1; _i >= 0; _i--) {
				newPaletteColors.push(_this.state.paletteColors[_i]);
			}
			var newSelectedIndex = _this.state.swatchCount - 1 - _this.state.currentSelectIndex;
			_this.setState({
				paletteColors: newPaletteColors,
				currentSelectIndex: newSelectedIndex
			});
		};

		_this.applyPaletteColor = function () {
			var namePresent = !!_this.state.paletteNameValue;
			var sufficientColors = false;

			var paletteFills = null;
			var currFillType = null;
			if (_this.state.paletteType == 'continuous') {
				paletteFills = _this.deriveContinuousFills();
				sufficientColors = paletteFills.length > 1;
				currFillType = 'continuous';
			} else {
				paletteFills = _this.state.paletteColors.filter(_this.removeEmptySwatches);
				currFillType = 'simple';
				sufficientColors = paletteFills.length > 1;
			}
			if (!namePresent || !sufficientColors) {
				_this.setState({
					noName: !namePresent,
					insufficientColors: !sufficientColors
				});
				return;
			}

			var palette = { label: _this.state.paletteNameValue, fillType: currFillType, fills: paletteFills };
			var isPublic = _this.props.type == 'global';
			var paletteServicePromise = _this.props.paletteService ? Promise.resolve(_this.props.paletteService) : _this.props.glassContext.getSvc('.Palette');

			if (_this.props.paletteDef && _this.props.paletteId) {
				var options = { id: _this.props.paletteId, palette: palette };
				paletteServicePromise.then(function (service) {
					service.updatePalette(options).then(function () {
						_this.closeDialog();
					}, function (error) {
						console.log(error);
					});
				});
			} else if (!isPublic) {
				paletteServicePromise.then(function (service) {
					service.createPalette({ palette: palette }).then(function (paletteId) {
						if (_this.props.onPaletteCreated) {
							_this.props.onPaletteCreated(paletteId);
						}
						_this.closeDialog();
					}, function (error) {
						console.log(error);
					});
				});
			} else if (isPublic) {
				paletteServicePromise.then(function (service) {
					service.createPalette({ palette: palette, public: isPublic }).then(function (paletteId) {
						if (_this.props.onPaletteCreated) {
							_this.props.onPaletteCreated(paletteId);
						}
						_this.closeDialog();
					}, function (error) {
						console.log(error);
					});
				});
			}
		};

		_this.openDialog = function () {
			_this.setState({ isDialogOpen: true });
		};

		_this.closeDialog = function () {
			_this.setState({ isDialogOpen: false });
			if (_this.props.removeDialog) {
				_this.props.removeDialog();
			}
		};

		_this.state = {
			isDialogOpen: props.isDialogOpen || false,
			selectedTab: 'idColorGrid',
			selectedColorType: 'RGB',
			paletteNameValue: '',
			radioGroupSelectedOption: 'custom',
			swatchCount: _this.props.paletteType == 'continuous' ? 2 : 10,
			paletteDirection: 'forward',
			paletteType: 'standard',
			currentSelectIndex: 0,
			insufficientColors: false,
			noName: false,
			paletteColors: _this.props.paletteType == 'continuous' ? ['#FFFFFF', '#FFFFFF'] : []
		};
		return _this;
	}

	/**
 * componentDidMount - Lifecycle method. Executes before first render. Executes when the element is inserted into the virtual DOM but before the HTML node itself can be manipulated.
 * Use this point to configure the element as required based on properties passed upon creation
 **/


	/**
 *	componentDidUpdate - Lifecycle method. Executes after first render and any time a render is executed. Use this opportunity to manipulate the HTML node as required.
 * @param {Object} prevProps - Object holding the key value pairs of the previous properties used to render this element
 * @param {Object} prevState - Object holding the key value pairs of the previous state used to render this element
 **/
	CustomPalette.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {

		if (this.props.paletteType && this.state.paletteType != prevProps.paletteType) {
			this.setState({ paletteType: this.props.paletteType });
		}

		if (this.state.paletteType == 'continuous') {
			if (this.state.paletteType != prevState.paletteType) {
				var colorGuide = this.state.paletteType == 'continuous' ? 'custom' : this.state.radioGroupSelectedOption;
				this.setState({
					radioGroupSelectedOption: colorGuide,
					insufficientColors: false
				});
			}
		}
	};

	/**
 * addSwatchEntry - Add a swatch to the end of the dialog
 **/


	/**
 * removeEntryAtIndex - Remove the color entry in paletteColors at the corresponding index
 **/


	/**
 * reversePalette - Change the order of the colors in the swatches as well as the corresponding palette array.
 * In the case of continuous palettes change the direction of the gradient preview
 **/


	CustomPalette.prototype.generateSwatches = function generateSwatches() {
		var className = 'clsSwatchContainer';
		var swatches = '';
		if (this.state.paletteType === 'standard') {
			swatches = this.generateCategoricalSwatches();
		} else if (this.props.continuousStepped) {
			className = 'clsSteppedSwatchContainer';
			swatches = this.generateSteppedContinuousSwatches();
		} else {
			swatches = this.generateGradientContinuousSwatches();
		}

		return _react2.default.createElement(
			'div',
			{ className: className, tabIndex: '0', onKeyDown: this.navigateSwatch.bind(this) },
			swatches
		);
	};

	CustomPalette.prototype.generateCategoricalSwatches = function generateCategoricalSwatches() {
		var swatches = [];
		for (var i = 0; i < this.state.swatchCount; i++) {
			var backgroundColor = i < this.state.paletteColors.length ? this.state.paletteColors[i] : '#FFFFFF';
			var hasPalette = i < this.state.paletteColors.length && this.state.paletteColors[i];
			var isSelected = i == this.state.currentSelectIndex;
			var className = 'clsSwatchStyle_empty';
			if (isSelected) {
				className = hasPalette ? 'clsSwatchStyle_filled_selected' : 'clsSwatchStyle_empty_selected';
			} else if (hasPalette) {
				var hsl = _ColorConversion2.default.convertRgbToHsl(this.state.paletteColors[i]);
				className = hsl.light > 0.67 ? 'clsSwatchStyle_filled_light' : 'clsSwatchStyle_filled';
			}
			swatches.push(_react2.default.createElement(_baUiCarbonToolkit.FlexItem, {
				className: className,
				key: 'swatch' + i,
				id: 'swatch' + i,
				style: { backgroundColor: backgroundColor },
				onClick: this.selectSwatch.bind(this, i) }));
		}
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ wrap: 'wrap' },
			swatches
		);
	};

	CustomPalette.prototype.generateSteppedContinuousSwatches = function generateSteppedContinuousSwatches() {
		var _this2 = this;

		var swatches = this.state.paletteColors.map(function (color, idx) {
			var className = idx == _this2.state.currentSelectIndex ? 'clsSwatchStyle_continuous_selected' : 'clsSwatchStyle_continuous_unselected';
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ key: idx },
				_react2.default.createElement('div', { className: className, style: { backgroundColor: color }, onClick: _this2.selectSwatch.bind(_this2, idx) })
			);
		});
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ className: 'clsSwatchOutline_continuous_stepped' },
			swatches
		);
	};

	CustomPalette.prototype.generateGradientContinuousSwatches = function generateGradientContinuousSwatches() {
		var fillsCopy = this.state.paletteColors.filter(this.removeEmptySwatches);
		var gradientColor = '#FFFFFF';
		if (fillsCopy.length > 1) {
			gradientColor = 'linear-gradient(to right, ' + fillsCopy.join(',') + ')';
		}
		var fillSelectors = [];
		if (this.state.swatchCount > 1) {
			for (var i = 0; i < this.state.swatchCount; i++) {
				var className = i == this.state.currentSelectIndex ? 'clsSelector' : 'clsContinuousIndicator';
				fillSelectors.push(_react2.default.createElement(
					'div',
					{ key: 'selector_' + i, className: 'clsContinuousIndicatorContainer' },
					_react2.default.createElement('div', { className: className, style: { backgroundColor: this.state.paletteColors[i] }, onClick: this.selectSwatch.bind(this, i) })
				));
			}
		}
		var roundedEdgeClass = '';
		if (this.state.currentSelectIndex == 0) {
			roundedEdgeClass = ' clsContinuousPreviewRoundLeft';
		} else if (this.state.swatchCount == this.state.currentSelectIndex + 1) {
			roundedEdgeClass = ' clsContinuousPreviewRoundRight';
		}
		return _react2.default.createElement(
			'div',
			{ style: { background: gradientColor }, id: 'idContinuousPreview', className: 'clsContinuousPreview' + roundedEdgeClass },
			fillSelectors
		);
	};

	CustomPalette.prototype.selectSwatch = function selectSwatch(swatchIndex) {
		if (swatchIndex != this.state.currentSelectIndex) {
			this.setState({ currentSelectIndex: swatchIndex });
		}
	};

	CustomPalette.prototype.onColorChange = function onColorChange(color, isGreyScale) {
		var newPaletteColors = [];
		var selectedIndex = this.state.currentSelectIndex || 0;
		for (var i = 0; i < this.state.paletteColors.length; i++) {
			newPaletteColors.push(this.state.paletteColors[i]);
		}

		if (this.state.radioGroupSelectedOption == 'custom') {
			newPaletteColors[selectedIndex] = color;
		} else if (this.state.radioGroupSelectedOption == 'auto') {
			var hslColor = _ColorConversion2.default.convertRgbToHsl(color);
			var swatchCount = this.state.swatchCount - this.state.currentSelectIndex;
			var hslColors = isGreyScale ? _PaletteAlgorithms2.default.createPaletteViaLight(swatchCount, hslColor, isGreyScale) : _PaletteAlgorithms2.default.createPaletteViaHue(swatchCount, hslColor, isGreyScale);
			newPaletteColors[selectedIndex] = color;
			// start from 1, leaving the current "seed" color unchanged to avoid roundoff in RGB->HSL->RGB
			for (var _i2 = 1; _i2 < hslColors.length; _i2++) {
				var rgbVal = _ColorConversion2.default.convertHslToRgb(hslColors[_i2]);
				var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(rgbVal);
				newPaletteColors[selectedIndex + _i2] = rgbHex;
			}
		}
		// we always set insufficient colors to false (even if there is not enough) on a color change to keep the error indicator from being noisy
		this.setState({
			paletteColors: newPaletteColors,
			insufficientColors: false
		});
	};

	CustomPalette.prototype.removeEmptySwatches = function removeEmptySwatches(currentSwatch) {
		return !!currentSwatch;
	};

	CustomPalette.prototype.deriveContinuousFills = function deriveContinuousFills() {
		var fillsCopy = this.state.paletteColors.filter(this.removeEmptySwatches);
		// this only supports 2 colors
		if (fillsCopy.length < 2) {
			return [];
		}
		var contFills = [];
		var step = 1 / (fillsCopy.length - 1);
		for (var i = 0; i < fillsCopy.length; i++) {
			var currFill = {
				fill: fillsCopy[i],
				at: step * i
			};
			contFills.push(currFill);
		}
		return contFills;
	};

	CustomPalette.prototype.changePaletteType = function changePaletteType(val) {
		if (this.state.paletteType == val) {
			return;
		}

		this.setState({
			paletteType: val,
			paletteColors: val == 'standard' ? [] : ['#FFFFFF', '#FFFFFF'],
			currentSelectIndex: 0,
			swatchCount: val == 'standard' ? 10 : 2
		});
	};

	CustomPalette.prototype.getAdminButtons = function getAdminButtons() {
		var _this3 = this;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			null,
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					'div',
					{ className: this.state.paletteType == 'standard' ? 'clsPaletteIcons_wrapper_selected' : 'clsPaletteIcons_wrapper' },
					_react2.default.createElement('div', {
						className: 'clsPaletteStandard',
						id: 'imgStandardPalette',
						value: 'standard',
						onClick: function onClick() {
							return _this3.changePaletteType('standard');
						},
						title: _StringResources2.default.get('standardPalette')
					})
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					'div',
					{ className: this.state.paletteType == 'continuous' ? 'clsPaletteIcons_wrapper_selected' : 'clsPaletteIcons_wrapper' },
					_react2.default.createElement('div', {
						className: 'clsPaletteGradient',
						id: 'imgContinuousPalette',
						value: 'continuous',
						onClick: function onClick() {
							return _this3.changePaletteType('continuous');
						},
						title: _StringResources2.default.get('continuousPalette')
					})
				)
			)
		);
	};

	CustomPalette.prototype.navigateSwatch = function navigateSwatch(e) {
		var currentIndex = this.state.currentSelectIndex;
		var key = e.keyCode;
		switch (key) {
			case 37:
				//	left arrow
				if (currentIndex > 0) this.setState({ currentSelectIndex: currentIndex - 1 });
				break;
			case 39:
				// right arrow
				if (currentIndex != this.state.swatchCount - 1) this.setState({ currentSelectIndex: currentIndex + 1 });
				break;
		}
	};

	CustomPalette.prototype.navigatePaletteType = function navigatePaletteType(e) {
		var key = e.keyCode;
		switch (key) {
			case 37:
				//	left arrow
				if (this.state.paletteType == 'continuous') this.changePaletteType('standard');
				break;
			case 39:
				// right arrow
				if (this.state.paletteType == 'standard') this.changePaletteType('continuous');
				break;
		}
	};

	CustomPalette.prototype._getMaxSwatchCount = function _getMaxSwatchCount() {
		return this.state.paletteType == 'continuous' ? MAX_SWATCH_COUNT_CONTINUOUS : MAX_SWATCH_COUNT_CATEGORICAL;
	};

	// Function used to render the CustomPalette element (dialog)


	CustomPalette.prototype.render = function render() {
		var _this4 = this;

		var radioOptions = [{ label: _StringResources2.default.get('modeCustom'), value: 'custom', checked: true }, { label: _StringResources2.default.get('modeAutomatic'), value: 'auto' }];
		if (this.state.paletteType == 'continuous') {
			radioOptions[1].disabled = true;
		}
		var continuousStandardBtns = this.props.userClass && this.props.userClass == 'admin' ? this.getAdminButtons() : [];
		var swatches = this.generateSwatches();

		var colorWarningText = this.state.insufficientColors ? _StringResources2.default.get('errorInsufficientColors') : '';

		return this.state.isDialogOpen && _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog,
				{ width: '640px', onClose: this.closeDialog, startingFocusIndex: 0 },
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Header,
					null,
					this.props.paletteDef ? _StringResources2.default.get('modifyPaletteHeader') : _StringResources2.default.get('createPaletteHeader')
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Body,
					{ style: { height: '525px', overflow: 'hidden' } },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('paletteName'), id: 'idNameLabel', htmlFor: 'idPaletteName', type: 'caption' })
					),
					_react2.default.createElement(
						'div',
						{ style: { marginTop: '8px' } },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ justifyContent: 'space-between' },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ style: { width: '288px', height: '60px' } },
								_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
									light: true,
									placeholder: _StringResources2.default.get('paletteNamePlaceholder'),
									id: 'idPaletteName',
									value: this.state.paletteNameValue,
									onValueChange: function onValueChange(value) {
										return _this4.setState({ paletteNameValue: value, noName: !value });
									},
									style: { width: '100%' },
									label: _StringResources2.default.get('paletteName'),
									autoFocus: true,
									fullWidth: true,
									validationErrorText: _StringResources2.default.get('errorNoName'),
									hasValidationError: this.state.noName
								})
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(
									'div',
									{ tabIndex: continuousStandardBtns ? '0' : '-1', onKeyDown: this.navigatePaletteType.bind(this) },
									continuousStandardBtns
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ justifyContent: 'space-between' },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								swatches,
								_react2.default.createElement(
									'span',
									{ className: 'clsErrorMessage' },
									colorWarningText,
									'\xA0'
								)
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(
									_baUiCarbonToolkit.FlexLayout,
									null,
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Button, {
											id: 'idDelSwatch',
											intent: 'primary',
											icon: _delete_2.default.id,
											iconSize: 'small',
											variant: 'icon',
											onClick: this.removeSwatchEntry,
											iconDescription: _StringResources2.default.get('removeSwatch'),
											tabIndex: 0,
											disabled: this.state.swatchCount <= MIN_SWATCH_COUNT,
											tooltipAlignment: 'end'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Separator, {
											orientation: 'vertical',
											style: { margin: '0px' },
											className: 'clsButtonSeparator'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Button, {
											id: 'idAddSwatch',
											intent: 'primary',
											icon: _addNew_2.default.id,
											iconSize: 'small',
											variant: 'icon',
											onClick: this.addSwatchEntry,
											iconDescription: _StringResources2.default.get('addSwatch'),
											tabIndex: 0,
											disabled: this.state.swatchCount >= this._getMaxSwatchCount(),
											tooltipAlignment: 'end'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Button, {
											id: 'idReverse',
											intent: 'primary',
											icon: _repeat_2.default.id,
											iconSize: 'small',
											variant: 'icon',
											onClick: this.reversePalette.bind(this),
											tabIndex: 0,
											iconDescription: _StringResources2.default.get('reversePalette'),
											tooltipAlignment: 'end'
										})
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_baUiCarbonToolkit.Tabs,
							{ selected: this.state.selectedTab, onChange: function onChange(tabId) {
									return _this4.setState({ selectedTab: tabId });
								} },
							_react2.default.createElement(
								_baUiCarbonToolkit.TabPanel,
								{ keepTabContent: true, id: 'idColorGrid', label: _StringResources2.default.get('grid') },
								_react2.default.createElement(
									_baUiCarbonToolkit.FlexLayout,
									{ justifyContent: 'space-between', style: { marginTop: '16px' } },
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_baUiCarbonToolkit.Label, { id: 'idGridRadioGroupLabel', label: _StringResources2.default.get('colorGuide') }),
										_react2.default.createElement(_baUiCarbonToolkit.RadioGroup, {
											id: 'idGridRadioGroup',
											direction: 'vertical',
											options: radioOptions,
											onChange: function onChange(val) {
												return _this4.setState({ radioGroupSelectedOption: val });
											},
											checked: this.state.radioGroupSelectedOption,
											tabIndex: 0,
											'aria-labelledby': 'idGridRadioGroupLabel'
										})
									),
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexItem,
										null,
										_react2.default.createElement(_ColorGrid2.default, {
											id: 'idColorGridComponent',
											onColorChange: this.onColorChange.bind(this),
											color: this.state.paletteColors[this.state.currentSelectIndex]
										})
									)
								)
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.TabPanel,
								{ keepTabContent: true, id: 'idColorWheel', label: _StringResources2.default.get('wheel') },
								_react2.default.createElement(
									'div',
									{ style: { height: '320px' } },
									_react2.default.createElement(
										_baUiCarbonToolkit.FlexLayout,
										{ justifyContent: 'space-between', style: { marginTop: '16px' } },
										_react2.default.createElement(
											_baUiCarbonToolkit.FlexItem,
											null,
											_react2.default.createElement(_ColorMode2.default, {
												selectedColorType: this.state.selectedColorType,
												onChange: function onChange(value) {
													return _this4.setState({ selectedColorType: value });
												}
											}),
											_react2.default.createElement(_baUiCarbonToolkit.Label, {
												id: 'idWheelRadioGroupLabel',
												label: _StringResources2.default.get('colorGuide'),
												style: { paddingTop: '24px' }
											}),
											_react2.default.createElement(_baUiCarbonToolkit.RadioGroup, {
												id: 'idWheelRadioGroup',
												direction: 'vertical',
												options: radioOptions,
												onChange: function onChange(val) {
													return _this4.setState({ radioGroupSelectedOption: val });
												},
												checked: this.state.radioGroupSelectedOption,
												tabIndex: 0,
												'aria-labelledby': 'idWheelRadioGroupLabel'
											})
										),
										_react2.default.createElement(
											_baUiCarbonToolkit.FlexItem,
											{ style: { marginLeft: '16px' } },
											_react2.default.createElement(_ColorWheel2.default, {
												onColorChange: this.onColorChange.bind(this),
												color: this.state.paletteColors[this.state.currentSelectIndex]
											})
										),
										_react2.default.createElement(
											_baUiCarbonToolkit.FlexItem,
											{ style: { marginLeft: '16px' } },
											_react2.default.createElement(_ColorRgb2.default, {
												onChange: this.onColorChange.bind(this),
												color: this.state.paletteColors[this.state.currentSelectIndex]
											}),
											_react2.default.createElement(_ColorSliders2.default, {
												onColorChange: this.onColorChange.bind(this),
												selectedColorType: this.state.selectedColorType,
												color: this.state.paletteColors[this.state.currentSelectIndex],
												style: { marginTop: '16px' }
											})
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Footer,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCancelBtn', label: _StringResources2.default.get('cancelDialog'), onClick: this.closeDialog, tabIndex: 0 }),
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCreateBtn', label: this.props.paletteDef ? _StringResources2.default.get('saveDialog') : _StringResources2.default.get('createDialog'), onClick: this.applyPaletteColor, tabIndex: 0, primary: true })
				)
			)
		) || null;
	};

	return CustomPalette;
}(_react.Component);

CustomPalette.propTypes = {
	glassContext: _propTypes2.default.object,
	paletteDef: _propTypes2.default.string,
	paletteId: _propTypes2.default.string,
	onPaletteCreated: _propTypes2.default.func,
	removeDialog: _propTypes2.default.func,
	type: _propTypes2.default.string,
	userClass: _propTypes2.default.string,
	paletteType: _propTypes2.default.string,
	isDialogOpen: _propTypes2.default.bool,
	paletteService: _propTypes2.default.object,
	continuousStepped: _propTypes2.default.bool // treat continuous palettes as stepped (impacts the swatch rendering)
};
CustomPalette.defaultProps = {
	isDialogOpen: false,
	continuousStepped: false,
	name: 'CustomPaletteDialog'
};
exports.default = CustomPalette;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * @module /dashboard/data/Events
 * @see Events
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Class) {
	'use strict';

	/**
  * Events implements the Backbone-style eventing model objects
  *
  * @class Events
  */

	var Events = Class.extend({
		init: function init() {
			this._events = {};
		},

		/**
   * The 'on' method registers the handler and return DOJO-style event registration object with 'remove' method, which unregisters the handler.
   *
   * This implementation supports composite event names, such as 'eventBaseName:eventSecondaryName', for example: 'change:name'. Triggering 'change:name' event would invoke handlers registered to
   * listen 'change' event as well as the handlers registered to listen the 'change:name' event. The special event name 'all' can be used to listen to all event types.
   */
		on: function on(eventName, handler, context) {
			if (typeof handler !== 'function') {
				console.log('ERROR in Events.on: Invalid event handler');
			}
			if (!this._events[eventName]) {
				this._events[eventName] = [];
			}
			this._events[eventName].push({
				handler: handler,
				context: context
			});

			var that = this;
			return {
				remove: function remove() {
					that.off(eventName, handler, context);
				}
			};
		},

		/**
   * Removes the specified handler from the listening to the events on this object. If eventName is not specified then unregister handler and context for all event types. If handler is not specified
   * then unregister all event handlers for the specified context and event name. If context is not specified then unregister all event handlers for the specified handler and event name.
   *
   * Examples: obj.off('change:name', handler, context); // unregister handler in context from listening 'change:name' event obj.off(null, null, context); // unregister all event handlers for the
   * specified context obj.off(); // unregister all event handlers
   */
		off: function off(eventName, handler, context) {
			var getEvents = function getEvents(evName, self) {
				var events = self._events;
				if (!evName) {
					return events;
				}
				var parts = evName.split(':');
				events = {};
				events[parts[0]] = self._events[parts[0]];
				if (parts.length > 1 && parts[1] !== '*') {
					events[evName] = self._events[evName];
				} else if (parts.length > 1 && parts[1] === '*') {
					for (var name in self._events) {
						if (name.indexOf(parts[0] + ':') === 0) {
							events[name] = self._events[name];
						}
					}
				}
				return events;
			};
			var events = getEvents(eventName, this);

			for (var name in events) {
				var i = 0,
				    handlers = events[name];
				if (!handlers) {
					continue;
				}
				while (i < handlers.length) {
					if ((handlers[i].handler === handler || !handler) && (handlers[i].context === context || !context)) {
						handlers.splice(i, 1);
					} else {
						i++;
					}
				}
			}
		},

		/**
   * Triggers an event
   */
		trigger: function trigger(eventName, event) {
			var parts = eventName.split(':');
			var handlers = [].concat(this._events['all'] || []).concat(this._events[parts[0]] || []);
			if (parts.length > 1) {
				handlers = handlers.concat(this._events[eventName] || []);
			}
			for (var i = 0; i < handlers.length; i++) {
				if (typeof handlers[i].handler === 'function') {
					handlers[i].handler.call(handlers[i].context, event, eventName);
				}
			}
		}
	});

	// alias
	Events.prototype.emit = Events.prototype.trigger;

	//
	return Events;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=Events.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorWheel = __webpack_require__(23);

var _ColorWheel2 = _interopRequireDefault(_ColorWheel);

var _ColorMode = __webpack_require__(24);

var _ColorMode2 = _interopRequireDefault(_ColorMode);

var _ColorSliders = __webpack_require__(25);

var _ColorSliders2 = _interopRequireDefault(_ColorSliders);

var _ColorRgb = __webpack_require__(26);

var _ColorRgb2 = _interopRequireDefault(_ColorRgb);

var _ColorGrid = __webpack_require__(27);

var _ColorGrid2 = _interopRequireDefault(_ColorGrid);

var _Favorites = __webpack_require__(41);

var _Favorites2 = _interopRequireDefault(_Favorites);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var MAX_FAVORITES = 12;

// CustomPalette class

var CustomColorDialog = function (_Component) {
	_inherits(CustomColorDialog, _Component);

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed, the selectedTab for the tab panel and the selected item in the select drop down list
	function CustomColorDialog(props) {
		_classCallCheck(this, CustomColorDialog);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.applyPaletteColor = function () {
			var paletteServicePromise = _this.props.paletteService ? Promise.resolve(_this.props.paletteService) : _this.props.glassContext.getSvc('.Palette');
			paletteServicePromise.then(function (service) {
				service.setFavoriteColors(_this.favoritesView.getFavoriteColors()).then(function () {
					_this.props.onChange(_this.state.currentColor);
					_this.closeDialog();
				}, function (error) {
					console.log(error);
				});
			});
		};

		_this.closeDialog = function () {
			_this.setState({ isDialogOpen: false });
			if (_this.props.onCloseDialog) {
				_this.props.onCloseDialog();
			}
		};

		_this.openDialog = function () {
			_this.setState({ isDialogOpen: true });
		};

		_this.favoritesView = null;
		_this.state = {
			currentColor: null,
			isDialogOpen: props.isDialogOpen || false,
			selectedTab: 'idColorGrid',
			selectedColorType: 'RGB'
		};
		return _this;
	}

	CustomColorDialog.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		var paletteServicePromise = this.props.paletteService ? Promise.resolve(this.props.paletteService) : this.props.glassContext.getSvc('.Palette');
		paletteServicePromise.then(function (service) {
			service.getFavoriteColors().then(function (cmFavoriteColors) {
				_this2.favoritesView.setState({
					favoriteColors: cmFavoriteColors
				});
			});
		});
	};

	CustomColorDialog.prototype.updateSelectedColor = function updateSelectedColor(color) {
		this.setState({
			currentColor: color
		});
	};

	CustomColorDialog.prototype.setColor = function setColor(color) {
		this.updateSelectedColor(color);
		if (this.favoritesView.isFavoriteSelected()) {
			this.favoritesView.updateSelectedColor(color);
			this.favoritesView.deselectCurrentFavorite();
		}
	};

	CustomColorDialog.prototype.addFavorite = function addFavorite() {
		if (this.state.currentColor && this.favoritesView.state.favoriteColors.length < MAX_FAVORITES) {
			var colors = this.favoritesView.state.favoriteColors;
			colors.push(this.state.currentColor);
			this.favoritesView.setState({
				favoriteColors: colors
			});
		}
	};

	CustomColorDialog.prototype.render = function render() {
		var _this3 = this;

		return this.state.isDialogOpen && _react2.default.createElement(
			_baUiCarbonToolkit.Dialog,
			{ width: '481px', onClose: this.closeDialog, className: 'customColorDialog' },
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Header,
				null,
				_StringResources2.default.get('colorPicker')
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Body,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.Tabs,
					{ selected: this.state.selectedTab, onChange: function onChange(tabId) {
							return _this3.setState({ selectedTab: tabId });
						}, style: { height: '375px' } },
					_react2.default.createElement(
						_baUiCarbonToolkit.TabPanel,
						{ keepTabContent: true, id: 'idColorGrid', label: _StringResources2.default.get('grid') },
						_react2.default.createElement(
							'div',
							{ style: { marginTop: '16px' } },
							_react2.default.createElement(_ColorGrid2.default, {
								id: 'idColorGridComponent',
								onColorChange: this.setColor.bind(this)
							})
						)
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.TabPanel,
						{ keepTabContent: true, id: 'idColorWheel', label: _StringResources2.default.get('wheel') },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ style: { marginTop: '16px' } },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_ColorWheel2.default, {
										id: 'idColorWheelComponent',
										onColorChange: this.setColor.bind(this),
										color: this.state.currentColor
									})
								),
								_react2.default.createElement(
									'div',
									{ style: { marginTop: '16px', width: '160px' } },
									_react2.default.createElement(_ColorMode2.default, {
										selectedColorType: this.state.selectedColorType,
										onChange: function onChange(value) {
											return _this3.setState({ selectedColorType: value });
										}
									})
								)
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ style: { marginLeft: '16px' } },
								_react2.default.createElement(_ColorRgb2.default, {
									onChange: this.setColor.bind(this),
									color: this.state.currentColor
								}),
								_react2.default.createElement(_ColorSliders2.default, {
									onColorChange: this.setColor.bind(this),
									selectedColorType: this.state.selectedColorType,
									color: this.state.currentColor,
									style: { marginTop: '16px' }
								})
							)
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ direction: 'column' },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ justifyContent: 'flex-end' },
						_react2.default.createElement(
							_baUiCarbonToolkit.Link,
							{ className: 'addFavorite', style: { zIndex: 3000 }, onClick: this.addFavorite.bind(this) },
							_StringResources2.default.get('setAsFavorite')
						)
					),
					_react2.default.createElement(_Favorites2.default, {
						favoriteColors: [],
						updateColor: this.updateSelectedColor.bind(this),
						ref: function ref(element) {
							_this3.favoritesView = element;
						},
						numberOfFavorites: MAX_FAVORITES })
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Footer,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { label: _StringResources2.default.get('cancelDialog'), onClick: this.closeDialog }),
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { label: _StringResources2.default.get('applyDialog'), onClick: this.applyPaletteColor, disabled: !this.state.currentColor, primary: true })
			)
		) || null;
	};

	return CustomColorDialog;
}(_react.Component);

CustomColorDialog.propTypes = {
	isDialogOpen: _propTypes2.default.bool,
	glassContext: _propTypes2.default.object,
	paletteService: _propTypes2.default.object,
	onChange: _propTypes2.default.func,
	onCloseDialog: _propTypes2.default.func
};
CustomColorDialog.defaultProps = {
	isDialogOpen: false
};
exports.default = CustomColorDialog;


CustomColorDialog.defaultProps = {
	name: 'CustomColorDialog'
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(12);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorConversion = __webpack_require__(15);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var WHEEL_PIXEL_SIZE = 225;
var WHEEL_ORIGIN_OFFSET = WHEEL_PIXEL_SIZE / 2;

var ColorWheel = function (_Component) {
	_inherits(ColorWheel, _Component);

	function ColorWheel(props) {
		_classCallCheck(this, ColorWheel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._drawCanvas = function () {
			var canvasContext = _this.colorWheel.getContext('2d');
			// Center coordinates of the color wheel
			var xCoordinate = WHEEL_ORIGIN_OFFSET;
			var yCoordinate = WHEEL_ORIGIN_OFFSET;
			//Radius of the color wheel
			var iRadius = WHEEL_ORIGIN_OFFSET;
			var bCounterClockwise = false;

			//For loop used to draw the color wheel pixel by pixel on the canvas
			for (var angle = 0; angle <= 360; angle++) {
				var v_iStartAngle = (angle - 2) * Math.PI / 180;
				var v_iEndAngle = angle * Math.PI / 180;
				canvasContext.beginPath();
				canvasContext.moveTo(xCoordinate, yCoordinate);
				canvasContext.arc(xCoordinate, yCoordinate, iRadius, v_iStartAngle, v_iEndAngle, bCounterClockwise);
				canvasContext.closePath();
				var v_iGradient = canvasContext.createRadialGradient(xCoordinate, yCoordinate, 0, xCoordinate, yCoordinate, iRadius);
				v_iGradient.addColorStop(0, 'hsl(' + angle + ', 10%, 100%)');
				v_iGradient.addColorStop(1, 'hsl(' + angle + ', 100%, 50%)');
				canvasContext.fillStyle = v_iGradient;
				canvasContext.fill();
			}
		};

		_this._clickOnPalette = function (event) {
			var eventX = null;
			var eventY = null;

			if (event.type == 'touchmove') {
				eventX = event.targetTouches[0].clientX;
				eventY = event.targetTouches[0].clientY;
			} else {
				eventX = event.clientX;
				eventY = event.clientY;
			}

			var elementRelativePosition = _this._getRelativeOffset();
			var x = eventX - elementRelativePosition.left;
			var y = eventY - elementRelativePosition.top;

			var pickerOffsetWidth = _this.colorPicker.offsetWidth / 2 + 1;
			var pickerOffsetHeight = _this.colorPicker.offsetHeight / 2;

			// if clicking outside the radius of the circle, move it to the outside edge of the circle
			var circleX = x - WHEEL_ORIGIN_OFFSET;
			var circleY = WHEEL_ORIGIN_OFFSET - y;
			var radius = Math.sqrt(Math.pow(circleX, 2) + Math.pow(circleY, 2));
			if (radius > WHEEL_ORIGIN_OFFSET) {
				var fixedCircleX = WHEEL_ORIGIN_OFFSET * Math.cos(Math.acos(circleX / radius));
				var fixedCircleY = WHEEL_ORIGIN_OFFSET * Math.sin(Math.asin(circleY / radius));
				x = fixedCircleX + WHEEL_ORIGIN_OFFSET;
				y = WHEEL_ORIGIN_OFFSET - fixedCircleY;
			}

			var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(_this._getCanvasColor(x, y));
			if (rgbHex === '#000000') {
				// this is an error state in IE, where a color could not be retrieved from the canvas (our canvas has no black)
				// return and let the user try to click again
				return;
			}
			_this.setState({ pickerColor: rgbHex });
			_this.colorPicker.style.left = x - pickerOffsetWidth + 'px';
			_this.colorPicker.style.top = y - (_this.colorWheel.height + pickerOffsetHeight) + 'px';
			_this.props.onColorChange(rgbHex, false);
		};

		_this.colorWheel = null;
		_this.colorPicker = null;
		_this.state = {
			pickerColor: null
		};
		return _this;
	}

	ColorWheel.prototype.componentDidMount = function componentDidMount() {
		this._drawCanvas();
		this.colorWheel.onclick = this.colorPicker.onclick = this._clickOnPalette.bind(this);
	};

	ColorWheel.prototype._getRelativeOffset = function _getRelativeOffset() {
		var clientRect = this.colorWheel.getBoundingClientRect();
		var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		var position = { top: clientRect.top + scrollTop, left: clientRect.left + scrollLeft };

		return position;
	};

	ColorWheel.prototype._getCanvasColor = function _getCanvasColor(left, top) {
		var dataArray = this.colorWheel.getContext('2d').getImageData(left, top, 1, 1).data;
		return {
			red: dataArray[0],
			green: dataArray[1],
			blue: dataArray[2]
		};
	};

	ColorWheel.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			'div',
			{ style: { height: WHEEL_PIXEL_SIZE + 'px', width: WHEEL_PIXEL_SIZE + 'px' } },
			_react2.default.createElement('canvas', {
				width: WHEEL_PIXEL_SIZE,
				height: WHEEL_PIXEL_SIZE,
				id: 'colorWheel',
				ref: function ref(element) {
					_this2.colorWheel = element;
				}
			}),
			_react2.default.createElement('div', {
				id: 'colorPicker',
				style: { backgroundColor: this.state.pickerColor, visibility: this.state.pickerColor && this.state.pickerColor === this.props.color ? '' : 'hidden' },
				className: 'clsWheelSelector clsWheelSelectorEmpty clsPickerWrapper',
				ref: function ref(element) {
					_this2.colorPicker = element;
				} })
		);
	};

	return ColorWheel;
}(_react.Component);

ColorWheel.propTypes = {
	onColorChange: _propTypes2.default.func,
	color: _propTypes2.default.string
};
ColorWheel.defaultProps = {
	color: '#FFFFFF'
};
exports.default = ColorWheel;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorMode = function (_PureComponent) {
	_inherits(ColorMode, _PureComponent);

	function ColorMode() {
		_classCallCheck(this, ColorMode);

		return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	}

	ColorMode.prototype.render = function render() {
		var myList = [{ value: 'RGB', label: _StringResources2.default.get('modelRGB') },
		// { value: 'CMYK', label: StringResources.get('modelCMYK') },
		{ value: 'HSB', label: _StringResources2.default.get('modelHSB') }];
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_baUiCarbonToolkit.Label, { id: 'idSelectColorModeLabel', label: _StringResources2.default.get('colorModel') }),
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Select, {
					light: true,
					selected: this.props.selectedColorType,
					options: myList,
					onChange: this.props.onChange,
					'aria-labelledby': 'idSelectColorModeLabel'
				})
			)
		);
	};

	return ColorMode;
}(_react.PureComponent);

ColorMode.propTypes = {
	selectedColorType: _propTypes2.default.string,
	onChange: _propTypes2.default.func
};
ColorMode.defaultProps = {
	selectedColorType: 'RGB'
};
exports.default = ColorMode;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RgbSlider = __webpack_require__(39);

var _RgbSlider2 = _interopRequireDefault(_RgbSlider);

var _ColorConversion = __webpack_require__(15);

var _ColorConversion2 = _interopRequireDefault(_ColorConversion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorSliders = function (_Component) {
	_inherits(ColorSliders, _Component);

	function ColorSliders(props) {
		_classCallCheck(this, ColorSliders);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.onRGBChange = function (value, color) {
			if (isNaN(value)) {
				return;
			}
			var rgbColor = _ColorConversion2.default.convertRgbHexToRgbVal(_this.props.color);
			rgbColor[color.toLowerCase()] = parseInt(value);
			var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(rgbColor);
			if (rgbHex != _this.props.color) {
				_this.props.onColorChange(rgbHex, false);
			}
		};

		_this.onHSLChange = function (value, color) {
			if (isNaN(value)) {
				return;
			}
			var hslColor = _extends({}, _this.state.hslColor);
			switch (color) {
				case 'Hue':
					if (Math.round(hslColor.hue) === value) {
						return;
					}
					hslColor.hue = value;
					break;
				case 'Saturation':
					if (Math.round(hslColor.sat * 100) === value) {
						return;
					}
					hslColor.sat = value / 100;
					break;
				case 'Brightness':
					if (Math.round(hslColor.light * 100) === value) {
						return;
					}
					hslColor.light = value / 100;
					break;
			}
			_this.setState({ hslColor: hslColor });
			var rgbHex = _ColorConversion2.default.convertRgbValToRgbHex(_ColorConversion2.default.convertHslToRgb(hslColor));
			if (rgbHex != _this.props.color) {
				_this.props.onColorChange(rgbHex);
			}
		};

		_this.state = {
			hslColor: _ColorConversion2.default.convertRgbToHsl(props.color)
		};
		return _this;
	}

	ColorSliders.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		if (this.props.color != prevProps.color) {
			var newColor = this.props.color;
			// if the current HSL doesn't map to the RGB then we reset it
			if (newColor != _ColorConversion2.default.convertRgbValToRgbHex(_ColorConversion2.default.convertHslToRgb(this.state.hslColor))) {
				this.setState({ hslColor: _ColorConversion2.default.convertRgbToHsl(newColor) });
			}
		}
	};

	ColorSliders.prototype._getSliders = function _getSliders() {
		switch (this.props.selectedColorType) {
			case 'RGB':
				{
					var rgbVal = _ColorConversion2.default.convertRgbHexToRgbVal(this.props.color);
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'red',
							color: 'Red',
							onChange: this.onRGBChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: rgbVal.red
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'green',
							color: 'Green',
							onChange: this.onRGBChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: rgbVal.green
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'blue',
							color: 'Blue',
							onChange: this.onRGBChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: rgbVal.blue
						})
					);
				}
			case 'HSB':
				{
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'hue',
							color: 'Hue',
							onChange: this.onHSLChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: Math.round(this.state.hslColor.hue)
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'sat',
							color: 'Saturation',
							onChange: this.onHSLChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: Math.round(this.state.hslColor.sat * 100)
						}),
						_react2.default.createElement(_RgbSlider2.default, {
							key: 'light',
							color: 'Brightness',
							onChange: this.onHSLChange.bind(this),
							selectedColorType: this.props.selectedColorType,
							value: Math.round(this.state.hslColor.light * 100)
						})
					);
				}
		}
	};

	ColorSliders.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ id: 'idRGBWrapper' },
			this._getSliders()
		);
	};

	return ColorSliders;
}(_react.Component);

ColorSliders.propTypes = {
	onColorChange: _propTypes2.default.func,
	selectedColorType: _propTypes2.default.string,
	color: _propTypes2.default.string
};
ColorSliders.defaultProps = {
	color: '#FFFFFF',
	selectedColorType: 'RGB'
};
exports.default = ColorSliders;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorRgb = function (_PureComponent) {
	_inherits(ColorRgb, _PureComponent);

	function ColorRgb() {
		var _temp, _this, _ret;

		_classCallCheck(this, ColorRgb);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._validator = function (regex, color) {
			var matches = color.match(regex);
			return matches && matches.length == 1 && matches[0] === color;
		}, _this.validateHexInput = function (value) {
			// inject the hex string identifier if not present
			if (value.length == 0 || value[0] != '#') {
				value = '#' + value;
			}

			// if any pair is not hex digits, return before updating state to prevent the input
			var regex = /[0-9A-Fa-f]{1,2}/;
			if (value.length > 1 && !_this._validator(regex, value.substr(1, 2))) {
				return;
			}
			if (value.length > 3 && !_this._validator(regex, value.substr(3, 2))) {
				return;
			}
			if (value.length > 5 && !_this._validator(regex, value.substr(5, 2))) {
				return;
			}

			// only "process" the input if it's a full hex string
			if (value.length == 7) {
				_this.props.onChange(value.toUpperCase(), false);
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	ColorRgb.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_baUiCarbonToolkit.Label, {
				id: 'idHexCodeLabel',
				type: 'caption',
				label: _StringResources2.default.get('hexCode'),
				htmlFor: 'idTextRgbCode',
				title: _StringResources2.default.get('hexCode'),
				alt: _StringResources2.default.get('hexCode')
			}),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ style: { width: '160px' } },
					_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
						id: 'idTextRgbCode',
						light: true,
						value: this.props.color,
						onValueChange: function onValueChange(value) {
							return _this2.validateHexInput(value);
						},
						fullWidth: true,
						maxLength: '7',
						tabIndex: 0
					})
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement('div', {
						id: 'divPreview',
						className: 'clsPreviewBox',
						style: { backgroundColor: this.props.color }
					})
				)
			)
		);
	};

	return ColorRgb;
}(_react.PureComponent);

ColorRgb.propTypes = {
	color: _propTypes2.default.string,
	onChange: _propTypes2.default.func
};
ColorRgb.defaultProps = {
	color: '#FFFFFF'
};
exports.default = ColorRgb;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IBMColors = __webpack_require__(40);

var IBMColors = _interopRequireWildcard(_IBMColors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ColorGrid = function (_Component) {
	_inherits(ColorGrid, _Component);

	function ColorGrid(props) {
		_classCallCheck(this, ColorGrid);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			activeSelector: null
		};

		_this.colorNodes = _this.generateColorGrid();
		_this.blackAndWhite = [_this.getColorGrid({ backgroundColor: '#000000' }, 'black', true, false), _this.getColorGrid({ backgroundColor: '#FFFFFF' }, 'white', true, true)];
		return _this;
	}

	ColorGrid.prototype.generateColorGrid = function generateColorGrid() {
		var colorsArray = [IBMColors['Yellow 10'], IBMColors['Orange 10'], IBMColors['Red 10'], IBMColors['Magenta 10'], IBMColors['Purple 10'], IBMColors['Blue 10'], IBMColors['Cyan 10'], IBMColors['Teal 10'], IBMColors['Green 10'], IBMColors['Cool Gray 10'], IBMColors['Gray 10'], IBMColors['Warm Gray 10'], IBMColors['Yellow 20'], IBMColors['Orange 20'], IBMColors['Red 20'], IBMColors['Magenta 20'], IBMColors['Purple 20'], IBMColors['Blue 20'], IBMColors['Cyan 20'], IBMColors['Teal 20'], IBMColors['Green 20'], IBMColors['Cool Gray 20'], IBMColors['Gray 20'], IBMColors['Warm Gray 20'], IBMColors['Yellow 30'], IBMColors['Orange 30'], IBMColors['Red 30'], IBMColors['Magenta 30'], IBMColors['Purple 30'], IBMColors['Blue 30'], IBMColors['Cyan 30'], IBMColors['Teal 30'], IBMColors['Green 30'], IBMColors['Cool Gray 30'], IBMColors['Gray 30'], IBMColors['Warm Gray 30'], IBMColors['Yellow 40'], IBMColors['Orange 40'], IBMColors['Red 40'], IBMColors['Magenta 40'], IBMColors['Purple 40'], IBMColors['Blue 40'], IBMColors['Cyan 40'], IBMColors['Teal 40'], IBMColors['Green 40'], IBMColors['Cool Gray 40'], IBMColors['Gray 40'], IBMColors['Warm Gray 40'], IBMColors['Yellow 50'], IBMColors['Orange 50'], IBMColors['Red 50'], IBMColors['Magenta 50'], IBMColors['Purple 50'], IBMColors['Blue 50'], IBMColors['Cyan 50'], IBMColors['Teal 50'], IBMColors['Green 50'], IBMColors['Cool Gray 50'], IBMColors['Gray 50'], IBMColors['Warm Gray 50'], IBMColors['Yellow 60'], IBMColors['Orange 60'], IBMColors['Red 60'], IBMColors['Magenta 60'], IBMColors['Purple 60'], IBMColors['Blue 60'], IBMColors['Cyan 60'], IBMColors['Teal 60'], IBMColors['Green 60'], IBMColors['Cool Gray 60'], IBMColors['Gray 60'], IBMColors['Warm Gray 60'], IBMColors['Yellow 70'], IBMColors['Orange 70'], IBMColors['Red 70'], IBMColors['Magenta 70'], IBMColors['Purple 70'], IBMColors['Blue 70'], IBMColors['Cyan 70'], IBMColors['Teal 70'], IBMColors['Green 70'], IBMColors['Cool Gray 70'], IBMColors['Gray 70'], IBMColors['Warm Gray 70'], IBMColors['Yellow 80'], IBMColors['Orange 80'], IBMColors['Red 80'], IBMColors['Magenta 80'], IBMColors['Purple 80'], IBMColors['Blue 80'], IBMColors['Cyan 80'], IBMColors['Teal 80'], IBMColors['Green 80'], IBMColors['Cool Gray 80'], IBMColors['Gray 80'], IBMColors['Warm Gray 80'], IBMColors['Yellow 90'], IBMColors['Orange 90'], IBMColors['Red 90'], IBMColors['Magenta 90'], IBMColors['Purple 90'], IBMColors['Blue 90'], IBMColors['Cyan 90'], IBMColors['Teal 90'], IBMColors['Green 90'], IBMColors['Cool Gray 90'], IBMColors['Gray 90'], IBMColors['Warm Gray 90'], IBMColors['Yellow 100'], IBMColors['Orange 100'], IBMColors['Red 100'], IBMColors['Magenta 100'], IBMColors['Purple 100'], IBMColors['Blue 100'], IBMColors['Cyan 100'], IBMColors['Teal 100'], IBMColors['Green 100'], IBMColors['Cool Gray 100'], IBMColors['Gray 100'], IBMColors['Warm Gray 100']];

		var colors = [];
		for (var i = 0; i < colorsArray.length; i++) {
			var RgbColor = '#' + colorsArray[i];
			var colorStyle = {
				backgroundColor: RgbColor
			};
			colors.push(this.getIndexedColorGrid(colorStyle, i));
		}
		return colors;
	};

	ColorGrid.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	ColorGrid.prototype.setColor = function setColor(e, color, isGreyScale) {
		var newSelector = e.target.firstChild || e.target;
		if (this.state.activeSelector) {
			var oldSelector = this.state.activeSelector;
			if (oldSelector != newSelector) {
				oldSelector.style.display = 'none';
				oldSelector.parentNode.style.borderWidth = '1px';
				oldSelector.parentNode.style.backgroundColor = oldSelector.style.backgroundColor;
			}
		}
		newSelector.style.display = 'block';
		newSelector.parentNode.style.borderWidth = '0px';
		newSelector.parentNode.style.backgroundColor = '#FFFFFF';
		this.setState({ activeSelector: newSelector });
		this.props.onColorChange(color.toUpperCase(), isGreyScale);
	};

	ColorGrid.prototype.getIndexedColorGrid = function getIndexedColorGrid(colorStyle, i) {
		var isGreyScale = i % 12 >= 9; // column 10 is true grey, 9 and 11 are warm/cool grey, which could work without setting greyscale, but give better results treated as grey
		var needsOutline = i < 36; // somewhat random assertion that the first 3 rows are light enough to warrant an outline
		return this.getColorGrid(colorStyle, i, isGreyScale, needsOutline);
	};

	ColorGrid.prototype.getColorGrid = function getColorGrid(colorStyle, identifier, isGreyScale, needsOutline) {
		var _this2 = this;

		var gridSquareClass = needsOutline ? 'clsColorBoxStyle_white' : 'clsColorBoxStyle';
		return _react2.default.createElement(
			'div',
			{ id: 'gridIndex' + identifier, key: identifier, style: colorStyle, className: gridSquareClass, onClick: function onClick(element) {
					return _this2.setColor(element, colorStyle.backgroundColor, isGreyScale);
				} },
			_react2.default.createElement('div', { id: 'gridSelector' + identifier, className: 'clsSelector', style: { display: 'none', backgroundColor: colorStyle.backgroundColor } })
		);
	};

	ColorGrid.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ style: { display: 'flex', width: '448px' } },
			_react2.default.createElement(
				'div',
				{ style: { display: 'flex', width: '64px' } },
				this.blackAndWhite
			),
			_react2.default.createElement(
				'div',
				{ style: { display: 'flex', flexWrap: 'wrap', width: '384px' } },
				this.colorNodes
			)
		);
	};

	return ColorGrid;
}(_react.Component);

ColorGrid.propTypes = {
	onColorChange: _propTypes2.default.func,
	color: _propTypes2.default.string
};
exports.default = ColorGrid;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in a)("object"==typeof exports?exports:e)[o]=a[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1370],{"139ff196022a7a1221df":function(e,s,a){"use strict";var o=a("9689a9c94ae38b47fa2c"),c=a.n(o),i=a("9ce58a7deea14f49ef01"),t=a.n(i),n=new c.a({id:"delete_32_v7",use:"delete_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="delete_32_v7"><path d="M12 12H14V24H12zM18 12H20V24H18z" /><path d="M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z" /></symbol>'});t.a.add(n);s.a=n},"421c5ca19058cc77b189":function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var o=a("6873601dfe1d9459c1a9"),c=(a.n(o),a("139ff196022a7a1221df"));s.default=c.a},"6873601dfe1d9459c1a9":function(s,a){s.exports=e}},["421c5ca19058cc77b189"])});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(5), __webpack_require__(50), __webpack_require__(19), __webpack_require__(51)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, _, dot, Events) {
	'use strict';

	var View = null;
	var eventsRegex = /^(\S+)\s*(.*)$/;

	// View related attributes that are supported
	var viewAttributes = ['el', 'id', 'className', 'tagName', 'events'];

	/**
  * A Backbone style base View Class. UI Views should extend this class.
  *
  */
	View = Events.extend({
		templateString: null,
		id: null,

		init: function init(attributes) {
			View.inherited('init', this, arguments);
			this.viewId = _.uniqueId('view');
			this.dotTemplate = dot.template(this.templateString || '');

			_.extend(this, _.pick(attributes || {}, viewAttributes));
			this._initDomElement();
			this._attachEvents();
		},

		/**
   * The tag name given to the view's DOM element. By default it's a DIV.
   */
		tagName: 'div',

		/**
   * Initialize the DOM element for this view
   */
		_initDomElement: function _initDomElement() {
			if (!this.el) {
				var attrs = {};
				if (this.id) {
					attrs.id = _.result(this, 'id');
				}
				if (this.className) {
					attrs['class'] = _.result(this, 'className');
				}
				this.setElement(document.createElement(this.tagName));
				this.$el.attr(attrs);
			} else {
				this.setElement(_.result(this, 'el'));
			}
		},

		/**
   * Convenience function to use jQuery to find a DOM element within this view. This is
   * faster then doing a global lockup.
   */
		$: function $(selector) {
			return this.$el.find(selector);
		},

		/**
   * Hide the view
   */
		hide: function hide() {
			this.$el.hide();
		},

		/**
   * Show the view if hidden
   */
		show: function show() {
			this.$el.show();
		},

		/**
   * Make sure the target is the intended dom node, using CSS class to validate.
   * If not the right node, check out the parents.
   */
		getTarget: function getTarget(target, sClass) {
			var $t = $(target);
			if (!$t.hasClass(sClass)) {
				var parents = $t.parents('.' + sClass);
				if (parents.length > 0) {
					target = parents[0];
				}
			}
			return target;
		},

		/**
   * Render is the main function of the View. Views should implement (override) the render
   * method to populate this.el with the appropriate HTML. Render should always return this
   * to allow chaining of calls.
   */
		render: function render() {
			return this;
		},

		/**
   * Remove this view:
   *		-Remove the element from the DOM
   *		-Remove the event listeners
   */
		remove: function remove() {
			if (this.$el) {
				this.$el.remove();
			}
			if (this.off) {
				this.off();
			}
			return this;
		},

		/**
   * Set the view element to a new DOM element
   */
		setElement: function setElement(el) {
			this._detachEvents();
			this.$el = el instanceof $ ? el : $(el);
			this.el = this.$el[0];
			this._attachEvents();
			return this;
		},

		/**
   * Attaches the events in this.events to this.el for this view
   */
		_attachEvents: function _attachEvents() {
			var events = this.events;

			this._detachEvents();
			for (var key in events) {
				var callback = events[key];
				if (!_.isFunction(callback)) {
					callback = this[events[key]];
				}
				if (!callback) {
					continue;
				}
				var match = key.match(eventsRegex);
				var eventName = match[1];
				var selector = match[2];
				// add the event to the element, with a namespace 'privateViewEvents'
				this.$el.on(eventName + '.privateViewEvents' + this.viewId, selector, callback.bind(this));
			}
			return this;
		},

		/**
   * Detaches all the events from the element
   */
		_detachEvents: function _detachEvents() {
			if (this.$el) {
				this.$el.off('.privateViewEvents' + this.viewId);
			}
			return this;
		}

	});

	return View;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=View.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var ToastEnum = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};
Object.freeze(ToastEnum);
module.exports = ToastEnum;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jszip = __webpack_require__(67);

var _jszip2 = _interopRequireDefault(_jszip);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // Licensed Materials - Property of IBM
//
// IBM Watson Analytics
//
// (C) Copyright IBM Corp. 2019
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with IBM Corp.

var MB = 1000000;

/**
 * Utility class to load an SVG which can either be a single SVG or a zipped file containing one or more SVG's
 */

var FileLoader = function FileLoader(_reader, _zipMaxSize, _imgMaxSize, _allowedFileExtensions) {
	var _this = this;

	_classCallCheck(this, FileLoader);

	this.load = function (_files, _callback, _reject) {
		try {
			var results = [];

			// Define the file info if not created
			if (!_this._files) _this._files = {};

			// Load each file returning a promise for each one
			for (var i = 0; i < _files.length; i++) {
				results.push(_this._loadFile(_files[i]));
			}

			// Process all the promises and when all have finished fire the callback
			// function returning the list of svg names that have been loaded
			Promise.all(results).then(function (_dataArray) {
				// The result of the load will always return an array for each file
				// even if one file is selected.
				// Merge all arrays into one
				var mergedArrays = [].concat.apply([], _dataArray);
				return _callback(mergedArrays);
			}.bind(_this), _reject);
		} catch (_error) {
			_reject(_error);
		}
	};

	this.getFileAsBlob = function (_fileName) {
		return new Promise(function (_resolve, _reject) {
			var _fileData = this._getFileInfo(_fileName);
			if (_fileData) {
				if (_fileData.type === 'zip') {
					try {
						var file = {
							name: _fileData.data[_fileName].name,
							size: _fileData.data[_fileName]._data.uncompressedSize
						};
						this._verifyImgFileSize(file);
						_fileData.data[_fileName].async('blob').catch(function (_error) {
							_reject(_error);
						}).then(function (_content) {
							_resolve(_content);
						});
					} catch (_error) {
						_reject(_error);
					}
				} else _resolve(_fileData.data);
			} else _reject({ message: _StringResources2.default.get('schematicsInvalidSvgData') });
		}.bind(_this));
	};

	this._listZip = function (_zip) {
		var files = [];

		Object.keys(_zip).forEach(function (_fileName) {
			files.push(_fileName);
		});

		return files.filter(_this._isSVG);
	};

	this._loadFile = function (_file) {
		var results = [];
		var fileReader = !_this._reader ? new window.FileReader() : _this._reader;
		var fileType = _file.name.toLowerCase().substr(-3);

		if (_this._isSVG(_file.name) || _this._isAllowedFile(_file.name)) {
			var data = _file;
			_this._verifyImgFileSize(_file);
			_this._files[_file.name] = _this._fileData(_file.name, fileType, data, _file.size);
			results.push(_file.name);
			return Promise.resolve(results);
		} else if (!_this._allowedFileExtensions && _this._isZip(_file)) {
			return new Promise(function (_resolve, _reject) {
				fileReader.onload = function (e) {
					// Zipped svgs
					if (this._isZip(_file)) {
						// Load asynchronously
						_jszip2.default.loadAsync(e.target.result).then(function (jsZip) {
							this._files[_file.name] = this._fileData(_file.name, 'zip', jsZip.files, _file.size);
							// Get all SVG files in the zip
							var files = this._listZip(jsZip.files);
							for (var i = 0; i < files.length; i++) {
								results.push(files[i]);
							}
							_resolve(results);
						}.bind(this), function (error) {
							_reject(error);
						});
					} else {
						var data = _file;
						this._files[_file.name] = this._fileData(_file.name, 'svg', data, _file.size);
						results.push(_file.name);
						_resolve(results);
					}
				}.bind(this);

				try {
					this._readFile(_file, fileReader);
				} catch (e) {
					_reject(e);
				}
			}.bind(_this));
		} else {
			throw new Error(_StringResources2.default.get('schematicsInvalidType', { type: _file.name }));
		}
	};

	this._isZip = function (_file) {
		return _file && _file.name && _file.name.toLowerCase().substr(-4) === '.zip' && (_file.type === 'application/x-zip-compressed' || _file.type === 'application/zip' || _file.type === 'application/x-compressed');
	};

	this._isSVG = function (_fileName) {
		return _fileName.toLowerCase().substr(-4) === '.svg';
	};

	this._isAllowedFile = function (_fileName) {
		return _this._allowedFileExtensions && _this._allowedFileExtensions.indexOf(_fileName.toLowerCase().substr(-4)) >= 0;
	};

	this._readFile = function (_file, _fileReader) {
		if (_this._isZip(_file)) {
			_this._verifyZipFileSize(_file);
			_fileReader.readAsArrayBuffer(_file);
		} else if (_this._isSVG(_file)) {
			_this._verifyImgFileSize(_file);
			_fileReader.readAsDataURL(_file);
		} else {
			throw Error(_StringResources2.default.get('schematicsInvalidType', { type: _file.name }));
		}
	};

	this._verifyZipFileSize = function (_file) {
		if (_file.size > _this._zipMaxSize * MB) {
			throw Error(_StringResources2.default.get('schematicsInvalidSize', { file: _file.name, size: _file.size }));
		}
	};

	this._verifyImgFileSize = function (_file) {
		if (_file.size > _this._imgMaxSize * MB) {
			throw Error(_StringResources2.default.get('schematicsInvalidSize', { file: _file.name, size: _file.size }));
		}
	};

	this._fileData = function (_name, _type, _data) {
		return {
			'name': _name,
			'type': _type,
			'data': _data
		};
	};

	this._arrayFind = function (_arr, _obj) {
		for (var idx = 0; idx < _arr.length; ++idx) {
			if (_arr[idx] === _obj) return _obj;
		}
		return null;
	};

	this._getFileInfo = function (_fileName) {
		var keys = Object.keys(_this._files);
		var result;

		// Check first if the file is in the list
		var file = _this._arrayFind(keys, _fileName);

		if (file) {
			result = _this._files[file];
		} else {
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
				var fileData = _this._files[key];
				if (fileData.type === 'zip') {
					file = _this._arrayFind(Object.keys(fileData.data), _fileName);
					if (file) {
						result = fileData;
						break;
					}
				}
			}
		}
		return result;
	};

	this._files = null;
	if (_reader) this._reader = _reader;

	if (_zipMaxSize) this._zipMaxSize = _zipMaxSize;

	if (_imgMaxSize) this._imgMaxSize = _imgMaxSize;

	this._allowedFileExtensions = _allowedFileExtensions;
}

/**
 * Load one or more files or a single zip file
 * @param {Array} _files Array of file names
 * @param {Function} _callback The function to be called with the SVG file list
 */


/**
 * Get the svg contents
 * @param {String} _fileName The file name
 * @returns {Promise} Return a promise
 */


/**
 * List =the SVGs found in a zip file
 * @param {String} _zip The filename
 * @returns {Array} List of file names
 */


/**
 * Load a file
 * @param {Object} _file The file object
 * @param {FileReader} _fileReader A file reader object
 * @returns {Promise} A promise that loads the file
 */


/**
 * Determine if the file is a zip file
 * @param {File} _file A file object
 * @returns {Boolean} true is the file is a zip
 */


/**
 * Read the file contents
 * @param {File} _file A file object
 * @param {FileReader} The file reader
 */


/**
 * Creates a file data object
 * @param {String} _name
 * @param {String} _type zip|svg
 * @param {Object} _data Depending on the type this will be a map of ZipObjects or for single files, the svg text
 * @returns {Object} The file data object
 */


// IE do not support array.find()


/**
 * Get file metadata
 * @param {String} _fileName The file name
 * @returns {Object} Return the file metadata. See _fileData()
 */
;

exports.default = FileLoader;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                   *| IBM Cognos Products: BI
                                                                                                                                                                                                                                                                   *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                   *|
                                                                                                                                                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogWrapper = {
	show: function show(dialogClass, options) {
		var container = document.querySelector('.dialogWrapper');
		if (!container) {
			container = document.body.appendChild(document.createElement('DIV'));
			container.className = 'dialogWrapper';
		}
		var externalCloseCallback = options.onCloseDialog;
		var props = _extends({}, options, {
			ref: function ref(instance) {
				if (instance) instance.openDialog();
			},
			onCloseDialog: function onCloseDialog() {
				_reactDom2.default.unmountComponentAtNode(container);
				if (externalCloseCallback) {
					externalCloseCallback();
				}
			}
		});

		_reactDom2.default.render(_react2.default.createElement(dialogClass, props), container);
	}
};
exports.default = DialogWrapper;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbon = __webpack_require__(20);

var _baUiCarbonToolkit = __webpack_require__(3);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _CustomPalette = __webpack_require__(18);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _DialogWrapper = __webpack_require__(32);

var _DialogWrapper2 = _interopRequireDefault(_DialogWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* IBM Confidential
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OCO Source Materials
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: authoring-common
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The source code for this program is not published or otherwise
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * divested of its trade secrets, irrespective of what has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * deposited with the U.S. Copyright Office.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_ENCODING=UTF-8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_MESSAGEFORMAT_NONE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var PaletteListing = function (_Component) {
	_inherits(PaletteListing, _Component);

	// these are the anticipated props based on the ChangePaletteView options
	function PaletteListing(props) {
		_classCallCheck(this, PaletteListing);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			palettes: null
		};
		return _this;
	}

	PaletteListing.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this._registerPaletteServiceEvents();
		this.props.getPalettes().then(function (palettes) {
			_this2.setState({
				palettes: _this2._removeGlobalFromCustom(palettes),
				selectedId: _this2.props.selectedId
			});
		});
	};

	PaletteListing.prototype.componentWillUnmount = function componentWillUnmount() {
		this._unregisterPaletteServiceEvents();
	};

	PaletteListing.prototype.render = function render() {
		var _this3 = this;

		if (!this.state.palettes) return null;
		var sections = [];

		var _loop = function _loop(section) {
			var open = false;
			var palettes = _this3.state.palettes[section].map(function (palette) {
				var fills = palette.content.fills.map(function (fill) {
					if (_this3.props.createPaletteType === 'continuous') {
						fill = fill.fill;
					}
					return _react2.default.createElement(_baUiCarbonToolkit.FlexItem, { className: 'clsPaletteListingBoxStyle', style: { backgroundColor: fill }, key: fill });
				});
				var className = 'clsPaletteListingPalette';
				if (palette.id === _this3.state.selectedId) {
					className += '_selected';
					open = true;
				}
				var menuItems = _this3.props.sectionMenuItems[section];
				var overFlow = null;
				if (menuItems && menuItems.length) {
					overFlow = _react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(
							_baUiCarbon.OverflowMenu,
							null,
							menuItems.map(function (menuItem) {
								return _react2.default.createElement(_baUiCarbon.OverflowMenuItem, {
									key: menuItem,
									itemText: _StringResources2.default.get(menuItem),
									onClick: function onClick(event) {
										return _this3._performPaletteAction(event, palette, menuItem);
									}
								});
							})
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ key: palette, className: className, onClick: _this3._selectPalette.bind(_this3, palette) },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ justifyContent: 'space-between', alignItems: 'center' },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexItem,
							null,
							_react2.default.createElement(_baUiCarbonToolkit.Label, { label: palette.content.label })
						),
						overFlow
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ wrap: 'wrap' },
						fills
					)
				);
			});
			if (palettes.length) {
				sections.push(_react2.default.createElement(
					_baUiCarbon.AccordionItem,
					{ open: open, title: _StringResources2.default.get(section + 'PaletteLabel'), className: 'clsPaletteListingAccordianItem' },
					palettes
				));
			}
		};

		for (var section in this.state.palettes) {
			_loop(section);
		}
		return _react2.default.createElement(
			_baUiCarbon.Accordion,
			null,
			sections
		);
	};

	PaletteListing.prototype._registerPaletteServiceEvents = function _registerPaletteServiceEvents() {
		if (!this._registered) {
			this.props.paletteService.on('palette:created', this._onPaletteCreated, this);
			this.props.paletteService.on('palette:updated', this._onPaletteUpdate, this);
			this.props.paletteService.on('palette:deleted', this._onPaletteDelete, this);
			this._registered = true;
		}
	};

	PaletteListing.prototype._unregisterPaletteServiceEvents = function _unregisterPaletteServiceEvents() {
		if (this._registered) {
			this.props.paletteService.off('palette:created', this._onPaletteCreated, this);
			this.props.paletteService.off('palette:updated', this._onPaletteUpdate, this);
			this.props.paletteService.off('palette:deleted', this._onPaletteDelete, this);
		}
	};

	PaletteListing.prototype._selectPalette = function _selectPalette(palette) {
		this.setState({ selectedId: palette.id });
		this.props.onChange(null, palette);
	};

	PaletteListing.prototype._onPaletteUpdate = function _onPaletteUpdate(options) {
		if (options.paletteId === this.state.selectedId) {
			this.props.onChange(null, this._findPaletteFromId(options.paletteId));
		}
	};

	PaletteListing.prototype._onPaletteDelete = function _onPaletteDelete(options) {
		var palettes = _extends({}, this.state.palettes);
		var matchedSection = null;

		var _loop2 = function _loop2(sectionName) {
			var sectionPalettes = palettes[sectionName];
			var matchedPalette = sectionPalettes.find(function (candidatePalette) {
				return candidatePalette.id == options.paletteId;
			});
			if (matchedPalette) {
				palettes[sectionName] = sectionPalettes.filter(function (p) {
					return p != matchedPalette;
				});
				matchedSection = sectionName;
				return 'break';
			}
		};

		for (var sectionName in palettes) {
			var _ret2 = _loop2(sectionName);

			if (_ret2 === 'break') break;
		}
		if (options.paletteId != this.state.selectedId) {
			this.setState({ palettes: palettes });
		} else {
			var section = matchedSection || 'system';
			var palette = palettes[section].length ? palettes[section][0] : palettes['system'][0];
			this.setState({ palettes: palettes, selectedId: palette.id });
			this.props.onChange(null, palette);
		}
	};

	PaletteListing.prototype._onPaletteCreated = function _onPaletteCreated(options) {
		var _this4 = this;

		this.props.paletteService.getPalette(options.paletteId).then(function (palette) {
			var palettes = _extends({}, _this4.state.palettes);
			// can we really know which section to put it in? sections can be overriden, may not even exist...
			if (palette.public) {
				palettes.public.push(palette);
			} else if (palette.my) {
				palettes.my.push(palette);
			} else {
				// can this even happen?  maybe they should go on local
			}
			_this4.setState({
				palettes: palettes,
				selectedId: palette.id
			});
			_this4.props.onChange(null, palette);
		});
	};

	PaletteListing.prototype._findPaletteFromId = function _findPaletteFromId(paletteId) {
		for (var sectionName in this.state.palettes) {
			var _matchedPalette = this.state.palettes[sectionName].find(function (candidatePalette) {
				return candidatePalette.id == paletteId;
			});
			if (_matchedPalette) {
				return _matchedPalette;
			}
		}
	};

	PaletteListing.prototype._removeGlobalFromCustom = function _removeGlobalFromCustom(palettes) {
		if (!palettes.my) {
			return palettes;
		}
		palettes.my = palettes.my.filter(function (palette) {
			return !palette.public;
		});
		return palettes;
	};

	PaletteListing.prototype._performPaletteAction = function _performPaletteAction(_event, palette, action) {
		switch (action) {
			case 'edit':
				_DialogWrapper2.default.show(_CustomPalette2.default, {
					paletteService: this.props.paletteService,
					paletteDef: palette.content,
					paletteId: palette.id,
					isDialogOpen: true,
					type: this.props.createGlobalPalettes ? 'global' : '',
					userClass: this.props.createGlobalPalettes ? 'admin' : '',
					paletteType: palette.content.type === 'continuous' ? 'continuous' : 'standard'
				});
				break;
			case 'delete':
				this.props.paletteService.deletePalette(palette.id);
				break;
			case 'duplicate':
				_DialogWrapper2.default.show(_CustomPalette2.default, {
					paletteService: this.props.paletteService,
					paletteDef: palette.content,
					isDialogOpen: true,
					type: this.props.createGlobalPalettes ? 'global' : '',
					userClass: this.props.createGlobalPalettes ? 'admin' : '',
					paletteType: palette.content.type === 'continuous' ? 'continuous' : 'standard'
				});
				break;
			default:
				break;
		}
	};

	return PaletteListing;
}(_react.Component);

PaletteListing.propTypes = {
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	getPalettes: _propTypes2.default.func.isRequired,
	onCreatePalette: _propTypes2.default.func.isRequired,
	onChange: _propTypes2.default.func.isRequired,
	mruComponentIdentifier: _propTypes2.default.string.isRequired, // was component
	selectedId: _propTypes2.default.string,
	createPaletteType: _propTypes2.default.string,
	showRecentlyUsed: _propTypes2.default.bool,
	createGlobalPalettes: _propTypes2.default.bool, // was isAdminUI
	sectionMenuItems: _propTypes2.default.object // was menuItems
};
PaletteListing.defaultProps = {
	sectionMenuItems: {
		'my': ['edit', 'duplicate', 'delete'],
		'local': ['duplicate'],
		'public': ['duplicate'],
		'system': ['duplicate'],
		'legacy': []
	}
};
exports.default = PaletteListing;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PaletteListingView = exports.PalettePicker = exports.PaletteListing = exports.ColorPicker = exports.DialogWrapper = exports.SchematicEditor = exports.ChangePaletteView = exports.CustomPalette = exports.CustomColorDialog = undefined;

var _CustomColorDialog = __webpack_require__(21);

var _CustomColorDialog2 = _interopRequireDefault(_CustomColorDialog);

var _CustomPalette = __webpack_require__(18);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _ChangePaletteView = __webpack_require__(49);

var _ChangePaletteView2 = _interopRequireDefault(_ChangePaletteView);

var _SchematicEditor = __webpack_require__(58);

var _SchematicEditor2 = _interopRequireDefault(_SchematicEditor);

var _DialogWrapper = __webpack_require__(32);

var _DialogWrapper2 = _interopRequireDefault(_DialogWrapper);

var _ColorPicker = __webpack_require__(77);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _PaletteListing = __webpack_require__(33);

var _PaletteListing2 = _interopRequireDefault(_PaletteListing);

var _PalettePicker = __webpack_require__(80);

var _PalettePicker2 = _interopRequireDefault(_PalettePicker);

var _PaletteListingView = __webpack_require__(81);

var _PaletteListingView2 = _interopRequireDefault(_PaletteListingView);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
exports.CustomColorDialog = _CustomColorDialog2.default;
exports.CustomPalette = _CustomPalette2.default;
exports.ChangePaletteView = _ChangePaletteView2.default;
exports.SchematicEditor = _SchematicEditor2.default;
exports.DialogWrapper = _DialogWrapper2.default;
exports.ColorPicker = _ColorPicker2.default;
exports.PaletteListing = _PaletteListing2.default;
exports.PalettePicker = _PalettePicker2.default;
exports.PaletteListingView = _PaletteListingView2.default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(12);
var invariant = __webpack_require__(13);
var warning = __webpack_require__(22);
var assign = __webpack_require__(36);

var ReactPropTypesSecret = __webpack_require__(14);
var checkPropTypes = __webpack_require__(37);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(13);
  var warning = __webpack_require__(22);
  var ReactPropTypesSecret = __webpack_require__(14);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(12);
var invariant = __webpack_require__(13);
var ReactPropTypesSecret = __webpack_require__(14);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var RgbSlider = function (_PureComponent) {
	_inherits(RgbSlider, _PureComponent);

	function RgbSlider() {
		_classCallCheck(this, RgbSlider);

		return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	}

	RgbSlider.prototype.render = function render() {
		var _this2 = this;

		var sliderId = 'id' + (this.props.color.charAt(0).toUpperCase() + this.props.color.slice(1)) + 'Range';
		var max = this.props.selectedColorType == 'RGB' ? 255 : this.props.color == 'Hue' ? 360 : 100;

		return _react2.default.createElement(
			'div',
			{ className: 'clsRgbWrapper' },
			_react2.default.createElement(_baUiCarbonToolkit.Slider, {
				light: true,
				id: sliderId,
				showBoundaryLabels: true,
				value: this.props.value,
				labelText: _StringResources2.default.get('code'.concat(this.props.color)),
				onChange: function onChange(value) {
					return _this2.props.onChange(parseInt(value), _this2.props.color);
				},
				min: 0,
				max: max,
				hideTextInput: false,
				className: 'clsRgbSlider'
			})
		);
	};

	return RgbSlider;
}(_react.PureComponent);

RgbSlider.propTypes = {
	color: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	selectedColorType: _propTypes2.default.string,
	value: _propTypes2.default.int
};
exports.default = RgbSlider;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = {"Red 100":"2d0709","Red 90":"520408","Red 80":"750e13","Red 70":"a2191f","Red 60":"da1e28","Red 50":"fa4d56","Red 40":"ff8389","Red 30":"ffb3b8","Red 20":"ffd7d9","Red 10":"fff1f1","Magenta 100":"2a0a18","Magenta 90":"510224","Magenta 80":"740937","Magenta 70":"9f1853","Magenta 60":"d12771","Magenta 50":"ee5396","Magenta 40":"ff7eb6","Magenta 30":"ffafd2","Magenta 20":"ffd6e8","Magenta 10":"fff0f7","Purple 100":"1c0f30","Purple 90":"31135e","Purple 80":"491d8b","Purple 70":"6929c4","Purple 60":"8a3ffc","Purple 50":"a56eff","Purple 40":"be95ff","Purple 30":"d4bbff","Purple 20":"e8Daff","Purple 10":"f6f2ff","Blue 100":"001141","Blue 90":"001d6c","Blue 80":"002d9c","Blue 70":"0043ce","Blue 60":"0f62fe","Blue 50":"4589ff","Blue 40":"78a9ff","Blue 30":"a6c8ff","Blue 20":"d0e2ff","Blue 10":"edf5ff","Cyan 100":"061727","Cyan 90":"012749","Cyan 80":"003a6d","Cyan 70":"00539a","Cyan 60":"0072c3","Cyan 50":"1192e8","Cyan 40":"33b1ff","Cyan 30":"82cfff","Cyan 20":"bae6ff","Cyan 10":"e5f6ff","Teal 100":"081a1c","Teal 90":"022b30","Teal 80":"004144","Teal 70":"005d5d","Teal 60":"007d79","Teal 50":"009d9a","Teal 40":"08bdba","Teal 30":"3ddbd9","Teal 20":"9ef0f0","Teal 10":"d9fbfb","Green 100":"071908","Green 90":"022d0d","Green 80":"044317","Green 70":"0e6027","Green 60":"198038","Green 50":"24a148","Green 40":"42be65","Green 30":"6fdc8c","Green 20":"a7F0ba","Green 10":"defbe6","Cool Gray 100":"121619","Cool Gray 90":"21272a","Cool Gray 80":"343a3f","Cool Gray 70":"4d5358","Cool Gray 60":"697077","Cool Gray 50":"878d96","Cool Gray 40":"a2a9b0","Cool Gray 30":"c1c7cd","Cool Gray 20":"dde1E6","Cool Gray 10":"f2f4f8","Gray 100":"161616","Gray 90":"262626","Gray 80":"393939","Gray 70":"525252","Gray 60":"6f6f6f","Gray 50":"8d8d8d","Gray 40":"a8a8a8","Gray 30":"c6c6c6","Gray 20":"e0e0e0","Gray 10":"f4f4f4","Warm Gray 100":"171414","Warm Gray 90":"272525","Warm Gray 80":"3c3838","Warm Gray 70":"565151","Warm Gray 60":"736f6f","Warm Gray 50":"8f8b8b","Warm Gray 40":"ada8a8","Warm Gray 30":"cac5c4","Warm Gray 20":"e5e0df","Warm Gray 10":"f7f3f2","Yellow 100":"1c1500","Yellow 90":"302400","Yellow 80":"483700","Yellow 70":"684e00","Yellow 60":"8e6a00","Yellow 50":"b28600","Yellow 40":"d2a106","Yellow 30":"f1c21b","Yellow 20":"fddc69","Yellow 10":"fcf4d6","Orange 100":"231000","Orange 90":"3e1a00","Orange 80":"5e2900","Orange 70":"8a3800","Orange 60":"ba4e00","Orange 50":"eb6200","Orange 40":"ff832b","Orange 30":"ffb784","Orange 20":"ffd9Be","Orange 10":"fff2e8"}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

var _delete_ = __webpack_require__(28);

var _delete_2 = _interopRequireDefault(_delete_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var DEFAULT_FAVORITES = 12;

var Favorites = function (_Component) {
	_inherits(Favorites, _Component);

	function Favorites(props) {
		_classCallCheck(this, Favorites);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.numberOfFavorites = props.numberOfFavorites ? props.numberOfFavorites : DEFAULT_FAVORITES;
		_this.currentFavorite = null;
		_this.state = {
			favoriteColors: props.favoriteColors
		};
		return _this;
	}

	/**
 	 * Create a view that will show the user his favorite colors, and allow him to choose and delete
 	 * @param {array} options.updateColor - {Optional} callback when a favorite color is selected.
 	 * @param {array} options.favoriteColors - {REQUIRED} Favorite colors previously saved
 	 * @param {integer} options.numberOfFavorites - {Optional} Max number of favorites possible, by default 12.
 */

	Favorites.prototype.onDeleteFavorite = function onDeleteFavorite() {
		//last one
		var index = this.state.favoriteColors.length - 1;
		if (this.currentFavorite) {
			index = this.currentFavorite.getAttribute('favoriteIndex');
			this.deselectCurrentFavorite();
		}
		var colors = this.state.favoriteColors;
		colors.splice(index, 1);
		this.setState({
			favoriteColors: colors
		});
	};

	Favorites.prototype.handleKeyDown = function handleKeyDown(e, handler) {
		if (e.which === 13 || e.which === 32) {
			handler(e);
		}
	};

	Favorites.prototype.deselectCurrentFavorite = function deselectCurrentFavorite() {
		if (this.isFavoriteSelected()) {
			this.currentFavorite.classList.remove('selected');
			this.currentFavorite = null;
		}
	};

	Favorites.prototype.isFavoriteSelected = function isFavoriteSelected() {
		return !!this.currentFavorite;
	};

	Favorites.prototype.updateSelectedColor = function updateSelectedColor(color) {
		var colors = this.state.favoriteColors;
		colors[this.getSelectedIndex()] = color;
		this.setState({
			favoriteColors: colors
		});
	};

	Favorites.prototype.getSelectedIndex = function getSelectedIndex() {
		if (this.isFavoriteSelected()) {
			return this.currentFavorite.getAttribute('favoriteIndex');
		}
	};

	Favorites.prototype.getSelectedColor = function getSelectedColor() {
		if (this.isFavoriteSelected()) {
			return this.currentFavorite.getAttribute('value');
		}
	};

	Favorites.prototype.selectFavorite = function selectFavorite(element) {
		if (element.target.classList.contains('selected')) {
			this.currentFavorite = null;
		} else {
			this.deselectCurrentFavorite();
			this.currentFavorite = element.target;
		}
		element.target.classList.toggle('selected');
		if (this.props.updateColor) {
			this.props.updateColor(this.getSelectedColor());
		}
	};

	Favorites.prototype.getFavoriteColors = function getFavoriteColors() {
		return this.state.favoriteColors;
	};

	Favorites.prototype.getFavorite = function getFavorite(i, color) {
		var _this2 = this;

		if (color) {
			return _react2.default.createElement('div', { className: 'favoriteBox filled', key: i, tabIndex: '0', favoriteIndex: i, value: color, onKeyDown: function onKeyDown(e) {
					return _this2.handleKeyDown(e, _this2.selectFavorite.bind(_this2));
				}, onClick: function onClick(e) {
					return _this2.selectFavorite(e);
				}, style: { backgroundColor: color } });
		} else {
			return _react2.default.createElement('div', { className: 'favoriteBox', key: i, favoriteIndex: i });
		}
	};

	Favorites.prototype.generateFavorites = function generateFavorites() {
		//TODO Get CM colors
		var favorites = [];
		for (var i = 0; i < this.numberOfFavorites; i++) {
			var color = i < this.state.favoriteColors.length ? this.state.favoriteColors[i] : undefined;
			favorites.push(this.getFavorite(i, color));
		}
		return favorites;
	};

	Favorites.prototype.render = function render() {
		var _this3 = this;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ className: 'favoriteColors', direction: 'column' },
			_react2.default.createElement(_baUiCarbonToolkit.Label, { className: 'favoritesLabel', label: _StringResources2.default.get('favoritesLabel') }),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ className: 'favoritesPicker', inline: true, direction: 'row' },
				this.generateFavorites(),
				_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, { className: 'deleteFavorite', size: 'small', iconId: _delete_2.default.id, tabIndex: '0', onKeyDown: function onKeyDown(e) {
						return _this3.handleKeyDown(e, _this3.onDeleteFavorite.bind(_this3));
					}, onClick: this.onDeleteFavorite.bind(this) })
			)
		);
	};

	return Favorites;
}(_react.Component);

Favorites.propTypes = {
	updateColor: _propTypes2.default.func,
	favoriteColors: _propTypes2.default.array.isRequired,
	numberOfFavorites: _propTypes2.default.number
};
exports.default = Favorites;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(43)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n#dummyId {\n  background-color: white;\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI\n * (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.clsSteppedSwatchContainer {\n  overflow: auto;\n  margin-top: 8px;\n  height: 32px;\n}\n\n.clsSwatchContainer {\n  overflow: auto;\n  margin-top: 8px;\n  width: 450px;\n  height: 40px;\n}\n\n.clsSwatchStyle,\n.clsSwatchStyle_empty,\n.clsSwatchStyle_filled,\n.clsSwatchStyle_filled_light,\n.clsSwatchStyle_empty_selected,\n.clsSwatchStyle_filled_selected,\n.clsVisualItem_empty {\n  height: 24px;\n  padding: 0;\n  width: 24px;\n  margin: 4px 5px;\n}\n\n.clsSwatchStyle_empty,\n.clsSwatchStyle_filled,\n.clsSwatchStyle_filled_light {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_empty:hover,\n.clsSwatchStyle_filled:hover,\n.clsSwatchStyle_filled_light:hover {\n  box-shadow: 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1), 0 0 0 3px hsla(var(--hover-secondary-h, 0), var(--hover-secondary-s, 0%), var(--hover-secondary-l, 29.80392%), 1);\n}\n\n.clsSwatchStyle_empty_selected {\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.clsSwatchStyle_filled {\n  border: none;\n}\n\n.clsSwatchStyle_filled_light {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_filled_selected {\n  border: 2px solid;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.clsSwatchOutline_continuous_stepped {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_continuous,\n.clsSwatchStyle_continuous_unselected,\n.clsSwatchStyle_continuous_unselected_light,\n.clsSwatchStyle_continuous_selected {\n  height: 24px;\n  padding: 0;\n  width: 40px;\n}\n\n.clsSwatchStyle_continuous_unselected:hover:before,\n.clsSwatchStyle_continuous_unselected_light:hover:before {\n  content: '';\n  position: absolute;\n  border: 1px solid;\n  height: 28px;\n  width: 40px;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 50%), 1);\n  margin-top: -2px;\n}\n\n.clsSwatchStyle_continuous_unselected_light {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSwatchStyle_continuous_selected {\n  border: 2px solid;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.clsColorBoxStyle,\n.clsColorBoxStyle_white {\n  margin-right: 7px;\n  margin-bottom: 7px;\n  width: 25px;\n  height: 25px;\n}\n\n.clsColorBoxStyle_white {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsPaletteIcons_wrapper,\n.clsPaletteIcons_wrapper_selected {\n  padding-bottom: 3px;\n  margin: 0 8px;\n}\n\n.clsPaletteIcons_wrapper_selected {\n  box-shadow: 0 2px hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.clsPaletteIcons,\n.clsPaletteStandard,\n.clsPaletteGradient {\n  margin-top: 10px;\n  box-sizing: border-box;\n  width: 22px;\n  height: 22px;\n  border: 2px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.clsPaletteStandard {\n  background-color: #e0e0e0;\n  background-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsPaletteGradient {\n  background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, black 100%);\n}\n\n.clsWheelContainer {\n  cursor: pointer;\n}\n\n.clsPickerWrapper {\n  height: 24px;\n  width: 24px;\n  top: 0;\n  left: 0;\n  position: relative;\n}\n\n.clsWheelSelector {\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  background-color: transparent;\n}\n\n.clsPreviewBox {\n  margin-left: 8px;\n  height: 40px;\n  width: 40px;\n  position: relative;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsSelector {\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  transition: 150ms;\n}\n\n.clsContinuousIndicatorContainer {\n  width: 32px;\n  height: 32px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.clsContinuousIndicator {\n  border: 2px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  box-shadow: inset 0 0 0 1px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1), inset 0 0 0 2px hsla(var(--hover-secondary-h, 0), var(--hover-secondary-s, 0%), var(--hover-secondary-l, 29.80392%), 1);\n}\n\n.clsContinuousIndicator:hover {\n  height: 24px;\n  width: 24px;\n  transition: 150ms;\n}\n\n.clsContinuousPreview {\n  width: 97%;\n  height: 32px;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.clsContinuousPreviewRoundLeft {\n  border-radius: 16px 0px 0px 16px;\n}\n\n.clsContinuousPreviewRoundRight {\n  border-radius: 0px 16px 16px 0px;\n}\n\n.clsRgbWrapper {\n  margin-top: 16px;\n}\n\n.clsRgbWrapper .clsRgbSlider {\n  width: 71px;\n  min-width: 71px;\n  margin: 12px;\n}\n\n.clsErrorMessage {\n  color: red;\n  font-size: 0.75rem;\n}\n\n.clsButtonSeparator {\n  color: #161616;\n  color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI\n * (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.favoriteColors .favoritesLabel {\n  margin: 0px 0px 8px 8px;\n}\n\n.favoriteColors .deleteFavorite {\n  margin-left: 16px;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n\n.favoriteColors .favoriteBox {\n  border: 2px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  height: 24px;\n  padding: 0;\n  width: 24px;\n  float: left;\n  margin-left: 8px;\n}\n\n.favoriteColors .favoriteBox.filled {\n  border-style: solid;\n}\n\n.favoriteColors .favoriteBox.selected {\n  border-color: #161616;\n  border-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.addFavorite {\n  margin-right: 8px;\n}\n\n/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: BI\n * (C) Copyright IBM Corp. 2019\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n#schematicEditorToastTargetId .ba-common-globaltoast {\n  position: absolute;\n  width: 56%;\n  left: 22%;\n}\n\n.clsSVGEditorTabs .ba-common-tabList__item.is-label {\n  min-width: 120px;\n}\n\n.clsSVGSearch .ba-common-baseInput {\n  width: 288px;\n}\n\n.clsSVGTileStyle,\n.clsSVGTileStyle_selected {\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.clsSVGTileStyle:hover,\n.clsSVGTileStyle_selected:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.clsSVGTileStyleContainer {\n  margin-left: 16px;\n  margin-top: 16px;\n}\n\n.clsSVGTileStyle_selected {\n  outline: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsSVGTilesStyle {\n  overflow: auto;\n  height: 491px;\n  width: 100%;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  text-align: center;\n}\n\n.clsSVGTileStyleBase,\n.clsSVGTileStyle .clsSVGCheckmarkSelected,\n.clsSVGTileStyle_selected .clsSVGCheckmarkSelected {\n  transition: 110ms cubic-bezier(0.2, 0, 0.38, 0.9);\n}\n\n.clsSVGTileStyle .clsSVGCheckmarkSelected,\n.clsSVGTileStyle_selected .clsSVGCheckmarkSelected {\n  opacity: 0;\n}\n\n.clsSVGTileStyle_selected .clsSVGCheckmarkSelected {\n  opacity: 1;\n}\n\n.clsSVGTileCheckmark {\n  padding-top: 16px;\n  padding-right: 16px;\n}\n\n.clsSVGTabsStyle {\n  padding-top: 16px;\n  height: 594px;\n  box-sizing: border-box;\n}\n\n.clsSVGDetailContainer {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  padding: 16px;\n}\n\n.clsSVGPackageEdit .ba-common-baseInput,\n.clsSVGPackageEdit .ba-common-textArea > textarea {\n  width: 420px;\n}\n\n.clsSVGDetailEdit,\n.clsSVGDetailEdit .ba-common-baseInput,\n.clsSVGPackageEdit .ba-common-baseInput {\n  width: 100%;\n}\n\n.clsSVGFileTypeLabel {\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.clsSVGFileSizeLabel {\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.clsSVGDetailsPanel [for=\"packageNameEdit\"] {\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.clsSVGPackageEdit [for=\"packageDescriptionEdit\"] {\n  font-size: 0.875rem;\n}\n\n.clsSVGDetailEdit input,\n.clsSVGPackageEdit input,\n.clsSVGPackageEdit .ba-common-textArea > textarea {\n  box-sizing: border-box;\n}\n\n.clsSVGDetailStyle {\n  height: 216px;\n  width: 237px;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.clsSVGTileStyleMenu {\n  height: 16px;\n}\n\n.clsSVGTileStyleMenu .svgIcon {\n  color: #a8a8a8;\n  color: hsla(var(--text-03-h, 0), var(--text-03-s, 0%), var(--text-03-l, 65.88235%), 1);\n}\n\n.clsSVGTileStyleMenu .clsSVGTileStyleMenuAnchor {\n  padding-right: 4px;\n}\n\n.clsSVGTileStyleMenu:hover .svgIcon {\n  color: #e0e0e0;\n  color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsVisualItem_empty {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.clsVisualItem_empty:hover {\n  box-shadow: 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1), 0 0 0 4px hsla(var(--hover-secondary-h, 0), var(--hover-secondary-s, 0%), var(--hover-secondary-l, 29.80392%), 1);\n}\n\n.clsSVGIconPanel,\n.clsSVGDropZone {\n  width: 300px;\n}\n\n.clsSVGDetailsPanel {\n  width: 420px;\n  box-sizing: border-box;\n}\n\n.clsSVGIconRow {\n  height: 48px;\n  width: 410px;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n}\n\n#svgIconFL {\n  width: 48px;\n  height: 48px;\n}\n\n#svgIconFI {\n  margin: 4px;\n  width: 40px;\n  height: 40px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.clsSVGDropZone {\n  height: 100%;\n  border: 1px dashed;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.clsSVGDropZone.dragging {\n  outline: 2px solid;\n  outline-offset: -1px;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.clsSVGDropZone.dragging a {\n  text-decoration: underline;\n}\n\n.clsSVGDndOverlay {\n  position: absolute;\n  width: 300px;\n  height: 100%;\n  z-index: 1;\n  display: none;\n}\n\n#schematicEditorFooterId {\n  margin-top: 24px;\n}\n\n.clsSVGPackageIcon {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  font-weight: bold;\n}\n\n.clsColorPicker {\n  position: relative;\n}\n\n.clsColorPicker_flyout {\n  position: relative;\n  padding: 0.3em;\n  width: 228px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-high-contrast-adjust: none;\n}\n\n.clsColorPicker_paletteColor,\n.clsColorPicker_favoriteColor {\n  position: relative;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin: 2px 1.6px;\n}\n\n.clsColorPicker_paletteColor:hover,\n.clsColorPicker_favoriteColor:hover {\n  cursor: pointer;\n}\n\n.clsColorPicker_paletteColor:not(.clsColorPicker_not_selected),\n.clsColorPicker_favoriteColor:not(.clsColorPicker_not_selected) {\n  background-image: repeating-linear-gradient(135deg, white 0%, white 48%, red 50%, white 52%, white 100%);\n}\n\n.clsColorPicker_cell {\n  position: relative;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin: 2px 1.6px;\n}\n\n.clsColorPicker_cell:hover {\n  cursor: pointer;\n}\n\n.clsColorPicker_customColorContainer {\n  margin: 0px 0px 0px 16px;\n  width: 92px;\n  text-align: left;\n}\n\n.clsColorPicker_customColorContainer .clsColorPicker_customColor {\n  font-size: 0.875rem;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.clsColorPicker_container {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 0px 15.5px 15.5px 15.5px;\n}\n\n.clsColorPicker_topLabel {\n  font-size: 0.875rem;\n  font-weight: bold;\n  margin: 16px 0px 0px 16px;\n  width: 92px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.clsColorPicker_label {\n  font-size: 0.875rem;\n  font-weight: bold;\n  margin: 0px 0px 0px 16px;\n  width: 92px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.clsColorPicker_selected_indicator {\n  margin: 2px;\n  border: 2px solid;\n  border-color: #393939;\n  border-color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 2px hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  transition: 150ms;\n}\n\n.clsColorPicker_restoreDefault {\n  margin-left: 72px;\n  margin-top: 18px;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n\n.clsPaletteListingAccordianItem > div {\n  padding: 0px;\n}\n\n.clsPaletteListingBoxStyle {\n  margin-right: 4px;\n  margin-bottom: 4px;\n  width: 16px;\n  height: 16px;\n}\n\n.clsPaletteListingPalette {\n  border-left: 4px solid;\n  padding-left: 15.5px;\n  border-color: white;\n  border-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.clsPaletteListingPalette:hover {\n  border-color: #e0e0e0;\n  border-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n  background-color: #e0e0e0;\n  background-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.clsPaletteListingPalette_selected {\n  border-left: 4px solid;\n  padding-left: 15.5px;\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  background-color: #e0e0e0;\n  background-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}", ""]);

// exports


/***/ }),
/* 43 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(45);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 45 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var PaletteAlgorithms = function () {
	function PaletteAlgorithms() {
		_classCallCheck(this, PaletteAlgorithms);
	}

	PaletteAlgorithms.createPaletteViaHue = function createPaletteViaHue(numSwatches, hslColor) {

		var colors = [];
		var incrementAngle = 360 / numSwatches;
		var startAngle = hslColor.hue;

		for (var i = 0; i < numSwatches; i++) {
			var currAngle = startAngle + incrementAngle * i;
			if (currAngle < 0) {
				currAngle = 360 - currAngle;
			} else if (currAngle > 360) {
				currAngle = currAngle - 360;
			}
			colors.push({
				hue: currAngle,
				sat: hslColor.sat,
				light: hslColor.light
			});
		}
		return colors;
	};

	PaletteAlgorithms.createPaletteViaLight = function createPaletteViaLight(numSwatches, hslColor) {
		var colors = [];
		var startLight = hslColor.light;
		// interval is only needed if there is more than 1
		var interval = numSwatches > 1 ? startLight / (numSwatches - 1) : 0;
		for (var i = 0; i < numSwatches; i++) {
			colors.push({
				hue: hslColor.hue,
				sat: hslColor.sat,
				light: startLight - i * interval
			});
		}
		return colors;
	};

	return PaletteAlgorithms;
}();

exports.default = PaletteAlgorithms;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in a)("object"==typeof exports?exports:e)[o]=a[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([2068],{"6873601dfe1d9459c1a9":function(s,a){s.exports=e},c88a074faeb5fe768940:function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var o=a("6873601dfe1d9459c1a9"),i=(a.n(o),a("d725e5b1813de9af78e7"));s.default=i.a},d725e5b1813de9af78e7:function(e,s,a){"use strict";var o=a("9689a9c94ae38b47fa2c"),i=a.n(o),c=a("9ce58a7deea14f49ef01"),n=a.n(c),t=new i.a({id:"add-new_32_v7",use:"add-new_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="add-new_32_v7"><path d="M17 9L15 9 15 15 9 15 9 17 15 17 15 23 17 23 17 17 23 17 23 15 17 15z" /><path d="M16,2C8.269,2,2,8.269,2,16s6.269,14,14,14s14-6.269,14-14S23.731,2,16,2z M16,28C9.383,28,4,22.617,4,16S9.383,4,16,4 s12,5.383,12,12S22.617,28,16,28z" /></symbol>'});n.a.add(t);s.a=t}},["c88a074faeb5fe768940"])});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){if(true)module.exports=a(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],a);else{var s=a("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in s)("object"==typeof exports?exports:e)[o]=s[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([556],{"10eed102fbc488d5f846":function(e,a,s){"use strict";Object.defineProperty(a,"__esModule",{value:!0});var o=s("6873601dfe1d9459c1a9"),c=(s.n(o),s("33c7892ad4967aa3ba24"));a.default=c.a},"33c7892ad4967aa3ba24":function(e,a,s){"use strict";var o=s("9689a9c94ae38b47fa2c"),c=s.n(o),i=s("9ce58a7deea14f49ef01"),t=s.n(i),n=new c.a({id:"repeat_32_v7",use:"repeat_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="repeat_32_v7"><path d="M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z" /></symbol>'});t.a.add(n);a.a=n},"6873601dfe1d9459c1a9":function(a,s){a.exports=e}},["10eed102fbc488d5f846"])});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CustomPalette = __webpack_require__(18);

var _CustomPalette2 = _interopRequireDefault(_CustomPalette);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _underscore = __webpack_require__(5);

var _underscore2 = _interopRequireDefault(_underscore);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(9);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var View = __webpack_require__(29);

/**
	Class that will take the palettes, generate a property spec spec and renders it
**/

var DEFAULT_MENUITEMS = {
	'my': ['edit', 'duplicate', 'delete'],
	'local': ['duplicate'],
	'public': ['duplicate'],
	'system': ['duplicate'],
	'legacy': []
};

var PALETTE_SECTION_ORDER = ['mru', 'local', 'my', 'public', 'legacy', 'system'];

var ChangePaletteView = View.extend({

	/**
 	 * Creates a slideout view that renders a list of palettes
 	 * @param {node} options.el - parent element
 	 * @param {String} options.name - property name
 	 * @param {Object} options.isAdminUI - {boolean} boolean to duplicate items in global instead
 	 * @param {Object} options.glassContext - Glass context
 	 * @param {Object} options.menuItems - Object that represents the menu items shown for each type of palettes (my, public, system). By default : DEFAULT_MENUITEMS
 	 * @param {Function} options.getPalettes - function to call to get the list of palettes. Must return a promise that resolved with the palettes
 		 * @param {String} options.selectedId - Palette that is currently selected
 	 * @param {Function} [options.onCreatePalette]- callback called after creating a palette
 	 * @param {Function} options.onCloseCb - callback before closing the view
 	 * @param {Function} options.onChange - callback when we change palette
 	 * @param {Boolean} [options.showHeader] - Should the header be show?  Default is true
 	 * @param {String} options.createPaletteType - Type of palette to create when launching the palette dialog
 	 * @param {String} options.name - property name
 	 * @param {Boolean} [options.useSections] - Should the palettes be rendered inside of collapsible sections?  Default is true.
 	 * @param {String} [options.component] - Used for MRU logic, currently supports 'dashboard' and 'reporting'
 	 * @param {Boolean} [options.showRecentlyUsed] - Should the list of recently used palettes be displayed
 */

	init: function init(options) {
		ChangePaletteView.inherited('init', this, arguments);
		this._sectionOpenState = {}; // Use to track which section are open/closed for when we need to refresh the view
		this._initialSelectedId = options.selectedId;

		_underscore2.default.extend(this, options);
	},

	_createBannerSpec: function _createBannerSpec() {
		var _this = this;

		return {
			'type': 'Banner',
			'value': _StringResources2.default.get('changePaletteLabel'),
			'name': 'changePaletteBanner',
			'id': 'changePaletteBanner',
			'centerLabel': true,
			'onClose': function onClose() {
				_this._handleUpdatingMRU();

				if (_this.onCloseCb) {
					_this.onCloseCb();
				} else if (_this.slideout) {
					_this.slideout.hide();
				}
			},
			'clickables': [{
				'type': 'icon',
				'name': 'addNewPalette',
				'svgIcon': 'common-add-new',
				'iconTooltip': _StringResources2.default.get('createPalette'),
				'clickCallback': this._openPaletteCreator.bind(this)
			}],
			'backButton': true
		};
	},

	_openPaletteCreator: function _openPaletteCreator() {
		var _this2 = this;

		var paletteComponent = _react2.default.createElement(_CustomPalette2.default, {
			key: 'addNewPalette',
			glassContext: this.glassContext,
			onPaletteCreated: this.onPaletteCreated.bind(this),
			paletteType: this.createPaletteType,
			removeDialog: function removeDialog() {
				(0, _jquery2.default)(document.body).find('.paletteDialogContainer').remove();
			},
			ref: function ref(instance) {
				_this2.palleteDialog = instance;
			} });
		var paletteContainer = (0, _jquery2.default)(document.body).find('.paletteDialogContainer');
		if (paletteContainer.length === 0) {
			paletteContainer = (0, _jquery2.default)('<div class="paletteDialogContainer">');
			(0, _jquery2.default)(document.body).append(paletteContainer);
		}
		_reactDom2.default.render(paletteComponent, paletteContainer.get(0));
		this.palleteDialog.openDialog();
	},

	_createSectionSpec: function _createSectionSpec(paletteCategory) {
		var _this3 = this;

		var ret = {
			type: 'CollapsibleSection',
			label: _StringResources2.default.get(paletteCategory + 'PaletteLabel'),
			id: 'sectionLabel' + paletteCategory,
			name: paletteCategory,
			styleAsSimpleRow: true,
			hideSectionTitle: this.hideSectionTitle ? this.hideSectionTitle : false,
			items: [],
			onOpenChange: function onOpenChange(name, isOpen) {
				// Need to keep track which section is opened/closed for when we refresh the view
				_this3._sectionOpenState[name] = isOpen;
			}
		};
		if (paletteCategory === 'legacy') {
			ret['sectionExtraMessage'] = _StringResources2.default.get('legacySectionExtraMessage');
		}
		return ret;
	},

	_createPaletteSpec: function _createPaletteSpec(palettes, properties) {
		var _this4 = this;

		PALETTE_SECTION_ORDER.forEach(function (sectionName) {
			if (palettes[sectionName] && palettes[sectionName].length > 0) {
				var collapsibleSpec = null;
				if (_this4.useSections !== false) {
					collapsibleSpec = _this4._createSectionSpec(sectionName);
					properties.push(collapsibleSpec);
				}
				var containerProperty = collapsibleSpec ? collapsibleSpec : properties;
				palettes[sectionName].forEach(function (palette) {
					var isSelected = _this4.selectedId === palette.id;
					var propertySpec = {
						type: 'NewPalette',
						id: palette.id,
						name: _this4.name,
						reverse: _this4.reverse,
						selected: isSelected,
						palette: palette,
						createPaletteType: _this4.createPaletteType,
						isAdminUI: _this4.isAdminUI,
						onChange: _this4.onPaletteChange.bind(_this4),
						readOnly: false
					};

					if (_this4.menuItems && _this4.menuItems[palette.section]) {
						propertySpec.menuItems = _this4.menuItems[palette.section];
					} else {
						propertySpec.menuItems = DEFAULT_MENUITEMS[palette.section];
					}

					if (_this4.useSections !== false) {
						if (isSelected && typeof _this4._sectionOpenState[sectionName] === 'undefined') {
							_this4._sectionOpenState[sectionName] = true;
						}

						if (_this4._sectionOpenState[sectionName]) {
							containerProperty.open = true;
						}
						containerProperty.items.push(propertySpec);
					} else {
						containerProperty.push(propertySpec);
					}
				});
			}
		});
	},

	_getPropertySpec: function _getPropertySpec() {
		var _this5 = this;

		var properties = [];

		if (this.showHeader !== false) {
			properties.push(this._createBannerSpec());
		}

		return this.getPalettes().then(function (palettes) {
			_this5._augmentPalettes(palettes);
			_this5.palettes = palettes;
			_this5._trimCustomPalettes(palettes);
			return _this5._getMRUPalettes().then(function (mruPalettes) {
				palettes.mru = mruPalettes || [];

				_this5._createPaletteSpec(palettes, properties);

				if (properties.length === 0) {
					return null;
				}

				return {
					el: _this5.$el,
					glassContext: _this5.glassContext,
					items: properties,
					ariaLabel: properties[0].value,
					primaryUIControl: true
				};
			});
		});
	},


	/**
  * We need to augement the palette information with which section the palette is being shown in
  * @param {Array} palettes
  */
	_augmentPalettes: function _augmentPalettes(palettes) {
		if (!palettes) {
			return;
		}

		var _loop = function _loop(section) {
			if (palettes[section] && palettes[section].length > 0) {
				palettes[section].forEach(function (palette) {
					palette.section = section;
				});
			}
		};

		for (var section in palettes) {
			_loop(section);
		}
	},
	_getMRUPalettes: function _getMRUPalettes() {
		var _this6 = this;

		var mruPalettes = [];
		if (this.showRecentlyUsed === false || !this._paletteService) {
			return Promise.resolve(mruPalettes);
		}

		return this._paletteService.getRecentlyUsedPaletteInfo(this._getFillType()).then(function (mruInfo) {
			mruInfo.forEach(function (info) {
				// Cap the MRU list of palettes to 3
				if (mruPalettes.length < 3) {
					// Only add palettes to the MRU if there already somewhere else in the view (custom, global, system)
					var palette = _this6._findPaletteFromId(info.id);
					if (palette) {
						mruPalettes.push(palette);
					}
				}
			});

			return mruPalettes;
		});
	},


	/**
  * Gets the fill type of the palettes being displayed.  Assumes there's only one fillType at a time, so either all
  * simple or all continuous
  */
	_getFillType: function _getFillType() {
		if (this._fillType) {
			return this._fillType;
		}

		for (var key in this.palettes) {
			if (this.palettes[key] && this.palettes[key].length > 0) {
				var palettes = this.palettes[key];
				for (var i = 0; i < palettes.length; i++) {
					if (palettes[i].content && palettes[i].content.fillType) {
						this._fillType = palettes[i].content.fillType;
						return this._fillType;
					}
				}
			}
		}
	},


	/**
  * Given an ID, search all the sections (custom, local, global, system) for a matching ID
  */
	_findPaletteFromId: function _findPaletteFromId(id) {
		var _this7 = this;

		if (!this.palettes) {
			return null;
		}

		// Make sure we compare the base CM ID without any prefixes
		var safeId = this._getRealPaletteId(id);
		for (var key in this.palettes) {
			if (this.palettes[key]) {
				var match = _underscore2.default.find(this.palettes[key], function (palette) {
					return _this7._getRealPaletteId(palette.id) === safeId;
				});
				if (match) {
					return match;
				}
			}
		}

		return null;
	},


	/**
  * Make sure the same palette doesn't show up in the custom AND global sections
  * @param {Array} palettes
  */
	_trimCustomPalettes: function _trimCustomPalettes() {
		var palettes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		var myPalettes = palettes.my;
		var globalPalettes = palettes.public;

		var findMatch = function findMatch(id) {
			return _underscore2.default.find(globalPalettes, function (palette) {
				return palette.id === id;
			});
		};

		if (myPalettes && globalPalettes) {
			for (var i = 0; i < myPalettes.length; i++) {
				var id = myPalettes[i].id;
				if (findMatch(id)) {
					myPalettes.splice(i, 1);
					i--;
				}
			}
		}
	},


	onPaletteCreated: function onPaletteCreated(paletteId) {
		if (this.onCreatePalette) {
			this.selectedId = this.onCreatePalette(paletteId);
		}
	},

	_registerPaletteServiceEvents: function _registerPaletteServiceEvents() {
		if (this._paletteService && !this._regisered) {
			this._regisered = true;
			this._paletteService.on('palette:created', this.render, this);
			this._paletteService.on('palette:updated', this._onPaletteUpdate, this);
			this._paletteService.on('palette:deleted', this._onPaletteDelete, this);
		}
	},
	_unregisterPaletteServiceEvents: function _unregisterPaletteServiceEvents() {
		if (this._paletteService) {
			this._paletteService.off('palette:created', this.render, this);
			this._paletteService.off('palette:updated', this._onPaletteUpdate, this);
			this._paletteService.off('palette:deleted', this._onPaletteDelete, this);
		}
	},


	/**
  * Update the internal selectedId and call the onChange callback
  */
	onPaletteChange: function onPaletteChange(propertyName, paletteItem) {
		this.selectedId = paletteItem.id;
		if (this.onChange) {
			this.onChange(propertyName, paletteItem);
		}
	},
	_handleUpdatingMRU: function _handleUpdatingMRU() {
		// If the user changed the palette, then update the recently used list
		if (this.selectedId !== this._initialSelectedId) {
			var palette = this._findPaletteFromId(this.selectedId);

			// Don't add local palettes to the MRU list
			if (palette && palette.section !== 'local') {
				var propName = this.name || '';

				// Dashboard has a different list of system palettes for heat and conditional.  Make sure
				// we keep 3 palettes in the MRU for both sets
				var trimSystemByPropName = propName === 'condColorPalette' || propName.indexOf('contColorPalette') === 0 ? true : false;

				this._paletteService.addRecentlyUsedPalette({
					palette: palette,
					isSystem: palette.section === 'system',
					component: this.component,
					propName: propName,
					trimSystemByPropName: trimSystemByPropName
				});
			}
		}
	},


	/**
  * Palette IDs sometime have a prefix to let us know it's a CM palette.  This will
  * remove any prefix
  */
	_getRealPaletteId: function _getRealPaletteId(id) {
		return this._paletteService.getCMSafePaletteId(id);
	},
	_onPaletteUpdate: function _onPaletteUpdate(_ref) {
		var paletteId = _ref.paletteId;

		this._updatePaletteProperties({
			properties: this._propertyUIControl.getProperties(),
			paletteIdToUpdate: paletteId,
			action: 'update'
		});
	},


	/**
  * Method to update properties inline without having to refresh the entire pane.  Only works
  * for updates and if deleting a palette that you currently don't have selected.
  */
	_updatePaletteProperties: function _updatePaletteProperties(_ref2) {
		var _this8 = this;

		var properties = _ref2.properties,
		    paletteIdToUpdate = _ref2.paletteIdToUpdate,
		    action = _ref2.action,
		    parentProperty = _ref2.parentProperty;

		var _loop2 = function _loop2(_i) {
			var property = properties[_i];
			if (property.type === 'CollapsibleSection') {
				_this8._updatePaletteProperties({
					properties: property._oPropertyUIControl.getProperties(),
					paletteIdToUpdate: paletteIdToUpdate,
					action: action,
					parentProperty: property
				});
			} else if (property.type === 'NewPalette' && property.palette && _this8._getRealPaletteId(property.palette.id) === paletteIdToUpdate) {
				var propertyNode = property.$el.find('.property_' + property.id);
				if (action === 'update') {
					propertyNode.remove();
					_this8._paletteService.getPalette(paletteIdToUpdate).then(function (palette) {
						property.palette.content = palette.content;
						property.doRender();
					});
				} else if (action === 'delete') {
					properties.splice(_i, 1);
					_i--;
					if (properties.length === 0 && parentProperty) {
						parentProperty.$el.find('.collapsibleSectionToggle' + parentProperty.id).remove();
						parentProperty.$el.find('.property_' + parentProperty.id).remove();
					} else {
						propertyNode.remove();
					}
				}
			}
			i = _i;
		};

		for (var i = 0; i < properties.length; i++) {
			_loop2(i);
		}
	},


	/**
  * When a palette gets deleted we need to correctly default to something else if the one being
  * deleted is the currently selected palette
  */
	_onPaletteDelete: function _onPaletteDelete(_ref3) {
		var paletteId = _ref3.paletteId;

		if (this._getRealPaletteId(paletteId) === this._getRealPaletteId(this.selectedId)) {
			var newSelectedPalette = null;
			var palette = this._findPaletteFromId(paletteId);

			// We should still have the deleted palette since we have re-renderd.
			if (palette) {
				var section = palette.section;

				// Check the section where the palette was deleted from to see if there are more available
				// palettes in the same section. If so, use that as the selected palette
				for (var _i2 = 0; _i2 < this.palettes[section].length; _i2++) {
					if (this._getRealPaletteId(this.palettes[section][_i2].id) !== this._getRealPaletteId(paletteId)) {
						newSelectedPalette = this.palettes[section][_i2];
						this._sectionOpenState[section] = true;
						break;
					}
				}
			}

			// All else fails defaulkt to the first system palette
			if (!newSelectedPalette && this.palettes.system) {
				newSelectedPalette = this.palettes.system[0];
				this._sectionOpenState['system'] = true;
			}

			if (newSelectedPalette) {
				this.onPaletteChange(this.name, {
					id: newSelectedPalette.id,
					reverse: this.reverse
				});
			}

			this.render();
		} else {
			this._updatePaletteProperties({
				properties: this._propertyUIControl.getProperties(),
				paletteIdToUpdate: paletteId,
				action: 'delete'
			});
		}
	},


	/**
  * Shifts the selection highlight on to the new palette
  */
	updateSelection: function updateSelection() {
		if (this.getPaletteId) {
			var paletteId = this.getPaletteId();
			if (paletteId && paletteId !== this.selectedId) {
				this.selectedId = paletteId;
				// Deselect previous palette, then select the current one
				this.$el && this.$el.find('.paletteColors.selected').removeClass('selected').attr('aria-pressed', 'false');
				this.$el && this.$el.find('.property_' + paletteId).addClass('selected').attr('aria-pressed', 'true');
			}
		}
	},

	remove: function remove() {
		this._unregisterPaletteServiceEvents();
		if (this.onRemove) {
			this.onRemove();
		}
	},

	render: function render() {
		var _this9 = this;

		this.$el.parent().addClass('changePalettePane');

		if (this._propertyUIControl) {
			this._propertyUIControl.remove();
			this.$el.empty();
		}

		return this.glassContext.getSvc('.Palette').then(function (paletteService) {
			_this9._paletteService = paletteService;

			return _this9._getPropertySpec().then(function (propertySpec) {
				if (!propertySpec || !propertySpec.items || !propertySpec.items.length) {
					_this9._registerPaletteServiceEvents();
					return;
				}

				return new Promise(function (resolve) {
					new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(57)]; ((function (PropertyUIControl) {
						_this9._propertyUIControl = new PropertyUIControl(propertySpec);

						return _this9._propertyUIControl.render().then(function () {
							_this9._propertyUIControl.focus();
							_this9._registerPaletteServiceEvents();

							resolve(_this9._propertyUIControl);
						});
					}).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
				});
			});
		});
	},

	getPropertyUIControl: function getPropertyUIControl() {
		return this._propertyUIControl;
	}
});

exports.default = ChangePaletteView;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_50__;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(52), __webpack_require__(53), __webpack_require__(5), __webpack_require__(55), __webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, BidiUtil, DnDManager, _, hammer) {

	// Setup jquery to create a hammer instance when we use hammer events.
	var hammerGestures = [];
	for (var name in hammer.gestures) {
		if (Object.prototype.hasOwnProperty.call(hammer.gestures, name)) {
			hammerGestures.push(hammer.gestures[name].name);
		}
	}
	var hammerDefaultOptions = {
		'prevent_mouseevents': true,
		'stop_browser_behavior': false
	};
	$.each(hammerGestures, function (index, name) {
		$.event.special[name] = {
			setup: function setup() {
				var $el = $(this);
				var inst = $el.data('hammer');
				if (!inst) {
					// create hammer instance with default values
					$el.hammer(hammerDefaultOptions);
				}
			}
		};
	});

	/**
  * A jQuery function that can be used to attach the onClick event handler. This function will also attach the touch events required for touch devices to avoid the delay caused by simulated mouse
  * events
  */
	$.fn.onClick = function (handler) {
		this.on('click', function (e) {
			handler(e);
		}).on('tap', function (e) {
			handler(e);
			// prevent the simulated clicks on touch devices
			e.gesture.preventDefault();
		});
		return this;
	};

	// Get the box style to be applied to the inline editor
	var getInlineEditBoxStyles = function getInlineEditBoxStyles($text, options) {

		var cssProps = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'border-bottom-color', 'border-bottom-style', 'border-bottom-width', 'border-top-color', 'border-top-style', 'border-top-width', 'border-right-color', 'border-right-style', 'border-right-width', 'border-left-color', 'border-left-style', 'border-left-width', 'position', 'top', 'right', 'left', 'bottom', 'height', 'width', 'min-height', 'min-width', 'max-height', 'max-width'];

		var cssValues = $text.css(cssProps);

		// We don't want to set a zero height and width
		if (cssValues.height === '0px') {
			delete cssValues.height;
		}
		if (cssValues.width === '0px') {
			delete cssValues.width;
		}

		// Set the maximum width to strech with the parent
		if (options && options.maxSizeNode) {
			var $node = $(options.maxSizeNode);
			var width = options.maxSizeNode.style.width;
			if (width) {
				cssValues['max-width'] = '100%';
				delete cssValues.width;
			} else {
				cssValues['max-width'] = $node.width() + 'px';
			}
		}

		return cssValues;
	};

	// Get the css styles to be applied to the inline editor input element
	var getInlineEditStyles = function getInlineEditStyles($text) {

		var textCss = {
			width: '0px',
			'min-width': $text.css('fontSize')
		};

		// Get the text alignment and apply it to the text input
		var textAlignment = $text.css('text-align');
		if (textAlignment === 'center') {
			textCss['margin'] = '0px auto';
		} else if (textAlignment === 'right') {
			textCss['margin'] = '0px 0px 0px auto';
		}

		return textCss;
	};

	// Get the text css style to be applied to the inline editor
	var getInlineEditTextStyles = function getInlineEditTextStyles($text) {
		return $text.css(['fontSize', 'fontFamily', 'fontWeight', 'letterSpacing', 'color']);
	};

	var _addInlineEditHandlers = function _addInlineEditHandlers($text, fCallback, options) {

		var $inlineEdit = $text._$inlineEdit;

		$text._updateWidth = function () {
			if ($inlineEdit) {
				var value = $inlineEdit.val() || '';
				if (value !== $inlineEdit._hidden.text()) {
					$inlineEdit._hidden.text(value);
					$inlineEdit.width($inlineEdit._hidden.width() + 2);
				}
			}
		};

		$text._inlineEditChangedFn = function () {
			var sText = $inlineEdit.val().trim();

			if (sText.length === 0 && options.noEmptyText) {
				sText = $text._previousInlineText;
			}

			$inlineEdit.removeClass('inlineText').off('keypress').off('keydown').off('blur');
			var invokeCallback = false;
			if ($text._previousInlineText !== sText) {
				invokeCallback = true;
			}
			$text._previousInlineText = null;
			$inlineEdit._hidden.remove();
			$inlineEdit._hidden = null;
			$inlineEdit.off();
			$inlineEdit.hide();
			$inlineEdit.parent().remove();
			$inlineEdit = null;
			$text._$inlineEdit = null;

			$text.text(sText);
			$text.removeClass('inEditMode');
			$text.show().focus();

			if (invokeCallback) {
				fCallback(sText);
			}

			var onEditEnd = options && options.onEditEnd;
			if (onEditEnd) {
				onEditEnd();
			}
		}.bind($text);

		var sText = $text.text();
		$text._previousInlineText = sText; // keep a back up of the current string

		if (!$inlineEdit) {

			$text.addClass('inEditMode');

			// Create a container node that will inherit the text container properties
			// like margin, padding, border and position
			var $inlineEditContainer = $('<div>', {
				'class': 'inlineEditContainer'
			});
			$inlineEditContainer.css(getInlineEditBoxStyles($text, options));
			$text.after($inlineEditContainer);

			$inlineEdit = $('<input>', {
				'class': 'inlineText'
			});

			$inlineEdit.css('max-width', '100%');
			$inlineEdit.css(getInlineEditStyles($text));
			var cssValues = getInlineEditTextStyles($text);
			$inlineEdit.css(cssValues);

			$inlineEditContainer.append($inlineEdit);

			$text._$inlineEdit = $inlineEdit;
			$inlineEdit.val(sText);

			$inlineEdit._hidden = $('<div style="white-space:pre; top:-999px; left:-999px; position:absolute;"/>');
			$inlineEdit._hidden.css(cssValues);

			$text.hide();
			$text.after($inlineEdit._hidden);
			$inlineEdit.on('keyup keydown input propertychange change', function () {
				$text._updateWidth();
			});

			if (options && options.style) {
				$inlineEdit.css(options.style);
			}

			$text._updateWidth();

			$inlineEdit.on('blur', $text._inlineEditChangedFn).on('keypress', function (e) {
				if (e.keyCode === 13) {
					$text._inlineEditChangedFn();
				}
			}).on('keyup', function (e) {
				//stop propagation for delete key
				if (e.keyCode === 46 || e.keyCode === 8) {
					e.stopPropagation();
				}
			}).on('keydown', function (e) {
				// stop the arrow keys from bubbling when in edit mode. Fix for when editing the name of a tab.
				if (e.keyCode === 37 || e.keyCode === 39) {
					e.stopPropagation();
				}
			}).on('mousedown mouseup dblclick', function (e) {
				// cancel the mouse down, up and double click to allow the user to interact with the text
				e.stopPropagation();
			});
			BidiUtil.initElementForBidi($inlineEdit[0]);
			$inlineEdit.show();
		} else {
			$inlineEdit.val(sText);
		}

		$inlineEdit.focus();
		$inlineEdit[0].setSelectionRange(0, 9999); //needed for selecting on ios

		return false;
	};

	/**
  * Turns an div element into an inline edit control
  */
	$.fn.inlineEditor = function (action, options) {
		if (action === 'remove') {
			if (this._$inlineEdit) {
				this._inlineEditChangedFn();
			}

			this.off('dblclick', this._inlineEditFn);
			this.off('hold', this._inlineEditFn);
			delete this._inlineEditFn;
			delete this._previousInlineText;
			delete this._inlineEditChangedFn;
			delete this._updateWidth;
		} else if (action === 'blur') {

			if (this._$inlineEdit) {
				this._inlineEditChangedFn();
			}
		} else if (action === 'isEditing') {
			return this._$inlineEdit ? true : false;
		} else if (action === 'edit') {
			if (this._inlineEditFn) {
				this._inlineEditFn();
			}
		} else {
			var onEditStart = options && options.onEditStart;
			this._inlineEditFn = function (e) {

				DnDManager.resetDragging();

				if (onEditStart) {
					onEditStart();
				}
				_addInlineEditHandlers(this, action, options);

				if (e) {
					e.stopPropagation();
				}
			}.bind(this);
			this.hammer({
				stop_browser_behavior: false,
				prevent_mouseevents: true
			});
			this.on('dblclick', this._inlineEditFn);
			this.on('hold', this._inlineEditFn);
			this.on('keypress', function (e) {
				var keyCode = e.keyCode || e.charCode;
				if (keyCode === 13 || keyCode === 32) {
					this._inlineEditFn(e);
				}
			}.bind(this));
		}
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=EventHelper.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2012, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * borrowed from cclcore.
 * Common bidi javascript library - BidiUtils.
 * Singleton containing useable bidi methods.
 */

/**
 * This module contains a subset of BidiUtils from cclcore with some
 * modifications to meet gemini's requirements for BiDi text. Elements passed
 * in to the methods of this module is expected to contain only a single text
 * node such as <div contenteditable> or <input> elements
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
	'use strict';

	var AUTO = 'auto',
	    arabicLocales = {
		'General Info': {
			'Generated from': 'CLDR Version: 30.0.3',
			'Generated by': 'BDL CLDR Reader Tool',
			'Date': '16-03-17 12:40:12'
		},
		'Arabic Default Numbering Systems': {
			'ar': 'arab',
			'ar_AE': 'arab',
			'ar_BH': 'arab',
			'ar_DJ': 'arab',
			'ar_DZ': 'latn',
			'ar_EG': 'arab',
			'ar_EH': 'latn',
			'ar_ER': 'arab',
			'ar_IL': 'arab',
			'ar_IQ': 'arab',
			'ar_JO': 'arab',
			'ar_KM': 'arab',
			'ar_KW': 'arab',
			'ar_LB': 'arab',
			'ar_LY': 'latn',
			'ar_MA': 'latn',
			'ar_MR': 'arab',
			'ar_OM': 'arab',
			'ar_PS': 'arab',
			'ar_QA': 'arab',
			'ar_SA': 'arab',
			'ar_SD': 'arab',
			'ar_SO': 'arab',
			'ar_SS': 'arab',
			'ar_SY': 'arab',
			'ar_TD': 'arab',
			'ar_TN': 'latn',
			'ar_YE': 'arab'
		}
	},
	    cldrData = arabicLocales['Arabic Default Numbering Systems'];

	var BidiUtil = function BidiUtil() {
		this._isIE = this._detectIE(navigator.userAgent);
		this.userPreferredTextDir = this._getUserPreferredTextDir() || AUTO;
		this.LRE = '\u202A';
		this.RLE = '\u202B';
		this.PDF = '\u202C';
		this.LRM = '\u200E';
	};

	BidiUtil.prototype._detectIE = function (useragent) {
		return (/\b(MSIE|Trident|Edge)\b/.test(useragent)
		);
	};

	// Private Methods
	// Should not need to call these methods outside this module. Although real
	// encapsulation is possible, defining as part of BidiUtil's prototype allows
	// unit testing and faster scope chain access from public methods

	/**
  * Gets the user's preferred text direction from <html> attribute passed in
  * from server-side and stores it as member of this singleton as userPreferredTextDir
  * @return {string} User's preferred text direction (i.e. ltr, rtl, auto)
  */
	BidiUtil.prototype._getUserPreferredTextDir = function () {
		if (!this.userPreferredTextDir) {
			this.userPreferredTextDir = document.documentElement.getAttribute('data-pref-text-dir');
		}
		return this.userPreferredTextDir;
	};

	/**
  * Normalizes the process of retrieving the value from <input> or <div contenteditable>
  * HTML elements
  * @param  {Element|HTMLInputElement} element - DOM element receiving text input
  * @return {string} String value of the DOM element
  */
	BidiUtil.prototype._getNodeValue = function (element) {
		return element.value || element.tagName === 'INPUT' ? element.value : element.textContent;
	};

	/**
  * Normalizes the process of setting the value to <input> or <div contenteditable>
  * HTML elements
  * @param {Element|HTMLInputElement} element - DOM element receiving text input
  * @param {string} value - String value to be set to element
  */
	BidiUtil.prototype._setNodeValue = function (element, value) {
		if (element.value || element.tagName === 'INPUT') {
			element.value = value;
		} else {
			// setting the textContent removes any text of its child nodes
			element.textContent = value;
		}
	};

	/**
  * Checks if the character passed in is an Arabic character.
  * @param {string} charCode - Character code
  * @return {boolean} True, if character is an Arabic character
  */
	BidiUtil.prototype._isArabicChar = function (charCode) {
		if (charCode >= 0x0600 && charCode <= 0x0669 || charCode >= 0x06fa && charCode <= 0x07ff || charCode >= 0xfb50 && charCode <= 0xfdff || charCode >= 0xfe70 && charCode <= 0xfefc) {
			return true;
		}
		return false;
	};

	/**
  * Checks if the character passed in is a Hebrew character.
  * @param {string} charCode - Character code
  * @return {boolean} True, if character is a Hebrew character
  */
	BidiUtil.prototype._isHebrewChar = function (charCode) {
		if (charCode >= 0x05d0 && charCode <= 0x05ff) {
			return true;
		}
		return false;
	};

	/**
  * Checks if the character passed in is a BiDi character.
  * @param  {number}  charCode - Chracter code
  * @return {boolean} True, if the character is a BiDi (Arabic or Hebrew) character
  */
	BidiUtil.prototype._isBidiChar = function (charCode) {
		return this._isArabicChar(charCode) || this._isHebrewChar(charCode);
	};

	/**
  * Checks if the character passed in is a Latin character (Only treats
  * capital and lower case alphabets as latin characters)
  * @param  {number}  charCode - Character code
  * @return {boolean} True, if the character is a Latin character
  */
	BidiUtil.prototype._isLatinChar = function (charCode) {
		if (charCode > 64 && charCode < 91 || charCode > 96 && charCode < 123) {
			return true;
		}
		return false;
	};

	/**
  * Event handler for 'input' event (events causing the value of the target
  * element to change)
  * Resolves the base text direction and sets the dir attribute
  * @param {Event} event - DOM Event object
  */
	BidiUtil.prototype._handleInputEvent = function (event) {
		// NOTE: 'this' has been binded to be BidiUtil in _addBidiEventListeners function
		this._resolveDirAttr(event.target);
	};

	/**
  * Adds event listeners for events changing the value of the element being passed in
  * @param {Element|HTMLInputElement} element - DOM element receiving text input
  */
	BidiUtil.prototype._addBidiEventListeners = function (element) {
		if (!element._hasBidiEventListeners) {
			element._hasBidiEventListeners = true;

			var eventTypes = ['keyup', 'cut', 'paste'];
			for (var i = 0; i < eventTypes.length; ++i) {
				element.addEventListener(eventTypes[i], this._handleInputEvent.bind(this), false);
			}
		}
	};

	/**
  * Sets dir attribute of the DOM element passed in as parameter according to
  * the direction of the first strong character in the text content of the element
  * @param {Element|HTMLInputElement} element - DOM element receiving text input
  */
	BidiUtil.prototype._resolveDirAttr = function (element) {
		if (this._isIE && (this.userPreferredTextDir === AUTO || !this.userPreferredTextDir)) {
			// IE doesn't support dir="auto" HTML attribute
			var text = this._getNodeValue(element);
			element.dir = this.resolveBaseTextDir(text);
		} else {
			// Chrome, Safari, and Firefox supports dir="auto" HTML attribute
			// IE will only receive "ltr" or "rtl" in this block
			element.dir = this.userPreferredTextDir || AUTO;
		}
	};

	/**
 * This function determines the positions where we should insert the LRM marker for correct display
 * of Structured Text Value
 * @param str
 * @param isLocation
 * @returns array
 */
	BidiUtil.prototype._parseSTT = function (str, isLocation) {
		var delimiter = isLocation ? '>' : ':/@=[]\'<>';
		var segmentsPointers = [];
		var sp_len = 0,
		    i;

		for (i = 0; i < str.length; i++) {
			if (delimiter.indexOf(str.charAt(i)) >= 0) {
				segmentsPointers[sp_len] = i;
				sp_len++;
			}
		}
		return segmentsPointers;
	};

	// Public Methods
	/**
  * Simply resolves the dir attribute of the HTML element and adds BiDi specific
  * event handlers if necessary
  * @param  {Element|HTMLInputElement} element - DOM element receiving text input
  */
	BidiUtil.prototype.initElementForBidi = function (element) {
		if (element) {
			this._resolveDirAttr(element); // resolve dir attribute of the element

			if (this._isIE) {
				this._addBidiEventListeners(element);
			}
		}
	};

	/**
  * Enforces text direction by adding UCC (Unicode Control Characters)
  * @param  {String} text - The text for which we should enforce text direction.
  * @returns string
  */
	BidiUtil.prototype.enforceTextDirection = function (text) {
		if (text) {
			var finalDir = this.resolveBaseTextDir(text);
			var finalValue = text;

			if (finalDir === 'ltr') {
				finalValue = this.LRE + finalValue + this.PDF;
			} else if (finalDir === 'rtl') {
				finalValue = this.RLE + finalValue + this.PDF;
			}
			return finalValue;
		}
		return text;
	};

	/**
  * Traverses the string passed in as parameter from the beginning and
  * determines the direction of the text based on the first strong character
  * @param  {string} text - A bi-directional text
  * @param  {bool} isTextArea - Does the text belong to a textarea
  * @return {string} Direction of the text
  */
	BidiUtil.prototype.resolveBaseTextDir = function (text, isTextArea) {

		var textDir = this.userPreferredTextDir;
		if (!textDir) {
			textDir = AUTO;
		}
		if (textDir === AUTO && (!isTextArea || this._isIE)) {
			for (var i = 0; text && i < text.length; i++) {
				var character = text.charCodeAt(i);
				if (this._isBidiChar(character)) {
					textDir = 'rtl';
					break;
				} else if (this._isLatinChar(character)) {
					textDir = 'ltr';
					break;
				}
			}
			if (this._isIE && textDir === AUTO) {
				textDir = '';
			}
		}

		return textDir;
	};

	/**
  * Enforces text direction for Structured Text value by adding UCC (Unicode Control Characters)
  * We should add an LRM before each segment and also we should enforce text direction of each segment
  * @param  {String} text - The text for which we should enforce text direction.
  * @returns string
  */
	BidiUtil.prototype.enforceTextDirectionForSTT = function (text) {
		if (text) {
			text = this.removeMarkers(text);
			var isLocation = (text.match(/ > /g) || []).length > 0;
			var segmentsPointers = this._parseSTT(text, isLocation);
			var result = '';
			var n;
			var marker = this.LRM;
			var offset = isLocation ? 1 : 0;
			if (segmentsPointers.length === 0) {
				result = this.enforceTextDirection(text);
			} else {
				result = this.enforceTextDirection(text.substring(0, segmentsPointers[0] - offset));
			}
			for (var i = 0; i < segmentsPointers.length; i++) {
				n = segmentsPointers[i];
				if (n) {
					var endIndex = i < segmentsPointers.length - 1 ? segmentsPointers[i + 1] - offset : text.length;
					var segment = text.substring(n + 1 + offset, endIndex);
					result = result + marker + text.substring(n - offset, n + offset + 1) + this.enforceTextDirection(segment);
				}
			}
			return result;
		}
		return text;
	};

	/**
  * Enforces text direction for Structured Text value by adding UCC (Unicode Control Characters)
  * We should add an LRM before each segment and also we should enforce text direction of each segment
  * @param  {String} text - The text for which we should enforce text direction.
  * @returns string
  */
	BidiUtil.prototype.enforceTextDirectionForLocation = function (text) {
		return this.enforceTextDirectionForSTT(text);
	};

	/**
  * Removes all the markers from the text
  * @param  {String} text - The text
  * @returns string
  */
	BidiUtil.prototype.removeMarkers = function (text) {
		return text.replace(/[\u202A\u202B\u202C\u200E]/g, '');
	};

	BidiUtil.prototype._isArabicLocale = function (locale) {
		return locale.match(/^ar[-_].*$/i);
	};

	BidiUtil.prototype._useLatinNums = function (locale) {
		if (!this._isArabicLocale(locale)) {
			return true;
		}
		return cldrData[locale] && cldrData[locale] === 'latn';
	};

	/**
  * Enforces numeric shaping for the given string
  * @param {Object} text to be wrapped. Can be number or string object.
  * @param {bool} isContextual. Should enforce contextual numeric shaping.
  * @returns {string}
  */
	BidiUtil.prototype.enforceNumericShaping = function (text, isContextual) {
		if (this.bidiSupport && this.userPreferredContentLocale.startsWith('ar') && (typeof text === 'number' || typeof text === 'string')) {
			var segmentDir = this.userPreferredTextDir;
			if (this.userPreferredTextDir === AUTO) {
				segmentDir = this.resolveBaseTextDir(text);
			}
			var locale = typeof navigator === 'undefined' ? '' : navigator.language || navigator.userLanguage || '';
			locale = locale.replace('-', '_');
			var finalText = text;
			if (typeof text === 'number') {
				finalText = text.toString();
			}
			// eslint-disable-next-line no-misleading-character-class
			var pattern = /([0-9])|([\u0660-\u0669])|([\u0590-\u05FF\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE]+)|([^0-9\u0590-\u05FF\u0660-\u0669\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE\u0600-\u0607\u0609-\u060A\u060C\u060E-\u061A\u064B-\u066C\u0670\u06D6-\u06E4\u06E7-\u06ED\u06F0-\u06F9\u08E4-\u08FF\uFD3E-\uFD3F\uFDD0-\uFDEF\uFDFD\uFEFF\u0000-\u0040\u005B-\u0060\u007B-\u007F\u0080-\u00A9\u00AB-\u00B4\u00B6-\u00B9\u00BB-\u00BF\u00D7\u00F7\u02B9-\u02BA\u02C2-\u02CF\u02D2-\u02DF\u02E5-\u02ED\u02EF-\u02FF\u2070\u2074-\u207E\u2080-\u208E\u2100-\u2101\u2103-\u2106\u2108-\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A-\u213B\u2140-\u2144\u214A-\u214D\u2150-\u215F\u2189\uA720-\uA721\uA788\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE]+)/g; // eslint-disable-line no-control-regex
			var self = this;
			return finalText.replace(pattern, function (curChs, latNum, araNum, rtlChs, ltrChs) {
				if (araNum) {
					if (isContextual && segmentDir === 'ltr' || !isContextual && self._useLatinNums(locale)) {
						return araNum.charCodeAt(0) - 1632;
					} else {
						return araNum;
					}
				} else if (latNum) {
					if (isContextual && segmentDir === 'rtl' || !isContextual && !self._useLatinNums(locale)) {
						return String.fromCharCode(parseInt(latNum) + 1632);
					} else {
						return latNum;
					}
				} else if (rtlChs) {
					segmentDir = 'rtl';
				} else if (ltrChs) {
					segmentDir = 'ltr';
				}
				return curChs;
			});
		}
		return text;
	};

	/**
  * Sets the text dir user preference
  * @param  {String} textDir - The text direction user preference.
  * @param  {String} bidiSupport - Is Bidi support enabled ?
  */
	BidiUtil.prototype.setUserPreferredTextDir = function (textDir, bidiSupport) {
		this.userPreferredTextDir = '';
		this.bidiSupport = false;
		if (bidiSupport === 'true') {
			this.userPreferredTextDir = textDir.toLowerCase();
			this.bidiSupport = true;
		}
	};

	/**
  * Sets the content locale user preference
  * @param  {String} contentLocale - The content locale user preference.
  */
	BidiUtil.prototype.setUserPreferredContentLocale = function (contentLocale) {
		this.userPreferredContentLocale = contentLocale;
	};

	return new BidiUtil();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=BidiUtil.js.map
//# sourceMappingURL=BidiUtil.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * Drag-and-Drop Manager
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(5), __webpack_require__(10), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, _, Class, utils) {
	'use strict';

	var DnDManager = null;

	DnDManager = Class.extend({

		dropTargets: null,
		currentDropTarget: null,
		init: function init() {
			this.dropTargets = [];
			this.currentDropTarget = {};

			// Add the dialog blocker as a default drop zone to swallow and ignore any drop that happens on the backdrop
			this.addDropTarget($('body')[0], '.dialogBlocker', {
				accepts: function accepts() {
					return true;
				}
			});
		},

		// Utility method that subscribes to the specified jQuery event
		// and returns removable object, that can be inserted into the 'owned' collections
		// of subscriptions
		//
		on: function on($el, types, selector, data, fn) {
			$el.on(types, selector, data, fn);
			return {
				remove: function remove() {
					$el.off(types, selector, fn);
				}
			};
		},

		/**
   * Register a drop Zone with the drag and drop manage
   *
   *
   * @param el - The drop zone element.
   * @param selector - Selector to identify the drop zone sub regions. If not specified, there will only be one region which is the drop zone element.
   * @param callbacks
   *		callbacks.accepts(dragObject)  - Called to check if the dropzone accepts the payload.
   *		callbacks.onDragStart() - Called when a drag starts
   *		callbacks.onDragEnd() - Called when a drag ends
   *		callbacks.onDragEnter(dragObject, dropNode) - Called when we enter a drop zone
   *		callbacks.onDragMove(dragObject, dropNode) - Called when we move inside a drop zone
   *		callbacks.onDragLeave(dragObject, dropNode) - Called when we leave a drop zone
   *		callbacks.onDrop(dragObject, dropNode) - Called when a drop occurs.
   * @returns {___anonymous1282_1365}
   */
		addDropTarget: function addDropTarget(el, selector, callbacks) {
			if (typeof selector !== 'string') {
				callbacks = selector;
				selector = null;
			}

			this.removeDropTarget(el);
			this.dropTargets.push({
				el: el,
				selector: selector,
				callbacks: callbacks
			});

			return {
				remove: function () {
					this.removeDropTarget(el);
				}.bind(this)
			};
		},

		/**
   * Remove a registered drop target
   * @param el
   */
		removeDropTarget: function removeDropTarget(el) {
			var target = _.find(this.dropTargets, function (t) {
				return t.el === el;
			});
			if (target) {
				this.dropTargets.splice(_.indexOf(this.dropTargets, target), 1);
			}
		},

		_isScrollDropSupported: function _isScrollDropSupported() {
			return this.currentDropTarget.target && this.currentDropTarget.target.callbacks.isScrollDropSupported ? true : false;
		},

		/**
   *
   * Check if the intention is scrolling and return the proper scrolling enabled drop zone.
   * If we are dragging outside of the view port, the intention is to auto scroll. In this case we do the following:
   * 		- if we have a drop zone, find the closest scrollable drop zone in the ancestors.
   *      - if there is no drop zone, select the last scrollable drop zone that was used.
   *
   * If we are dragging within the view and we have no drop zone, find the closest scrolling drop zone using the last drop target that was used.
   *  @param target
   * @param isScrollDropSupported
   * @param pos - current mouse position
   *
   * @returns the target or empty object.
   */
		_validateDropTarget: function _validateDropTarget(target, isScrollDropSupported, pos) {
			var foundTarget = target;
			if (isScrollDropSupported) {
				if (pos.x + 1 >= $(window).innerWidth() || pos.y + 1 >= $(window).height() || pos.x <= 1 || pos.y <= 1) {
					// dragging outside of the viewport.. most likely the intent is to auto scroll a drop zone
					if (foundTarget) {
						foundTarget = this._getClosestTargetWithScrollSupport(foundTarget.node);
					} else {
						foundTarget = this.lastActiveScrollableTarget;
					}
				}

				if (!foundTarget && this.currentDropTarget) {
					foundTarget = this._getClosestTargetWithScrollSupport(this.currentDropTarget.node);
				}
			}

			return foundTarget || {};
		},

		/**
   * Scan the list containing the ancestors + self and return the first drop zone that suppports scrolling.
   *
   * @param dropTargetNode - the node of the drop target where to start the search
   *
   */
		_getClosestTargetWithScrollSupport: function _getClosestTargetWithScrollSupport(dropTargetNode) {
			var parentsAndSelf = $(dropTargetNode).parents();
			parentsAndSelf.splice(0, 0, dropTargetNode);
			var target = null;
			for (var i = 0; i < parentsAndSelf.length; i++) {
				target = this._getDropTargetWithScrollSupport(parentsAndSelf[i]);
				if (target) {
					this.lastActiveScrollableTarget = target;
					break;
				}
			}

			return target;
		},

		/**
   * Find the drop zone that support scrolling where the node match the given node parameter
   *
   * @param targetNode - node to match with the drop zone node.
   *
   */
		_getDropTargetWithScrollSupport: function _getDropTargetWithScrollSupport(targetNode) {
			var foundTarget = null;

			var dropTarget = _.find(this.dropTargets, function (target) {
				var $elements = $(target.el);
				if (target.selector) {
					$elements = $elements.find(target.selector);
				}

				return _.find($elements, function (node) {
					return node === targetNode && target.callbacks.isScrollDropSupported && (!target.callbacks.accepts || target.callbacks.accepts(this.dragObject));
				}.bind(this));
			}.bind(this));

			if (dropTarget) {
				foundTarget = {
					target: dropTarget,
					node: targetNode
				};
			}
			return foundTarget;
		},

		/**
   * Helper method that gets the current drop target from a position
   * @param pos
   * @param options -- options passed by the called when the startDrag method is called
   * @returns {Object} - drop target
   */
		getDropTargetFromPos: function getDropTargetFromPos(pos, options) {
			var isScrollDropSupported = options && !options.disableScrollableDropZoneSupport;

			var foundTarget = null;
			var foundTargetArea = 0;
			var foundTargetPriority = 0;

			var nonActiveDropZones = [];

			_.each(this.dropTargets, function (target) {
				var $elements = $(target.el);
				if (target.selector) {
					$elements = $elements.find(target.selector);
				}

				_.each($elements, function (node) {

					var info = this.getTargetMatchInformation(pos, node, target, foundTarget, foundTargetArea, foundTargetPriority);
					if (info.isMatch) {
						if (!target.callbacks.accepts || target.callbacks.accepts(this.dragObject)) {
							foundTarget = {
								target: target,
								node: node
							};
							foundTargetArea = info.area;
							foundTargetPriority = info.priority;
						} else if (target.callbacks.receiveEventsWhenNotAccepting) {
							nonActiveDropZones.push({
								target: target,
								node: node
							});
						}
					}
				}.bind(this));
			}.bind(this));

			foundTarget = this._validateDropTarget(foundTarget, isScrollDropSupported, pos);

			if (foundTarget) {
				foundTarget.nonActiveDropZones = nonActiveDropZones;
			}

			return foundTarget || {};
		},

		/**
   * Return true if val is between lowerBound and (lowerBound + rangeSize).
   */
		_isInRange: function _isInRange(val, lowerBound, rangeSize) {
			return val >= lowerBound && val < lowerBound + rangeSize;
		},

		/**
   * return the priority set for target or 0.
   */
		_getPriority: function _getPriority(target) {
			var priority = target.callbacks.priority;
			if (typeof priority === 'function') {
				priority = priority();
			}
			return priority || 0;
		},

		/**
   * Helper function used by getDropTargetFromPos to decide if a drop target is found or not using the current mouse position
   */
		getTargetMatchInformation: function getTargetMatchInformation(pos, node, target, foundTarget, foundTargetArea, foundTargetPriority) {
			var matchInformation = {};
			var $el = $(node);
			var bounds = node.getBoundingClientRect();
			var isVisible = $el.is(':visible');
			if (isVisible) {
				var xInRange = this._isInRange(pos.x, bounds.left, bounds.width);
				var yInRange = this._isInRange(pos.y, bounds.top, bounds.height);

				if (xInRange && yInRange) {
					matchInformation = {
						area: bounds.width * bounds.height,
						priority: this._getPriority(target)
					};
					matchInformation.isMatch = !foundTarget || matchInformation.priority > foundTargetPriority || foundTargetArea > matchInformation.area && matchInformation.priority >= foundTargetPriority;
				}
			}

			return matchInformation;
		},

		/**
   * Helper method that gets the current drop target from a node
   * @param pos
   * @returns {Object} - drop target
   */
		getDropTargetFromNode: function getDropTargetFromNode(node) {

			var target = null;
			for (var i = 0; i < this.dropTargets.length; i++) {
				if (node === this.dropTargets[i].el) {
					target = this.dropTargets[i];
					break;
				}
			}

			return target;
		},

		dragObject: null,
		/**
   * Called to start dragging
   * @param options
   *		options.event ev - the event used to start the drag. e.g. mousedown, touchstart
   *		options.type - The type of the data being dropped.
   *		options.data - The data being dropped.
   *		options.avatar - the avatar node associated with the drag and drop operation
   *		options.avatarXOffset - the number of pixel added to the avatar left position
   *		options.avatarYOffset - the number of pixel added to the avatar top position
   *		options.restrictToXAxis - restrict moving on the x axis
   *		options.restrictToYAxis - restrict moving on the y axis
   *
   *		options.callerCallbacks
   *			callerCallback.onDragStart(event, {dragObject}) - Called when the drag is started.
   *			callerCallback.onMove(event, {dragObject, dropNode}) - Called on every move event.
   *			callerCallback.onDragDone(event, {dragObject, dropNode, isDropped}) - Called when the drag is complete, whether we droppped or not.
   *
   *		options.moveXThreshold - the number of pixel to move on the X axis before we allow the drag to start. A good example to use this is
   *			when want to enable a drag horizontally and still allow vertical scrolling/panning. In this case, we would set the moveXThreshold to something like 30.
   *			This will allow vertical scroll as long as we don't drag horizontally more that 30 pixels.
   *
   *		options.moveYThreshold - the number of pixel to move on the Y axis before we allow the drag to start.
   *
   * @param moveThreshold - distance in pixel that will activate the move and the avatar
   */
		startDrag: function startDrag(options) {
			if (this.dragObject) {
				// cannot start another drag operation until the previous one is finished
				return;
			}
			$('body').addClass('preventSelection');
			this.isDragStartCalled = false;

			this.targetMap = {};

			var isTouch = utils.isTouchEvent(options.event);
			this.dragObject = {
				type: options.type,
				data: options.data,
				avatar: options.avatar,
				isTouch: isTouch || options.event.gesture !== undefined
			};

			var eventPos = utils.getEventPos(options.event);
			this.dragObject.startPosition = {
				x: eventPos.pageX,
				y: eventPos.pageY
			};

			this.setAvatar(options.avatar, options);

			this.callerCallbacks = options.callerCallbacks ? options.callerCallbacks : {};

			var $target = $(window);
			if (isTouch) {
				$target = $(utils.getEventTarget(options.event));
			}
			this.attachedMoveHandler = this.on($target, 'mousemove touchmove', this.moveHandler.bind(this, options));
			this.attachedUpHandler = this.on($target, 'mouseup touchend touchcancel', this.upHandler.bind(this));
			if (options.event.type === 'mousedown') {
				this.attachedScrollHandler = this.on($(options.event.target), 'scroll', this.scrollHandler.bind(this));
			}

			if (options.currentDropZoneNode) {
				var target = this.getDropTargetFromNode(options.currentDropZoneNode);
				if (target) {
					this.currentDropTarget = {
						target: target,
						node: options.currentDropZoneNode
					};
				}
			}
		},

		scrollHandler: function scrollHandler() /* event */{
			// we are scrolling, do not track movement
			// cancel drag
			// IE does not fire mouseUp on scrollbar so drag move continues after releasing the mouse when it should not
			this.resetDragging();
		},

		_setAvatarPosition: function _setAvatarPosition(options) {
			if (this.avatar && this.dragObject.position) {
				if (!this.avatar.parentNode) {
					$('body').append(this.avatar);
				}

				var xOffset = options && options.avatarXOffset ? options.avatarXOffset : 1;
				var yOffset = options && options.avatarYOffset ? options.avatarYOffset : 1;
				$(this.avatar).css({
					left: this.dragObject.position.x + xOffset + 'px',
					top: this.dragObject.position.y + yOffset + 'px'
				});
			}
		},

		setAvatar: function setAvatar(avatar, options) {
			this.avatar = avatar;
			this._setAvatarPosition(options);
		},

		/**
   * Move event main handler
   * @param options - drag options
   * @param ev
   */
		moveHandler: function moveHandler(options, ev) {

			//Always prevent the default behavior on drag move to prevent chrome auto scrolling
			ev.preventDefault();

			var eventPos = utils.getEventPos(ev);
			var dx = eventPos.pageX;
			var dy = eventPos.pageY;

			this.dragObject.position = {
				x: dx,
				y: dy
			};

			if (options.restrictToXAxis) {
				this.dragObject.position.y = this.dragObject.startPosition.y;
			}

			if (options.restrictToYAxis) {
				this.dragObject.position.x = this.dragObject.startPosition.x;
			}

			if (!this.isDragStartCalled && this._isThresholdNotMet(options)) {
				return;
			}

			this._setAvatarPosition(options);
			var dropTarget = this.getDropTargetFromPos(this.dragObject.position, options);

			this._callStartDrag(ev);

			this._callMove(dropTarget, ev);

			this._processCallbacks(dropTarget);

			// Don't stop the propagation. This will interfere with hammer gestures like tap and hold.
			// If there is an active tap/hold handlers, hammer needs to know when there is a move.
		},

		_processCallbacks: function _processCallbacks(dropTarget) {

			var currentNonActiveDropZones = this.currentDropTarget.nonActiveDropZones;

			// Process the callback for the active drop zone that accepted the drop
			if (dropTarget.target !== this.currentDropTarget.target || dropTarget.node !== this.currentDropTarget.node) {
				this._dropTargetCallback(this.currentDropTarget, 'onDragLeave');
				this.currentDropTarget = dropTarget;
				this._dropTargetCallback(this.currentDropTarget, 'onDragEnter');
			} else {
				this._dropTargetCallback(this.currentDropTarget, 'onDragMove');
			}

			// Process callback for drop zone that didn't accept but chose to receive the event anyway
			this._processCallbacksForNonActiveDropzones(dropTarget.nonActiveDropZones, currentNonActiveDropZones);
		},

		_processCallbacksForNonActiveDropzones: function _processCallbacksForNonActiveDropzones(newDropZones, oldDropZones) {

			_.each(newDropZones, function (dropZone) {
				if (this._isDropZoneInArray(dropZone, oldDropZones)) {
					this._dropTargetCallback(dropZone, 'onDragMove');
				} else {
					this._dropTargetCallback(dropZone, 'onDragEnter');
				}
			}.bind(this));

			if (oldDropZones) {
				_.each(oldDropZones, function (dropZone) {
					if (!this._isDropZoneInArray(dropZone, newDropZones)) {
						this._dropTargetCallback(dropZone, 'onDragLeave');
					}
				}.bind(this));
			}

			this.currentDropTarget.nonActiveDropZones = newDropZones;
		},

		_dropTargetCallback: function _dropTargetCallback(dropTarget, callbackName) {
			if (dropTarget.target && dropTarget.target.callbacks[callbackName]) {
				dropTarget.target.callbacks[callbackName](this.dragObject, dropTarget.node);
				return true;
			}
			return false;
		},
		_isDropZoneInArray: function _isDropZoneInArray(dropZone, dropZoneArray) {
			var found = false;
			if (dropZoneArray) {
				for (var i = 0; i < dropZoneArray.length; i++) {
					if (dropZone.target === dropZoneArray[i].target) {
						found = true;
						break;
					}
				}
			}

			return found;
		},

		_isThresholdNotMet: function _isThresholdNotMet(options) {
			var hasThreshold = options.moveXThreshold || options.moveYThreshold;
			var isXThresholdNotMet = !options.moveXThreshold || options.moveXThreshold > Math.abs(this.dragObject.position.x - this.dragObject.startPosition.x);
			var isYThresholdNotMet = !options.moveYThreshold || options.moveYThreshold > Math.abs(this.dragObject.position.y - this.dragObject.startPosition.y);

			return hasThreshold && isXThresholdNotMet && isYThresholdNotMet;
		},

		_callMove: function _callMove(dropTarget, ev) {
			if (this.callerCallbacks.onMove) {
				this.callerCallbacks.onMove(ev, {
					dragObject: this.dragObject,
					dropTargetNode: dropTarget.node
				});
			}
		},

		_callStartDrag: function _callStartDrag(ev) {
			if (this.callerCallbacks.onDragStart && !this.isDragStartCalled) {
				this.callerCallbacks.onDragStart(ev, { dragObject: this.dragObject });

				_.each(this.dropTargets, function (target) {
					if (target.callbacks.onDragStart) {
						target.callbacks.onDragStart(this.dragObject);
					}
				}.bind(this));
			}
			$('body').addClass('dragging');
			this.isDragStartCalled = true;
		},

		/**
   *  mouseup/touchend main handler
   *
   * @param ev
   */
		upHandler: function upHandler(ev) {
			if (this.isDragStartCalled) {
				var isDropped = false;
				$('body').removeClass('dragging');

				var dropTarget = this.currentDropTarget;
				if (this._dropTargetCallback(dropTarget, 'onDrop')) {
					isDropped = true;
				}

				if (this.callerCallbacks.onDragDone) {
					this.callerCallbacks.onDragDone(ev, {
						dragObject: this.dragObject,
						dropTargetNode: isDropped ? dropTarget.node : null,
						isDropped: isDropped
					});
				}

				if (dropTarget.nonActiveDropZones) {
					_.each(dropTarget.nonActiveDropZones, function (dropZone) {
						this._dropTargetCallback(dropZone, 'onDrop');
					}.bind(this));
				}

				_.each(this.dropTargets, function (target) {
					if (target.callbacks.onDragEnd) {
						target.callbacks.onDragEnd(this.dragObject);
					}
				}.bind(this));
			}

			this.resetDragging();

			// Don't stop the propagation. This will interfere with hammer gestures like tap and hold.
			// If there is an active tap/hold handlers, hammer needs to know when the touch ends.
		},
		resetDragging: function resetDragging() {

			// Release the capture that we set in the mouse down.
			// This is used to allow IE to keep firing the mouse event when the mouse leaves the window or iframe
			if (document.releaseCapture) {
				document.releaseCapture();
			}

			if (this.attachedMoveHandler) {
				this.attachedMoveHandler.remove();
			}
			if (this.attachedUpHandler) {
				this.attachedUpHandler.remove();
			}

			if (this.attachedScrollHandler) {
				this.attachedScrollHandler.remove();
			}

			$('body').removeClass('preventSelection');
			this.currentDropTarget = {};
			this.dragObject = null;
			this.isDragStartCalled = false;
			this.targetMap = null;
			this.lastActiveScrollableTarget = null;

			$(this.avatar).remove();
		}
	});

	return new DnDManager();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=DnDManager.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
	'use strict';

	return {
		getAncestorOfClass: function getAncestorOfClass(node, className) {
			var doc = document;
			while (node && node !== doc) {
				if (node.className.split(' ').indexOf(className) >= 0) {
					return node;
				}
				node = node.parentNode;
			}

			return null;
		},

		isTouchEvent: function isTouchEvent(ev) {
			return ev.type.indexOf('touch') === 0;
		},

		isPointerTouch: function isPointerTouch(ev) {
			return ev.gesture && ev.gesture.pointerType === 'touch';
		},

		isMultiTouchEvent: function isMultiTouchEvent(ev) {
			var oev = ev.originalEvent || ev;
			if (oev && oev.touches && oev.touches.length > 1) {
				return true;
			}
			return false;
		},

		isGesture: function isGesture(ev) {
			if (ev.gesture && ev.gesture.touches && ev.gesture.touches.length > 0) {
				return true;
			}
			return false;
		},

		getEventPos: function getEventPos(ev) {
			var pageValuesValid = function pageValuesValid(event) {
				return event && (event.pageX || event.pageX === 0) && (event.pageY || event.pageY === 0);
			};

			var pos;
			if (this.isGesture(ev)) {
				var touches = ev.gesture.touches[0];
				if (pageValuesValid(touches)) {
					pos = {
						pageX: touches.pageX,
						pageY: touches.pageY
					};
				}
			}
			if (!pos && this.isTouchEvent(ev)) {
				var oev = ev.originalEvent || ev;
				if (oev && oev.touches.length > 0 && pageValuesValid(oev.touches[0])) {
					pos = { pageX: oev.touches[0].pageX, pageY: oev.touches[0].pageY };
				}
			}
			if (!pos && pageValuesValid(ev)) {
				pos = { pageX: ev.pageX, pageY: ev.pageY };
			}
			if (!pos && pageValuesValid(ev.originalEvent)) {
				pos = { pageX: ev.originalEvent.pageX, pageY: ev.originalEvent.pageY };
			}
			if (!pos) {
				// could not find any valid numbers so return zero.  Returning undefined values breaks some other code.
				pos = { pageX: 0, pageY: 0 };
			}
			return pos;
		},

		getEventTarget: function getEventTarget(ev) {
			if (this.isTouchEvent(ev)) {
				var oev = ev.originalEvent || ev;
				if (oev && oev.touches.length > 0) {
					return oev.touches[0].target;
				}
			}
			return ev.target;
		},

		withinElementBoundaries: function withinElementBoundaries(event, node) {
			var pos = this.getEventPos(event);
			var boundingRect = node.getBoundingClientRect();
			var inXRange = pos.pageX >= boundingRect.left && pos.pageX <= boundingRect.right;
			var inYRange = pos.pageY >= boundingRect.top && pos.pageY <= boundingRect.bottom;

			return inXRange && inYRange;
		}

	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=dom-utils.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_55__;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_56__;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_57__;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ContentPanel = __webpack_require__(59);

var _ContentPanel2 = _interopRequireDefault(_ContentPanel);

var _PackagePanel = __webpack_require__(75);

var _PackagePanel2 = _interopRequireDefault(_PackagePanel);

var _ToastEnum = __webpack_require__(30);

var _ToastEnum2 = _interopRequireDefault(_ToastEnum);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// Schematic Editor class
var SchematicEditor = function (_Component) {
	_inherits(SchematicEditor, _Component);

	// Constructor
	// State consists of property to define whether or not the dialog is open or closed,
	// the selectedTab for the tab panel and the selected item in the select drop down list
	function SchematicEditor(props) {
		_classCallCheck(this, SchematicEditor);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {};

		_this.openDialog = function () {
			_this.setState({ isDialogOpen: true });
		};

		_this.applyDialog = function () {
			// normally just call the OK callback - but wrap in a function for any housekeeping
			_this.props.okCallbackFn(_this.state.definition);
			_this.closeDialog();
		};

		_this.closeDialog = function () {
			var onCloseDialog = _this.props.onCloseDialog;

			_this.setState({ isDialogOpen: false }, function () {
				if (onCloseDialog) {
					onCloseDialog();
				}
			});
		};

		_this._cloneJsonObject = function (_object) {
			return JSON.parse(JSON.stringify(_object));
		};

		_this._renderGlobalToast = function () {
			var toastMsg = _this.state.toastMsg;

			return toastMsg && toastMsg.type && toastMsg.info && _react2.default.createElement(_baUiCarbonToolkit.GlobalToast, {
				statusType: toastMsg.type,
				timedDismiss: true,
				contentString: toastMsg.info,
				targetId: 'schematicEditorToastTargetId',
				onClose: function onClose() {
					_this.setState({ toastMsg: null });
				} });
		};

		_this._updatePackageInfo = function (_result) {
			var newDefinition = _this._cloneJsonObject(_this.state.definition);
			newDefinition.meta[_result.name] = _result.value;
			_this.setState({
				definition: newDefinition
			});
		};

		_this._handleContentChange = function (_result) {
			_this.setState(_result);
		};

		_this._iconLoadFailed = function (_error) {
			_this.setState({
				toastMsg: {
					type: _ToastEnum2.default.ERROR,
					info: _error.message
				}
			});
		};

		_this._handleIconLoad = function (_fileName, _blobUrl) {
			var newDefinition = _this._cloneJsonObject(_this.state.definition);
			newDefinition.meta.icon = _fileName;
			newDefinition.iconUrl = _blobUrl;

			var msg = _fileName ? _StringResources2.default.get('schematicsIconAdded', { file: _fileName }) : _StringResources2.default.get('schematicsIconRemove');
			_this.setState({
				toastMsg: {
					type: _ToastEnum2.default.SUCCESS,
					info: msg
				},
				definition: newDefinition
			});
		};

		_this.addSvgFilesButtonRef = null;

		// need to clone the definition from input props
		var stateDefinition = _this._cloneJsonObject(_this.props.definition);

		_this.state = {
			isDialogOpen: false,
			definition: stateDefinition,
			selectedIndices: [],
			search: '',
			searchMatches: null,
			toastMsg: null,
			svgFiles: null,
			selectedTab: 'schematicEditorContentTab',
			tabs: null
		};
		return _this;
	}

	/**
 * componentDidMount - Lifecycle method. Executes before first render. Executes when the element is inserted into the virtual DOM but before the HTML node itself can be manipulated.
 * Use this point to configure the element as required based on properties passed upon creation
 **/


	// Update the state when the package details(name or description) have changed


	// Function used to render the CustomPalette element (dialog)
	SchematicEditor.prototype.render = function render() {
		var _this2 = this;

		var dialogTitle = _StringResources2.default.get('editSchematic');
		var contentTabTitle = _StringResources2.default.get('schematicsContentTab');
		var packageTabTitle = _StringResources2.default.get('schematicsPackageTab');

		var _props = this.props,
		    zipMaxSize = _props.zipMaxSize,
		    imgMaxSize = _props.imgMaxSize;
		var _state = this.state,
		    isDialogOpen = _state.isDialogOpen,
		    selectedTab = _state.selectedTab,
		    tabs = _state.tabs,
		    definition = _state.definition,
		    svgFiles = _state.svgFiles,
		    selectedIndices = _state.selectedIndices,
		    search = _state.search,
		    searchMatches = _state.searchMatches;


		return isDialogOpen && _react2.default.createElement(
			'div',
			null,
			this._renderGlobalToast(),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog,
				{ width: '920px', onClose: this.closeDialog, startingFocusIndex: 0 },
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Header,
					{ id: 'schematicEditorToastTargetId' },
					dialogTitle
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Body,
					null,
					_react2.default.createElement(
						_baUiCarbonToolkit.Tabs,
						{
							draggable: false,
							selected: selectedTab,
							onChange: function onChange(tabId) {
								return _this2.setState({ selectedTab: tabId });
							},
							stateTabs: tabs,
							className: 'clsSVGEditorTabs'
						},
						_react2.default.createElement(
							_baUiCarbonToolkit.TabPanel,
							{ id: 'schematicEditorPackageTab', label: packageTabTitle },
							_react2.default.createElement(_PackagePanel2.default, {
								packageName: definition.meta.name,
								packageDescription: definition.meta.description,
								iconName: definition.meta.icon,
								iconURL: definition.iconUrl,
								zipMaxSize: zipMaxSize,
								imgMaxSize: imgMaxSize,
								onChange: this._updatePackageInfo,
								onIconChanged: this._handleIconLoad,
								onIconError: this._iconLoadFailed
							})
						),
						_react2.default.createElement(
							_baUiCarbonToolkit.TabPanel,
							{ id: 'schematicEditorContentTab', label: contentTabTitle },
							_react2.default.createElement(_ContentPanel2.default, {
								definition: definition,
								svgFiles: svgFiles,
								selectedIndices: selectedIndices,
								search: search,
								searchMatches: searchMatches,
								zipMaxSize: zipMaxSize,
								imgMaxSize: imgMaxSize,
								onChange: this._handleContentChange
							})
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.Dialog.Footer,
					{ id: 'schematicEditorFooterId' },
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCancelBtn', label: _StringResources2.default.get('cancelDialog'), onClick: this.closeDialog, tabIndex: 0 }),
					_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idOkBtn', autofocus: true, label: _StringResources2.default.get('saveDialog'), onClick: this.applyDialog, tabIndex: 0, primary: true })
				)
			)
		);
	};

	return SchematicEditor;
}(_react.Component);

SchematicEditor.propTypes = {
	definition: _propTypes2.default.object.isRequired,
	okCallbackFn: _propTypes2.default.func.isRequired,
	onCloseDialog: _propTypes2.default.func,
	zipMaxSize: _propTypes2.default.number,
	imgMaxSize: _propTypes2.default.number };
exports.default = SchematicEditor;


SchematicEditor.defaultProps = {
	zipMaxSize: 500,
	imgMaxSize: 500
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ConfirmReplaceDialog = __webpack_require__(60);

var _ConfirmReplaceDialog2 = _interopRequireDefault(_ConfirmReplaceDialog);

var _ItemDetail = __webpack_require__(61);

var _ItemDetail2 = _interopRequireDefault(_ItemDetail);

var _ToastEnum = __webpack_require__(30);

var _ToastEnum2 = _interopRequireDefault(_ToastEnum);

var _VisualItems = __webpack_require__(62);

var _VisualItems2 = _interopRequireDefault(_VisualItems);

var _SVGFileInput = __webpack_require__(66);

var _SVGFileInput2 = _interopRequireDefault(_SVGFileInput);

var _baUiCarbonToolkit = __webpack_require__(3);

var _baUiCarbon = __webpack_require__(20);

var _upload_ = __webpack_require__(74);

var _upload_2 = _interopRequireDefault(_upload_);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ContentPanel = function (_Component) {
	_inherits(ContentPanel, _Component);

	function ContentPanel(props) {
		_classCallCheck(this, ContentPanel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._cloneJsonObject = function (_object) {
			return JSON.parse(JSON.stringify(_object));
		};

		_this._findSearchMatches = function (value) {
			var _this$props = _this.props,
			    definition = _this$props.definition,
			    onChange = _this$props.onChange;

			var matchIndices = null;
			// if the value is empty - there's nothing being searched
			if (value) {
				matchIndices = [];
				definition.meta.content.forEach(function (item, j) {
					if (item.caption.toLowerCase().indexOf(value.toLowerCase()) !== -1) matchIndices.push(j);
				});
			}

			onChange({
				search: value,
				searchMatches: matchIndices
			});
		};

		_this._updateItem = function (property, value, index) {
			var _this$props2 = _this.props,
			    definition = _this$props2.definition,
			    onChange = _this$props2.onChange;

			var newDefinition = _this._cloneJsonObject(definition);
			newDefinition.meta.content = newDefinition.meta.content.map(function (item, j) {
				if (j === index) {
					item[property] = value;
				}
				return item;
			});

			onChange({
				definition: newDefinition
			});
		};

		_this._updateSVGFiles = function (sourceNames, blobUrls, action, applyToAll, replaceIdx) {
			var _this$props3 = _this.props,
			    definition = _this$props3.definition,
			    onChange = _this$props3.onChange;

			var newDefinition = _this._cloneJsonObject(definition);
			var count = 0;
			while (sourceNames.length > 0) {
				var sourceName = sourceNames[0];
				var blobUrl = blobUrls[0];
				var existIdx = -1;
				for (var idx = 0; idx < newDefinition.meta.content.length; ++idx) {
					if (newDefinition.meta.content[idx].source === sourceName) {
						existIdx = idx;
						break;
					}
				}

				if (replaceIdx >= 0 && replaceIdx < newDefinition.meta.content.length) {
					newDefinition.files[replaceIdx] = blobUrl;
					count = 1;
				} else if (existIdx >= 0) {
					if (action === 'confirm') break;

					if (action === 'replace') {
						newDefinition.files[existIdx] = blobUrl;
						count++;
					}
				} else {
					newDefinition.meta.content.push({
						'key': sourceName,
						'caption': sourceName,
						'source': sourceName
					});
					newDefinition.files.push(blobUrl);
					count++;
				}

				sourceNames.shift();
				blobUrls.shift();

				if (!applyToAll) action = 'confirm';
			}

			var toastMsg = count ? { type: _ToastEnum2.default.SUCCESS } : null;
			if (count === 1) toastMsg.info = _StringResources2.default.get('schematicsSingleAddSuccessed');else if (count > 1) toastMsg.info = _StringResources2.default.get('schematicsMultipleAddSuccessed', { 'count': count });

			onChange({
				definition: newDefinition,
				svgFiles: sourceNames.length > 0 ? { 'sourceNames': sourceNames, 'blobUrls': blobUrls } : null,
				search: '',
				searchMatches: null,
				toastMsg: toastMsg
			});
		};

		_this._newSvgFiles = function (sourceNames, blobUrls, replaceIdx) {
			_this._updateSVGFiles(sourceNames, blobUrls, 'confirm', false, replaceIdx);
		};

		_this._toastSchematicsAddFailed = function (_error) {
			_this.props.onChange({
				toastMsg: {
					type: _ToastEnum2.default.ERROR,
					info: _error && _error.message || _StringResources2.default.get('schematicsAddFailed')
				}
			});
		};

		_this._toggleSelection = function (idx, multiSelect) {
			var _this$props4 = _this.props,
			    selectedIndices = _this$props4.selectedIndices,
			    onChange = _this$props4.onChange;


			var newSelectedIndices = _this._cloneJsonObject(selectedIndices);

			var index = newSelectedIndices.indexOf(idx);
			if (index !== -1 && multiSelect) {
				newSelectedIndices.splice(index, 1);
			} else {
				if (multiSelect) newSelectedIndices.push(idx);else newSelectedIndices = newSelectedIndices.find(function (item) {
					return item === idx;
				}) !== undefined ? [] : [idx];
			}

			onChange({
				selectedIndices: newSelectedIndices
			});
		};

		_this._replaceSelected = function () {
			if (_this.replaceSvgFilesInputRef) {
				var selectedIndices = _this.props.selectedIndices;

				_this.replaceSvgFilesInputRef.openFileSelector(false, selectedIndices[0]);
			}
		};

		_this._deleteSelected = function () {
			var selectedIndices = _this.props.selectedIndices;

			_this._handleDeletions(selectedIndices);
		};

		_this._handleDeletions = function (itemIdxArray) {
			var _this$props5 = _this.props,
			    definition = _this$props5.definition,
			    searchMatches = _this$props5.searchMatches,
			    selectedIndices = _this$props5.selectedIndices,
			    onChange = _this$props5.onChange;

			if (itemIdxArray.length > 0) {
				var deletedCount = 0;

				var newDefinition = {
					meta: function (_ref) {
						var clone = _objectWithoutProperties(_ref, []);

						return clone;
					}(definition.meta),
					files: []
				};

				// Add the icon if defined
				if (definition.iconUrl) {
					newDefinition.iconUrl = definition.iconUrl;
				}

				newDefinition.meta.content = [];

				var newSelectedIndices = [];
				var newSearchMatches = searchMatches ? [] : null;
				for (var idx = 0; idx < definition.files.length; ++idx) {
					if (!(itemIdxArray.indexOf(idx) !== -1)) {
						newDefinition.meta.content.push(definition.meta.content[idx]);
						newDefinition.files.push(definition.files[idx]);
						var newIdx = newDefinition.files.length - 1;
						if (selectedIndices.indexOf(idx) !== -1) {
							newSelectedIndices.push(newIdx);
						}
						if (searchMatches && searchMatches.indexOf(idx) !== -1) {
							newSearchMatches.push(newIdx);
						}
					} else {
						deletedCount += 1;
					}
				}

				if (deletedCount > 0) {
					var toastInfo = deletedCount === 1 ? _StringResources2.default.get('schematicsSingleDeletionSuccessed') : _StringResources2.default.get('schematicsMultipleDeletionSuccessed', { count: deletedCount });

					onChange({
						selectedIndices: newSelectedIndices,
						searchMatches: newSearchMatches,
						definition: newDefinition,
						toastMsg: {
							type: _ToastEnum2.default.SUCCESS,
							info: toastInfo
						}
					});
				}
			}
		};

		_this._replaceAddSVGFiles = function (applyToAll) {
			var newSvgFiles = _this._cloneJsonObject(_this.props.svgFiles);
			_this._updateSVGFiles(newSvgFiles.sourceNames, newSvgFiles.blobUrls, 'replace', applyToAll);
		};

		_this._cancelAddSVGFiles = function (applyToAll) {
			var newSvgFiles = _this._cloneJsonObject(_this.props.svgFiles);
			_this._updateSVGFiles(newSvgFiles.sourceNames, newSvgFiles.blobUrls, 'cancel', applyToAll);
		};

		_this._renderHeader = function (selectedCount) {
			if (selectedCount > 0) return _this._renderBatchActions(selectedCount);

			var searchTitle = _StringResources2.default.get('searchSchematic');
			var _this$props6 = _this.props,
			    search = _this$props6.search,
			    definition = _this$props6.definition,
			    onChange = _this$props6.onChange,
			    zipMaxSize = _this$props6.zipMaxSize,
			    imgMaxSize = _this$props6.imgMaxSize;

			return _react2.default.createElement(
				'div',
				{ style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexGrow: 1 } },
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_baUiCarbonToolkit.SearchInput, {
						light: true,
						tabIndex: 0,
						placeholder: searchTitle,
						className: 'clsSVGSearch',
						value: search,
						disabled: definition.meta.content.length === 0,
						onChange: _this._findSearchMatches,
						onClear: function onClear() {
							return onChange({ search: '', searchMatches: null });
						}
					})
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_SVGFileInput2.default, {
						ref: function ref(_ref2) {
							_this.addSvgFilesInputRef = _ref2;
						},
						successCallback: _this._newSvgFiles,
						failCallback: _this._toastSchematicsAddFailed,
						zipMaxSize: zipMaxSize,
						imgMaxSize: imgMaxSize
					}),
					_react2.default.createElement(
						_baUiCarbonToolkit.Button,
						{
							icon: _upload_2.default.id,
							kind: 'ghost',
							onClick: function onClick() {
								return _this.addSvgFilesInputRef ? _this.addSvgFilesInputRef.openFileSelector(true) : {};
							},
							title: _StringResources2.default.get('addSchematic')
						},
						' ',
						_StringResources2.default.get('addSchematic'),
						' '
					)
				)
			);
		};

		_this._renderBatchActions = function (selectedCount) {
			var _this$props7 = _this.props,
			    zipMaxSize = _this$props7.zipMaxSize,
			    imgMaxSize = _this$props7.imgMaxSize;

			return _react2.default.createElement(
				_baUiCarbon.TableToolbar,
				null,
				_react2.default.createElement(
					_baUiCarbon.TableBatchActions,
					{
						style: { justifyContent: 'space-between' },
						totalSelected: selectedCount,
						shouldShowBatchActions: true,
						onCancel: function onCancel() {
							_this.props.onChange({ selectedIndices: [] });
						} },
					selectedCount === 1 ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_baUiCarbon.TableBatchAction,
							{
								isVisible: selectedCount === 1,
								tabIndex: selectedCount === 1 ? 0 : -1,
								onClick: function onClick() {
									_this._replaceSelected();
								},
								renderIcon: function renderIcon() {
									return null;
								} },
							_StringResources2.default.get('schematicsContextMenuReplace')
						),
						_react2.default.createElement(_SVGFileInput2.default, {
							ref: function ref(_ref3) {
								_this.replaceSvgFilesInputRef = _ref3;
							},
							successCallback: _this._newSvgFiles,
							failCallback: _this._toastSchematicsAddFailed,
							zipMaxSize: zipMaxSize,
							imgMaxSize: imgMaxSize
						})
					) : null,
					_react2.default.createElement(
						_baUiCarbon.TableBatchAction,
						{
							tabIndex: 0,
							onClick: function onClick() {
								_this._deleteSelected();
							},
							renderIcon: function renderIcon() {
								return null;
							} },
						_StringResources2.default.get('schematicsContextMenuDelete')
					)
				)
			);
		};

		return _this;
	}

	// update the state when a property value is changed


	// add button parameters: action, applyToAll
	// contextMenu replace parameters: replaceIdx


	//
	// Main render function
	//
	ContentPanel.prototype.render = function render() {
		var _props = this.props,
		    selectedIndices = _props.selectedIndices,
		    searchMatches = _props.searchMatches,
		    definition = _props.definition,
		    onChange = _props.onChange,
		    svgFiles = _props.svgFiles;
		// calculate the values which drive the detail panel. Have to take into account the searchMatches - which
		// reduces the set of items to see

		var filteredItems = !searchMatches ? selectedIndices : selectedIndices.filter(function (value) {
			return searchMatches.indexOf(value) !== -1;
		});
		var selectedCount = filteredItems.length;
		var selectedItem = selectedCount === 1 ? definition.meta.content[filteredItems[0]] : {};
		var selectedFileRef = selectedCount === 1 ? definition.files[filteredItems[0]] : '';
		var selectedIndex = selectedCount === 1 ? filteredItems[0] : -1;

		return _react2.default.createElement(
			'div',
			{ className: 'clsSVGTabsStyle' },
			_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 }),
			this._renderHeader(selectedCount),
			_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 }),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'row',
					justifyContent: 'space-between',
					alignItems: 'stretch',
					style: { width: '100%' }
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{
						style: { width: '593px' }
					},
					_react2.default.createElement(_VisualItems2.default, {
						items: definition.meta.content,
						files: definition.files,
						selections: selectedIndices,
						searchMatches: searchMatches,
						selectVisualItemCallback: this._toggleSelection,
						deSelectAllCallback: function deSelectAllCallback() {
							onChange({
								selectedIndices: []
							});
						}
					})
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.HSpacer, { size: 1 })
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{
						style: { width: '271px' }
					},
					_react2.default.createElement(_ItemDetail2.default, {
						item: selectedItem,
						fileRef: selectedFileRef,
						index: selectedIndex,
						selectionCount: selectedCount,
						updateItemCallback: this._updateItem
					})
				)
			),
			!!svgFiles && _react2.default.createElement(_ConfirmReplaceDialog2.default, {
				sourceName: svgFiles ? svgFiles.sourceNames[0] : '',
				isApplyToAll: false,
				okCallback: this._replaceAddSVGFiles,
				cancelCallback: this._cancelAddSVGFiles
			})
		);
	};

	return ContentPanel;
}(_react.Component);

ContentPanel.propTypes = {
	definition: _propTypes2.default.object.isRequired,
	svgFiles: _propTypes2.default.object,
	selectedIndices: _propTypes2.default.array.isRequired,
	search: _propTypes2.default.string.isRequired,
	searchMatches: _propTypes2.default.array,
	zipMaxSize: _propTypes2.default.number,
	imgMaxSize: _propTypes2.default.number,
	onChange: _propTypes2.default.func.isRequired
};
exports.default = ContentPanel;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ConfirmReplaceDialog = function (_Component) {
	_inherits(ConfirmReplaceDialog, _Component);

	function ConfirmReplaceDialog(props) {
		_classCallCheck(this, ConfirmReplaceDialog);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._replace = function () {
			_this.props.okCallback(_this.state.isApplyToAll);
		};

		_this._cancel = function () {
			_this.props.cancelCallback(_this.state.isApplyToAll);
		};

		_this.state = {
			isApplyToAll: _this.props.isApplyToAll
		};
		return _this;
	}

	ConfirmReplaceDialog.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			_baUiCarbonToolkit.Dialog,
			{ width: '500px', onClose: this._cancel, startingFocusIndex: 0 },
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Header,
				null,
				_StringResources2.default.get('schematicsReplaceDlgTitle')
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Body,
				null,
				_react2.default.createElement(
					'div',
					{ style: { marginTop: '8px' } },
					_StringResources2.default.get('schematicsReplaceDlgContent', { 'sourceName': this.props.sourceName })
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{
						direction: 'column',
						width: '100%',
						height: '100%',
						alignItems: 'flex-start',
						justifyContent: 'center',
						style: { marginTop: '8px' }
					},
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Checkbox, {
							label: _StringResources2.default.get('schematicsReplaceDlgApplyToAllFiles'),
							checked: this.state.isApplyToAll,
							onChange: function onChange() {
								return _this2.setState({ isApplyToAll: !_this2.state.isApplyToAll });
							}
						})
					)
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.Dialog.Footer,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idCancelBtn', label: _StringResources2.default.get('cancelDialog'), onClick: this._cancel, tabIndex: 0 }),
				_react2.default.createElement(_baUiCarbonToolkit.Dialog.Button, { id: 'idOkBtn', label: _StringResources2.default.get('okDialog'), onClick: this._replace, tabIndex: 0, primary: true })
			)
		);
	};

	return ConfirmReplaceDialog;
}(_react.Component);

ConfirmReplaceDialog.propTypes = {
	sourceName: _propTypes2.default.string.isRequired,
	isApplyToAll: _propTypes2.default.bool.isRequired,
	okCallback: _propTypes2.default.func.isRequired,
	cancelCallback: _propTypes2.default.func.isRequired
};
exports.default = ConfirmReplaceDialog;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ItemDetail = function (_Component) {
	_inherits(ItemDetail, _Component);

	function ItemDetail(props) {
		_classCallCheck(this, ItemDetail);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	/* componentWillReceiveProps(nextProps) {
 } */

	ItemDetail.prototype.renderCountSelection = function renderCountSelection() {
		var selectionCount = this.props.selectionCount;


		var label = selectionCount === 0 ? _StringResources2.default.get('schematicsNoSelection') : _StringResources2.default.get('schematicsMultipleSelection', { count: selectionCount });
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				direction: 'column',
				width: '100%',
				height: '100%',
				alignItems: 'center',
				justifyContent: 'center',
				className: 'clsSVGDetailContainer'
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', label: label })
			)
		);
	};

	ItemDetail.prototype.renderSingleSelection = function renderSingleSelection() {
		var _this2 = this;

		var _props = this.props,
		    item = _props.item,
		    index = _props.index,
		    fileRef = _props.fileRef;


		var nameLabel = _StringResources2.default.get('nameLabelSchematic');
		var captionLabel = _StringResources2.default.get('captionLabelSchematic');
		var keyLabel = _StringResources2.default.get('keyLabelSchematic');

		var sourceUrl = fileRef;
		var source = item.source;
		var caption = item.caption;
		var key = item.key;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				direction: 'column',
				width: '100%',
				height: '100%',
				alignItems: 'center',
				className: 'clsSVGDetailContainer'
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{
						direction: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						className: 'clsSVGDetailStyle'
					},
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ style: { width: '100%' } },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexItem,
							null,
							item && _react2.default.createElement('img', { style: { width: '100%', height: 'auto', maxWidth: '237px', maxHeight: '216px' }, src: sourceUrl })
						)
					)
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { width: '100%', height: '24px' } },
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'nameEdit', label: nameLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsSVGDetailEdit' },
				_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
					id: 'nameEdit',
					value: source,
					disabled: true })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { width: '100%', height: '24px' } },
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'captionEdit', label: captionLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsSVGDetailEdit' },
				_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
					id: 'captionEdit',
					value: caption,
					onValueChange: function onValueChange(v) {
						_this2.props.updateItemCallback('caption', v, index);
					}
				})
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { width: '100%', height: '24px' } },
				_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'keyEdit', label: keyLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsSVGDetailEdit' },
				_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
					id: 'keyEdit',
					value: key,
					onValueChange: function onValueChange(v) {
						_this2.props.updateItemCallback('key', v, index);
					}
				})
			)
		);
	};

	ItemDetail.prototype.render = function render() {
		var selectionCount = this.props.selectionCount;


		if (selectionCount === 1) return this.renderSingleSelection();
		return this.renderCountSelection();
	};

	return ItemDetail;
}(_react.Component);

ItemDetail.propTypes = {
	item: _propTypes2.default.object.isRequired,
	fileRef: _propTypes2.default.string.isRequired,
	updateItemCallback: _propTypes2.default.func.isRequired,
	index: _propTypes2.default.number.isRequired,
	selectionCount: _propTypes2.default.number.isRequired
};
exports.default = ItemDetail;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _VisualItem = __webpack_require__(63);

var _VisualItem2 = _interopRequireDefault(_VisualItem);

var _baUiCarbonToolkit = __webpack_require__(3);

__webpack_require__(4);

var _search_ = __webpack_require__(65);

var _search_2 = _interopRequireDefault(_search_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// search_16 is placeHolder.


//import emptySearchResults from '@ba/ba-graphics/dist/illustrations-js/search-results_128.js';

var VisualItems = function (_Component) {
	_inherits(VisualItems, _Component);

	function VisualItems(props) {
		_classCallCheck(this, VisualItems);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._renderEmptySearchResults = function () {
			var searchMatches = _this.props.searchMatches;

			if (searchMatches && searchMatches.length === 0) return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'column',
					width: '100%',
					height: '100%',
					alignItems: 'center',
					justifyContent: 'center'
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
							width: 150,
							height: 150,
							focusable: false,
							intent: 'info',
							className: 'svgIcon',
							verticalAlign: 'middle',
							iconId: _search_2.default.id
						})
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('schematicsEmptySearchResults') })
					)
				)
			);
		};

		return _this;
	}

	/* componentWillReceiveProps(nextProps) {
 } */

	VisualItems.prototype.renderVisualizationItem = function renderVisualizationItem(item, fileRef, selected, idx) {
		// remove the props we don't want to pass to each child
		return _react2.default.createElement(_VisualItem2.default, _extends({}, this.props, { key: item.source, item: item, fileRef: fileRef, selected: selected, idx: idx }));
	};

	VisualItems.prototype.render = function render() {
		var _this2 = this;

		var _props = this.props,
		    items = _props.items,
		    files = _props.files,
		    selections = _props.selections,
		    searchMatches = _props.searchMatches;

		var contentItems = [];
		items.forEach(function (item, idx) {
			var selected = selections.indexOf(idx) !== -1;
			if (searchMatches && searchMatches.indexOf(idx) !== -1 || !searchMatches) contentItems.push(_this2.renderVisualizationItem(item, files[idx], selected, idx));
		});

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				direction: 'row',
				wrap: 'wrap',
				alignItems: 'flex-start',
				justifyContent: 'flex-start',
				style: { alignContent: 'flex-start' },
				className: 'clsSVGTilesStyle',
				onClick: function onClick(e) {
					e.stopPropagation();
					_this2.props.deSelectAllCallback();
				}
			},
			this._renderEmptySearchResults(),
			contentItems
		);
	};

	return VisualItems;
}(_react.Component);

VisualItems.propTypes = {
	items: _propTypes2.default.array.isRequired,
	files: _propTypes2.default.array.isRequired,
	selections: _propTypes2.default.array.isRequired,
	searchMatches: _propTypes2.default.array, // can be null means no search at all, show all items.
	selectVisualItemCallback: _propTypes2.default.func.isRequired,
	deSelectAllCallback: _propTypes2.default.func.isRequired
};
exports.default = VisualItems;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbonToolkit = __webpack_require__(3);

var _checkmarkFilled_ = __webpack_require__(64);

var _checkmarkFilled_2 = _interopRequireDefault(_checkmarkFilled_);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var VisualItem = function (_Component) {
	_inherits(VisualItem, _Component);

	function VisualItem(props) {
		_classCallCheck(this, VisualItem);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._onClickHandler = function (e) {
			e.stopPropagation();
			_this.props.selectVisualItemCallback(_this.props.idx, e.ctrlKey || e.metaKey);
		};

		_this._onKeyDownHandler = function (e) {
			// implement
			if (e.keyCode === 32 || e.keyCode === 13) {
				// TODO - we should cancel the event
				// but this is react event so outside normal event processing
				// see https://medium.com/@ericclemmons/react-event-preventdefault-78c28c950e46
				// use native event to stop this
				_this.props.selectVisualItemCallback(_this.props.idx, e.ctrlKey || e.metaKey);
			}
		};

		_this._showVisualItemContextMenu = function (idx) {
			_this.props.selectVisualItemCallback(idx);
			_this.props.handleVisualItemContextMenuCallback();
			_this.setState({ isContextMenuOpen: !_this.state.isContextMenuOpen });
		};

		_this._closeVisualItemContextMenu = function () {
			_this.setState({ isContextMenuOpen: false });
		};

		_this._renderItem = function (fileRef) {
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'column',
					role: 'button',
					onClick: _this._onClickHandler,
					onKeyDown: _this._onKeyDownHandler },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ style: { width: '128px', height: '128px' } },
					_this._renderContent(fileRef)
				)
			);
		};

		_this._renderContent = function (fileRef) {
			// all urls are represented as blobs in our files data
			// (implies that any integrator would extract and supply as blobs)
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					direction: 'column',
					width: '100%',
					height: '100%',
					alignItems: 'center',
					justifyContent: 'center'
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ style: { width: '100%' } },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement('img', { style: { width: '100%', height: 'auto', maxWidth: '108px', maxHeight: '108px' },
							src: fileRef
						})
					)
				)
			);
		};

		_this._renderItemLabel = function (item) {
			return _react2.default.createElement(_baUiCarbonToolkit.Label, { label: item.caption, ellipsis: true });
		};

		_this.state = {
			isContextMenuOpen: false
		};
		return _this;
	}

	//
	// Main render function
	//
	VisualItem.prototype.render = function render() {
		var className = 'clsSVGTileStyle' + (this.props.selected ? '_selected' : '');

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexItem,
			{ className: 'clsSVGTileStyleContainer' },
			_react2.default.createElement(
				'div',
				{ ref: this._rootRef, style: { width: '128px' } },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{
						fullHeight: true,
						direction: 'column',
						alignItems: 'flex-start',
						className: className,
						onClick: this._onClickHandler,
						onKeyDown: this._onKeyDownHandler,
						tabIndex: 0
					},
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ alignSelf: 'flex-end', className: 'clsSVGTileCheckmark' },
						_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
							size: 'small',
							className: 'svgIcon clsSVGCheckmarkSelected',
							verticalAlign: 'initial',
							iconId: _checkmarkFilled_2.default.id,
							tabIndex: -1
						})
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						this._renderItem(this.props.fileRef, this.props.selected, this.props.idx)
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ alignSelf: 'center'
						},
						this._renderItemLabel(this.props.item)
					)
				)
			)
		);
	};

	return VisualItem;
}(_react.Component);

VisualItem.propTypes = {
	item: _propTypes2.default.object.isRequired,
	fileRef: _propTypes2.default.string.isRequired,
	selected: _propTypes2.default.bool.isRequired,
	idx: _propTypes2.default.number.isRequired,
	items: _propTypes2.default.array.isRequired,
	files: _propTypes2.default.array.isRequired,
	selections: _propTypes2.default.array.isRequired,
	selectVisualItemCallback: _propTypes2.default.func.isRequired,
	handleVisualItemContextMenuCallback: _propTypes2.default.func.isRequired
};
exports.default = VisualItem;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var c=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in c)("object"==typeof exports?exports:e)[a]=c[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1691],{"6873601dfe1d9459c1a9":function(s,c){s.exports=e},"719d2200b9ef2c0c6681":function(e,s,c){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=c("6873601dfe1d9459c1a9"),o=(c.n(a),c("c8afa3f4f2def0c0f92f"));s.default=o.a},c8afa3f4f2def0c0f92f:function(e,s,c){"use strict";var a=c("9689a9c94ae38b47fa2c"),o=c.n(a),i=c("9ce58a7deea14f49ef01"),f=c.n(i),n=new o.a({id:"checkmark--filled_16_v7",use:"checkmark--filled_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="checkmark--filled_16_v7"><path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z" /></symbol>'});f.a.add(n);s.a=n}},["719d2200b9ef2c0c6681"])});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var c in a)("object"==typeof exports?exports:e)[c]=a[c]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([456],{"2faa256623dda8fa3df1":function(e,s,a){"use strict";var c=a("9689a9c94ae38b47fa2c"),o=a.n(c),i=a("9ce58a7deea14f49ef01"),t=a.n(i),n=new o.a({id:"search_16_v7",use:"search_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="search_16_v7"><path d="M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5\tC2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z" /></symbol>'});t.a.add(n);s.a=n},"6873601dfe1d9459c1a9":function(s,a){s.exports=e},"7417e443bcec9c766abb":function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var c=a("6873601dfe1d9459c1a9"),o=(a.n(c),a("2faa256623dda8fa3df1"));s.default=o.a}},["7417e443bcec9c766abb"])});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileLoader = __webpack_require__(31);

var _FileLoader2 = _interopRequireDefault(_FileLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// This is a bit of an odd component, it renders a hidden file input and relies on the parent component to invoke openFileSelector using a ref
var SVGFileInput = function (_Component) {
	_inherits(SVGFileInput, _Component);

	function SVGFileInput(props) {
		_classCallCheck(this, SVGFileInput);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._findSourceName = function (name) {
			return name.split('/').pop();
		};

		_this._onFileChange = function (e) {
			var loader = new _FileLoader2.default(null, _this.props.zipMaxSize, _this.props.imgMaxSize);
			loader.load(e.target.files, function (_fileList) {
				if (_fileList.length > 0) {
					var sourceNames = [];
					var blobUrls = [];
					var loadBlobPromises = [];

					_fileList.forEach(function (item) {
						sourceNames.push(_this._findSourceName(item));
						blobUrls.push('');
						loadBlobPromises.push(loader.getFileAsBlob(item));
					});

					var urlCreator = window.URL || window.webkitURL;
					Promise.all(loadBlobPromises).then(function (loadedBlobUrls) {
						loadedBlobUrls.forEach(function (item, i) {
							// item is returned as blob - but it won't have a type
							// so we need to slice it to set the type
							var sliceBlob = item.slice(0, item.size, 'image/svg+xml');
							// want to keep the source URL - we need to release it later
							blobUrls[i] = urlCreator.createObjectURL(sliceBlob);
						});
						_this.props.successCallback(sourceNames, blobUrls, _this.replaceIdx);
					}).catch(_this.props.failCallback);
				}
			}, _this.props.failCallback);
		};

		_this.fileInputRef = null;
		_this.replaceIdx = null;
		return _this;
	}

	SVGFileInput.prototype.openFileSelector = function openFileSelector(isMultiple, replaceIdx) {
		this.replaceIdx = replaceIdx;
		if (this.fileInputRef) {
			this.fileInputRef.multiple = isMultiple;
			this.fileInputRef.click();
		}
	};

	// some utility methods - need to find the name of the image - without path


	SVGFileInput.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('input', {
				id: 'myInput',
				accept: '.svg',
				multiple: true,
				value: '',
				type: 'file',
				style: { display: 'none' },
				ref: function ref(_ref) {
					_this2.fileInputRef = _ref;
				},
				onChange: this._onFileChange
			})
		);
	};

	return SVGFileInput;
}(_react.Component);

SVGFileInput.propTypes = {
	successCallback: _propTypes2.default.func.isRequired,
	failCallback: _propTypes2.default.func.isRequired,
	zipMaxSize: _propTypes2.default.number.isRequired,
	imgMaxSize: _propTypes2.default.number.isRequired
};
exports.default = SVGFileInput;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Buffer, setImmediate) {var require;var require;/*!

JSZip v3.6.0 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE
*/

!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=e()}}(function(){return function s(a,o,u){function h(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return require(r,!0);if(f)return f(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return h(t||e)},i,i.exports,s,a,o,u)}return o[r].exports}for(var f="function"==typeof require&&require,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(e,t,r){"use strict";var c=e("./utils"),l=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,u=[],h=0,f=e.length,l=f,d="string"!==c.getTypeOf(e);h<e.length;)l=f-h,n=d?(t=e[h++],r=h<f?e[h++]:0,h<f?e[h++]:0):(t=e.charCodeAt(h++),r=h<f?e.charCodeAt(h++):0,h<f?e.charCodeAt(h++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<l?(15&r)<<2|n>>6:64,o=2<l?63&n:64,u.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return u.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,u=0;if("data:"===e.substr(0,"data:".length))throw new Error("Invalid base64 input, it looks like a data url.");var h,f=3*(e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(h=l.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),h[u++]=t,64!==s&&(h[u++]=r),64!==a&&(h[u++]=n);return h}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(e){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils"),a=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r){var n=a,i=0+r;e^=-1;for(var s=0;s<i;s++)e=e>>>8^n[255&(e^t[s])];return-1^e}(0|t,e,e.length):function(e,t,r){var n=a,i=0+r;e^=-1;for(var s=0;s<i;s++)e=e>>>8^n[255&(e^t.charCodeAt(s))];return-1^e}(0|t,e,e.length):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function u(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(u,a),u.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},u.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},u.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},u.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new u("Deflate",e)},r.uncompressWorker=function(){return new u("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function I(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function i(e,t,r,n,i,s){var a,o,u=e.file,h=e.compression,f=s!==B.utf8encode,l=O.transformTo("string",s(u.name)),d=O.transformTo("string",B.utf8encode(u.name)),c=u.comment,p=O.transformTo("string",s(c)),m=O.transformTo("string",B.utf8encode(c)),_=d.length!==u.name.length,g=m.length!==c.length,v="",b="",w="",y=u.dir,k=u.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),f||!_&&!g||(S|=2048);var z,E=0,C=0;y&&(E|=16),"UNIX"===i?(C=798,E|=((z=u.unixPermissions)||(z=y?16893:33204),(65535&z)<<16)):(C=20,E|=63&(u.dosPermissions||0)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v+="up"+I((b=I(1,1)+I(T(l),4)+d).length,2)+b),g&&(v+="uc"+I((w=I(1,1)+I(T(p),4)+m).length,2)+w);var A="";return A+="\n\0",A+=I(S,2),A+=h.magic,A+=I(a,2),A+=I(o,2),A+=I(x.crc32,4),A+=I(x.compressedSize,4),A+=I(x.uncompressedSize,4),A+=I(l.length,2),A+=I(v.length,2),{fileRecord:R.LOCAL_FILE_HEADER+A+l+v,dirRecord:R.CENTRAL_FILE_HEADER+I(C,2)+A+I(p.length,2)+"\0\0\0\0"+I(E,4)+I(n,4)+l+v+p}}var O=e("../utils"),s=e("../stream/GenericWorker"),B=e("../utf8"),T=e("../crc32"),R=e("../signature");function n(e,t,r,n){s.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}O.inherits(n,s),n.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,s.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},n.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=i(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},n.prototype.closedSource=function(e){this.accumulate=!1;var t,r=this.streamFiles&&!e.file.dir,n=i(e,r,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(n.dirRecord),r)this.push({data:(t=e,R.DATA_DESCRIPTOR+I(t.crc32,4)+I(t.compressedSize,4)+I(t.uncompressedSize,4)),meta:{percent:100}});else for(this.push({data:n.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},n.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r,n,i,s,a,o,u=this.bytesWritten-e,h=(r=this.dirRecords.length,n=u,i=e,s=this.zipComment,a=this.encodeFileName,o=O.transformTo("string",a(s)),R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+I(r,2)+I(r,2)+I(n,4)+I(i,4)+I(o.length,2)+o);this.push({data:h,meta:{percent:100}})},n.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},n.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},n.prototype.resume=function(){return!!s.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},n.prototype.error=function(e){var t=this._sources;if(!s.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},n.prototype.lock=function(){s.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=n},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var h=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),u=0;try{e.forEach(function(e,t){u++;var r=function(e,t){var r=e||t,n=h[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=u}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files={},this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.5.0",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var n=e("./utils"),i=e("./external"),o=e("./utf8"),u=e("./zipEntries"),s=e("./stream/Crc32Probe"),h=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new s);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,s){var a=this;return s=n.extend(s||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:o.utf8decode}),h.isNode&&h.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):n.prepareContent("the loaded zip file",e,!0,s.optimizedBinaryString,s.base64).then(function(e){var t=new u(s);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(s.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n];a.file(i.fileNameStr,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:s.createFolders})}return t.zipComment.length&&(a.comment=t.zipComment),a})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=f.getTypeOf(t),s=f.extend(r||{},d);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=h(e)),s.createFolders&&(n=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""}(e))&&g.call(this,n,!0);var a,o="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!o),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string"),a=t instanceof c||t instanceof l?t:m.isNode&&m.isStream(t)?new _(e,t):f.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var u=new p(e,a,s);this.files[e]=u}function h(e){return"/"!==e.slice(-1)&&(e+="/"),e}var i=e("./utf8"),f=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),d=e("./defaults"),c=e("./compressedObject"),p=e("./zipObject"),o=e("./generate"),m=e("./nodejsUtils"),_=e("./nodejs/NodejsStreamInputAdapter"),g=function(e,t){return t=void 0!==t?t:d.createFolders,e=h(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function u(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)this.files.hasOwnProperty(t)&&(n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n))},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(u(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(u(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=g.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(e){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=f.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");f.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(e){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(e){},lastIndexOfSignature:function(e){},readAndCheckSignature:function(e){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),u=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new u(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)this.extraStreamInfo.hasOwnProperty(e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),f=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function u(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}u.prototype={accumulate:function(e){return o=this,u=e,new a.Promise(function(t,r){var n=[],i=o._internalType,s=o._outputType,a=o._mimeType;o.on("data",function(e,t){n.push(e),u&&u(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return f.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()});var o,u},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=u},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),u=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),h=new Array(256),i=0;i<256;i++)h[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function f(){n.call(this,"utf-8 encode")}h[254]=h[254]=1,s.utf8encode=function(e){return u.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=u.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return u.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=h[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(u.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(u.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(u.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+h[e[r]]>t?r:t}(t),i=t;n!==t.length&&(u.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(f,n),f.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=f},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,o){"use strict";var u=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),n=e("set-immediate-shim"),f=e("./external");function i(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}o.newBlob=function(t,r){o.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var s={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return u.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return u.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function a(e){var t=65536,r=o.getTypeOf(e),n=!0;if("uint8array"===r?n=s.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=s.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return s.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return s.stringifyByChar(e)}function d(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}o.applyFromCharCode=a;var c={};c.string={string:i,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:a,array:i,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return a(new Uint8Array(e))},array:function(e){return d(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:i,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:a,array:function(e){return d(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:i,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:a,array:function(e){return d(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return d(e,new Uint8Array(e.length))},nodebuffer:i},o.transformTo=function(e,t){if(t=t||"",!e)return t;o.checkSupport(e);var r=o.getTypeOf(t);return c[r][e](t)},o.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":u.nodebuffer&&r.isBuffer(e)?"nodebuffer":u.uint8array&&e instanceof Uint8Array?"uint8array":u.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},o.checkSupport=function(e){if(!u[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},o.MAX_VALUE_16BITS=65535,o.MAX_VALUE_32BITS=-1,o.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},o.delay=function(e,t,r){n(function(){e.apply(r||null,t||[])})},o.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},o.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])arguments[e].hasOwnProperty(t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},o.prepareContent=function(n,e,i,s,a){return f.Promise.resolve(e).then(function(n){return u.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new f.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t,r=o.getTypeOf(e);return r?("arraybuffer"===r?e=o.transformTo("uint8array",e):"string"===r&&(a?e=h.decode(e):i&&!0!==s&&(e=l(t=e,u.uint8array?new Uint8Array(t.length):new Array(t.length)))),e):f.Promise.reject(new Error("Can't read the data of '"+n+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,"set-immediate-shim":54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=(e("./utf8"),e("./support"));function u(e){this.files=[],this.loadOptions=e}u.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Corrupted zip: can't find end of central directory"):new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=u},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utf8":31,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),u=e("./compressions"),h=e("./support");function f(e,t){this.options=e,this.loadOptions=t}f.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in u)if(u.hasOwnProperty(t)&&u[t].magic===e)return u[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(e){if(this.extraFields[1]){var t=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=t.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=t.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=t.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=t.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=h.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=f},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),u=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new u("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof u?this._data:new i(this._data)}};for(var h=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],f=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},l=0;l<h.length;l++)n.prototype[h[l]]=f;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,f,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(h),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){h(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(h,0)};else{var o=new t.MessageChannel;o.port1.onmessage=h,r=function(){o.port2.postMessage(0)}}var u=[];function h(){var e,t;n=!0;for(var r=u.length;r;){for(t=u,u=[],e=-1;++e<r;)t[e]();r=u.length}n=!1}f.exports=function(e){1!==u.push(e)||n||r()}}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function h(){}var f={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==h&&c(this,e)}function u(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function l(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return f.reject(t,e)}e===t?f.reject(t,new TypeError("Cannot resolve promise with itself")):f.resolve(t,e)})}function d(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function c(t,e){var r=!1;function n(e){r||(r=!0,f.reject(t,e))}function i(e){r||(r=!0,f.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(h);return this.state!==n?l(r,this.state===a?e:t,this.outcome):this.queue.push(new u(r,e,t)),r},u.prototype.callFulfilled=function(e){f.resolve(this.promise,e)},u.prototype.otherCallFulfilled=function(e){l(this.promise,this.onFulfilled,e)},u.prototype.callRejected=function(e){f.reject(this.promise,e)},u.prototype.otherCallRejected=function(e){l(this.promise,this.onRejected,e)},f.resolve=function(e,t){var r=p(d,t);if("error"===r.status)return f.reject(e,r.value);var n=r.value;if(n)c(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},f.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){return e instanceof this?e:f.resolve(new this(h),e)},o.reject=function(e){var t=new this(h);return f.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);for(var s=new Array(n),a=0,t=-1,o=new this(h);++t<n;)u(e[t],t);return o;function u(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,f.resolve(o,s))},function(e){i||(i=!0,f.reject(o,e))})}},o.race=function(e){if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var t=e.length,r=!1;if(!t)return this.resolve([]);for(var n,i=-1,s=new this(h);++i<t;)n=e[i],this.resolve(n).then(function(e){r||(r=!0,f.resolve(s,e))},function(e){r||(r=!0,f.reject(s,e))});return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),u=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),h=Object.prototype.toString,f=0,l=-1,d=0,c=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:l,method:c,chunkSize:16384,windowBits:15,memLevel:8,strategy:d,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==f)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?u.string2buf(t.dictionary):"[object ArrayBuffer]"===h.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==f)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=u.string2buf(e):"[object ArrayBuffer]"===h.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==f)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(u.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===f):2!==n||(this.onEnd(f),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===f&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var d=e("./zlib/inflate"),c=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=c.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=d.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,d.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,u=this.strm,h=this.options.chunkSize,f=this.options.dictionary,l=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?u.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?u.input=new Uint8Array(e):u.input=e,u.next_in=0,u.avail_in=u.input.length;do{if(0===u.avail_out&&(u.output=new c.Buf8(h),u.next_out=0,u.avail_out=h),(r=d.inflate(u,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&f&&(o="string"==typeof f?p.string2buf(f):"[object ArrayBuffer]"===_.call(f)?new Uint8Array(f):f,r=d.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===l&&(r=m.Z_OK,l=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);u.next_out&&(0!==u.avail_out&&r!==m.Z_STREAM_END&&(0!==u.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(u.output,u.next_out),s=u.next_out-i,a=p.buf2string(u.output,i),u.next_out=s,u.avail_out=h-s,s&&c.arraySet(u.output,u.output,i,s,0),this.onData(a)):this.onData(c.shrinkBuf(u.output,u.next_out)))),0===u.avail_in&&0===u.avail_out&&(l=!0)}while((0<u.avail_in||0===u.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=d.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(u.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=c.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var u=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var h=new u.Buf8(256),n=0;n<256;n++)h[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function f(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,u.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}h[254]=h[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new u.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return f(e,e.length)},r.binstring2buf=function(e){for(var t=new u.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=h[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return f(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+h[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var u,d=e("../utils/common"),h=e("./trees"),c=e("./adler32"),p=e("./crc32"),n=e("./messages"),f=0,l=0,m=-2,i=2,_=8,s=286,a=30,o=19,g=2*s+1,v=15,b=3,w=258,y=w+b+1,k=42,x=113;function S(e,t){return e.msg=n[t],t}function z(e){return(e<<1)-(4<e?9:0)}function E(e){for(var t=e.length;0<=--t;)e[t]=0}function C(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(d.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function A(e,t){h._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,C(e.strm)}function I(e,t){e.pending_buf[e.pending++]=t}function O(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function B(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,u=e.strstart>e.w_size-y?e.strstart-(e.w_size-y):0,h=e.window,f=e.w_mask,l=e.prev,d=e.strstart+w,c=h[s+a-1],p=h[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(h[(r=t)+a]===p&&h[r+a-1]===c&&h[r]===h[s]&&h[++r]===h[s+1]){s+=2,r++;do{}while(h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&s<d);if(n=w-(d-s),s=d-w,a<n){if(e.match_start=t,o<=(a=n))break;c=h[s+a-1],p=h[s+a]}}}while((t=l[t&f])>u&&0!=--i);return a<=e.lookahead?a:e.lookahead}function T(e){var t,r,n,i,s,a,o,u,h,f,l=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=l+(l-y)){for(d.arraySet(e.window,e.window,l,l,0),e.match_start-=l,e.strstart-=l,e.block_start-=l,t=r=e.hash_size;n=e.head[--t],e.head[t]=l<=n?n-l:0,--r;);for(t=r=l;n=e.prev[--t],e.prev[t]=l<=n?n-l:0,--r;);i+=l}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,u=e.strstart+e.lookahead,f=void 0,(h=i)<(f=a.avail_in)&&(f=h),r=0===f?0:(a.avail_in-=f,d.arraySet(o,a.input,a.next_in,f,u),1===a.state.wrap?a.adler=c(a.adler,o,f,u):2===a.state.wrap&&(a.adler=p(a.adler,o,f,u)),a.next_in+=f,a.total_in+=f,f),e.lookahead+=r,e.lookahead+e.insert>=b)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+b-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<b)););}while(e.lookahead<y&&0!==e.strm.avail_in)}function R(e,t){for(var r,n;;){if(e.lookahead<y){if(T(e),e.lookahead<y&&t===f)return 1;if(0===e.lookahead)break}if(r=0,e.lookahead>=b&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-y&&(e.match_length=B(e,r)),e.match_length>=b)if(n=h._tr_tally(e,e.strstart-e.match_start,e.match_length-b),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=b){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=h._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=e.strstart<b-1?e.strstart:b-1,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}function D(e,t){for(var r,n,i;;){if(e.lookahead<y){if(T(e),e.lookahead<y&&t===f)return 1;if(0===e.lookahead)break}if(r=0,e.lookahead>=b&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=b-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-y&&(e.match_length=B(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===b&&4096<e.strstart-e.match_start)&&(e.match_length=b-1)),e.prev_length>=b&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-b,n=h._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-b),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=b-1,e.strstart++,n&&(A(e,!1),0===e.strm.avail_out))return 1}else if(e.match_available){if((n=h._tr_tally(e,0,e.window[e.strstart-1]))&&A(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return 1}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=h._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<b-1?e.strstart:b-1,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}function F(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function N(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=_,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new d.Buf16(2*g),this.dyn_dtree=new d.Buf16(2*(2*a+1)),this.bl_tree=new d.Buf16(2*(2*o+1)),E(this.dyn_ltree),E(this.dyn_dtree),E(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new d.Buf16(v+1),this.heap=new d.Buf16(2*s+1),E(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new d.Buf16(2*s+1),E(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function U(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?k:x,e.adler=2===t.wrap?0:1,t.last_flush=f,h._tr_init(t),l):S(e,m)}function P(e){var t,r=U(e);return r===l&&((t=e.state).window_size=2*t.w_size,E(t.head),t.max_lazy_match=u[t.level].max_lazy,t.good_match=u[t.level].good_length,t.nice_match=u[t.level].nice_length,t.max_chain_length=u[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=b-1,t.match_available=0,t.ins_h=0),r}function L(e,t,r,n,i,s){if(!e)return m;var a=1;if(-1===t&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||9<i||r!==_||n<8||15<n||t<0||9<t||s<0||4<s)return S(e,m);8===n&&(n=9);var o=new N;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+b-1)/b),o.window=new d.Buf8(2*o.w_size),o.head=new d.Buf16(o.hash_size),o.prev=new d.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new d.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,P(e)}u=[new F(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(T(e),0===e.lookahead&&t===f)return 1;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,A(e,!1),0===e.strm.avail_out))return 1;if(e.strstart-e.block_start>=e.w_size-y&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(A(e,!0),0===e.strm.avail_out?3:4):(e.strstart>e.block_start&&(A(e,!1),e.strm.avail_out),1)}),new F(4,4,8,4,R),new F(4,5,16,8,R),new F(4,6,32,32,R),new F(4,4,16,16,D),new F(8,16,32,32,D),new F(8,16,128,128,D),new F(8,32,128,256,D),new F(32,128,258,1024,D),new F(32,258,258,4096,D)],r.deflateInit=function(e,t){return L(e,t,_,15,8,0)},r.deflateInit2=L,r.deflateReset=P,r.deflateResetKeep=U,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?m:(e.state.gzhead=t,l):m},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?S(e,m):m;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&4!==t)return S(e,0===e.avail_out?-5:m);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===k)if(2===n.wrap)e.adler=0,I(n,31),I(n,139),I(n,8),n.gzhead?(I(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),I(n,255&n.gzhead.time),I(n,n.gzhead.time>>8&255),I(n,n.gzhead.time>>16&255),I(n,n.gzhead.time>>24&255),I(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),I(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(I(n,255&n.gzhead.extra.length),I(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(I(n,0),I(n,0),I(n,0),I(n,0),I(n,0),I(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),I(n,3),n.status=x);else{var a=_+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=x,O(n,a),0!==n.strstart&&(O(n,e.adler>>>16),O(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),C(e),i=n.pending,n.pending!==n.pending_buf_size));)I(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),C(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,I(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),C(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,I(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&C(e),n.pending+2<=n.pending_buf_size&&(I(n,255&e.adler),I(n,e.adler>>8&255),e.adler=0,n.status=x)):n.status=x),0!==n.pending){if(C(e),0===e.avail_out)return n.last_flush=-1,l}else if(0===e.avail_in&&z(t)<=z(r)&&4!==t)return S(e,-5);if(666===n.status&&0!==e.avail_in)return S(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==f&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(T(e),0===e.lookahead)){if(t===f)return 1;break}if(e.match_length=0,r=h._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=w){if(T(e),e.lookahead<=w&&t===f)return 1;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=b&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+w;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=w-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=b?(r=h._tr_tally(e,1,e.match_length-b),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=h._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}(n,t):u[n.level].func(n,t);if(3!==o&&4!==o||(n.status=666),1===o||3===o)return 0===e.avail_out&&(n.last_flush=-1),l;if(2===o&&(1===t?h._tr_align(n):5!==t&&(h._tr_stored_block(n,0,0,!1),3===t&&(E(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),C(e),0===e.avail_out))return n.last_flush=-1,l}return 4!==t?l:n.wrap<=0?1:(2===n.wrap?(I(n,255&e.adler),I(n,e.adler>>8&255),I(n,e.adler>>16&255),I(n,e.adler>>24&255),I(n,255&e.total_in),I(n,e.total_in>>8&255),I(n,e.total_in>>16&255),I(n,e.total_in>>24&255)):(O(n,e.adler>>>16),O(n,65535&e.adler)),C(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?l:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==k&&69!==t&&73!==t&&91!==t&&103!==t&&t!==x&&666!==t?S(e,m):(e.state=null,t===x?S(e,-3):l):m},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,u,h,f=t.length;if(!e||!e.state)return m;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==k||r.lookahead)return m;for(1===s&&(e.adler=c(e.adler,t,f,0)),r.wrap=0,f>=r.w_size&&(0===s&&(E(r.head),r.strstart=0,r.block_start=0,r.insert=0),h=new d.Buf8(r.w_size),d.arraySet(h,t,f-r.w_size,r.w_size,0),t=h,f=r.w_size),a=e.avail_in,o=e.next_in,u=e.input,e.avail_in=f,e.next_in=0,e.input=t,T(r);r.lookahead>=b;){for(n=r.strstart,i=r.lookahead-(b-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+b-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=b-1,T(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=b-1,r.match_available=0,e.next_in=o,e.input=u,e.avail_in=a,r.wrap=s,l},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,u,h,f,l,d,c,p,m,_,g,v,b,w,y,k,x,S,z,E;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,E=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),u=r.dmax,h=r.wsize,f=r.whave,l=r.wnext,d=r.window,c=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,v=(1<<r.distbits)-1;e:do{p<15&&(c+=z[n++]<<p,p+=8,c+=z[n++]<<p,p+=8),b=m[c&g];t:for(;;){if(c>>>=w=b>>>24,p-=w,0==(w=b>>>16&255))E[s++]=65535&b;else{if(!(16&w)){if(0==(64&w)){b=m[(65535&b)+(c&(1<<w)-1)];continue t}if(32&w){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}y=65535&b,(w&=15)&&(p<w&&(c+=z[n++]<<p,p+=8),y+=c&(1<<w)-1,c>>>=w,p-=w),p<15&&(c+=z[n++]<<p,p+=8,c+=z[n++]<<p,p+=8),b=_[c&v];r:for(;;){if(c>>>=w=b>>>24,p-=w,!(16&(w=b>>>16&255))){if(0==(64&w)){b=_[(65535&b)+(c&(1<<w)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&b,p<(w&=15)&&(c+=z[n++]<<p,(p+=8)<w&&(c+=z[n++]<<p,p+=8)),u<(k+=c&(1<<w)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(c>>>=w,p-=w,(w=s-a)<k){if(f<(w=k-w)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=d,(x=0)===l){if(x+=h-w,w<y){for(y-=w;E[s++]=d[x++],--w;);x=s-k,S=E}}else if(l<w){if(x+=h+l-w,(w-=l)<y){for(y-=w;E[s++]=d[x++],--w;);if(x=0,l<y){for(y-=w=l;E[s++]=d[x++],--w;);x=s-k,S=E}}}else if(x+=l-w,w<y){for(y-=w;E[s++]=d[x++],--w;);x=s-k,S=E}for(;2<y;)E[s++]=S[x++],E[s++]=S[x++],E[s++]=S[x++],y-=3;y&&(E[s++]=S[x++],1<y&&(E[s++]=S[x++]))}else{for(x=s-k;E[s++]=E[x++],E[s++]=E[x++],E[s++]=E[x++],2<(y-=3););y&&(E[s++]=E[x++],1<y&&(E[s++]=E[x++]))}break}}break}}while(n<i&&s<o);n-=y=p>>3,c&=(1<<(p-=y<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=c,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),T=e("./inffast"),R=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function u(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function h(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=u(e,t))!==N&&(e.state=null),r):U}var f,l,d=!0;function j(e){if(d){var t;for(f=new I.Buf32(512),l=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(R(D,e.lens,0,288,f,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;R(F,e.lens,0,32,l,0,e.work,{bits:5}),d=!1}e.lencode=f,e.lenbits=9,e.distcode=l,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=u,r.inflateResetKeep=a,r.inflateInit=function(e){return h(e,15)},r.inflateInit2=h,r.inflate=function(e,t){var r,n,i,s,a,o,u,h,f,l,d,c,p,m,_,g,v,b,w,y,k,x,S,z,E=0,C=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,u=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,h=r.hold,f=r.bits,l=o,d=u,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(2&r.wrap&&35615===h){C[r.check=0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0),f=h=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&h)<<8)+(h>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&h)){e.msg="unknown compression method",r.mode=30;break}if(f-=4,k=8+(15&(h>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&h?10:12,f=h=0;break;case 2:for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(r.flags=h,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=h>>8&1),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0)),f=h=0,r.mode=3;case 3:for(;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.head&&(r.head.time=h),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,C[2]=h>>>16&255,C[3]=h>>>24&255,r.check=B(r.check,C,4,0)),f=h=0,r.mode=4;case 4:for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.head&&(r.head.xflags=255&h,r.head.os=h>>8),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0)),f=h=0,r.mode=5;case 5:if(1024&r.flags){for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.length=h,r.head&&(r.head.extra_len=h),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0)),f=h=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(c=r.length)&&(c=o),c&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,c,k)),512&r.flags&&(r.check=B(r.check,n,c,s)),o-=c,s+=c,r.length-=c),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(c=0;k=n[s+c++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&c<o;);if(512&r.flags&&(r.check=B(r.check,n,c,s)),o-=c,s+=c,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(c=0;k=n[s+c++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&c<o;);if(512&r.flags&&(r.check=B(r.check,n,c,s)),o-=c,s+=c,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(h!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}f=h=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}e.adler=r.check=L(h),f=h=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=u,e.next_in=s,e.avail_in=o,r.hold=h,r.bits=f,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){h>>>=7&f,f-=7&f,r.mode=27;break}for(;f<3;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}switch(r.last=1&h,f-=1,3&(h>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;h>>>=2,f-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}h>>>=2,f-=2;break;case 14:for(h>>>=7&f,f-=7&f;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if((65535&h)!=(h>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&h,f=h=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(c=r.length){if(o<c&&(c=o),u<c&&(c=u),0===c)break e;I.arraySet(i,n,s,c,a),o-=c,s+=c,u-=c,a+=c,r.length-=c;break}r.mode=12;break;case 17:for(;f<14;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(r.nlen=257+(31&h),h>>>=5,f-=5,r.ndist=1+(31&h),h>>>=5,f-=5,r.ncode=4+(15&h),h>>>=4,f-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;f<3;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.lens[A[r.have++]]=7&h,h>>>=3,f-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=R(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(E=r.lencode[h&(1<<r.lenbits)-1])>>>16&255,v=65535&E,!((_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(v<16)h>>>=_,f-=_,r.lens[r.have++]=v;else{if(16===v){for(z=_+2;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(h>>>=_,f-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],c=3+(3&h),h>>>=2,f-=2}else if(17===v){for(z=_+3;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}f-=_,k=0,c=3+(7&(h>>>=_)),h>>>=3,f-=3}else{for(z=_+7;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}f-=_,k=0,c=11+(127&(h>>>=_)),h>>>=7,f-=7}if(r.have+c>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;c--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=R(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=R(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=u){e.next_out=a,e.avail_out=u,e.next_in=s,e.avail_in=o,r.hold=h,r.bits=f,T(e,d),a=e.next_out,i=e.output,u=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,h=r.hold,f=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(E=r.lencode[h&(1<<r.lenbits)-1])>>>16&255,v=65535&E,!((_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(g&&0==(240&g)){for(b=_,w=g,y=v;g=(E=r.lencode[y+((h&(1<<b+w)-1)>>b)])>>>16&255,v=65535&E,!(b+(_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}h>>>=b,f-=b,r.back+=b}if(h>>>=_,f-=_,r.back+=_,r.length=v,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.length+=h&(1<<r.extra)-1,h>>>=r.extra,f-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(E=r.distcode[h&(1<<r.distbits)-1])>>>16&255,v=65535&E,!((_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(0==(240&g)){for(b=_,w=g,y=v;g=(E=r.distcode[y+((h&(1<<b+w)-1)>>b)])>>>16&255,v=65535&E,!(b+(_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}h>>>=b,f-=b,r.back+=b}if(h>>>=_,f-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=v,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.offset+=h&(1<<r.extra)-1,h>>>=r.extra,f-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===u)break e;if(c=d-u,r.offset>c){if((c=r.offset-c)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=c>r.wnext?(c-=r.wnext,r.wsize-c):r.wnext-c,c>r.length&&(c=r.length),m=r.window}else m=i,p=a-r.offset,c=r.length;for(u<c&&(c=u),u-=c,r.length-=c;i[a++]=m[p++],--c;);0===r.length&&(r.mode=21);break;case 26:if(0===u)break e;i[a++]=r.length,u--,r.mode=21;break;case 27:if(r.wrap){for(;f<32;){if(0===o)break e;o--,h|=n[s++]<<f,f+=8}if(d-=u,e.total_out+=d,r.total+=d,d&&(e.adler=r.check=r.flags?B(r.check,i,d,a-d):O(r.check,i,d,a-d)),d=u,(r.flags?h:L(h))!==r.check){e.msg="incorrect data check",r.mode=30;break}f=h=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(h!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}f=h=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=u,e.next_in=s,e.avail_in=o,r.hold=h,r.bits=f,(r.wsize||d!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,d-e.avail_out)?(r.mode=31,-4):(l-=e.avail_in,d-=e.avail_out,e.total_in+=l,e.total_out+=d,r.total+=d,r.wrap&&d&&(e.adler=r.check=r.flags?B(r.check,i,d,e.next_out-d):O(r.check,i,d,e.next_out-d)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==l&&0===d||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var u,h,f,l,d,c,p,m,_,g=o.bits,v=0,b=0,w=0,y=0,k=0,x=0,S=0,z=0,E=0,C=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),T=null,R=0;for(v=0;v<=15;v++)O[v]=0;for(b=0;b<n;b++)O[t[r+b]]++;for(k=g,y=15;1<=y&&0===O[y];y--);if(y<k&&(k=y),0===y)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(w=1;w<y&&0===O[w];w++);for(k<w&&(k=w),v=z=1;v<=15;v++)if(z<<=1,(z-=O[v])<0)return-1;if(0<z&&(0===e||1!==y))return-1;for(B[1]=0,v=1;v<15;v++)B[v+1]=B[v]+O[v];for(b=0;b<n;b++)0!==t[r+b]&&(a[B[t[r+b]]++]=b);if(c=0===e?(A=T=a,19):1===e?(A=F,I-=257,T=N,R-=257,256):(A=U,T=P,-1),v=w,d=s,S=b=C=0,f=-1,l=(E=1<<(x=k))-1,1===e&&852<E||2===e&&592<E)return 1;for(;;){for(p=v-S,_=a[b]<c?(m=0,a[b]):a[b]>c?(m=T[R+a[b]],A[I+a[b]]):(m=96,0),u=1<<v-S,w=h=1<<x;i[d+(C>>S)+(h-=u)]=p<<24|m<<16|_|0,0!==h;);for(u=1<<v-1;C&u;)u>>=1;if(0!==u?(C&=u-1,C+=u):C=0,b++,0==--O[v]){if(v===y)break;v=t[r+a[b]]}if(k<v&&(C&l)!==f){for(0===S&&(S=k),d+=w,z=1<<(x=v-S);x+S<y&&!((z-=O[x+S])<=0);)x++,z<<=1;if(E+=1<<x,1===e&&852<E||2===e&&592<E)return 1;i[f=C&l]=k<<24|x<<16|d-s|0}}return 0!==C&&(i[d+C]=v-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var o=e("../utils/common");function n(e){for(var t=e.length;0<=--t;)e[t]=0}var _=15,i=16,u=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],h=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],a=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],f=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],l=new Array(576);n(l);var d=new Array(60);n(d);var c=new Array(512);n(c);var p=new Array(256);n(p);var m=new Array(29);n(m);var g,v,b,w=new Array(30);function y(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function s(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function k(e){return e<256?c[e]:c[256+(e>>>7)]}function x(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function S(e,t,r){e.bi_valid>i-r?(e.bi_buf|=t<<e.bi_valid&65535,x(e,e.bi_buf),e.bi_buf=t>>i-e.bi_valid,e.bi_valid+=r-i):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function z(e,t,r){S(e,r[2*t],r[2*t+1])}function E(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function C(e,t,r){var n,i,s=new Array(_+1),a=0;for(n=1;n<=_;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=E(s[o]++,o))}}function A(e){var t;for(t=0;t<286;t++)e.dyn_ltree[2*t]=0;for(t=0;t<30;t++)e.dyn_dtree[2*t]=0;for(t=0;t<19;t++)e.bl_tree[2*t]=0;e.dyn_ltree[512]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function I(e){8<e.bi_valid?x(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function O(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function B(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&O(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!O(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function T(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?z(e,i,t):(z(e,(s=p[i])+256+1,t),0!==(a=u[s])&&S(e,i-=m[s],a),z(e,s=k(--n),r),0!==(a=h[s])&&S(e,n-=w[s],a)),o<e.last_lit;);z(e,256,t)}function R(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,u=t.stat_desc.elems,h=-1;for(e.heap_len=0,e.heap_max=573,r=0;r<u;r++)0!==s[2*r]?(e.heap[++e.heap_len]=h=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=h<2?++h:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=h,r=e.heap_len>>1;1<=r;r--)B(e,s,r);for(i=u;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],B(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,B(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,u=t.dyn_tree,h=t.max_code,f=t.stat_desc.static_tree,l=t.stat_desc.has_stree,d=t.stat_desc.extra_bits,c=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=_;s++)e.bl_count[s]=0;for(u[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<573;r++)p<(s=u[2*u[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),u[2*n+1]=s,h<n||(e.bl_count[s]++,a=0,c<=n&&(a=d[n-c]),o=u[2*n],e.opt_len+=o*(s+a),l&&(e.static_len+=o*(f[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)h<(i=e.heap[--r])||(u[2*i+1]!==s&&(e.opt_len+=(s-u[2*i+1])*u[2*i],u[2*i+1]=s),n--)}}(e,t),C(s,h,e.bl_count)}function D(e,t,r){var n,i,s=-1,a=t[1],o=0,u=7,h=4;for(0===a&&(u=138,h=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<u&&i===a||(o<h?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[32]++):o<=10?e.bl_tree[34]++:e.bl_tree[36]++,s=i,h=(o=0)===a?(u=138,3):i===a?(u=6,3):(u=7,4))}function F(e,t,r){var n,i,s=-1,a=t[1],o=0,u=7,h=4;for(0===a&&(u=138,h=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<u&&i===a)){if(o<h)for(;z(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(z(e,i,e.bl_tree),o--),z(e,16,e.bl_tree),S(e,o-3,2)):o<=10?(z(e,17,e.bl_tree),S(e,o-3,3)):(z(e,18,e.bl_tree),S(e,o-11,7));s=i,h=(o=0)===a?(u=138,3):i===a?(u=6,3):(u=7,4)}}n(w);var N=!1;function U(e,t,r,n){var i,s,a;S(e,0+(n?1:0),3),s=t,a=r,I(i=e),x(i,a),x(i,~a),o.arraySet(i.pending_buf,i.window,s,a,i.pending),i.pending+=a}r._tr_init=function(e){N||(function(){var e,t,r,n,i,s=new Array(_+1);for(n=r=0;n<28;n++)for(m[n]=r,e=0;e<1<<u[n];e++)p[r++]=n;for(p[r-1]=n,n=i=0;n<16;n++)for(w[n]=i,e=0;e<1<<h[n];e++)c[i++]=n;for(i>>=7;n<30;n++)for(w[n]=i<<7,e=0;e<1<<h[n]-7;e++)c[256+i++]=n;for(t=0;t<=_;t++)s[t]=0;for(e=0;e<=143;)l[2*e+1]=8,e++,s[8]++;for(;e<=255;)l[2*e+1]=9,e++,s[9]++;for(;e<=279;)l[2*e+1]=7,e++,s[7]++;for(;e<=287;)l[2*e+1]=8,e++,s[8]++;for(C(l,287,s),e=0;e<30;e++)d[2*e+1]=5,d[2*e]=E(e,5);g=new y(l,u,257,286,_),v=new y(d,h,0,30,_),b=new y(new Array(0),a,0,19,7)}(),N=!0),e.l_desc=new s(e.dyn_ltree,g),e.d_desc=new s(e.dyn_dtree,v),e.bl_desc=new s(e.bl_tree,b),e.bi_buf=0,e.bi_valid=0,A(e)},r._tr_stored_block=U,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return 0;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return 1;for(t=32;t<256;t++)if(0!==e.dyn_ltree[2*t])return 1;return 0}(e)),R(e,e.l_desc),R(e,e.d_desc),a=function(e){var t;for(D(e,e.dyn_ltree,e.l_desc.max_code),D(e,e.dyn_dtree,e.d_desc.max_code),R(e,e.bl_desc),t=18;3<=t&&0===e.bl_tree[2*f[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?U(e,t,r,n):4===e.strategy||s===i?(S(e,2+(n?1:0),3),T(e,l,d)):(S(e,4+(n?1:0),3),function(e,t,r,n){var i;for(S(e,t-257,5),S(e,r-1,5),S(e,n-4,4),i=0;i<n;i++)S(e,e.bl_tree[2*f[i]+1],3);F(e,e.dyn_ltree,t-1),F(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),T(e,e.dyn_ltree,e.dyn_dtree)),A(e),n&&I(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(p[r]+256+1)]++,e.dyn_dtree[2*k(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){var t;S(e,2,3),z(e,256,l),16===(t=e).bi_valid?(x(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):8<=t.bi_valid&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){"use strict";t.exports="function"==typeof setImmediate?setImmediate:function(){var e=[].slice.apply(arguments);e.splice(1,0,0),setTimeout.apply(null,e)}},{}]},{},[10])(10)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(68).Buffer, __webpack_require__(72).setImmediate))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(69)
var ieee754 = __webpack_require__(70)
var isArray = __webpack_require__(71)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 70 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 71 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(73);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(7)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var o=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in o)("object"==typeof exports?exports:e)[a]=o[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([115],{"0768325c7d55ee3d0425":function(e,s,o){"use strict";var a=o("9689a9c94ae38b47fa2c"),c=o.n(a),i=o("9ce58a7deea14f49ef01"),n=o.n(i),t=new c.a({id:"upload_16_v7",use:"upload_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="upload_16_v7"><path d="M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z" /></symbol>'});n.a.add(t);s.a=t},"105375219d726d2ad9eb":function(e,s,o){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=o("6873601dfe1d9459c1a9"),c=(o.n(a),o("0768325c7d55ee3d0425"));s.default=c.a},"6873601dfe1d9459c1a9":function(s,o){s.exports=e}},["105375219d726d2ad9eb"])});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(3);

var _baUiCarbon = __webpack_require__(20);

__webpack_require__(4);

var _FileLoader = __webpack_require__(31);

var _FileLoader2 = _interopRequireDefault(_FileLoader);

var _dismiss_ = __webpack_require__(76);

var _dismiss_2 = _interopRequireDefault(_dismiss_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: BI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ICON_ADD = 'add';
var ICON_REMOVE = 'remove';
var ICON_FILE_TYPES = '.svg .jpg .png';

var PackagePanel = function (_Component) {
	_inherits(PackagePanel, _Component);

	function PackagePanel(props) {
		_classCallCheck(this, PackagePanel);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._showOverlay = function () {
			_this.setState({ isDragging: true });
		};

		_this._hideOverlay = function () {
			_this.setState({ isDragging: false });
		};

		_this._findSourceName = function (_name) {
			return _name.split('/').pop();
		};

		_this._getUrlCreator = function () {
			return window.URL || window.webkitURL;
		};

		_this._handlePackageNameChange = function (_value) {
			_this.props.onChange({ 'name': 'name', 'value': _value });
		};

		_this._handlePackageDescriptionChange = function (synthEvent) {
			_this.props.onChange({ 'name': 'description', 'value': synthEvent.target.value });
		};

		_this._handleDragEnter = function () {
			_this._showOverlay();
		};

		_this._handleDragOver = function (_event) {
			_event.dataTransfer.dropEffect = 'copy';
			_event.preventDefault();
			_event.stopPropagation();
		};

		_this._handleDragEnd = function () {
			_this._hideOverlay();
		};

		_this._handleDragLeave = function (_event) {
			_this._hideOverlay();
			_event.preventDefault();
		};

		_this._handleDrop = function (_event) {
			_this._hideOverlay();
			var failed = false;
			// Check that the file type is '.svg'
			for (var i = 0; i < _event.dataTransfer.files.length; i++) {
				var file = _event.dataTransfer.files[i];
				if (ICON_FILE_TYPES.indexOf(file.name.toLowerCase().substr(-4)) < 0) {
					_this.props.onIconError(new Error(_StringResources2.default.get('schematicsInvalidType', { type: file.name })));
					failed = true;
					break;
				}
			}

			if (!failed) _this._handleIconChange(ICON_ADD, _event.dataTransfer.files);
			_event.preventDefault();
		};

		_this._handleIconChange = function (_action, _files) {
			var _this$props = _this.props,
			    zipMaxSize = _this$props.zipMaxSize,
			    imgMaxSize = _this$props.imgMaxSize,
			    onIconError = _this$props.onIconError,
			    onIconChanged = _this$props.onIconChanged;

			if (_action === 'add') {
				var loader = new _FileLoader2.default(null, zipMaxSize, imgMaxSize, ICON_FILE_TYPES);
				loader.load(_files, function (_fileList) {
					if (_fileList.length > 0) {
						var item = _fileList[0];
						var blobUrl = null;
						var sourceName = _this._findSourceName(item);
						var loadPromise = loader.getFileAsBlob(item);

						loadPromise.then(function (loadedBlobUrl) {
							blobUrl = _this._getUrlCreator().createObjectURL(loadedBlobUrl);
							onIconChanged(sourceName, blobUrl);
						}).catch(onIconError);
					}
				}, onIconError);
			} else if (_action === 'remove') {
				onIconChanged('', '');
			}
		};

		_this.state = {
			isDragging: false
		};

		_this.inputRef = null;
		_this.dndOverlay = null;
		return _this;
	}

	//
	// Utility functions
	//


	//
	// Event handlers
	//

	// The package name has changed


	// The package description has changed


	PackagePanel.prototype._renderIconRow = function _renderIconRow() {
		var _this2 = this;

		var _props = this.props,
		    iconURL = _props.iconURL,
		    iconName = _props.iconName;

		if (iconURL) {
			return _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{
					className: 'clsSVGIconRow',
					direction: 'row',
					justifyContent: 'flex-start',
					alignItems: 'center'
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ id: 'svgIconFL' },
						_react2.default.createElement(_baUiCarbonToolkit.FlexItem, { id: 'svgIconFI', style: { backgroundImage: 'url(' + iconURL + ')' } })
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ grow: true },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexLayout,
						{ direction: 'row', justifyContent: 'flex-start' },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexItem,
							{ style: { height: '18px' } },
							_react2.default.createElement(_baUiCarbonToolkit.Label, { id: 'idSchematicIconLabel', type: 'caption', htmlFor: 'idSchematicIcon', label: iconName, ellipsis: true })
						)
					)
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					null,
					_react2.default.createElement(_baUiCarbonToolkit.Button, {
						intent: 'primary',
						icon: _dismiss_2.default.id,
						iconSize: 'small',
						variant: 'icon',
						onClick: function onClick() {
							return _this2._handleIconChange(ICON_REMOVE, null);
						},
						title: _StringResources2.default.get('schematicsDeleteIcon'),
						tabIndex: 0
					})
				)
			);
		} else return;
	};

	PackagePanel.prototype._renderDropZone = function _renderDropZone() {
		var _this3 = this;

		var dropLabel = _StringResources2.default.get('schematicsIconDropFiles');

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				fullHeight: true,
				direction: 'column'
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ style: { margin: '16px' } },
				_react2.default.createElement(
					_baUiCarbon.Link,
					{ href: 'javascript:void()', onClick: function onClick() {
							return _this3.inputRef.click();
						} },
					dropLabel
				)
			)
		);
	};

	PackagePanel.prototype._renderIconContents = function _renderIconContents() {
		var _this4 = this;

		if (this.props.iconURL) return this._renderIconRow();
		// This component keeps a simple state of whether we are dragging on not.
		var overlayDisplayStyle = this.state.isDragging ? 'block' : 'none';
		var fileTypesLabel = _StringResources2.default.get('schematicsIconFileTypes');
		var imgMaxSize = this.props.imgMaxSize;

		var fileSizeLabel = _StringResources2.default.get('schematicsIconFileSize', { size: imgMaxSize });
		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ direction: 'column', fullHeight: true },
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Label, { className: 'clsSVGFileTypeLabel', label: fileTypesLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.Label, { className: 'clsSVGFileSizeLabel', label: fileSizeLabel })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ grow: 1, className: 'clsSVGIconPanel' },
				_react2.default.createElement(
					_baUiCarbonToolkit.Container,
					{
						onDragEnter: function onDragEnter(e) {
							return _this4._handleDragEnter(e);
						},
						className: this.state.isDragging ? 'clsSVGDropZone dragging' : 'clsSVGDropZone',
						droppable: 'true'
					},
					_react2.default.createElement(_baUiCarbonToolkit.Container, {
						className: 'clsSVGDndOverlay',
						onDragOver: function onDragOver(e) {
							return _this4._handleDragOver(e);
						},
						onDragEnd: function onDragEnd(e) {
							return _this4._handleDragEnd(e);
						},
						onDragLeave: function onDragLeave(e) {
							return _this4._handleDragLeave(e);
						},
						onDrop: function onDrop(e) {
							return _this4._handleDrop(e);
						},
						style: { display: overlayDisplayStyle },
						ref: function ref(_ref) {
							_this4.dndOverlay = _ref;
						}
					}),
					this._renderDropZone()
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement('input', {
					ref: function ref(_ref2) {
						_this4.inputRef = _ref2;
					},
					id: 'idChooseFile_Input',
					accept: '.svg, .jpg, .png',
					type: 'file',
					onChange: function onChange() {
						return _this4._handleIconChange(ICON_ADD, _this4.inputRef.files);
					},
					style: { display: 'none' }
				}),
				_react2.default.createElement(_baUiCarbonToolkit.Button, {
					id: 'idChooseFile_Button',
					intent: 'primary',
					onClick: function onClick() {
						return _this4.inputRef.click();
					},
					label: _StringResources2.default.get('schematicsChooseFile'),
					tabIndex: 0
				})
			)
		);
	};

	//
	// Main render function
	//


	PackagePanel.prototype.render = function render() {
		var _props2 = this.props,
		    packageName = _props2.packageName,
		    packageDescription = _props2.packageDescription;
		// Get the i18n strings

		var packageNameLabel = _StringResources2.default.get('nameLabelSchematic');
		var packageDescriptionLabel = _StringResources2.default.get('schematicsDescriptionLabel');
		var iconLabel = _StringResources2.default.get('schematicsIconLabel');

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{
				className: 'clsSVGTabsStyle',
				direction: 'row',
				style: { width: '100%' }
			},
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				null,
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ direction: 'row' },
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ className: 'clsSVGDetailsPanel',
								direction: 'column'
							},
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'packageNameEdit', label: packageNameLabel })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ className: 'clsSVGPackageEdit' },
								_react2.default.createElement(_baUiCarbonToolkit.TextInput, {
									id: 'packageNameEdit',
									placeholder: packageNameLabel,
									value: packageName,
									onValueChange: this._handlePackageNameChange,
									light: true
								})
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 3 })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								{ className: 'clsSVGPackageEdit' },
								_react2.default.createElement(_baUiCarbon.TextArea, { style: { resize: 'none' },
									id: 'packageDescriptionEdit',
									placeholder: packageDescriptionLabel,
									rows: 6,
									maxLength: 100,
									value: packageDescription,
									labelText: packageDescriptionLabel,
									onChange: this._handlePackageDescriptionChange,
									light: true
								})
							)
						)
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						null,
						_react2.default.createElement(_baUiCarbonToolkit.HSpacer, { size: 4 })
					),
					_react2.default.createElement(
						_baUiCarbonToolkit.FlexItem,
						{ grow: 1 },
						_react2.default.createElement(
							_baUiCarbonToolkit.FlexLayout,
							{ direction: 'column', fullHeight: true },
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.VSpacer, { size: 2 })
							),
							_react2.default.createElement(
								_baUiCarbonToolkit.FlexItem,
								null,
								_react2.default.createElement(_baUiCarbonToolkit.Label, { type: 'caption', htmlFor: 'iconDropZone', label: iconLabel, className: 'clsSVGPackageIcon' })
							),
							this._renderIconContents()
						)
					)
				)
			)
		);
	};

	return PackagePanel;
}(_react.Component);

PackagePanel.defaultProps = {
	iconName: '',
	iconURL: '',
	packageDescription: ''
};
PackagePanel.propTypes = {
	packageName: _propTypes2.default.string.isRequired,
	packageDescription: _propTypes2.default.string.isRequired,
	iconURL: _propTypes2.default.string,
	iconName: _propTypes2.default.string,
	zipMaxSize: _propTypes2.default.number,
	imgMaxSize: _propTypes2.default.number,
	onChange: _propTypes2.default.func.isRequired,
	onIconChanged: _propTypes2.default.func.isRequired,
	onIconError: _propTypes2.default.func.isRequired
};
exports.default = PackagePanel;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var c=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var i in c)("object"==typeof exports?exports:e)[i]=c[i]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1346],{"6873601dfe1d9459c1a9":function(s,c){s.exports=e},"8d4ccaf2baec1d5ec793":function(e,s,c){"use strict";var i=c("9689a9c94ae38b47fa2c"),o=c.n(i),a=c("9ce58a7deea14f49ef01"),n=c.n(a),t=new o.a({id:"dismiss_16_v7",use:"dismiss_16_v7-usage",viewBox:"0 0 16 16",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="dismiss_16_v7"><path d="M14 3.5L12.5 2 8 6.5 3.5 2 2 3.5 6.5 8 2 12.5 3.5 14 8 9.5 12.5 14 14 12.5 9.5 8 14 3.5z" /></symbol>'});n.a.add(t);s.a=t},"97c51f33b6d3e5f2ee40":function(e,s,c){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var i=c("6873601dfe1d9459c1a9"),o=(c.n(i),c("8d4ccaf2baec1d5ec793"));s.default=o.a}},["97c51f33b6d3e5f2ee40"])});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbonToolkit = __webpack_require__(3);

var _reset_ = __webpack_require__(78);

var _reset_2 = _interopRequireDefault(_reset_);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _CustomColorDialog = __webpack_require__(21);

var _CustomColorDialog2 = _interopRequireDefault(_CustomColorDialog);

__webpack_require__(4);

var _KeyCodes = __webpack_require__(79);

var _KeyCodes2 = _interopRequireDefault(_KeyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* IBM Confidential
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OCO Source Materials
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: authoring-common
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The source code for this program is not published or otherwise
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * divested of its trade secrets, irrespective of what has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * deposited with the U.S. Copyright Office.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_ENCODING=UTF-8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_MESSAGEFORMAT_NONE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var colorPickerName = 'colorPicker';

/**
 * Description:
 * The client is responsible for supplying at least the required properties. The client is also responsible for
 * supplying the favorite colors from the paletteService if there is one as well. The selected color is returned
 * in the callback and the client must set the selectedColor property with it and presist the selected color.  
 * This is needed for the Color Picker to show which color is current selected from palette and/or favorites.
 * 
 * The color picker has 3 required properties. 
 *   colors - An array of colors to select from.
 * 	 onColorSelected - A callback prototype which has one parameter, which is the selected color that is returns back.
 *   paletteService - the paletteService object which is needed by the Custom Color dialog for selecting favorite/custom colors
 *  
 * */

var ColorPicker = function (_Component) {
	_inherits(ColorPicker, _Component);

	function ColorPicker(props, state) {
		_classCallCheck(this, ColorPicker);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, state));

		_this.state = _extends({}, ColorPicker.defaultProps);
		_this._handleOpen = _this._handleOpen.bind(_this);
		_this.triggerButton = _react2.default.createRef();
		_this.attachRef = _react2.default.createRef();
		return _this;
	}

	ColorPicker.prototype.render = function render() {
		var _state = this.state,
		    colorFlyoutOpen = _state.colorFlyoutOpen,
		    customColorDialogOpen = _state.customColorDialogOpen;
		var _props = this.props,
		    selectedColor = _props.selectedColor,
		    title = _props.title,
		    disabled = _props.disabled,
		    className = _props.className,
		    style = _props.style;

		var orientation = this.props.orientation;
		if (typeof orientation === 'undefined') {
			orientation = document.body.dir === 'rtl' ? 'bottomLeft' : 'bottomRight';
		}
		return _react2.default.createElement(
			'div',
			{
				className: '\'clsColorPicker\' ' + className,
				style: style
			},
			customColorDialogOpen && this._renderCustomColor(),
			_react2.default.createElement(_baUiCarbonToolkit.Button, {
				'aria-controls': colorPickerName + '_button',
				'data-tid': colorPickerName + '_button',
				title: title,
				disabled: disabled,
				tabIndex: 0,
				ref: this.triggerButton,
				variant: 'frameless',
				onClick: this._handleOpen,
				style: selectedColor && this._getColorStyle(selectedColor),
				className: 'clsColorPicker_button'
			}),
			colorFlyoutOpen && _react2.default.createElement(
				_baUiCarbonToolkit.Flyout,
				{
					id: colorPickerName + '_flyout',
					'data-tid': colorPickerName + '_flyout',
					'aria-hidden': colorFlyoutOpen,
					placement: orientation,
					domNodeToAttachTo: this.attachRef.current,
					hideArrow: true,
					offset: 2,
					onClose: this._handleClose.bind(this),
					className: 'clsColorPicker_flyout'
				},
				this._displayFlyout()
			)
		);
	};

	ColorPicker.prototype._displayFlyout = function _displayFlyout() {
		var _props2 = this.props,
		    colors = _props2.colors,
		    colorsLabel = _props2.colorsLabel,
		    favoriteColors = _props2.favoriteColors;

		return _react2.default.createElement(
			_baUiCarbonToolkit.FlexLayout,
			{ direction: 'column' },
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ direction: 'row' },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ className: 'clsColorPicker_topLabel' },
					_react2.default.createElement(_baUiCarbonToolkit.Label, { label: colorsLabel })
				),
				_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, {
					className: 'clsColorPicker_restoreDefault',
					size: 'small',
					iconId: _reset_2.default.id,
					tabIndex: '0',
					verticalAlign: 'middle',
					style: { color: '#0353E9' }
					// onKeyDown={e => this.handleKeyDown(e, this.onDeleteFavorite.bind(this))}
					, onClick: this._restoreDefault.bind(this) })
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ direction: 'row', className: 'clsColorPicker_container' },
				colors.map(this._displayColors.bind(this))
			),
			favoriteColors && favoriteColors.length > 1 && _react2.default.createElement(
				_baUiCarbonToolkit.FlexLayout,
				{ direction: 'column' },
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexItem,
					{ className: 'clsColorPicker_label' },
					_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('favorite') })
				),
				_react2.default.createElement(
					_baUiCarbonToolkit.FlexLayout,
					{ direction: 'row', className: 'clsColorPicker_container' },
					favoriteColors.map(this._displayColors.bind(this))
				)
			),
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ className: 'clsColorPicker_customColorContainer', tabIndex: 0 },
				_react2.default.createElement(_baUiCarbonToolkit.Label, {
					className: 'clsColorPicker_customColor',
					label: _StringResources2.default.get('modeCustom'),
					onClick: this._showCustomColor.bind(this, true)
				})
			)
		);
	};

	ColorPicker.prototype._displayColors = function _displayColors(color, index) {
		var _this2 = this;

		var selectedColor = this.props.selectedColor;

		var style = this._getColorStyle(color);

		style.background = style.backgroundColor;

		var clsName = void 0;
		if (selectedColor === color) {
			clsName = 'clsColorPicker_selected_indicator';
		} else {
			clsName = 'clsColorPicker_cell';
		}
		return _react2.default.createElement(_baUiCarbonToolkit.FlexItem, {
			className: clsName,
			style: color && style,
			key: index,
			tabIndex: 0,
			'datat-index': index,
			'data-value': color,
			onClick: this._handleSelect.bind(this, color),
			onKeyDown: function onKeyDown(e) {
				return _this2._handleKey(e, color);
			}
		});
	};

	ColorPicker.prototype._handleOpen = function _handleOpen() {
		this.setState({ colorFlyoutOpen: !this.state.colorFlyoutOpen });
	};

	ColorPicker.prototype._handleClose = function _handleClose() {
		var customColorDialogOpen = this.state.customColorDialogOpen;
		// hide this if the color dialog isn't open

		if (!customColorDialogOpen) {
			this.setState({
				colorFlyoutOpen: false
			});
		}
	};

	ColorPicker.prototype._getColorStyle = function _getColorStyle(color) {
		var style = {};

		style.color = color;
		style.backgroundColor = color;

		return style;
	};

	ColorPicker.prototype._handleSelect = function _handleSelect(color) {
		this.props.onColorSelected(color);
		this.setState({ colorFlyoutOpen: false });
	};

	ColorPicker.prototype._showCustomColor = function _showCustomColor(show) {
		this.setState({ customColorDialogOpen: show });
	};

	ColorPicker.prototype._renderCustomColor = function _renderCustomColor() {
		var paletteService = this.props.paletteService;


		return _react2.default.createElement(_CustomColorDialog2.default, {
			key: 'colorDialog',
			paletteService: paletteService,
			isDialogOpen: true,
			paletteType: 'ConditionalPalette',
			onChange: this._handleSelect.bind(this),
			onCloseDialog: this._showCustomColor.bind(this, false)
		});
	};

	ColorPicker.prototype._restoreDefault = function _restoreDefault() {
		var _props3 = this.props,
		    colors = _props3.colors,
		    defaultColorResetTo = _props3.defaultColorResetTo;


		var resetColor = defaultColorResetTo;
		// if no reset given, use the first color in the coloor array
		if (!resetColor) {
			resetColor = colors[0];
		}
		this._handleSelect(resetColor);
		this.setState({
			colorFlyoutOpen: true
		});
	};

	ColorPicker.prototype._handleKey = function _handleKey(e, color) {
		// if Enter or Space key
		if (e.keyCode === _KeyCodes2.default.ENTER || e.keyCode === _KeyCodes2.default.SPACE) {
			this._handleSelect(color);
			e.preventDefault();
		}
	};

	return ColorPicker;
}(_react.Component);

ColorPicker.propTypes = {
	/** Colors to be selected */
	colors: _propTypes2.default.array.isRequired,
	/** Function that will get called on click of a color or resetting to defaultColorResetTo.
  * onColorSelected(color) {}
  */
	onColorSelected: _propTypes2.default.func.isRequired,
	/** Palette Service needed to create custom color dialog */
	paletteService: _propTypes2.default.object.isRequired,
	/** the color to restore back to. If no color given, it will use the first color in the colors array */
	defaultColorResetTo: _propTypes2.default.string,
	/** Colors label. It has a limited size, width of the control */
	colorsLabel: _propTypes2.default.string,
	/** Tooltip when you hover on the color picker button */
	title: _propTypes2.default.string,
	/** Selected color to show on the button. NOTE: Must be set by client when a color is selected. Would be passed to the onColorSelected() */
	selectedColor: _propTypes2.default.string,
	/** Favorite colors to be selected. The palette service has a method to retrieve this called getFavoriteColors() */
	favoriteColors: _propTypes2.default.array,
	/** Flag to disable the color picker button */
	disabled: _propTypes2.default.bool,
	/** Flyout.propTypes.placement */
	orientation: _baUiCarbonToolkit.Flyout.propTypes.placement,
	/** Custom class name(s) */
	className: _propTypes2.default.string,
	/** Custom css styles. Applied to parent div */
	style: _propTypes2.default.object
};
ColorPicker.defaultProps = {
	colorFlyoutOpen: false,
	disabled: false,
	className: '',
	customColorDialogOpen: false
};
exports.default = ColorPicker;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(6));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var o=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var a in o)("object"==typeof exports?exports:e)[a]=o[a]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([529],{"4d98f53e61fdcfb55d18":function(e,s,o){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var a=o("6873601dfe1d9459c1a9"),c=(o.n(a),o("e0f9fbeeec6e2f0b6a93"));s.default=c.a},"6873601dfe1d9459c1a9":function(s,o){s.exports=e},e0f9fbeeec6e2f0b6a93:function(e,s,o){"use strict";var a=o("9689a9c94ae38b47fa2c"),c=o.n(a),i=o("9ce58a7deea14f49ef01"),t=o.n(i),f=new c.a({id:"reset_32_v7",use:"reset_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="reset_32_v7"><path d="M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z" /></symbol>'});t.a.add(f);s.a=f}},["4d98f53e61fdcfb55d18"])});

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2015, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

	return {
		NUM0: 48,
		NUM1: 49,
		NUM2: 50,
		NUM3: 51,
		NUM4: 52,
		NUM5: 53,
		NUM6: 54,
		NUM7: 55,
		NUM8: 56,
		NUM9: 57,

		// Letters: Upper and Lower Case share the same code, i.e. the code for "a" is 65, too.
		A: 65,
		B: 66,
		C: 67,
		D: 68,
		E: 69,
		F: 70,
		G: 71,
		H: 72,
		I: 73,
		J: 74,
		K: 75,
		L: 76,
		M: 77,
		N: 78,
		O: 79,
		P: 80,
		Q: 81,
		R: 82,
		S: 83,
		T: 84,
		U: 85,
		V: 86,
		W: 87,
		X: 88,
		Y: 89,
		Z: 90,

		NUMPAD0: 96,
		NUMPAD1: 97,
		NUMPAD2: 98,
		NUMPAD3: 99,
		NUMPAD4: 100,
		NUMPAD5: 101,
		NUMPAD6: 102,
		NUMPAD7: 103,
		NUMPAD8: 104,
		NUMPAD9: 105,

		F1: 112,
		F2: 113,
		F3: 114,
		F4: 115,
		F5: 116,
		F6: 117,
		F7: 118,
		F8: 119,
		F9: 120,
		F10: 121,
		F11: 122,
		F12: 123,

		// Note: some keys have the same shape but different number, like DIVIDE and FORWARDSLASH.
		// Make sure you're using the right key.
		BACKSPACE: 8,
		TAB: 9,
		ENTER: 13,
		SHIFT: 16,
		CTRL: 17,
		ALT: 18,
		PAUSEBREAK: 19,
		CAPSLOCK: 20,
		ESCAPE: 27,
		SPACE: 32,
		PAGEUP: 33,
		PAGEDOWN: 34,
		END: 35,
		HOME: 36,
		LEFT_ARROW: 37,
		UP_ARROW: 38,
		RIGHT_ARROW: 39,
		DOWN_ARROW: 40,
		INSERT: 45,
		DELETE: 46,
		SECOND: 50, // the same with NUM2. Keep it for history reason.
		LEFT_WINDOW_KEY: 91, // Left Command on Mac
		RIGHT_WINDOW_KEY: 92, // Right Command on Mac
		SELECT_KEY: 93,
		MULTIPLY: 106,
		ADD: 107,
		SUBTRACT: 109,
		DECIMAL_POINT: 110,
		DIVIDE: 111,
		NUM_LOCK: 144,
		SCROLL_LOCK: 145,
		SEMI_COLON: 186,
		EQUAL: 187,
		COMMA: 188,
		DASH: 189,
		PERIOD: 190,
		FORWARDSLASH: 191,
		GRAVE_ACCENT: 192,
		OPEN_BRACKET: 219,
		BACKSLASH: 220,
		CLOSE_BRACKET: 221,
		SINGLE_QUOTE: 222
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=KeyCodes.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* IBM Confidential
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * OCO Source Materials
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: authoring-common
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The source code for this program is not published or otherwise
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * divested of its trade secrets, irrespective of what has been
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * deposited with the U.S. Copyright Office.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_ENCODING=UTF-8
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * NLS_MESSAGEFORMAT_NONE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var PalettePicker = function (_Component) {
	_inherits(PalettePicker, _Component);

	function PalettePicker() {
		_classCallCheck(this, PalettePicker);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	PalettePicker.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			null,
			'Palette Picker Placeholder'
		);
	};

	// just a guesstimate of what it will need for now, based on ChangePaletteView options


	return PalettePicker;
}(_react.Component);

PalettePicker.propTypes = {
	paletteService: _propTypes2.default.object.isRequired, // was glass context
	getPalettes: _propTypes2.default.func.isRequired,
	onCreatePalette: _propTypes2.default.func.isRequired,
	onChange: _propTypes2.default.func.isRequired,
	mruComponentIdentifier: _propTypes2.default.string.isRequired, // was component
	selectedId: _propTypes2.default.string,
	createPaletteType: _propTypes2.default.string
};
exports.default = PalettePicker;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PaletteListing = __webpack_require__(33);

var _PaletteListing2 = _interopRequireDefault(_PaletteListing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: authoring-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var View = __webpack_require__(29);


var PaletteListingView = View.extend({
	init: function init(options, container) {
		PaletteListingView.inherited('init', this, arguments);
		this.container = container;
		this.options = options;
	},
	render: function render() {
		_reactDom2.default.render(_react2.default.createElement(_PaletteListing2.default, {
			paletteService: this.options.paletteService,
			getPalettes: this.options.getPalettes,
			onCreatePalette: this.options.onCreatePalette,
			onChange: this.options.onChange,
			mruComponentIdentifier: this.options.mruComponentIdentifier,
			selectedId: this.options.selectedId,
			createPaletteType: this.options.createPaletteType
		}), this.container);
	},
	remove: function remove() {
		_reactDom2.default.unmountComponentAtNode(this.container);
	}
});

exports.default = PaletteListingView;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// authoring-common.min.js